{
  "QXCiLH": "忘记 PIN？",
  "HlP9fV": "还没有 PIN？",
  "/N55ps": "登录即表示您同意我们的<terms>条款</terms>和<privacy>隐私政策</privacy>。",
  "T/TkAZ": "1. 我们收集什么",
  "w3v7mq": "注册时，我们会收集您的电子邮件地址，并为您创建登录 PIN。若您选择付款，付款信息由 Stripe 处理——我们从不看到您的信用卡号。您在使用应用过程中创建的内容（例如交易、策略和提醒）我们会为您保存。",
  "lgt491": "2. 我们如何使用它",
  "Wczvjp": "您的电子邮件用于登录、找回 PIN 以及发送提醒通知。我们会保存您的交易和策略，以确保应用正常运行。我们不会出售您的信息，也不会与任何人共享。",
  "qyw0P2": "3. 我们在哪里存储",
  "aauQMk": "您的数据保存在安全的数据库中，存储与网络传输过程中均已加密。付款由第三方支付服务商处理——我们从不查看或保存您的银行卡详细信息。",
  "66uD/i": "4. Cookie和存储",
  "vkWyDG": "我们使用一个 Cookie 以维持您的登录状态，并将语言和显示偏好保存在您的浏览器中。我们不使用任何追踪类 Cookie，也不会在网络上跟踪您。",
  "dibMUt": "5. 推送通知",
  "mywTS3": "如果您为价格提醒开启了推送通知，我们会在服务器上存储您浏览器的通知地址。您可以随时在浏览器设置或应用内关闭。",
  "+Vq92J": "6. 市场数据",
  "7RMFwt": "我们从公开市场数据源获取SPX和VIX价格。我们仅使用这些数据来支持应用内的模拟器和提醒。",
  "TSrjth": "7. 我们保留多久",
  "S94FWc": "只要您的账户仍然有效，我们就会保留您的数据。若账户过期且未续订，我们可能在 90 天后删除相关数据。您也可以随时要求我们删除您的数据。",
  "X+9MhG": "8. 我们使用的其他服务",
  "nwi02M": "我们使用第三方服务处理支付、托管和数据存储。每项服务都有各自的隐私政策，规定其如何处理数据。",
  "plSjrj": "9. 儿童",
  "A2TNyg": "本应用不面向 18 岁以下用户。我们不会有意收集未成年人的信息。",
  "T0Y1JF": "10. 变更",
  "kaSaA+": "我们可能会更新本政策。如果您在我们做出更改后继续使用本应用，即视为同意新的政策。",
  "n8T6A6": "11. 问题？",
  "ogOwoI": "如对隐私政策有任何疑问，请发送邮件至购买页面上列出的地址联系我们。",
  "vx0nkZ": "隐私政策",
  "b4hQBy": "最后更新：2026年4月",
  "BNSmGR": "正在重定向...",
  "l2hFvy": "免费注册",
  "tluEJw": "购买 ABG One",
  "3Z20HJ": "特别折扣",
  "zJ+6t8": "$360",
  "E5aNYh": "$168",
  "04b512": "$720",
  "grwZlV": "1 年",
  "kIqo6h": "终身",
  "gGm9Z+": "免费账户",
  "PRVJEa": "限时优惠",
  "tf1lIh": "免费",
  "Fg6Vy9": "$0",
  "hOETD6": "$0.46/天",
  "ZrPDaL": "{price} 购买 1 年",
  "YET32v": "{price} 购买终身",
  "vZ1TE8": "已应用特别折扣",
  "lF6IK8": "输入邮箱以继续",
  "wq1FQY": "该邮箱已注册账户",
  "yUVl6+": "邮箱",
  "PXn1u4": "购买即表示您同意我们的<terms>条款</terms>和<privacy>隐私政策</privacy>。",
  "39CMzF": "正在为您生成登录 PIN……",
  "pxCGqt": "发生错误，请联系客服。",
  "gmezZ0": "您的访问 PIN",
  "GcAzoB": "请保存此 PIN——这是您永久的登录凭证",
  "z0Wa9w": "PIN 已通过邮件发送给您。若未收到，请查看垃圾邮件文件夹。",
  "w8icYy": "复制 PIN",
  "r2Jjms": "登录",
  "6bKmjV": "使用",
  "CNxkz8": "通过使用",
  "Jm/KMV": "，即表示您同意遵守这些规则。如果您不同意，请勿使用本应用。",
  "g5q1wh": "2. 本应用的功能",
  "EEN/Vn": "是一款期权交易的学习与练习工具。您可以构建交易策略，以历史市场数据进行回测，并记录自己的交易日志。仅用于学习和分析。",
  "FTczxz": "3. 本声明并非投资建议",
  "gm0Inx": "我们不是财务顾问。本应用中的任何内容都不构成买入或卖出任何金融产品的建议，所有内容仅用于学习。在以真实资金交易之前，请咨询专业财务顾问。",
  "sRsiQ7": "4. 我们的数据可能不完美",
  "CVs9SW": "我们尽力保证数据准确，但无法保证所有信息 100% 正确。市场价格可能存在延迟，回测的历史结果也不代表未来收益。",
  "q+1zzm": "5. 交易有风险",
  "LPxSSb": "期权交易可能让您损失大量资金——有时甚至超过您投入的本金。本应用中的策略既复杂又具有高风险。如果您决定以真实资金交易，这完全是您自己的选择，相应的责任也由您自行承担。对于您因此造成的任何资金损失，我们概不负责。",
  "3x5OJy": "6. 您的账户",
  "+y4k3A": "请妥善保管您的登录 PIN，不要与任何人分享。若有人滥用您的账户，责任由您承担。我们有权关闭任何违反规则的账户。",
  "82qcLQ": "7. 付款",
  "5xo5Nw": "一次性付款即可在规定期限内使用本应用。如需退款，请联系我们，我们将按个案处理。",
  "f8QboS": "8. 请勿抄袭",
  "lL4yaz": "本应用中的一切",
  "f3taff": "——包括设计、代码与工具——均归我们所有。未经我们书面许可，您不得复制、分享或据此创作衍生内容。",
  "PDibdd": "9. 我们不对损失负责",
  "nvUot6": "如果出现任何问题——应用崩溃、数据有误，或交易亏损——我们概不负责。您使用本应用，风险自担。",
  "dJH5K0": "10. 我们可更新这些规则",
  "cqyG0o": "我们可能会不时更改这些规则。若您在更改后继续使用本应用，即视为同意新的规则。",
  "32rBNK": "服务条款",
  "JqiqNj": "发生错误",
  "FazwRl": "重试",
  "cyR7Kh": "返回",
  "Mwff1H": "扫码免费注册",
  "0/hL28": "扫码获取特别折扣",
  "qFTuo6": "创建免费 αβΓ✻1 账户——永久使用",
  "9wTZr7": "以 $168 购买 αβΓ✻1 一年，原价 $360",
  "W10lyi": "getabg.one",
  "RahCRH": "已过期",
  "R6oUU3": "暂无即将到期的账户",
  "VLj+gQ": "近期无新注册",
  "KLRorU": "暂无付款记录",
  "7EMIS2": "剩余 1 天",
  "R/eOkj": "专业版",
  "cb2kY6": "标准",
  "8WKgF6": "收入",
  "iYc3Ld": "付款",
  "jtkU3K": "转化率",
  "XT3gth": "人均",
  "aV/9Na": "新用户（7 天）",
  "FsQ6XB": "即将到期",
  "CrJOJJ": "推荐",
  "rkMuwE": "收入",
  "/ROgfO": "注册数",
  "vc26Tu": "即将到期",
  "kuMUY8": "{days} 天后到期",
  "CzyDZP": "新用户（7 天）",
  "sSynIO": "{days}天",
  "HyMNOt": "近期付款",
  "R4FxHZ": "发送通知",
  "82Y7Sa": "正在发送...",
  "/xwYHP": "已发送！",
  "SDlYwM": "所有用户",
  "md2DVT": "按等级",
  "kF2z/O": "指定用户",
  "AmzvJO": "按到期日",
  "HQJg+h": "撰写通知",
  "9a9+ww": "标题",
  "W7hXJH": "消息正文...",
  "OsIhLl": "链接 URL（可选）",
  "ngyB8X": "发送至",
  "p/iF5T": "搜索用户...",
  "mfnxVr": "也发送推送通知",
  "YDMrKK": "用户",
  "wcB/Jz": "意见领袖",
  "hlmkcL": "健康",
  "dhf5eK": "通知",
  "StcK67": "书架",
  "qOLogg": "社交",
  "MJ2jZQ": "总计",
  "iHN12u": "管理员",
  "gjBiyj": "加载中...",
  "currentSelection": "当前选择：{attribute}",
  "directionalBiasStrategy": "{bias}策略：",
  "currentDirectionalSelection": "当前选择：{attribute}（{bias}）",
  "Mn4m0R": "发送邀请",
  "/QToxN": "该邮箱已存在对应用户",
  "kmwJw5": "发送邀请失败",
  "Mh7T6y": "邀请用户",
  "UQwQCj": "发送带登录 PIN 的邀请邮件",
  "sy+pv5": "邮箱",
  "HAlOn1": "显示名称",
  "IuFETn": "时长",
  "SeliBa": "1 周",
  "EvG8up": "1 个月",
  "8oX0zs": "3 个月",
  "47FYwb": "取消",
  "zQvVDJ": "全部",
  "3a5wL8": "激活",
  "6fPnZJ": "已计提",
  "EomJQc": "应付",
  "WuHoZ9": "转化",
  "56Oum3": "添加 KOL",
  "TE51b7": "导出CSV",
  "jeoCCx": "搜索姓名、账号、标识符…",
  "w6DJdz": "无匹配 KOL",
  "Fh63wD": "尚无 KOL — 添加您的第一位潜在客户",
  "fwIt1X": "最新",
  "faeHEC": "最多欠款",
  "Mhy6AE": "最多转化",
  "51PqHa": "最多关注者",
  "trkSSY": "名称 A→Z",
  "8TBgHc": "KOL 漏斗",
  "R27mKm": "按平台：",
  "FjxWsX": "排序：",
  "TiR/Hq": "保存中…",
  "QgUPiQ": "保存潜在客户",
  "bFhfbm": "该标识符已被使用",
  "Vflwur": "该标识符已被保留 — 请选择其他",
  "3HWlMG": "创建 KOL 失败",
  "vNMhsQ": "添加 KOL 潜在客户",
  "LuKWb/": "先记为潜在客户。对方确认合作意向后，再走入驻流程（发送 PIN + 创建 Pro 账户）。",
  "X0ha1a": "保存更改",
  "WP4Inj": "保存更改失败",
  "Qva+p6": "删除KOL",
  "yyI2mr": "删除此KOL？",
  "QA6slB": "此操作将永久删除该 KOL 的记录。联盟代码仍然有效，但会失去归属人；相关付款和活动记录都会一并删除。",
  "K3r6DQ": "删除",
  "FQhUrc": "编辑KOL",
  "nTERwx": "修正拼写错误、更新用户名或调整佣金。状态变更仍在详情视图中完成。",
  "noZdV2": "删除中...",
  "qMePPG": "备注",
  "p7ZDhz": "已发送私信",
  "9HU8vw": "回复",
  "tzMNF3": "处理状态",
  "xdVU3q": "打款",
  "h2vipu": "代码",
  "pEvEiR": "已入驻",
  "2/2yg+": "添加",
  "ZmlNQ3": "活动",
  "tgdyVz": "记录私信、回复、电话或笔记...",
  "aojEGT": "尚无活动",
  "+tdSYp": "生成中…",
  "OwO+Nr": "生成",
  "rK7lyq": "尚无代码",
  "c4gwlB": "完成该 KOL 入驻后即可生成联盟代码",
  "3+UWwF": "激活",
  "ajHSDV": "未激活",
  "p556q3": "已复制",
  "GQNYob": "分享链接",
  "Pg73r+": "联盟代码",
  "KhrsOK": "新代码",
  "rltTep": "自定义代码（可选）",
  "ZE8lRT": "次",
  "4l6vz1": "复制",
  "ydIlLR": "尚未绑定",
  "6C3LyS": "个人资料",
  "wEQDC6": "编辑",
  "WlSvN2": "私信草稿",
  "ZgxxPi": "确认并入驻",
  "7PhW5W": "代码",
  "w4JmUR": "交易条款",
  "mznk9z": "佣金",
  "caR+vb": "粉丝价",
  "UlDEMV": "KOL礼品",
  "AX3Ned": "专业版永久（已发放）",
  "x6iKW2": "专业版永久（待加入）",
  "pzTOmv": "关注者",
  "ajMpUE": "仅复制",
  "pX3pgH": "正在记录...",
  "8A/ETL": "复制并记录为已发送",
  "2XHGT+": "DM 私信 — {name}",
  "FxdJbu": "预填姓名、平台、slug 和佣金。复制或记录为已发送。",
  "Yu9Sqk": "对方内容（填充 [具体内容]）",
  "aZQTyb": "例如：上周那篇讲铁鹰宽度的笔记",
  "LkKgAV": "必须是你确实读过的内容——OUTREACH.md 第七条：“不要群发同一模板”",
  "TJo5E6": "预览",
  "/30QJQ": "字符",
  "Mmuj1R": "平台",
  "iNWbVV": "用户名",
  "ooeJ6o": "自定义网址",
  "5CuZ1f": "2–32 个字符：字母、数字、_ 或 -。这是粉丝点击的分享链接。",
  "V4KNjk": "可选",
  "+1HAHt": "个人资料网址",
  "7+Domh": "笔记",
  "qbrnAy": "内容备注、协商条款、联系背景…",
  "1+MVJi": "确认并发送PIN",
  "rbrahO": "关闭",
  "oSRgw2": "发送PIN需要电子邮件",
  "T7yqEv": "该KOL已完成入驻",
  "1mxbAQ": "KOL 入驻失败",
  "ld9uH3": "入驻 {name}",
  "Vb2egu": "创建终身 Pro 账户、生成联盟代码，并将 PIN 发送至其邮箱。此操作不可撤销。",
  "XEzwxQ": "已关联用户 {email}——已升级为终身 Pro",
  "SgjGlq": "PIN码已发送至 {email}",
  "CZ6VD0": "PIN：",
  "8S9nW1": "代码：",
  "FhDDzO": "链接：",
  "zND/qF": "自定义代码",
  "2my2Wa": "留空则自动生成",
  "4dEFst": "用于 ?ref=CODE。留空则自动生成。",
  "Mjp+Mk": "确认后我们将执行以下操作：",
  "wTksty": "创建终身 Pro 账户",
  "SP+5y6": "生成联盟代码并关联到此 KOL",
  "buyckq": "将登录 PIN 发送至上述邮箱",
  "0QwyJz": "将状态更新为已入驻",
  "Wn+3o7": "保存打款记录",
  "y9xHR9": "打款记录",
  "d5engH": "记录打款",
  "H9mMTC": "期间开始",
  "p9+GhL": "期间结束",
  "u41foB": "金额（美元）",
  "W+1MOm": "方式",
  "724CrE": "选择...",
  "V8yJy5": "未设置",
  "PT6kJ+": "参考 (Stripe 交易/PayPal 收据)",
  "lwzj63": "暂无打款记录",
  "apr6+g": "二维码",
  "Jlfnum": "设置自定义短链接以生成二维码",
  "6vl1G/": "编码",
  "hd4SJr": "将二维码放到该 KOL 的小红书个人简介或视频卡片中。粉丝扫码后会跳转到其专属落地页。",
  "xzV2K7": "复制图像",
  "EAO/K+": "下载PNG",
  "JysGE6": "粉丝",
  "aGE2QO": "应欠",
  "rdEuVV": "转化",
  "bXb3Bs": "加载编辑器...",
  "X0hrh/": "未找到指南。",
  "P8tT2t": "正在加载书籍…",
  "Kq4pTx": "未找到该书",
  "J/9jle": "标题 (英文)",
  "RtFDsr": "标题 (中文)",
  "zn0GuF": "副标题 (英文)",
  "oLHosz": "副标题 (中文)",
  "/bdKNj": "URL路径",
  "3KNMbJ": "文章",
  "ylNz/0": "新文章",
  "cr52zp": "文章标题 (英文)",
  "jfk+6j": "未命名文章",
  "mKC2Yq": "尚无文章。请添加一篇。",
  "TVPV0v": "选择一篇文章进行编辑，或添加一篇新文章。",
  "WkrNSk": "英文",
  "i4jvwu": "中文",
  "pLur/+": "文章标题 (中文)",
  "502Gaj": "正文 (markdown)",
  "72RCKz": "删除此文章？",
  "qvc9uM": "此操作无法撤销。",
  "wmFdws": "上移",
  "H/r5m6": "下移",
  "dOgCSN": "章节",
  "5ljKSh": "新章节",
  "WNVxCo": "章节名称",
  "VzzYJk": "创建",
  "Zh+5A6": "开启",
  "OvzONl": "关闭",
  "Z5dM3R": "推荐人",
  "XMrYSI": "被推荐人",
  "Ov2lv+": "推荐",
  "quFyjO": "奖励天数",
  "R49KHd": "联盟",
  "4Ox3qJ": "暂无推荐码",
  "zINlao": "所有者",
  "+U6ozc": "提醒类型",
  "Vb+qQ4": "使用次数",
  "PuQb0P": "奖励",
  "9rufIf": "近期推荐事件",
  "u/vOPu": "已支付",
  "2QQ5Y5": "暂无帖子。请在上方撰写以开始。",
  "2atspc": "草稿",
  "cXAlMR": "计划",
  "QYYHH3": "已发布",
  "eR3YIn": "帖子",
  "FuJAJi": "演示视频",
  "+pwUpZ": "连接的账户",
  "FjU4Qa": "尚未连接。连接一个平台即可代表 Kiera 发布。",
  "+vVZ/G": "连接",
  "Eg11ZY": "重新连接",
  "qj1uhz": "断开连接",
  "pT/nDf": "断开此账户？您需要重新授权才能再次通过此账户发布。",
  "xhQMeQ": "到期",
  "7KMbBa": "从未使用",
  "iQhFxR": "上次使用",
  "IvjoDS": "已连接",
  "lpbja4": "粘贴 Discord Webhook URL",
  "Mww6Lr": "粘贴凭证",
  "TMzzGO": "正在加载连接...",
  "jvo0vs": "保存",
  "uS3NA3": "暂无演示视频。请在本地运行 tmp/build_demo.ts 来渲染和发布。",
  "5q3qC0": "下载",
  "lbr3Lq": "复制链接",
  "iVojI9": "删除此视频？Blob 将从存储中移除。",
  "5cFOSr": "连接失败",
  "TDaF6J": "关闭",
  "CHpZ5E": "撰写帖子",
  "PrvdcD": "主题，例如 铁鹰并非真的安全",
  "dTo23t": "钩子（第一行）",
  "1NdqJf": "正文",
  "x/kNJT": "结束语",
  "4osWT/": "内部注释（不生成）",
  "ea6iUX": "受众",
  "s9SGwm": "策略灵感",
  "eNR+LY": "生成脚本",
  "A/lLjO": "正在生成...",
  "E048/V": "保存为草稿",
  "hGQqkW": "计划",
  "CjBL+W": "计划（可选）",
  "/GCoTA": "清除",
  "2w42m1": "使用 Gemini 起草钩子/正文/结尾。之后可任意编辑。",
  "m5CvOs": "抖音",
  "13nSzN": "小红书",
  "Rb/hb9": "领英",
  "MXPwVk": "X",
  "iJOiJr": "Reels",
  "w+2Vw7": "Shorts",
  "LzrJWg": "Reddit",
  "FvmV6q": "Discord",
  "1kOFp2": "Threads",
  "0H9Fkb": "新手",
  "UTY9Hd": "早期交易者",
  "o5/DJA": "进阶",
  "3Rx6Qo": "高级",
  "NGE30i": "产品用户",
  "1iEPTM": "通用",
  "QsGagw": "再利用",
  "fIEqiO": "再利用中...",
  "rO/m1g": "标记为计划",
  "TfJ0ks": "标记为已发布",
  "sjdr1Y": "返回草稿",
  "meoXOo": "删除此帖子？此操作无法撤销。",
  "DLEiSJ": "立即发布",
  "TMicLW": "发送提醒",
  "PesLat": "发布中...",
  "lqFAMd": "查看实盘帖子",
  "NEzsjp": "已发送提醒 — 手动发布",
  "eDy55B": "上次发布失败",
  "w7tf2z": "已发布",
  "Z1QE8U": "生成配音",
  "y+cNoO": "重新生成配音",
  "Di/X8a": "正在生成配音...",
  "VMXG0i": "配音已生成",
  "NfIrYa": "计划于",
  "ssDLEL": "选择要生成变体的目标平台：",
  "wgr8yV": "运行再利用",
  "PrboG4": "录制样本",
  "q/uwLT": "停止",
  "3MawrJ": "提交样本",
  "txkW56": "正在提交...",
  "nmpevl": "放弃",
  "ewf7D2": "重新录制",
  "raexxM": "已提交",
  "pGCLGL": "已录制",
  "vXCeIi": "失败",
  "bZMC5A": "语音样本",
  "/U9cX/": "添加朗读文本",
  "zCzIEc": "麦克风权限被拒绝",
  "AUFgrw": "删除此样本？此操作无法撤销。",
  "mJbA00": "删除用户",
  "tbcrjL": "重发 PIN 邮件",
  "wv3Ip3": "用户信息",
  "xU7mdo": "统计",
  "WFpYCz": "提醒",
  "27THl1": "暂无提醒",
  "C2iTEH": "已暂停",
  "cmaSzx": "支付",
  "Ri4ZTj": "暂无支付",
  "e/4U0n": "修改 PIN",
  "+OGJYf": "操作",
  "YQ3ixO": "危险区",
  "2LtDKj": "此操作将永久删除 {name} 及其所有数据。",
  "b07w+D": "层级",
  "se5BCO": "复制折扣链接",
  "dtc8sT": "折扣链接已复制",
  "7qIiVK": "二维码已复制",
  "TUZLas": "复制失败",
  "s8Y12g": "点击获取 αβΓ✻1 特别折扣：{url}",
  "g8D79Y": "年度优惠",
  "hYOE+U": "邀请",
  "8zAvdb": "搜索姓名、邮箱、PIN...",
  "V6wm5v": "用户",
  "XWcjJb": "未找到用户",
  "udXPv8": "{days} 天后到期",
  "ONySWH": "无邮箱",
  "A3ptul": "模版",
  "iF/NIV": "交易",
  "9zub+u": "警报",
  "Zqa4dQ": "已触发",
  "/jJLYy": "交易记录",
  "JpAnzp": "推送订阅",
  "Zb4TtY": "违规",
  "b1zuN9": "价格",
  "DqTQOp": "一次性",
  "XfR4wn": "每日重复",
  "QNeYzN": "时间 (ET)",
  "uUdgim": "时间 (ET, RTH 09:30–16:00)",
  "zxvhnE": "每日",
  "/clOBU": "每周",
  "wYsv4Z": "每月",
  "k0eWdm": "警报标题（可选）",
  "/HKWfF": "消息正文（可选）",
  "m5eCsU": "至少需要启用一个通知渠道",
  "GN9UDB": "推送",
  "7ACBJ3": "未设置警报",
  "xWZNHq": "+ 添加警报",
  "CC6XgB": "警报已触发",
  "SA1H5e": "确定要删除此条提醒吗？此操作无法撤销。",
  "JJNc3c": "上一页",
  "9+Ddtu": "下一页",
  "sd2ieZ": "周",
  "TBovrx": "月份",
  "IFo1oo": "年份",
  "tUEyB3": "正在导入……",
  "9XUYQt": "导入",
  "mOFG3K": "开始",
  "3JVa6k": "结束",
  "JXYCuG": "总盈亏",
  "gcYCT/": "{count}天",
  "2S35Pb": "日均{value}",
  "njz9LZ": "{count}天连胜",
  "/OVhC1": "净值曲线",
  "QInnjm": "胜率",
  "9oOUbX": "夏普比率",
  "XO0uH1": "索提诺比率",
  "fF376U": "当前",
  "UHBWvP": "{count}天",
  "fG6gCw": "单笔最大盈利",
  "nXRE2N": "单笔最大亏损",
  "qoR2Kc": "盈利最多",
  "8arthz": "{count}笔交易",
  "0qog7D": "亏损最多",
  "ii58xS": "交易最多",
  "4YuB+L": "月度盈亏",
  "YAPyM+": "盈亏分布",
  "QUlc3L": "回撤",
  "3AWkGG": "按天",
  "kYixXf": "{pct}%胜率",
  "y4cCLq": "按标的",
  "m0qwrb": "显示全部 {count}",
  "qyJtWy": "显示更少",
  "/qpG/9": "返回分析",
  "pSrPN9": "交易",
  "2JiMkX": "胜率",
  "P7PLVj": "日期",
  "QlsDcr": "操作",
  "nV7Cv+": "合约",
  "7gXPhB": "数量",
  "/0TOL5": "金额",
  "nDyaq/": "运行中",
  "VdiJeK": "该区间内 {underlying} 无交易记录",
  "RyG+bT": "PIN 无效。",
  "B05Zig": "如果该邮箱已注册，PIN 即将送达。请查收收件箱（及垃圾邮件）。",
  "E6nn1R": "没收到？请查看垃圾邮件文件夹。",
  "o/DO8l": "购买时使用的邮箱",
  "kfL0Qd": "发送 PIN",
  "7tSUe8": "返回登录",
  "j0EUOG": "您的账户已准备就绪！",
  "NaVryt": "您的免费账户已准备就绪！",
  "HAlBRm": "请到邮箱查收登录 PIN。",
  "Wpki52": "计划交易",
  "xEs79x": "VIX范围",
  "97yArg": "平均盈亏",
  "Om9T4F": "测试策略",
  "XvJm2a": "正在测试...",
  "KXIgnu": "选择模版",
  "zG5bX7": "盈亏比",
  "ugytKh": "最大回撤",
  "YQN3JK": "胜",
  "JC3MvR": "负",
  "2LQqMZ": "日均",
  "PzlMqG": "最佳",
  "vzTkWJ": "最差",
  "NWOWw7": "每日日志",
  "yUhDpZ": "开→收",
  "UMbBzo": "变动",
  "LILvKC": "隐含波动率",
  "Do29Mx": "P&L",
  "OUDup4": "累计",
  "zmjMfM": "设计",
  "beLKfc": "风险%",
  "KYX50x": "止损%",
  "EwZPNI": "VIX过滤",
  "mZHhVC": "滑点/腿",
  "TbRX1i": "止损滑点",
  "a31Vgd": "利润目标%",
  "dM+p3/": "从",
  "9j3hXO": "到",
  "IaE50n": "本金",
  "2CAtHp": "VIX状态",
  "l2cSm1": "星期",
  "ACo1sD": "贷记敏感度",
  "jHJmjf": "无结果",
  "8erzOK": "暂无保存的模版",
  "gKZ7oq": "筛选模版...",
  "XCz6VC": "进入专业版",
  "/wTHUt": "回测",
  "EES7Oc": "识别",
  "n1gFSX": "无限制回测",
  "bq59ES": "跨标比较",
  "Vebvte": "运行中…",
  "jm/spn": "重置",
  "oSdxfu": "跨标比较",
  "moOg2N": "展望",
  "v6rYjQ": "风险",
  "vhQqLj": "区间",
  "URL784": "中性",
  "WZTXKm": "趋势",
  "XeAWps": "突破",
  "LmULx9": "保守",
  "r0q/a1": "平衡",
  "18T/KN": "激进",
  "mDS1Tp": "券商",
  "yfrz4Z": "策略侦测",
  "6MjbVc": "正在生成策略...",
  "29GKyy": "规划",
  "ffIQCt": "正在规划...",
  "/7BaIL": "创建计划",
  "6PgVSe": "重新生成",
  "LgZg0U": "保存到日记",
  "SIfKJW": "深度指导",
  "+xJ09d": "向 AI 提问：策略、指标或原理……",
  "gFfm+i": "继续追问……",
  "ZT0z9z": "提问",
  "zUGode": "存入课程",
  "W/5hwr": "出了点问题。",
  "QrZMdi": "思考中……",
  "B5dkeJ": "正在细读您的问题……",
  "9aALVT": "翻阅策略手册……",
  "s4QB5O": "对照期权数学公式……",
  "bDOKRs": "核对历史波动率模式……",
  "rY1htH": "权衡不同市场状态下的风险……",
  "c6IluE": "组织最清晰的解释……",
  "vs1u6W": "AI助手",
  "E1J2uJ": "AI问询",
  "U3e2LV": "保存至书架",
  "xejP63": "加入书中",
  "FgBZZi": "新建一本书",
  "bv2X6I": "书",
  "XlrkAJ": "新书名称",
  "JxHQPA": "例如：我的铁鹰笔记",
  "DC2jfb": "保存失败，请重试。",
  "XU9oUm": "首次保存会在您的书架上新建一本个人书——可以现在起名，也可以让系统为您生成。",
  "spwhNo": "策略计划",
  "r1upTX": "今天尚无策略计划",
  "I0m2JY": "为此日期记录一笔交易，然后在此处添加笔记。",
  "I9Po3d": "添加笔记...",
  "wR7xTu": "入场",
  "yDJQ0F": "添加策略",
  "Oc/0wp": "添加备注",
  "1geqnx": "已记录",
  "ADKsID": "已开仓",
  "Fv1ZSz": "已结束",
  "2tIG+9": "删除交易",
  "v4qxdc": "为此交易添加提醒",
  "4J9V2c": "事件",
  "nCRze5": "交易",
  "ZvKSfJ": "事件",
  "aFRjxY": "本月无事件",
  "+YYC3M": "当日暂无",
  "A8Rxwb": "交易日志",
  "E6iAD4": "确定要删除此笔交易吗？此操作无法撤销，此前记录的盈亏也将一并清除。",
  "KHrQob": "添加警报",
  "u9IdEb": "记录笔记",
  "xN7WFk": "暂无已保存策略",
  "ufC4LN": "请先在模拟器中设计一个。",
  "Gp8E4j": "我的策略",
  "iH2jXN": "筛选策略...",
  "edxpww": "切换日历",
  "YIUs4+": "清除日期筛选",
  "ZNUeQ6": "打开 {label}",
  "JfG49w": "打开",
  "N2IrpM": "确认",
  "E2sGaF": "退出",
  "4gGjKG": "{name} 的粉丝们，欢迎！",
  "w7BgT8": "期权策略构建器和回测器。",
  "p7fNYZ": "粉丝专属优惠",
  "t0yPJm": "注册免费账户",
  "etQKW7": "1 年仅需 $168",
  "Hs/nNW": "立省 53%（原价 $360）",
  "5+waIu": "无需信用卡，也无需邀请码。",
  "aoT0kc": "无需信用卡，无需邀请码",
  "VL/B6x": "your@email.com",
  "LyJi91": "该邮箱已注册账户",
  "prBAWB": "请输入有效邮箱",
  "xpod2V": "预览模式",
  "aElHrs": "这是您的专属落地页。上线后，访问 getabg.one/{slug} 的粉丝会看到同样的页面。",
  "rQKsAP": "策略生成器",
  "oVJbtC": "一键生成铁鹰、铁蝶、对角等结构——盈亏图与希腊字母实时更新。",
  "BjouTF": "回测引擎",
  "LikjGz": "覆盖自 2015 年至今的 SPX 历史数据：夏普比率、月度热力图、盈亏分布、完整交易明细一应俱全。",
  "gFnVSL": "交易日志与分析",
  "eSz4AK": "CSV 导入、自动同步、凯利公式、有效前沿等一系列专业指标。",
  "AYIKp4": "已有账户？请登录",
  "cXBJ7U": "隐私",
  "xkr+zo": "条款",
  "/93KBD": "看懂结构，模拟变化，再做决策。",
  "8YYioz": "已有账号？登录",
  "pmsyUe": "或免费注册 — 含 7 天 Pro 试用",
  "zPiw3E": "或免费注册 — 终身访问",
  "b37lXQ": "创建您的免费账户",
  "fGnkPi": "含 7 天 Pro 试用，无需信用卡",
  "XBEKZH": "无需信用卡",
  "cJwqG9": "先看懂结构",
  "iJDv7L": "从单腿到组合策略，把行权价、到期日、权利金和希腊字母放在同一张图里，先建立风险直觉，再考虑下单。",
  "humrmR": "行动前先推演",
  "SRAORy": "拖动价格、时间和波动率，观察收益曲线如何变化。把周五收盘、Theta decay 和极端情境都提前看一遍。",
  "/oNE8Q": "从模版到回测",
  "IG6hpK": "用 31 种策略原语搭建结构，保存模版，结合历史回测和交易日志，把想法沉淀成可复盘的流程。",
  "QwBh9x": "学习系统，不是券商",
  "r6HWtE": "ABG 不接收资金、不代客交易、不提供投资建议。它帮助你理解期权结构和风险，执行决策始终由你掌握。",
  "xcLPLf": "带盈亏图的策略模拟器",
  "jKr/3l": "绩效分析和净值曲线",
  "yzNIha": "时间衰减曲线模拟",
  "ACySSx": "盈亏摘要和净值曲线",
  "3eUVDM": "请到邮箱查收登录 PIN",
  "nNolbc": "您的免费账户已准备就绪。请输入您的PIN码登录。",
  "vR2vRi": "前往登录",
  "acRFKN": "注册即表示您同意我们的<terms>条款</terms>和<privacy>隐私政策</privacy>。",
  "F62y+K": "登出",
  "BHBJUz": "确定要退出登录吗？",
  "UctGSB": "Pro 将于明日到期",
  "s2gfPU": "续费",
  "KoD3Us": "Pro 将在 {days} 天后到期",
  "hOdd5/": "检测到未经授权的访问",
  "6TAWBD": "篡改界面以绕过付费功能违反我们的服务条款。若继续尝试，我们将停用您的账户。",
  "p5wxjR": "我了解",
  "ti1RKs": "书单",
  "P8cAQd": "新书",
  "3Qevik": "书名",
  "E3iaHv": "1 本书",
  "vEF59U": "指南",
  "xaXcEh": "{count} 本书",
  "f6GoZg": "删除此书",
  "NTYWCy": "删除“{name}”及其所有文章？此操作无法撤销。",
  "vy4o+D": "选择策略",
  "ejEGdx": "首页",
  "g5pX+a": "关于",
  "IbrSk1": "学习",
  "wXVN4/": "安全须知",
  "odXlk8": "登录",
  "dg8ZEb": "关闭菜单",
  "Spd88H": "取消全选",
  "94Fg25": "全选",
  "k55jq9": "暂无保存的策略",
  "SNmzJ/": "尝试其他搜索",
  "wl1b+c": "保存策略后即可在此处查看",
  "N87BeP": "全部打开",
  "J1Hzu0": "全部关闭",
  "NKPfmm": "{count} 个已选中",
  "AJXG3C": "暂无策略",
  "UOCLhC": "1 条策略",
  "J/UkMD": "{count} 条策略",
  "DRWfAe": "复制选中项",
  "CA09f6": "合并为新策略",
  "1sODf+": "删除选中项",
  "0h4MAj": "导航",
  "kQAf2d": "选择",
  "+TsRJH": "永久删除 \"{name}\"？此操作无法撤销。",
  "h12Fxr": "删除策略",
  "qCe51a": "永久删除 {count} 个策略？此操作无法撤销。",
  "iXNbPf": "重命名",
  "4fHiNl": "复制",
  "ZDo+Xb": "展平",
  "AVI/0j": "拆分",
  "M56d6a": "选项卡",
  "bwAKk1": "切换至选项卡 1-10",
  "PPJSRo": "上一个选项卡",
  "cEiT8I": "下一个选项卡",
  "9a2ShG": "新建选项卡",
  "HqPKrA": "关闭选项卡",
  "nyPHb+": "复制选项卡",
  "zGHadw": "策略",
  "Kx4w9M": "撤销更改",
  "Hhi+or": "切换图表/衰减",
  "xmcVZ0": "搜索",
  "0ajICy": "显示快捷键",
  "Rq6Tqd": "取消/关闭",
  "nFkLBj": "键盘快捷键",
  "046zjm": "日志",
  "ywDLaG": "回测",
  "GZJpDf": "分析",
  "zeXJCp": "多维",
  "D3idYv": "设置",
  "FZYEr3": "关闭此标签页？",
  "9X3q96": "未保存的更改",
  "19aJ+B": "\"{name}\"将被丢弃。此操作无法撤销。",
  "N33YMo": "\"{name}\"有未保存的更改。",
  "0sbMLZ": "保存并关闭",
  "Kteb0h": "丢弃并关闭",
  "0h/lPM": "升级",
  "70pJmB": "格式化",
  "nV0wNv": "源文本",
  "Wufzvy": "目录",
  "IVA/60": "上一篇",
  "FhjNv/": "下一篇",
  "MyIJbr": "目录",
  "BOPse5": "删除文章",
  "Gr/m46": "文章操作",
  "Lbo63c": "移至...",
  "fmEG05": "永久删除“{title}”？此操作无法撤销。",
  "js+IVa": "{number} 章",
  "0kK7Va": "将 \"{title}\" 移入此书的另一章节。",
  "yaw62S": "此书只有一章 — 请创建另一章以便在它们之间移动文章。",
  "ZrO1i3": "正在移动...",
  "X3134H": "无法移动。请重试。",
  "kJ5W29": "您",
  "ATohnZ": "市场价格",
  "ug01Mk": "时间",
  "tgvES0": "当前",
  "zdN8I5": "到期",
  "pGCnGm": "多维期权曲面",
  "I+TzDu": "在模拟器中构建策略，开始进行3D可视化。",
  "McP47I": "前往模拟器",
  "tfGFyx": "等待实时报价...",
  "aE0A50": "把期权，理解为",
  "0CLczI": "结构",
  "qYDijq": "是面向期权交易者的教育模拟器与分析工具。任何对期权感兴趣的人——从初学者到想测试新结构的老手——都能在不投入任何真金白银的前提下，构建一套策略、查看其风险形态，并理解背后的数学原理。",
  "6WB03m": "解读名称",
  "kLUUWf": "名称以希腊字母书写。每个字母都直接对应域名中的一个字母。",
  "wNlUn8": "alpha · 小写",
  "q52MZB": "beta · 小写",
  "kHHWYG": "Gamma · 大写",
  "RTq3Yj": "为何使用希腊字母",
  "yBIHRM": "α、β、Γ——连同 Δ、Θ、ν——正是交易者用来描述期权头寸行为的希腊字母：对价格、曲率、时间与波动率的敏感度。这个名字提醒我们真正在意的是什么：是风险的结构，而不是盈利的大小。",
  "+jAZf/": "标志中的希腊字母并非装饰，它们是期权的语言：Delta 代表方向，Gamma 代表曲率，Theta 代表时间衰减，Vega 代表波动率敏感度。您持有的每一个期权头寸，在这几个维度上都有各自的读数。",
  "J46MY6": "期权常常只以结果的形式呈现——利润、亏损、“+500% 的一笔交易”——而不是作为可以被理解的结构。我们名字中的希腊字母正是要提醒我们真正在意的是什么：把底层机制讲清楚，让交易者问出的第一个问题是“我的风险是什么形态？”——而不是“我能赚多少？”",
  "gy4m8V": "这是什么",
  "5IeQDZ": "策略模拟器 — 构建多腿期权头寸，查看盈亏曲线、希腊字母与盈亏平衡点。",
  "mWZkux": "学习环境 — 关于 Theta、价差、蝶式与风险的原创课程。",
  "Wl81EY": "分析界面 — 回测、净值曲线、夏普比率和索提诺比率、月度热力图。",
  "hnIcFQ": "交易日志 — 用于记录可以从中学习的决策、笔记和结果。",
  "Ea8obV": "这不是什么",
  "4m8fg7": "不是经纪商。我们不向任何交易所发送订单。",
  "ulwEvZ": "不是基金。我们不接受存款，也不代表您管理资金。",
  "Ys/3BC": "不是投资平台。本产品中的任何内容都不承诺或暗示任何回报。",
  "vLmakr": "与任何借用字母“abg”或“αβΓ”进行招揽的加密货币项目、信号群组，或 Telegram / WhatsApp / 微信推销活动均无关联。",
  "UuGg8R": "谁构建了它",
  "NbOoMm": "由一支小团队的交易者和工程师打造——他们做的正是自己当年学习时希望能有的模拟器与课程。我们在公开环境中工作，持续发布小幅改进，并把用户的每一次误解都当作我们自己需要修复的问题。",
  "Y92mVP": "阅读理念",
  "p1SM+f": "范围与安全",
  "d82w2J": "创建免费账户",
  "zE1J/t": "理念",
  "c8LnNR": "让人人都能看懂期权。",
  "Yn1zfv": "专注的学习环境，助您在入市前建立判断力。",
  "3fW0YY": "三大支柱",
  "iOYsHZ": "交易前先了解",
  "ursAWa": "入市前了解规则、风险及仓位结构。",
  "bN57w4": "识别风险，而非放大收益",
  "jHSbZC": "期权不是用来赌博的工具，而是用于管理不确定性。我们帮您看清一笔交易的成本，而不仅仅是它可能带来的回报。",
  "kaNTJF": "降低犯错的代价",
  "DuitYg": "少一次误判胜过一次侥幸。知识会复利，运气不会。",
  "5QiO1i": "宣言",
  "O/7+3q": "期权并非少数人的工具，而是大多数人未被教会如何使用的工具。",
  "bwxagR": "是专注于期权认知与风险理解的学习环境，旨在帮助您在投入真实资金之前，先建立起基本的判断力。",
  "S5C+tL": "开始理解期权",
  "u3X7Ik": "先理解风险",
  "yDSQO8": "用认知取代运气",
  "wGhqrf": "关于我们",
  "vL7XoS": "重要声明",
  "nRoyFi": "安全与范围",
  "5EyE6F": "最后更新 · 2026年4月",
  "TEssE0": "是一款教育用途的模拟器与分析工具。本页面旨在明确我们的范围——因为字母“abg”与“αβΓ”也被一些与我们毫无关联的项目所使用，我们不希望任何人对本产品产生混淆。",
  "kWtj2V": "面向学习者和经验丰富的交易者的教育期权模拟器。",
  "24SkLu": "用于根据历史市场数据回测策略的分析界面。",
  "ufiTvD": "课程体系 — 关于希腊字母、价差、蝶式期权与期权风险的原创课程。",
  "wVRDa9": "用于记录决策和复盘结果的交易日志。",
  "ziHhG6": "不是经纪商。我们不向任何交易所或交易对手路由订单。",
  "yibXkM": "不是基金。我们不接受任何人的存款或代表任何人管理资金。",
  "5CJa6k": "不是信号服务。我们不告诉任何人买什么、何时买、或以什么价格买。",
  "fvsiME": "不是投资平台。本产品中的任何内容均不承诺或暗示回报。",
  "Rbmgep": "与任何借用字母“abg”或“αβΓ”、要求存款或承诺获利的加密货币项目、Telegram 群组、WhatsApp 频道、微信群或 Discord 服务器无关。如果有人自称代表我们，并将您引导至此类群组：那不是我们。",
  "Qlt8Wb": "我们不",
  "TVHHGg": "接受任何形式的存款。",
  "2tO/6R": "承诺、暗示或保证任何策略的任何回报。",
  "11rVXI": "通过社交平台主动联系用户，提供“VIP通道”或“信号群”。",
  "N6agSX": "有授权的联盟代表我们收取款项。",
  "u2lCoU": "您是否收到联系",
  "fVgOUG": "有人冒用我们的名义？",
  "irYx8B": "请将对话截图与对方账户一并发送至 support@getabg.one。我们会核实对方是否与我们有关（几乎可以肯定无关），并会公开列出已知的冒充账户，方便其他用户警惕与规避。",
  "vZd74i": "联系安全团队",
  "0SM/Ve": "风险披露",
  "mLoMtg": "期权交易复杂，可能造成超过投资金额的损失。您用真实资金做出的每一个决定，均由您自行承担责任。",
  "07U0ps": "中的任何内容——无论是模拟、课程、分析或其他——都不构成交易建议。在以真实资金交易期权之前，请咨询您所在司法管辖区的持牌金融顾问。",
  "LbU6c8": "教育理念",
  "VCMKbt": "收件箱",
  "BX5BGP": "目前没有新消息",
  "09BbRR": "新消息会显示在这里",
  "aT5Flo": "{count} 条未读",
  "OCzXq7": "{count} 条消息",
  "p2fpU2": "您的第一个策略已保存。",
  "9zHEwE": "期权练习，从这里开始。",
  "GCUmmc": "查看日志",
  "LjAS+D": "尝试回测",
  "3CISeJ": "我自己摸索",
  "Q+8ExB": "新手引导完成",
  "BMtot+": "选中铁蝶和破翼蝶式，然后点“下一步”。",
  "mew7u1": "好的。现在点“+策略”按钮，再添加一个破翼蝶式。",
  "htBPP3": "把两个破翼蝶式设为相反方向——一个朝“上”，另一个朝“下”。",
  "HA+deI": "很好。把您的第一个策略保存下来吧。",
  "Gr5171": "这里是您的交易日志。每一个保存过的策略，都会在这里生成一条规划条目。",
  "H5k7At": "回测会用多年的 SPX 历史数据跑一遍您保存的策略，看看它过去的表现如何。",
  "v7WsIb": "开始搭建您的第一个策略。",
  "cAWbUJ": "大约一分钟即可完成，随时可以跳过。",
  "PVe26p": "开始",
  "gZ+1P9": "跳过引导",
  "+dLAnb": "预估总计",
  "Nn048e": "$58",
  "ApCNdR": "1 个月",
  "Y8IOas": "$0.99/天",
  "EKV979": "$1.93/天",
  "/kvFI4": "超值套餐",
  "jO008B": "更多功能",
  "j8V0ws": "实时模拟器控件、进阶策略参数旋钮，以及自定义登录 PIN。",
  "6NJc2H": "无限回测",
  "JM70UE": "在多年真实 SPX 数据上运行您的策略，全面扫描敏感度，并按星期几、月份和波动率类型拆解表现。",
  "h757df": "解答您的问题，针对您的策略给出洞察，并直接为您执行相应操作。",
  "A98E+C": "可视化策略结构构建器",
  "9lPIw0": "通过直观的图形界面，自由构建和调整策略逻辑。",
  "n7m92O": "数据分析",
  "b4hL7j": "从多个维度剖析策略表现，洞察收益来源、风险分布与优化机会。",
  "hjcrWM": "日志系统",
  "fMuAJa": "完整记录策略与关键事件，方便回溯决策与操作。",
  "s2XIgr": "显示详情",
  "X5Q310": "隐藏详情",
  "ja7XBf": "安装 αβΓ✻1",
  "/Gmbfp": "轻触",
  "3pcopg": "然后“添加到主屏幕”",
  "q3FTFW": "添加到主屏幕以获得完整的应用体验",
  "ubmFc8": "安装",
  "f3SJnH": "启用中...",
  "dZWgSQ": "开启推送提醒",
  "Sc/QN5": "通知已被屏蔽，请在浏览器设置中开启",
  "hIHeqt": "剩余 1 天",
  "HAtMf2": "1 位推荐",
  "VA/Z1S": "隐藏",
  "K7AkdL": "显示",
  "0oL1zz": "已复制！",
  "u5aHb4": "复制链接",
  "Q5Sgak": "该 PIN 已被使用 — 请换一个。",
  "Q2aQbw": "必须为 6 位字母数字字符",
  "+OtV6h": "PIN 更新失败。",
  "J+02wx": "您的账户需要续费",
  "syp54I": "明天到期",
  "GAQtLV": "{days} 天后到期",
  "ZSAr7w": "剩余 {days} 天",
  "6caMaA": "推荐码",
  "WZWbrp": "{count} 位推荐",
  "nZJqb9": "分享此链接邀请好友，双方都将获得奖励天数。",
  "/gImBv": "使用深色背景主题",
  "hMUQH5": "深色",
  "BY7vjL": "在英语和中文之间切换",
  "y1Z3or": "语言",
  "n+2mRW": "为盈亏交换红绿颜色",
  "Dxz5va": "翻转 ",
  "vAyQap": "利润",
  "XIbwNE": " / ",
  "hcmJ3s": "亏损",
  "VedtZs": "颜色",
  "+NKMAc": "查看所有键盘快捷键",
  "vzYPVX": "键盘快捷键",
  "Ngnq4K": "锚定至市场",
  "afkFAN": "您的策略将锚定至市场。交易时段内为实时SPX价格；交易时段外为最近收盘价。所有行权价、收益和计算均以市场价格为基础。",
  "eJiZz9": "这不是一笔交易。没有买卖发生。",
  "taAeCh": "我们不是经纪商，也不对接任何经纪商。",
  "C1GqY0": "这是一款教育工具，您只是在自行探索策略。",
  "JcmUf3": "显示的市价来源于近期数据，可能延迟于实时交易所。",
  "87M0uj": "历史业绩与模拟结果并不代表未来表现。",
  "orvpWh": "返回",
  "Zct5E1": "锚定至市场",
  "OFJRb5": "贷记",
  "kCckrX": "借记",
  "GCY0dr": "市场",
  "/A3g/O": "价差",
  "XuKi2x": "市场隐含波动率",
  "JfDsQZ": "编辑腿",
  "ss6kle": "重置为默认值",
  "55md55": "删除腿",
  "Soc+LF": "盈亏平衡点",
  "esmm2w": "最大利润",
  "Rz3USJ": "最大亏损",
  "8XzeY5": "市场数据可用",
  "+S8HNF": "恢复默认颜色",
  "D3jS9h": "拆分为新策略",
  "v8B8F6": "上",
  "V9URnj": "较低",
  "KtEZXn": "多头",
  "juU558": "空头",
  "f+GKc4": "看涨",
  "HTYkFc": "看跌",
  "vRTZ4K": "反向",
  "WhCw5t": "条式",
  "UvJpJt": "带式",
  "CHPD2W": "名称（可选）",
  "ViEXjK": "重置为默认值",
  "zz6ObK": "恢复",
  "I/KeXM": "删除层",
  "frfRjz": "重置腿",
  "oLVyck": "组合",
  "1mXwUz": "市场IV",
  "zeBMWn": "预估IV",
  "mk9OQu": "腿",
  "aZOPsZ": "重命名策略",
  "9VpqFd": "为此策略命名",
  "OIU/70": "保存策略",
  "Fj+X+3": "策略名称...",
  "G/yZLu": "移除",
  "535i2y": "减少数量",
  "gXeH2D": "增加数量",
  "0ieEMW": "保存并覆盖",
  "X5VkMo": "另存为副本",
  "sLnDOb": "放弃更改",
  "uqG5cv": "确定要放弃所有尚未保存的更改吗？",
  "Wfatyy": "无参数可调 — 加载后配置腿",
  "5xeJ1c": "净贷记",
  "N8n+MV": "净借记",
  "nEMQl2": "最差",
  "9mI1wt": "策略编辑器",
  "LytP7C": "模拟盈亏",
  "zg8/dK": "策略选择器",
  "1G15DZ": "时间衰减",
  "GSSEg4": "盈亏图拖拽已锁定",
  "UsPknq": "锁定盈亏图拖拽",
  "psi9Qd": "选择一种策略即可查看盈亏图",
  "Ia/CZp": "保存失败，请重试。",
  "RSdGvw": "删除失败，请重试。",
  "QVtFOj": "数据加载失败，请重试。",
  "NQREOs": "更新失败，请重试。",
  "qGc0qW": "该项目已存在。",
  "YPPpwY": "无法删除——该项目仍在使用中。",
  "yluQWn": "未找到相关项目，可能已被删除。",
  "xhjcHL": "请求过于频繁，请稍后再试。",
  "v7s25K": "请先登录后再继续。",
  "wX+jrn": "您无权执行此操作。",
  "X8G8je": "此 PIN 已被占用，请换一个。",
  "G18mTN": "该邮箱对应的账户已存在。",
  "nRzzEa": "连接已断开，请检查网络后重试。",
  "owYnPh": "无法开始结账。请重试。",
  "eLHxis": "导入失败，请检查文件后重试。",
  "iLqkuN": "永续",
  "a1UOjm": "{count} 笔交易已导入",
  "Yj5wok": "导入失败",
  "ttXUMO": "小红书",
  "Gfix8D": "B站",
  "zuA3Bg": "YouTube",
  "39PtLD": "Instagram",
  "/VnDMl": "其他",
  "TFfDPW": "潜在客户",
  "6O9OMe": "已联系",
  "TP/cMX": "结束",
  "WxYHUj": "备兑看涨期权",
  "vhPJcA": "现金担保卖出看跌期权",
  "JA5EZS": "牛市看涨价差",
  "K8ZzHW": "熊市看跌价差",
  "BAIs+v": "牛市看跌价差",
  "yYnHyH": "熊市看涨价差",
  "zGfAc4": "铁鹰",
  "EZo0jy": "铁蝶",
  "EafK35": "蝶式",
  "8qhcGp": "破翼蝶式",
  "mndiAJ": "多头鹰式",
  "pC/mCh": "空头鹰式",
  "P3esPL": "玉蜥蜴",
  "A/jDOX": "比例反向价差",
  "LRUyIp": "比例价差",
  "S0rkLz": "牛市看涨阶梯",
  "Q70WOv": "熊市看涨阶梯",
  "LxGacl": "牛市看跌阶梯",
  "LspYOE": "熊市看跌阶梯",
  "7sjUNb": "合成期货",
  "GVauyJ": "组合",
  "COs1u/": "价内宽跨式",
  "sy4hXI": "时间价差",
  "AdnNe+": "双重时间价差",
  "mS8WNh": "跨式",
  "zLk4mQ": "宽跨式",
  "Sjo1P4": "自定义",
  "inBVoA": "新建策略",
  "btOI+Z": "新标签页",
  "WNqryT": "单腿",
  "aPQRlz": "备兑",
  "D3gsD+": "垂直价差",
  "f4M5gO": "多腿",
  "gJkHZk": "收入",
  "EAwHkJ": "比例/阶梯",
  "7iztjK": "合成",
  "JjhYeA": "基于时间",
  "EHsGJ+": "波动率",
  "C9yvWo": "单腿看涨期权。\n\n**多空切换**： 买入（看涨，上行空间无限）或卖出（收取权利金，裸卖=风险无限）。\n\n**行权价偏移** — 相对于标的资产的带符号距离。负数 = 低于标的，正数 = 高于标的。",
  "vcc2uj": "单腿看跌期权。\n\n**多空切换**： 买入（看跌，下行空间利润大）或卖出（收取权利金，被行权风险大）。\n\n**行权价偏移** — 相对于标的资产的带符号距离。负数 = 低于标的，正数 = 高于标的。",
  "bVemTJ": "持有正股的多头头寸，同时卖出一张看涨期权，用权利金对冲部分上行收益。\n\n**看涨期权偏移** — 卖出看涨腿距标的资产价格上方的距离。越高 = 需要更大的上涨才会被行权。",
  "cot1cd": "卖出看跌期权，同时备好现金以在更低价位接货。价格下跌前先收取一笔权利金。\n\n**看跌期权偏移** — 卖出看跌腿距标的资产价格下方的距离。越高 = 被指派时买入价越低，但收到的权利金也越少。",
  "OEeEBp": "借记价差——价格上涨时获利。买入一张看涨期权，同时以更高行权价卖出另一张看涨期权以抵消部分成本。\n\n**多头偏移** — 买入看涨腿相对于标的资产的位置。\n\n**空头偏移** — 卖出看涨腿相对于多头腿的距离。越宽 = 最大利润越大，成本也越高。",
  "n+ZanB": "借记价差——价格下跌时获利。买入一张看跌期权，同时以更低行权价卖出另一张看跌期权以抵消部分成本。\n\n**多头偏移** — 买入看跌腿相对于标的资产的位置。\n\n**空头偏移** — 卖出看跌腿相对于多头腿的距离。越宽 = 最大利润越大，成本也越高。",
  "8j3AVr": "贷记价差——价格维持在卖出行权价之上时获利。\n\n**空头偏移** — 卖出看跌腿相对于标的资产价格的位置。越近 = 权利金越多，风险越大。\n\n**多头偏移** — 买入看跌腿相对于卖出腿的保护距离。越宽 = 贷记越多，风险也越大。",
  "QhLfp7": "贷记价差——价格维持在卖出行权价之下时获利。\n\n**空头偏移** — 卖出看涨腿相对于标的资产价格的位置。越近 = 权利金越多，风险越大。\n\n**多头偏移** — 买入看涨腿相对于卖出腿的保护距离。越宽 = 贷记越多，风险也越大。",
  "Mn0N9y": "两侧风险均已限定的贷记价差——价格维持在区间内时获利。\n\n**卖出看跌 / 买入看跌** — 标的资产价格下方的看跌贷记价差。\n\n**买入看涨 / 卖出看涨** — 标的资产价格上方的看涨贷记价差。\n\n**多空切换**： 在卖出（收取贷记）与买入（支付借记）之间切换。",
  "x5IXm/": "以平值卖出波动率价差，外侧加保护性蝶翼。价格停留在平值时拿到最大权利金。\n\n**蝶翼宽度** — 外侧买入腿与平值卖出腿之间的距离。越宽 = 最大利润越大，但保护越弱。\n\n**偏斜** — 将中心行权价移离平值。\n\n**多空切换**： 在卖出（卖出平值、买入蝶翼）和买入（买入平值、卖出蝶翼）之间切换。",
  "yassuy": "价格停留在中心行权价附近的低成本押注。使用同一种期权类型的三条腿。\n\n**蝶翼宽度** — 中心行权价到外侧行权价的距离。越宽 = 利润区越大，但成本也越高。\n\n**多空切换**： 买入蝶翼（多头蝶式）或卖出蝶翼（空头蝶式）。\n\n**期权类型切换** — 用看涨或看跌构建（到期盈亏相同，但希腊字母不同）。",
  "vFD6p2": "左右宽度不对称的蝶式。构建得当时可以以小额贷记建仓。\n\n**空头 1 / 空头 2 偏移** — 两条卖出腿之间的距离。\n\n**多头蝶翼偏移** — 较宽一侧的延伸距离。\n\n**方向切换** — 将额外宽度偏向下方或上方。",
  "1O/2Tc": "用同一种期权类型的四条腿构成的区间押注，风险已限定。价格保持在主体区间内时获利。\n\n**下主体 / 上主体** — 内侧行权价（利润区）的偏移。\n\n**蝶翼宽度** — 外侧保护腿与主体区间之间的距离。\n\n**期权类型切换** — 用看涨或看跌构建。",
  "+v+2r3": "用同一种期权类型卖出的铁鹰。价格大幅移出主体区间外时获利。\n\n**下主体 / 上主体** — 内侧行权价的偏移。\n\n**蝶翼宽度** — 外侧行权价的距离。\n\n**期权类型切换** — 用看涨或看跌构建。",
  "nQaOAs": "裸卖看跌 + 看涨贷记价差。构建得当时可以只收权利金、不承担上行风险。\n\n**裸卖腿偏移** — 裸卖看跌腿的位置。\n\n**价差空头 / 价差多头偏移** — 看涨贷记价差两条腿的行权价。\n\n**方向切换** — 标准方向（裸卖看跌 + 看涨价差）或反向（裸卖看涨 + 看跌价差）。",
  "VLsE2H": "卖出一张近价期权，买入两张更深虚值的期权。价格朝一个方向大幅移动时获利。\n\n**空头偏移** — 近价卖出腿的位置。\n\n**多头偏移** — 两条买入腿的位置。\n\n**期权类型切换** — 用看涨（看多）或看跌（看空）构建。",
  "4Ivw24": "买入一张近价期权，卖出两张更深虚值的期权。价格停留在卖出行权价附近时获利。\n\n**多头偏移** — 近价买入腿的位置。\n\n**空头偏移** — 两条卖出腿的位置。超出卖出行权价后风险无限。\n\n**期权类型切换** — 用看涨或看跌构建。",
  "W70NGU": "牛市看涨价差 + 额外一条更高行权价的裸卖看涨。多收一笔贷记，但同时引入无限的上行风险。\n\n**多头偏移** — 买入看涨腿的行权价。\n\n**空头 1 / 空头 2 偏移** — 上方两条卖出看涨腿的行权价。间距越宽 = 利润区越大，风险也越大。",
  "TnxQmk": "卖出一张看涨，买入两张更高行权价的看涨。方向看跌，但在价格大幅上涨时提供保护。\n\n**空头偏移** — 卖出看涨腿的行权价。\n\n**多头 1 / 多头 2 偏移** — 两条用于保护的买入看涨腿。",
  "xD1Ig0": "卖出一张看跌，买入两张更低行权价的看跌。方向看涨，但在价格大幅下跌时提供保护。\n\n**空头偏移** — 卖出看跌腿的行权价。\n\n**多头 1 / 多头 2 偏移** — 两条用于保护的买入看跌腿。",
  "vwV/lY": "熊市看跌价差 + 额外一条更低行权价的裸卖看跌。多收一笔贷记，但同时引入较大的下行风险。\n\n**多头偏移** — 买入看跌腿的行权价。\n\n**空头 1 / 空头 2 偏移** — 下方两条卖出看跌腿的行权价。",
  "VFPPrH": "同一行权价上的多头看涨 + 空头看跌——用以复制正股的多头敞口。\n\n**行权价偏移** — 将合成头寸整体移离平值。\n\n**多空切换**： 合成多头（看涨）或合成空头（看跌）。",
  "c26r3t": "不同行权价的虚值看涨 + 虚值看跌——分裂式合成。\n\n**看涨期权偏移** — 看涨腿相对于标的资产的位置。\n\n**看跌期权偏移** — 看跌腿相对于标的资产的位置。\n\n**多空切换**： 买入组合（多头）或卖出组合（空头）。",
  "IdoOY1": "偏向看跌的波动率价差——同一行权价上 1 张看涨 + 2 张看跌。价格下跌时收益更高。\n\n**行权价偏移** — 将整体头寸移离平值。",
  "6q+V7w": "偏向看涨的波动率价差——同一行权价上 2 张看涨 + 1 张看跌。价格上涨时收益更高。\n\n**行权价偏移** — 将整体头寸移离平值。",
  "KiQVPf": "价内看涨期权 + 价内看跌期权 — 形似跨式，但两腿都在价内。权利金更高，盈亏平衡范围也更宽。\n\n**看涨期权偏移** — 看涨腿进入价内的深度。\n\n**看跌期权偏移** — 看跌腿进入价内的深度。\n\n**多空切换**： 买入两腿（多头价内宽跨式）或卖出两腿（空头价内宽跨式）。",
  "tjC73j": "日历或斜跨——卖出一张近月期权，买入一张远月期权。\n\n**行权价偏移** — 基础行权价相对于标的资产的位置。\n\n**偏斜** — 偏移远月行权价以构成斜跨；为零时即为日历。\n\n**近/远 DTE** — 两条腿各自的到期天数。\n\n**期权类型切换** — 用看涨或看跌构建。",
  "7rxxXe": "双边时间价差——下方一组看跌日历/斜跨，上方一组看涨日历/斜跨。\n\n**看跌 / 看涨期权偏移** — 两侧各自相对于标的资产的位置。\n\n**看跌 / 看涨期权偏斜** — 偏移远月行权价以构成斜跨。\n\n**近/远 DTE** — 两侧共用的到期天数。",
  "RXyLOF": "同一行权价上的平值看涨 + 平值看跌。价格朝任一方向大幅移动时获利（多头），或从时间衰减中获利（空头）。\n\n**多空切换**： 多头跨式（买入两腿，支付借记）或空头跨式（卖出两腿，收取贷记）。",
  "Xtwe6d": "虚值看涨 + 虚值看跌——盈亏平衡范围比跨式更宽，成本也更低。\n\n**看涨期权偏移** — 看涨腿相对于标的资产的位置。\n\n**看跌期权偏移** — 看跌腿相对于标的资产的位置。\n\n**多空切换**： 买入组合（多头）或卖出组合（空头）。",
  "VjeWK1": "从零开始构建属于您自己的结构。最多可添加 10 条腿，每一条都可以单独配置。\n\n使用 **腿编辑器** 设定每条腿的行权价、类型（看涨/看跌）、方向（多头/空头）与数量。",
  "/060cE": "蝶翼宽度",
  "MQ02gW": "偏斜",
  "0EezXf": "看跌期权偏斜",
  "HpX0Tp": "看涨期权偏斜",
  "DZ2Koj": "方向",
  "hUQV9B": "空头 1 偏移",
  "BTFWpP": "空头 2 偏移",
  "Kg6ptZ": "多头蝶翼偏移",
  "+VExbc": "卖出看跌期权",
  "Wcliju": "买入看跌期权",
  "YPIa+q": "卖出看涨期权",
  "l4M3QP": "买入看涨期权",
  "7xpfuy": "多空",
  "tSGyio": "看涨期权偏移",
  "JEocny": "看跌期权偏移",
  "rEI51g": "行权价偏移",
  "strikeOffsetHelp": "行权价偏移 — 相对于标的资产的带符号距离。负数 = 低于标的，正数 = 高于标的。",
  "longOffsetHelp": "多头偏移 — 买入腿相对于标的价格或策略中心的位置。",
  "shortOffsetHelp": "空头偏移 — 卖出腿相对于标的价格或配对买入腿的位置。",
  "callOffsetHelp": "看涨期权偏移 — 看涨行权价与标的价格的距离。越高 = 越高于标的。",
  "putOffsetHelp": "看跌期权偏移 — 看跌行权价与标的价格的距离。越高 = 越低于标的。",
  "wingWidthHelp": "蝶翼宽度 — 中心/主体到外侧蝶翼的距离。越宽 = 潜在收益更高，但保护更弱或成本更高。",
  "lowerBodyHelp": "下主体 — 策略中心到下方内侧行权价的距离。",
  "upperBodyHelp": "上主体 — 策略中心到上方内侧行权价的距离。",
  "skewHelp": "偏斜 — 将中心行权价移离平值。负数 = 下移，正数 = 上移。",
  "putSkewHelp": "看跌偏斜 — 移动看跌侧远月行权价。负数 = 下移，正数 = 上移。",
  "callSkewHelp": "看涨偏斜 — 移动看涨侧远月行权价。负数 = 下移，正数 = 上移。",
  "putShortHelp": "卖出看跌 — 卖出看跌行权价距离标的价格下方的距离。",
  "putLongHelp": "买入看跌 — 保护性买入看跌行权价距离标的价格下方的距离。",
  "callShortHelp": "卖出看涨 — 卖出看涨行权价距离标的价格上方的距离。",
  "callLongHelp": "买入看涨 — 保护性买入看涨行权价距离标的价格上方的距离。",
  "short1OffsetHelp": "空头 1 偏移 — 第一条卖出腿距离策略中心的距离。",
  "short2OffsetHelp": "空头 2 偏移 — 第二条卖出腿距离策略中心的距离。",
  "longWingOffsetHelp": "多头蝶翼偏移 — 买入蝶翼距离策略中心的距离。",
  "short1StrategyOffsetHelp": "空头 1 偏移 — 第一条卖出腿相对于策略中心的位置。",
  "short2StrategyOffsetHelp": "空头 2 偏移 — 第二条卖出腿相对于策略中心的位置。",
  "long1OffsetHelp": "多头 1 偏移 — 第一条买入腿相对于策略中心的位置。",
  "long2OffsetHelp": "多头 2 偏移 — 第二条买入腿相对于策略中心的位置。",
  "nakedLegOffsetHelp": "裸腿偏移 — 未保护卖出期权腿距离标的价格的距离。",
  "spreadShortOffsetHelp": "价差空头偏移 — 价差中卖出腿距离标的价格的距离。",
  "spreadLongOffsetHelp": "价差多头偏移 — 价差中保护性买入腿距离标的价格的距离。",
  "frontDTEHelp": "前DTE — 近月腿距离到期的天数。",
  "backDTEHelp": "后DTE — 远月腿距离到期的天数。",
  "dynamicStrikeOffsetSideHelp": "行权价偏移 — 当前方向：{side}。负数 = 低于标的，正数 = 高于标的。",
  "dynamicLongIronFlyWidthHelp": "蝶翼宽度 — 当前为多头铁蝶。外侧蝶翼为卖出腿；越宽给大幅波动留下更多空间，但通常会改变支付的借记。",
  "dynamicShortIronFlyWidthHelp": "蝶翼宽度 — 当前为空头铁蝶。外侧蝶翼为买入保护腿；越宽可能提高可收贷记，但保护更弱。",
  "dynamicIronFlySkewHelp": "偏斜 — 当前方向：{side}。负数将铁蝶中心下移，正数将铁蝶中心上移。",
  "dynamicLongButterflyWidthHelp": "蝶翼宽度 — 当前为多头蝶式。越宽会扩大目标区间，但通常成本更高。",
  "dynamicShortButterflyWidthHelp": "蝶翼宽度 — 当前为空头蝶式。越宽会扩大风险区间，并改变收取的贷记。",
  "dynamicPutShortOffsetHelp": "卖出看跌 — 当前方向：{side}。这条内侧看跌腿当前为{legSide}。",
  "dynamicCallShortOffsetHelp": "卖出看涨 — 当前方向：{side}。这条内侧看涨腿当前为{legSide}。",
  "dynamicPutLongOffsetHelp": "买入看跌 — 当前方向：{side}。这条外侧看跌腿当前为{legSide}。",
  "dynamicCallLongOffsetHelp": "买入看涨 — 当前方向：{side}。这条外侧看涨腿当前为{legSide}。",
  "dynamicShort1DirectionHelp": "空头 1 偏移 — 当前方向：{direction}。将第一条卖出腿移向该方向。",
  "dynamicShort2DirectionHelp": "空头 2 偏移 — 当前方向：{direction}。将第二条卖出腿进一步移向该方向。",
  "dynamicLongWingDirectionHelp": "多头蝶翼偏移 — 当前方向：{direction}。将较宽的保护蝶翼延伸到该方向。",
  "dynamicNakedDirectionHelp": "裸腿偏移 — 当前方向：{direction}。控制未保护的卖出期权腿。",
  "dynamicSpreadShortDirectionHelp": "价差空头偏移 — 当前方向：{direction}。控制限定风险价差中的卖出腿。",
  "dynamicSpreadLongDirectionHelp": "价差多头偏移 — 当前方向：{direction}。控制价差中的保护性买入腿。",
  "dynamicLongOffsetTypeHelp": "多头偏移 — 当前类型：{optionType}。控制买入的{optionType}腿。",
  "dynamicShortOffsetTypeHelp": "空头偏移 — 当前类型：{optionType}。控制卖出的{optionType}腿。",
  "dynamicStrikeOffsetTypeHelp": "行权价偏移 — 当前类型：{optionType}。负数 = 低于标的，正数 = 高于标的。",
  "dynamicSkewTypeHelp": "偏斜 — 当前类型：{optionType}。正数将远月腿移向平值，负数移离平值。",
  "dynamicCallOffsetSideHelp": "看涨期权偏移 — 当前方向：{side}。控制{side}看涨腿距离标的价格的距离。",
  "dynamicPutOffsetSideHelp": "看跌期权偏移 — 当前方向：{side}。控制{side}看跌腿距离标的价格的距离。",
  "dynamicPutSkewHelp": "看跌偏斜 — 正数将远月看跌腿移向平值，负数移离平值。",
  "dynamicCallSkewHelp": "看涨偏斜 — 正数将远月看涨腿移向平值，负数移离平值。",
  "+c77SN": "多头偏移",
  "li9/qa": "空头偏移",
  "toDIbF": "前DTE",
  "qQRKaD": "后DTE",
  "R9e9So": "下主体",
  "5vVtJV": "上主体",
  "+A3wWe": "多头 1 偏移",
  "yYCNM0": "多头 2 偏移",
  "L6fdl4": "裸腿偏移",
  "4pm/91": "价差空头偏移",
  "Q6xaHI": "价差多头偏移",
  "/TDl2v": "偏倚",
  "veDZ8/": "消费价格指数",
  "fCGF+k": "非农就业人数",
  "vWKXdA": "美联储利率决议",
  "OPqL8X": "生产者价格指数",
  "MnsFMC": "每周失业救济金申请人数",
  "a5o3nB": "Theta",
  "kDNmhM": "Delta",
  "Wb9Iyu": "Gamma",
  "urRYR+": "Vega",
  "ZTNRlu": "元旦",
  "OHVKBE": "元旦（调休）",
  "CUtJjT": "马丁·路德·金纪念日",
  "dGj8P2": "总统日",
  "Xilayx": "耶稣受难日",
  "dwDYvG": "阵亡将士纪念日",
  "KeXvKY": "六月节",
  "HUl+d1": "六月节（调休）",
  "JADIlZ": "独立日",
  "hMH9z7": "独立日（调休）",
  "7gB8c9": "劳动节",
  "AuH0Nu": "感恩节",
  "Zr6Dvg": "圣诞节",
  "3bWdwJ": "圣诞节（调休）",
  "vfdQ6k": "期权不是赌博",
  "VbqhS7": "90秒看懂Theta",
  "/FswN9": "期权买卖：无术语解释",
  "xClpEB": "股价不动时，期权价为何变动",
  "LgaCIc": "新手必知的风险指标",
  "32iyB5": "深入理解“价内”",
  "Qms25m": "新手亏损期权的主要原因",
  "MDXUo6": "新手交易者最廉价的错误",
  "++eaNE": "垂直价差：通俗解释",
  "tfmZ+h": "为何卖出期权不是“免费的午餐”",
  "cQzGhs": "铁鹰并非稳赚，原因如下",
  "RTPYk4": "30秒读懂盈亏图",
  "sAImSf": "构建价差的隐性成本",
  "WKFSmd": "信贷价差何时止盈",
  "tbwHsB": "临近到期时，Gamma为何比Delta重要",
  "bddbJz": "0DTE的利弊",
  "EhDe6R": "Vega风险：被忽视的希腊字母",
  "rxQ8ka": "低VIX下铁蝶有效，高VIX下失效的原因",
  "NknKSL": "到期日强平风险解析",
  "PbMXwi": "解读波动率期限结构",
  "XZssxz": "当Skew告诉你价格未曾透露的信息",
  "f+tUCU": "做市商对冲如何影响盘中SPX波动",
  "FJyeyH": "Theta衰减为何非线性",
  "cNp5pS": "预期波动率与隐含波动率的数学原理",
  "xkFLHQ": "多腿组合的投资组合Gamma敞口",
  "EAkPNG": "日历价差作为纯Vega交易",
  "1DKyjw": "何时比率价差优于垂直价差",
  "Nfl8Ww": "Skew套利：散户能做什么，不能做什么",
  "KBZGGd": "构建能应对跳空的Delta中性组合",
  "+ow4kj": "卖出期权结构中的隐性尾部风险",
  "iHFKZ/": "为何Theta策略的Sharpe比率失真",
  "R7dsI0": "各结构保证金效率排名",
  "2ARw45": "如何解读ABG盈亏图",
  "AcQXvH": "为何我们选择摇杆而非行权价输入",
  "r631Xy": "ABG 10秒生成铁蝶",
  "kgHEuy": "ABG分析页面如何帮助您进行仓位规模调整",
  "lvuX8f": "设置真正有效的智能提醒",
  "aWcWRL": "ABG回测演示",
  "4q53kx": "如何使用ABG的市场状态探测",
  "/4MjPl": "在ABG中规划次日交易的最快方法",
  "KSuw4M": "期权在于结构，而非预测",
  "5AoqPb": "为何互联网上的大部分期权内容很糟糕",
  "pbAG1O": "每个期权交易者都应学会解读的图表",
  "4L8JL7": "0DTE对您的风险的真实影响",
  "0VkRie": "无人教授却人人交易的策略",
  "Zh7IP2": "为何VIX并非您所想的那样",
  "hDH2vx": "交易者如何实际思考风险",
  "5sQXbo": "“安全”期权策略的迷思",
  "NAH+Su": "忘记PIN？",
  "T4VxQN": "加载中…",
  "VSQpKn": "未找到该 KOL",
  "tMyCya": "该资料可能已迁移或停用。",
  "23G7HW": "该邮箱已有账户。请尝试登录。",
  "yTwoDT": "邮箱格式无效。",
  "PDMXb5": "尝试次数过多。请稍后重试。",
  "+MpYzf": "请检查您的邮箱，PIN码已发送。",
  "nONnTw": "您的邮箱",
  "N01U3b": "发送我的PIN",
  "WHHWX+": "已有PIN？立即登录",
  "YL63Yu": "购买专业版访问权限",
  "sPQbeD": "新用户？免费注册",
  "r81YbZ": "运行Detect以揭示此价差结构性风险。",
  "16o8B6": "解锁Detect",
  "zAm3dJ": "分析中…",
  "nY3qZ4": "重新分析",
  "HJv0iT": "分析",
  "+xkfBd": "读取结构…",
  "fsB/4p": "已保存",
  "ia1YFT": "回测",
  "e61Jf3": "即将推出",
  "EsyykW": "或",
  "Ntjkqd": "或",
  "nYrQd6": "you@email.com",
  "a3azUi": "滚动到功能",
  "ZnAHLW": "DM合成器尚未连接",
  "nbTIxq": "入门流程尚未连接",
  "wjbsVT": "代码、支付和活动部分即将推出。",
  "Itktvr": "代码铸造端点未连接",
  "aFyK+q": "QR码生成等待qrcode.react安装",
  "VAdNNz": "发送失败",
  "eKEL/g": "挂单",
  "mxjs8g": "已执行",
  "bJo75o": "未执行",
  "ZOeQK5": "当前 PIN 不匹配。",
  "dyElqO": "到期日",
  "iex2YB": "代码",
  "x/oJ17": "到期日",
  "8OtX8p": "天数",
  "tiTwYW": "天前",
  "uhe98j": "市场日历",
  "q6/I2V": "美股节假日 + 宏观数据发布 (FRED)。",
  "g8o2L3": "节假日",
  "gk3x/E": "更多",
  "hM9izU": "美股休市 (NYSE 节假日)",
  "74Vqk2": "无数据发布。",
  "6/aEFZ": "即将发布",
  "lDjMdp": "无即将发布。",
  "QqLawE": "无效的合约代码格式",
  "H6RJID": "发现尝试次数过多。请稍后再试。",
  "DljV7+": "未找到 {symbol} 的数据",
  "x3Jkca": "搜索合约代码…",
  "hunwkF": "按 Enter 添加 {symbol}",
  "rezLUu": "正在查询 {symbol}…",
  "irrBrQ": "正在加载市场数据…",
  "QRccCM": "未找到页面",
  "PiXTBV": "找不到您要查找的内容。",
  "DRXWXB": "404",
  "stj46b": "页面已失效",
  "MS5WWk": "您追踪的链接可能已过期、输入错误或不再指向任何有效内容。",
  "HaJFP2": "返回模拟器",
  "bVttEp": "尚未渲染演示视频。请从下方选择脚本或场景，并在您的笔记本电脑上运行命令。",
  "QCxm5a": "404 · 盘外",
  "iZNmMF": "页面已脱链。",
  "2rme/A": "链接可能已过期、输入错误，或指向我们不再支持的持仓。请重新生成并从上次中断处继续。",
  "mNAfKI": "或 登录",
  "wdHd1F": "尝试次数过多。请等待一分钟后重试。",
  "X02lYY": "登录失败。请重试。",
  "AufGsR": "无匹配项。请输入有效代码以添加。",
  "hUL+tI": "输入代码进行搜索。",
  "yFfDtT": "添加 {symbol}",
  "rAoKdW": "放弃此标签页?",
  "EPbatK": "确定要放弃此选项卡吗？此操作无法撤销。",
  "+DThNg": "多选",
  "hT6s55": "空间：收益无限，风险限权利金。",
  "WVcFCP": "空间：收益有限较大，风险限权利金。",
  "eUZMmu": "空间：短看涨上方收益封顶，持股下跌风险。",
  "ajwHje": "空间：收益限权利金，接货后下跌风险。",
  "+k9ZDz": "空间：价差宽度减净支出，净支出。",
  "GjHD9R": "空间：净权利金，价差宽度减权利金。",
  "eOctaZ": "空间：净权利金，单侧价差宽度减权利金。",
  "a2EjMw": "空间：净权利金，翼宽减权利金。",
  "1pKkab": "空间：翼宽减净支出，净支出。",
  "pWt44h": "空间：短腿区域净收益峰值，宽翼侧尾部风险。",
  "Sl3Ygx": "空间：中间区宽度减净支出，净支出。",
  "nJW7Nk": "空间：净权利金，裸看跌下行风险。",
  "6Qe3LN": "空间：突破方向收益，短长腿之间亏损峰值。",
  "G1M7Ox": "空间：短腿附近收益峰值，额外裸短腿尾部风险。",
  "BDxaYu": "空间：第一短看涨附近收益峰值，上行裸短看涨风险。",
  "WZUvmf": "空间：低于短看涨保留净权利金，短看涨到长看涨区间亏损。",
  "qEkyM4": "空间：高于短看跌保留净权利金，短看跌到长看跌区间亏损。",
  "QD7g6y": "空间：第一短看跌附近收益峰值，下行裸短看跌风险。",
  "38uU0H": "空间：方向线性收益，反向线性亏损。",
  "GT69EH": "空间：分裂行权价方向收益，反向线性亏损。",
  "CMyXFE": "空间：大幅波动收益且偏下行，净支出。",
  "JoFrp5": "空间：大幅波动收益且偏上行，净支出。",
  "0M93ge": "空间：大幅波动收益，净支出。",
  "riWjqV": "空间：近月归零且远月保值，净支出。",
  "0l18+O": "空间：任一目标区近月归零且远月保值，净支出。",
  "WdHGSd": "空间：净权利金，双侧裸卖风险。",
  "vrZUHF": "单腿任意方向自定义搭建。",
  "kNo9Ur": "默认借方",
  "mLvz+r": "贷方",
  "MxD6vP": "借方",
  "VRJBzY": "默认贷方",
  "EJXzwi": "可借可贷",
  "ud47iB": "通常借方",
  "l2cWpA": "通常贷方",
  "8MHCc/": "现金流自定",
  "biasBullish": "看多",
  "biasBearish": "看空",
  "fRvWNw": "看多 · 涨破盈亏平衡后获利",
  "cGtk7F": "看空 · 跌破盈亏平衡后获利",
  "yj3Ek7": "持股偏多 · 价格不涨破卖出看涨时获利",
  "zq/VPt": "偏多接货 · 价格守在卖出看跌上方时获利",
  "3go0FC": "看多 · 价格涨过上方卖出行权价时接近最大获利",
  "iDg/un": "看空 · 价格跌破下方卖出行权价时接近最大获利",
  "lHYKP1": "温和看多 · 价格守在卖出看跌上方时获利",
  "0dHz6I": "温和看空 · 价格守在卖出看涨下方时获利",
  "Zn6aWZ": "区间震荡 · 价格留在两个卖出行权价之间时获利",
  "BT6fmR": "贴近平值 · 获利靠近平值中心",
  "oqRva+": "价格钉住 · 获利停在中间行权价附近",
  "aJ8KXm": "偏破翼侧 · 价格靠近卖出行权价区域时获利",
  "YWH1k0": "中性区间 · 获利留在中间区间",
  "WmZDhK": "突破区间 · 获利脱离中间区间",
  "tRkOea": "偏多收租 · 价格高于卖出看跌且不突破看涨价差时获利",
  "AgBPp6": "单边突破 · 获利大幅移动",
  "HdAv0u": "靠近卖出腿 · 价格靠近卖出行权价区域时获利",
  "lrvcmZ": "温和看多 · 价格温和上涨时获利",
  "RqIcf6": "偏空 · 价格下行或停在卖出行权价下方时获利",
  "Puavpz": "偏多 · 价格上行或停在卖出行权价上方时获利",
  "1KymZh": "温和看空 · 价格温和下跌时获利",
  "IMd6jS": "多空切换 · 获利方向判断正确",
  "To5w2b": "偏空波动 · 获利大幅波动且偏下跌",
  "UAxQ4R": "偏多波动 · 获利大幅波动且偏上涨",
  "IAOgey": "押注波动 · 获利大幅波动",
  "Nlbz9u": "时间衰减 · 获利近月衰减快且靠近目标",
  "NhydAG": "双侧时间衰减 · 获利靠近两侧目标区",
  "3U2JDX": "低波动 · 获利价格贴近平值",
  "I0Evzm": "宽区间低波动 · 获利价格留在两腿之间",
  "MC0LHc": "任意单腿 · 获利随买卖方向变化",
  "zDV36j": "现金流可变",
  "qcpyb/": "这类结构可能是借方也可能是贷方，取决于参数、行权价距离和当时的期权价格。若净支付是借方；若净收取是贷方。",
  "LIxF3y": "贷方现金流",
  "We/i1W": "建仓时会净收取权利金，现金先流入。收益通常来自保留权利金，风险取决于保护腿、裸卖腿和价差宽度。",
  "Pio7S3": "借方现金流",
  "2VANPF": "建仓时需要净支付权利金，现金先流出。之后的最大风险通常以这笔净支出为基础，最大获利取决于策略结构。",
  "jDpwch": "最大获利",
  "zETXS9": "最大风险",
  "NB1boO": "欢迎来到",
  "OJnd0s": "从模拟器引导开始，或继续前往 {destination}。",
  "zWg38Y": "您的工作区已准备就绪。可以先打开模拟器，也可以继续前往 {destination}。",
  "1TUXHn": "开始模拟器引导",
  "Zgurtq": "打开模拟器",
  "M4evMK": "继续前往 {destination}",
  "addedStrategyButton": "已添加",
  "continueAddingStrategyButton": "继续添加",
  "scenarioInputsLinked": "参数已关联",
  "scenarioInputsIndependent": "参数已断开关联",
  "scenarioInputsExpiration": "到期",
  "scenarioInputsIV": "隐含波动率",
  "scenarioInputsCurrentHelp": "跳到当前模拟时间",
  "scenarioInputsExpirationHelp": "跳到期权到期时间",
  "scenarioInputsPriceHelp": "用于场景计算的标的价格",
  "scenarioInputsIVHelp": "用于场景计算的隐含波动率",
  "scenarioInputsTimeToExpiration": "到期时间",
  "scenarioInputsStockPrice": "股价",
  "scenarioInputsTimeHelp": "控制场景处在当前到到期之间的哪个时间点。越接近到期，越能看到时间衰减对策略的影响；跳到到期则查看到期盈亏图。",
  "scenarioInputsStockPriceHelp": "此场景使用的标的股价。移动它可以查看价格上涨或下跌时，策略盈亏如何变化。",
  "scenarioInputsImpliedVolatilityHelp": "隐含波动率是期权定价中使用的市场预期波动水平。移动它可以查看到期前波动率变化对模拟盈亏的影响。",
  "scenarioInputsReturnToLivePrice": "回到实时价",
  "scenarioInputsReturnToLiveIV": "回到实时隐含波动率",
  "strategyAnalysisInfoTitle": "模拟说明",
  "strategyAnalysisInfoNotAdvice": "此模拟器仅用于场景探索，不是投资参考工具。",
  "strategyAnalysisInfoDataRisk": "输出结果依赖模型假设、延迟或不完整的市场数据、所选隐含波动率、时间、价格和手动输入，结果可能不准确。",
  "strategyAnalysisInfoGreeks": "Greeks 会相互影响：Delta、Gamma、Theta、Vega 会随着价格、时间和波动率变化而变化，单次读数不能视为固定结论。",
  "strategyAnalysisInfoRisk": "期权具有重大风险。不要将这些模拟结果作为投资决策依据。",
  "footerDiary": "日记",
  "footerBackPrevious": "返回上一页",
  "footerJournalReview": "日记复盘",
  "footerGoBack": "返回上一页",
  "footerJournal": "日记复盘",
  "QA1paM": "模拟说明",
  "x/atQl": "此模拟器仅用于场景探索，不是投资参考工具。",
  "mcxleS": "输出结果依赖模型假设、延迟或不完整的市场数据、所选隐含波动率、时间、价格和手动输入，结果可能不准确。",
  "epNjRr": "Greeks 会相互影响：Delta、Gamma、Theta、Vega 会随着价格、时间和波动率变化而变化，单次读数不能视为固定结论。",
  "igHJav": "期权具有重大风险。不要将这些模拟结果作为投资决策依据。",
  "bBgyLq": "股价",
  "ARGRLU": "隐含波动率",
  "7o5wIx": "到期时间",
  "/Koi6R": "控制场景处在当前到到期之间的哪个时间点。越接近到期，越能看到时间衰减对策略的影响；跳到到期则查看到期盈亏图。",
  "3Vqaqo": "此场景使用的标的股价。移动它可以查看价格上涨或下跌时，策略盈亏如何变化。",
  "rEEoE5": "隐含波动率是期权定价中使用的市场预期波动水平。移动它可以查看到期前波动率变化对模拟盈亏的影响。",
  "pyfKzs": "回到实时价",
  "OMo3IK": "回到实时隐含波动率",
  "UAwu5n": "当前选择：{attribute}（{bias}）",
  "Qnw/66": "看多",
  "t9Ww7K": "看空",
  "jCOU1v": "当前选择：{attribute}（{mode}）",
  "6gTcRZ": "当前选择：{attribute}",
  "1uCNLn": "继续添加",
  "rIAJlE": "已添加",
  "Ar+4NI": "单腿看涨期权。\n\n**多空切换**： 买入（看涨，上行空间无限）或卖出（收取权利金，裸卖=风险无限）。\n\n**行权价偏移** — 相对于标的资产的带符号距离。负数 = 低于标的，正数 = 高于标的。",
  "duqrO4": "单腿看跌期权。\n\n**多空切换**： 买入（看跌，下行空间利润大）或卖出（收取权利金，被行权风险大）。\n\n**行权价偏移** — 相对于标的资产的带符号距离。负数 = 低于标的，正数 = 高于标的。",
  "51Mmrv": "两侧风险均已限定的贷记价差——价格维持在区间内时获利。\n\n**卖出看跌 / 买入看跌** — 标的资产价格下方的看跌贷记价差。\n\n**买入看涨 / 卖出看涨** — 标的资产价格上方的看涨贷记价差。\n\n**多空切换**： 在卖出（收取贷记）与买入（支付借记）之间切换。",
  "cXcT6r": "以平值卖出波动率价差，外侧加保护性蝶翼。价格停留在平值时拿到最大权利金。\n\n**蝶翼宽度** — 外侧买入腿与平值卖出腿之间的距离。越宽 = 最大利润越大，但保护越弱。\n\n**偏斜** — 将中心行权价移离平值。\n\n**多空切换**： 在卖出（卖出平值、买入蝶翼）和买入（买入平值、卖出蝶翼）之间切换。",
  "JwafHT": "价格停留在中心行权价附近的低成本押注。使用同一种期权类型的三条腿。\n\n**蝶翼宽度** — 中心行权价到外侧行权价的距离。越宽 = 利润区越大，但成本也越高。\n\n**多空切换**： 买入蝶翼（多头蝶式）或卖出蝶翼（空头蝶式）。\n\n**期权类型切换** — 用看涨或看跌构建（到期盈亏相同，但希腊字母不同）。",
  "NSVl0k": "同一行权价上的多头看涨 + 空头看跌——用以复制正股的多头敞口。\n\n**行权价偏移** — 将合成头寸整体移离平值。\n\n**多空切换**： 合成多头（看涨）或合成空头（看跌）。",
  "D5ErH1": "不同行权价的虚值看涨 + 虚值看跌——分裂式合成。\n\n**看涨期权偏移** — 看涨腿相对于标的资产的位置。\n\n**看跌期权偏移** — 看跌腿相对于标的资产的位置。\n\n**多空切换**： 买入组合（多头）或卖出组合（空头）。",
  "A0FCr1": "价内看涨期权 + 价内看跌期权 — 形似跨式，但两腿都在价内。权利金更高，盈亏平衡范围也更宽。\n\n**看涨期权偏移** — 看涨腿进入价内的深度。\n\n**看跌期权偏移** — 看跌腿进入价内的深度。\n\n**多空切换**： 买入两腿（多头价内宽跨式）或卖出两腿（空头价内宽跨式）。",
  "PAZryX": "同一行权价上的平值看涨 + 平值看跌。价格朝任一方向大幅移动时获利（多头），或从时间衰减中获利（空头）。\n\n**多空切换**： 多头跨式（买入两腿，支付借记）或空头跨式（卖出两腿，收取贷记）。",
  "Lxu4QL": "虚值看涨 + 虚值看跌——盈亏平衡范围比跨式更宽，成本也更低。\n\n**看涨期权偏移** — 看涨腿相对于标的资产的位置。\n\n**看跌期权偏移** — 看跌腿相对于标的资产的位置。\n\n**多空切换**： 买入组合（多头）或卖出组合（空头）。",
  "RiGLab": "行权价偏移 — 相对于标的资产的带符号距离。负数 = 低于标的，正数 = 高于标的。",
  "0GEKu4": "多头偏移 — 买入腿相对于标的价格或策略中心的位置。",
  "tkN/X7": "空头偏移 — 卖出腿相对于标的价格或配对买入腿的位置。",
  "6Fz0e2": "看涨期权偏移 — 看涨行权价与标的价格的距离。越高 = 越高于标的。",
  "TPcyBZ": "看跌期权偏移 — 看跌行权价与标的价格的距离。越高 = 越低于标的。",
  "IYKW2A": "蝶翼宽度 — 中心/主体到外侧蝶翼的距离。越宽 = 潜在收益更高，但保护更弱或成本更高。",
  "0Ov/mE": "下主体 — 策略中心到下方内侧行权价的距离。",
  "/Boq/3": "上主体 — 策略中心到上方内侧行权价的距离。",
  "/yMgas": "偏斜 — 将中心行权价移离平值。负数 = 下移，正数 = 上移。",
  "92y9KN": "看跌偏斜 — 移动看跌侧远月行权价。负数 = 下移，正数 = 上移。",
  "DtI+Id": "看涨偏斜 — 移动看涨侧远月行权价。负数 = 下移，正数 = 上移。",
  "DMBKyE": "卖出看跌 — 卖出看跌行权价距离标的价格下方的距离。",
  "wNkFMN": "买入看跌 — 保护性买入看跌行权价距离标的价格下方的距离。",
  "3WWSTo": "卖出看涨 — 卖出看涨行权价距离标的价格上方的距离。",
  "cZGjP1": "买入看涨 — 保护性买入看涨行权价距离标的价格上方的距离。",
  "+oqPh9": "空头 1 偏移 — 第一条卖出腿距离策略中心的距离。",
  "pQVJVu": "空头 2 偏移 — 第二条卖出腿距离策略中心的距离。",
  "MREoUc": "多头蝶翼偏移 — 买入蝶翼距离策略中心的距离。",
  "wGSwwY": "空头 1 偏移 — 第一条卖出腿相对于策略中心的位置。",
  "Rx8RDW": "空头 2 偏移 — 第二条卖出腿相对于策略中心的位置。",
  "rhx25O": "多头 1 偏移 — 第一条买入腿相对于策略中心的位置。",
  "T7tNXP": "多头 2 偏移 — 第二条买入腿相对于策略中心的位置。",
  "qCNMk4": "裸腿偏移 — 未保护卖出期权腿距离标的价格的距离。",
  "phcJV/": "价差空头偏移 — 价差中卖出腿距离标的价格的距离。",
  "QjP8u5": "价差多头偏移 — 价差中保护性买入腿距离标的价格的距离。",
  "HKSKPv": "前DTE — 近月腿距离到期的天数。",
  "hxSMgr": "后DTE — 远月腿距离到期的天数。",
  "h7uy/0": "行权价偏移 — 当前方向：{side}。负数 = 低于标的，正数 = 高于标的。",
  "C5ZbDk": "蝶翼宽度 — 当前为多头铁蝶。外侧蝶翼为卖出腿；越宽给大幅波动留下更多空间，但通常会改变支付的借记。",
  "5WTPuB": "蝶翼宽度 — 当前为空头铁蝶。外侧蝶翼为买入保护腿；越宽可能提高可收贷记，但保护更弱。",
  "2SFky2": "偏斜 — 当前方向：{side}。负数将铁蝶中心下移，正数将铁蝶中心上移。",
  "lYwHhh": "蝶翼宽度 — 当前为多头蝶式。越宽会扩大目标区间，但通常成本更高。",
  "CxolEe": "蝶翼宽度 — 当前为空头蝶式。越宽会扩大风险区间，并改变收取的贷记。",
  "4ymm00": "卖出看跌 — 当前方向：{side}。这条内侧看跌腿当前为{legSide}。",
  "J6M+7z": "卖出看涨 — 当前方向：{side}。这条内侧看涨腿当前为{legSide}。",
  "eagx3p": "买入看跌 — 当前方向：{side}。这条外侧看跌腿当前为{legSide}。",
  "AqTbbD": "买入看涨 — 当前方向：{side}。这条外侧看涨腿当前为{legSide}。",
  "kjZqR8": "空头 1 偏移 — 当前方向：{direction}。将第一条卖出腿移向该方向。",
  "9/Y8tC": "空头 2 偏移 — 当前方向：{direction}。将第二条卖出腿进一步移向该方向。",
  "12asnA": "多头蝶翼偏移 — 当前方向：{direction}。将较宽的保护蝶翼延伸到该方向。",
  "ea44hg": "裸腿偏移 — 当前方向：{direction}。控制未保护的卖出期权腿。",
  "xO28E7": "价差空头偏移 — 当前方向：{direction}。控制限定风险价差中的卖出腿。",
  "lKLApR": "价差多头偏移 — 当前方向：{direction}。控制价差中的保护性买入腿。",
  "gFo0YN": "多头偏移 — 当前类型：{optionType}。控制买入的{optionType}腿。",
  "RDthON": "空头偏移 — 当前类型：{optionType}。控制卖出的{optionType}腿。",
  "UkGTjM": "行权价偏移 — 当前类型：{optionType}。负数 = 低于标的，正数 = 高于标的。",
  "24zZ5W": "偏斜 — 当前类型：{optionType}。正数将远月腿移向平值，负数移离平值。",
  "CxJoai": "看涨期权偏移 — 当前方向：{side}。控制{side}看涨腿距离标的价格的距离。",
  "YuyjAw": "看跌期权偏移 — 当前方向：{side}。控制{side}看跌腿距离标的价格的距离。",
  "kR9dEl": "看跌偏斜 — 正数将远月看跌腿移向平值，负数移离平值。",
  "ujXZ/g": "看涨偏斜 — 正数将远月看涨腿移向平值，负数移离平值。",
  "rYExzo": "收益无限",
  "GGb4mP": "限权利金",
  "unMsI6": "收益有限较大",
  "TiV65K": "短看涨上方收益封顶",
  "VsAMpv": "持股下跌风险",
  "qdoAI0": "收益限权利金",
  "9CaQlF": "接货后下跌风险",
  "Vq5PyS": "价差宽度减净支出",
  "yUABey": "净支出",
  "n3Co/5": "净权利金",
  "PJ1dBr": "价差宽度减权利金",
  "24HXKj": "单侧价差宽度减权利金",
  "LYGUlD": "翼宽减权利金",
  "7rBe4+": "翼宽减净支出",
  "n+Cz2z": "短腿区域收益峰值",
  "XJj5d9": "宽翼侧尾部风险",
  "KKENWN": "中间区宽度减净支出",
  "F8rmdf": "裸看跌下行风险",
  "XqyKcj": "突破方向收益",
  "X31/VM": "短长腿之间亏损峰值",
  "dW+zxW": "短腿附近收益峰值",
  "1iTwDl": "额外裸短腿尾部风险",
  "VS/Ihf": "第一短看涨附近收益峰值",
  "45brT3": "上行裸短看涨风险",
  "eoaNBV": "低于短看涨保留净权利金",
  "AEjzZb": "短看涨到长看涨区间亏损",
  "wivuPI": "高于短看跌保留净权利金",
  "HixThU": "短看跌到长看跌区间亏损",
  "YukVUC": "第一短看跌附近收益峰值",
  "z3z5lZ": "下行裸短看跌风险",
  "/HSKER": "方向线性收益",
  "5O/sHw": "反向线性亏损",
  "Y4orcp": "分裂行权价方向收益",
  "OgQnrO": "大幅波动收益且偏下行",
  "dLifQL": "大幅波动收益且偏上行",
  "bQTroT": "大幅波动收益",
  "0ptZoB": "近月归零且远月保值",
  "35wBrm": "任一目标区近月归零且远月保值",
  "hhUUcA": "双侧裸卖风险",
  "dUi081": "单腿任意方向自定义搭建",
  "SX+0df": "**多空切换**：买入（看涨，上行空间无限）或卖出（收取权利金，裸卖风险无限）。",
  "UJKhEJ": "**多空切换**：买入（看跌，下行利润较大）或卖出（收取权利金，被行权风险较大）。",
  "orqgbR": "**多空切换**：在卖出主体（收取权利金）与买入主体（支付权利金）之间切换。",
  "eBViVv": "**多空切换**：在“卖出平值、买入蝶翼”与“买入平值、卖出蝶翼”之间切换。",
  "mUDzZH": "**多空切换**：多头蝶式（买入蝶翼）或空头蝶式（卖出蝶翼）。",
  "HmyTOF": "**多空切换**：多头合成（看涨）或空头合成（看跌）。",
  "YOYjdR": "**多空切换**：多头组合（双买）或空头组合（双卖）。",
  "9f8+TX": "**多空切换**：多头价内宽跨（双买）或空头价内宽跨（双卖）。",
  "jzrxdq": "**多空切换**：多头跨式（双买，支付权利金）或空头跨式（双卖，收取权利金）。",
  "uNYc8q": "**多空切换**：多头宽跨（双买）或空头宽跨（双卖）。",
  "/82+OE": "当前权利金",
  "VpUKzG": "当前盈亏",
  "UGnW6C": "切换到期日",
  "aTf36y": "总计",
  "EnLNT0": "锁定策略行权价",
  "7agtw7": "解锁策略行权价",
  "Txq8th": "撤销策略移动",
  "kkG/Ta": "检测为 {kind}",
  "ExtOfk": "锚定策略",
  "M9u3uV": "切换策略选择器",
  "ZbB4iW": "同到期日，long call 单腿识别为多头看涨。",
  "La02Ad": "同到期日，short put 单腿识别为空头看跌。",
  "Cq+rK0": "同到期日，long call K1 加 short call K2 识别为看涨价差。",
  "63C+To": "同到期日，四条腿 short put / long put / short call / long call，中间卖、两翼买，识别为铁鹰。",
  "3Dx8St": "同到期日，short call + short put 同 strike，外侧买保护，识别为铁蝶。",
  "G5dI7c": "不同到期日、同 strike、同 type，一买一卖，识别为时间价差 / calendar。",
  "EKd/46": "不同 strike、不同 expiry、同 type，一买一卖，识别为对角价差 / diagonal。",
  "/k/3jB": "两组 calendar，call 和 put 都有，识别为 double calendar。",
  "oVHCWl": "策略识别规则",
  "P9XgbG": "策略识别方式",
  "xC6/Ai": "识别方式：每条腿根据多空、期权类型、行权价、到期日和数量识别。",
  "8B9wNk": "同到期日，long call 加 short call 识别为看涨价差。",
  "2RcYOT": "术语说明，不同叫法：call / put 除了叫看涨 / 看跌，也可以叫认购 / 认沽；long / short 除了叫多头 / 空头，也可以叫买入 / 卖出。",
  "kdrNp+": "时间衰减开关",
  "GGRr8F": "概念演示，尚未连接到实时订单簿。",
  "QKBtQ5": "策略盈亏平衡契合度",
  "mgN21o": "区间内",
  "SE0PvZ": "尾部风险标志",
  "477I0g": "低",
  "EfF+uq": "预览 {x} 与 {y}, 按 {z} 着色。",
  "yxhVD/": "流形控件",
  "M2tpTm": "使用当前模拟器策略作为输入, 然后扫描两个维度以查看收益曲面何处弯曲。",
  "AqVlsJ": "X 轴",
  "h19We/": "Y 轴",
  "/AElfC": "曲面",
  "ct77po": "打开高级流形",
  "+6V3c+": "流形预览",
  "SSHeHt": "Y",
  "MiXf8H": "Z",
  "qzSPvl": "切换流形",
  "1SoDnn": "现价",
  "PZwINE": "IV / DTE",
  "EbywH3": "盈亏曲面",
  "nRhbp3": "当前策略曲面",
  "Kau+zp": "层",
  "r82eD8": "腿",
  "r5r5Dl": "展开完整多空组合",
  "Xci60n": "返回模拟器",
  "5IXQHH": "打开多重置入",
  "0TKzvD": "模拟器",
  "/MNdbX": "打开模拟器",
  "S8/4ZI": "更多操作",
  "keM5cz": "暂无操作",
  "MKfO2Q": "打开下一个操作",
  "Ud9h8E": "先选择策略，在此编辑其腿。",
  "fB7KUT": "打开策略选择器",
  "gYMkDE": "锚定至起始",
  "7sm+5m": "多日期",
  "VNsN2Z": "买入看涨",
  "4f0M7H": "卖出看涨",
  "RviXXY": "看空 · 跌破行权价获利",
  "N2PmMt": "无限上涨风险",
  "1suwkn": "买入看跌",
  "onXrid": "卖出看跌",
  "TFE0zL": "看多 · 突破行权价获利",
  "hzyvzb": "理论上收益无限",
  "HfWXsi": "理论上收益限权利金",
  "TKLjVV": "理论上无限的上涨风险",
  "u4KT64": "理论上收益有限较大",
  "yjzE8I": "理论上短看涨上方收益封顶",
  "X9lQXE": "**多空切换**：买入（看涨，理论上上行空间无限）或卖出（收取权利金，裸卖风险理论上无限）。",
  "L53h3t": "返回上次编辑",
  "nrbUvb": "一个专注于期权衍生品与市场风险理解的学习系统",
  "GTlcaG": "开始免费试用",
  "Rsbt3R": "一周免费试用",
  "rtYc5l": "含 7 天标准功能试用，无需信用卡",
  "Y3+Oxq": "您的账户已准备就绪，含 7 天标准功能试用。请使用您的 PIN 码登录。",
  "ZZeQsl": "含 7 天标准功能试用。无需信用卡，也无需邀请码。",
  "CfV3L5": "您的 7 天标准功能试用已激活。",
  "qlC/X6": "试用期明天结束",
  "F3ws3N": "试用期将在 {days} 天后结束",
  "1rqEzD": "您的访问已结束。请购买访问权限以继续。",
  "iBFdi+": "$98",
  "0c49tE": "$1.09/天",
  "Coy6SH": "日历",
  "WERbDz": "行情",
  "LPhZwu": "社交/学习",
  "rNNm91": "目标页面",
  "aI0Hsl": "登入成功！",
  "Todw8M": "您的工作区已准备就绪。先从模拟器开始探索吧～",
  "SMpO/p": "您的工作区已准备就绪。可以先打开模拟器，也可以继续前往你的页面。",
  "psITWt": "请保存此 PIN——这是您永久的登录凭证。之后可在设置中修改。",
  "Lv0zJu": "详情",
  "9GS7jq": "展开详情",
  "DnX0aY": "确认删除",
  "Ca0eu3": "恢复上一次颜色",
  "R2PGKQ": "第一行：市场视图和方向过滤器。",
  "uTvKEV": "第二行：策略结构类别。",
  "vyT33P": "退出多选",
  "ZsA2ql": "行情",
  "rihWTl": "结构",
  "fYgsCE": "清除已选策略",
  "S8QoAg": "选择所有可见策略",
  "EnCOBJ": "买入",
  "9AgXoz": "卖出",
  "/6UFyr": "恢复默认七彩",
  "JRHX28": "仅此次",
  "z+Zrln": "设为默认",
  "hXy6cA": "默认设置将应用于此类型的已保存策略及未来的选择。",
  "UflpIz": "设为偏好默认",
  "FibtbU": "恢复系统默认",
  "Z78Z6P": "使用彩虹色",
  "hcuBuO": "选择颜色",
  "O8XlC6": "当前每份合约权利金",
  "M59JhX": "手动",
  "8nvhZ9": "最新价",
  "rhSI1/": "模型",
  "nQyxpz": "重置权利金",
  "4Y/Ab3": "近月到期",
  "Taqr2e": "远月到期",
  "jM9qUI": "近",
  "YCzPPB": "远",
  "0dMo8L": "入场权利金",
  "oF2poX": "Theta网",
  "+s81D7": "宽幅, 稳定Theta, 厌恶突破",
  "kfzeF3": "铁鹰网",
  "indwML": "方向网, 捕捉上涨漂移",
  "TCXaNi": "熊市价差网",
  "LZCiFV": "紧凑中心网: 大获利或快速受损",
  "CiMCDO": "跨式网",
  "yNUS8n": "小目标, IV持平效果更佳",
  "Ou7sWk": "日历陷阱",
  "1Or9s1": "期权钓鱼游戏",
  "0dywrZ": "在价格河流周围布设期权网, 推进时间, 学习波动率, IV, 宽度和尾部风险如何相互作用。",
  "JeBy61": "捕获",
  "T807D4": "损失",
  "qukSCe": "价格河流",
  "z3AMi9": "到期日已到。重置牌组, 重新开始。",
  "fn/VCc": "干净的捕获。Theta已获利, 并且网已守住。",
  "+PnZg2": "压力触及边界。重新调整中心或拓宽网。",
  "X7s0vF": "布下网, 然后推进市场。",
  "xfYYJ1": "推进一天",
  "pgDoDR": "自动推进",
  "92HUDe": "IV潮",
  "Q7ij1k": "剩余天数",
  "V55xlZ": "轮",
  "5ir/Y+": "上期盈亏",
  "3efiQX": "布网控件",
  "WdD6el": "网中心",
  "8UZS3K": "网宽度",
  "0XM75I": "波动率渔获",
  "OGauwX": "当标的资产保持在网内时捕获。",
  "2BqG3O": "Theta流",
  "TALHpe": "临近到期日时支付更多。",
  "bxTnXb": "高IV可喂养日历期权或撕裂空头网。",
  "pXra9p": "边界压力",
  "xWc+eU": "当价格逃离支付区域时, 损失增加。",
  "sxNKiz": "开市钟",
  "Piv8gA": "钓鱼大师",
  "oAuHBH": "清理渔网",
  "/0eRJ0": "仍在水面",
  "z0DSW6": "绳索断裂",
  "mLlOgJ": "渔网得分",
  "xLCZAR": "连胜",
  "VP5+CR": "排名",
  "mXmvg2": "到期已达。阅读结算卡或重新投掷。",
  "Vl02jc": "暂停自动步进",
  "m1czzY": "事件",
  "dEYOLr": "结算卡",
  "KFY7s2": "您的渔网在到期时以正收益率幸存。",
  "RWb9RL": "河道已通过。尝试更宽的渔网或新的中心。",
  "QJsFeW": "重新投掷",
  "KpyF8v": "打开策略操作",
  "vASobk": "通知历史",
  "PsqxSX": "尚无通知",
  "8N9wG+": "收件人",
  "filwqD": "已读",
  "0HT+Ib": "已归档",
  "Sh368n": "{count} 位用户已选",
  "Bl8xZP": "{date} 之后",
  "U5sjCv": "{date} 之前",
  "+Nk8iq": "删除通知",
  "eF0SIH": "无法加载通知",
  "ztdbt+": "删除此通知历史记录？",
  "hX/ER9": "通知触发时发送邮件",
  "3hYpLY": "邮件通知",
  "06PkTq": "通知触发时发送推送通知",
  "Awq32I": "推送通知",
  "KIT+yN": "KOL",
  "O3xq5I": "有效",
  "77NxdU": "总佣金",
  "NkF305": "有效总佣金",
  "Q4P6gR": "当前待支付佣金",
  "6/+RUy": "退款扣减佣金",
  "LPn0WX": "权限账本",
  "nuOrfi": "暂无权限账本记录",
  "450Fty": "无",
  "OY+R39": "未退款",
  "NmK6zy": "付款",
  "d8EqQY": "天数",
  "f0W26f": "已撤销",
  "9anxhq": "开始",
  "04xGLE": "结束",
  "Gs86nL": "已退款",
  "ORGv1Q": "创建于",
  "KPgIKD": "此账户尚未绑定 KOL 看板。",
  "qCcwo3": "链接",
  "wFmAFC": "页面",
  "g4d3j2": "暂时没有可用链接。",
  "6Tps09": "未启用",
  "9Sak6b": "无参考号",
  "9Vy3zv": "推荐码 / 活动码",
  "EWw/tK": "应用",
  "7TUyZ1": "已应用",
  "x2R8CB": "无效代码",
  "zHDJut": "购买链接",
  "E+sBOl": "推广页",
  "eGxlvt": "推荐码",
  "wac8ex": "每日一测",
  "axS9Sl": "每日期权理论",
  "RLHw+x": "期权每日一测",
  "kOfScV": "题量",
  "UkjwCx": "{count} 题",
  "t4Yrhm": "开始测试",
  "OEGZQC": "{current} / {total}",
  "BY343C": "更换",
  "vdq4Hg": "下一题",
  "ZpQ6us": "结果",
  "U6vCLD": "正确率 {score}%",
  "FIJzvZ": "答对 {correct} / {total}",
  "t88s+R": "{correct}/{total}",
  "p8z+Tw": "买入看涨期权赋予持有人哪项权利？",
  "r8sXSe": "有权但无义务按行权价买入标的",
  "HkaKfs": "有义务按行权价买入标的",
  "Zr7vSc": "有权但无义务按行权价卖出标的",
  "XollnM": "有义务按行权价卖出标的",
  "R9pUXF": "看涨期权持有人拥有买入权；卖方在被指派时承担相应义务。",
  "sJdEUc": "买入看跌期权赋予持有人哪项权利？",
  "agCYGR": "看跌期权持有人拥有卖出权；看跌期权卖方可能被指派并需要买入。",
  "ieCW9m": "哪一个公式表示看涨期权到期时的内在价值？",
  "4rXYGk": "max(标的价格 - 行权价, 0)",
  "yPJKRI": "max(行权价 - 标的价格, 0)",
  "qnRlaM": "期权权利金 - 时间价值",
  "Z6lbD7": "标的价格 + 行权价",
  "m5w98g": "标的价格高于行权价时，看涨期权为价内。内在价值不会为负。",
  "8dfXCg": "哪一个公式表示看跌期权到期时的内在价值？",
  "N2iatI": "期权权利金 + 行权价",
  "dGAs0Q": "标的价格 - 期权权利金",
  "jHiKFs": "标的价格低于行权价时，看跌期权为价内。内在价值不会为负。",
  "Rw59/r": "时间价值最适合描述为期权价格中的哪一部分？",
  "Ti+nXJ": "期权权利金中高于内在价值的部分",
  "h/uehJ": "到期时的保证利润",
  "/YX34k": "行权价减去权利金",
  "1PVBkn": "报价中包含的券商佣金",
  "TpxZ5h": "期权权利金可拆为内在价值和时间价值；时间价值反映剩余不确定性。",
  "vNNLap": "买入看涨期权到期时的盈亏平衡价是多少？",
  "CoyymK": "行权价 + 支付的权利金",
  "xqBpsH": "行权价 - 支付的权利金",
  "sJnUwP": "支付的权利金 - 行权价",
  "Ywalns": "标的价格 - 行权价",
  "BpzpsR": "买入看涨期权到期时需要先覆盖支付的权利金，才达到盈亏平衡。",
  "tVP8qh": "买入看跌期权到期时的盈亏平衡价是多少？",
  "Y6fpjX": "标的价格 + 支付的权利金",
  "RJ7S9H": "买入看跌期权需要标的跌破行权价，并至少覆盖支付的权利金。",
  "6pa5qG": "虚值期权通常有多少内在价值？",
  "JaHxPk": "零",
  "CnZWCp": "正好等于权利金的一半",
  "3IH3Jq": "正好等于其时间价值",
  "xTYEBv": "负数",
  "UYQuxJ": "虚值期权没有内在价值；到期前的权利金来自时间价值。",
  "COgKc1": "Delta 主要衡量对哪个输入的敏感度？",
  "4WAtON": "标的价格变化",
  "caFyNW": "隐含波动率变化",
  "FHIYXU": "利率变化",
  "cmAzyy": "买卖价差变化",
  "1ZD3kZ": "Delta 估计标的小幅变动时，期权价格会变化多少。",
  "9I3PrQ": "Gamma 最适合描述为什么？",
  "oy9NPC": "标的价格变化时 Delta 的变化率",
  "c3vJfx": "隐含波动率变化时 Vega 的变化率",
  "PSrNLJ": "期权抵押品产生的每日利息",
  "tPPotT": "买价与卖价之差",
  "kx4aCp": "Gamma 描述曲率：标的移动时 Delta 变化的速度。",
  "5IX97R": "Theta 最直接描述哪种影响？",
  "ryGLHF": "期权理论价值的时间衰减",
  "XJRqxA": "对股息的价格敏感度",
  "wSue2S": "被指派的概率",
  "hvAy+w": "合约乘数大小",
  "wcdDPf": "Theta 估计在其他定价输入不变时，时间流逝对期权价值的影响。",
  "7LGFvM": "Vega 主要衡量对哪个输入的敏感度？",
  "ux9Tju": "隐含波动率",
  "sudrJ2": "标的价格",
  "0ZglLj": "距离到期时间",
  "TJl38p": "合约规模",
  "MeYCX7": "Vega 估计隐含波动率变化时，期权价值会变化多少。",
  "MDmbC7": "隐含波动率和历史波动率最清楚的区别是什么？",
  "ycgvyV": "隐含波动率来自期权价格；历史波动率来自标的过去走势",
  "AwqM5+": "隐含波动率总是低于历史波动率",
  "OmeRsw": "历史波动率只用于期货，不用于期权",
  "3sWwQ+": "它们是同一个指标的两个名字",
  "FTuly1": "隐含波动率通过期权价格反映前瞻预期；历史波动率来自已实现的过去波动。",
  "yNsoVb": "买入一张看涨期权，同时卖出同到期、更高行权价的看涨期权，构成什么结构？",
  "rDhkA9": "牛市看涨价差",
  "b9MNfz": "熊市看跌价差",
  "nf2rO+": "买入跨式",
  "5XyIqv": "卖出日历价差",
  "qpsFdn": "牛市看涨价差是由看涨期权构成的、风险有限的看多借记价差。",
  "bAnfSm": "买入跨式通常由哪两条腿构成？",
  "d1iX2n": "同一行权价、同一到期日的买入看涨 + 买入看跌",
  "fLmCbB": "不同到期日的卖出看涨 + 卖出看跌",
  "gcgmMM": "买入股票 + 卖出看涨",
  "uroA9V": "买入看涨 + 卖出更高行权价看涨",
  "AGixtS": "买入跨式同时持有同一行权价、同一到期日的看涨和看跌期权。",
  "KZHvVd": "指派最直接适用于期权合约的哪一方？",
  "WPKPiC": "持有空头期权头寸的期权卖方",
  "+x9iMv": "只有持有多头期权的买方",
  "PP/pAf": "只有做市商",
  "Hvnx3M": "只有已到期的虚值期权",
  "GFl3KB": "指派是期权买方行权后，期权卖方被要求履行合约的过程。",
  "KRpgBP": "为什么某些期权空头头寸需要保证金？",
  "kRwhsx": "因为卖方在被指派时可能承担未来义务",
  "16CiFP": "因为期权多头总是需要借钱",
  "e/kRj/": "因为期权权利金在到期后支付",
  "dc+YqR": "因为所有价差都有无限亏损",
  "2W3NCs": "期权空头可能产生义务，因此券商会要求资本覆盖潜在亏损或指派风险。",
  "lbriQa": "隐含波动率曲面按哪些维度组织隐含波动率？",
  "e+Pit9": "行权价或虚实程度，以及距离到期时间",
  "AIwt1N": "只有每日已实现收益",
  "S2cbVG": "只有买卖盘数量",
  "HV9hU2": "只有期权合约乘数",
  "nSW/Id": "波动率曲面展示隐含波动率在行权价或虚实程度、以及到期日上的分布。",
  "SCbIit": "波动率偏斜通常指什么？",
  "MefGGl": "同一到期日下，不同行权价对应不同隐含波动率",
  "Od/WwN": "每次到期前波动率必然上升",
  "n6zDGH": "股票开盘价与收盘价之差",
  "8byjCe": "Black-Scholes 模型中使用的利率",
  "RtIEpC": "偏斜描述隐含波动率如何随行权价变化，而不是保持平坦。",
  "CxO+nV": "标准日历价差通常如何组合不同到期日？",
  "9j0U1y": "卖出较近到期期权，买入同一行权价的较远到期期权",
  "DmsiNM": "同一到期日、不同行权价的两张期权",
  "XAb+zP": "买入股票 + 卖出看涨",
  "IFJW8p": "不同标的的看涨和看跌",
  "KIqGwC": "日历价差通过使用不同到期日，通常同一行权价，来体现期限结构。",
  "ASZDul": "对角价差与简单日历价差的区别是什么？",
  "+z5UQl": "各腿通常同时有不同到期日和不同行权价",
  "19ARtf": "各腿必须使用不同标的代码",
  "OdKxak": "该头寸不能包含期权空头",
  "fEl9K7": "该头寸对波动率没有敏感度",
  "LW6FCj": "对角价差同时涉及期限结构和行权价选择，因为各腿在到期日和行权价上都不同。",
  "y46EiJ": "Gamma动态对冲最接近哪一个概念？",
  "k+cb83": "随着 Delta 变化，重新平衡标的对冲",
  "jcOcao": "所有期权都持有到期且不调整",
  "Kbj+hp": "忽略 Delta，因为 Gamma 永远为零",
  "gGUfus": "只卖出没有买卖价差的期权",
  "5n018Y": "Gamma动态对冲是根据Delta的变化，反复买卖标的来调整期权持仓的对冲。",
  "0FCKHz": "对于多腿期权组合，哪项说法最准确？",
  "goAbTA": "组合的净希腊值和盈亏形状，可能与任何单独一腿都很不同",
  "63JmCk": "只有第一条腿决定组合风险",
  "iacmSU": "风险有限价差永远不会亏钱",
  "9/9anH": "Delta 接近零表示组合没有风险",
  "VIGkm7": "组合风险来自各腿合并后的整体效果。Delta、Gamma、Theta、Vega 和盈亏边界都重要。",
  "TR68QP": "波动率期限结构比较什么？",
  "gak5Bg": "不同到期日",
  "cIoSuE": "不同券商佣金",
  "PGaGLZ": "不同账户类型",
  "Z2byKh": "不同合约乘数",
  "w8q8hL": "期限结构描述隐含波动率在不同到期日之间如何变化。",
  "USuYeZ": "期权空头头寸通常具有什么 Gamma 特征？",
  "Dh+xiJ": "负 Gamma",
  "bDmD7Y": "总是正 Gamma",
  "P5wTCH": "所有价格下 Gamma 都为零",
  "6sJqdF": "只取决于股息的 Gamma",
  "cY3bh1": "期权空头通常带有负 Gamma，意味着价格移动时 Delta 可能朝不利方向变化。",
  "xxg9v7": "核心概念",
  "w8TgQj": "盈亏公式",
  "Cjv9+J": "希腊值",
  "uhAvqf": "策略结构",
  "dMPPSn": "风险与指派",
  "hiQTOD": "Call/Put、内在价值、时间价值、到期盈亏图。",
  "rPdqkE": "Greeks、波动率、价差、保证金、行权与指派。",
  "SIpNYn": "波动率曲面、skew、calendar/diagonal、gamma scalping、组合风险。",
  "3cc4Ct": "少量",
  "pPANfc": "较多",
  "ptXbgj": "隐藏答案",
  "WPipUN": "提示答案",
  "aXluVt": "上一题",
  "qp6UBO": "已答 {answered} 题",
  "jcFIWY": "换一组",
  "WEBo9C": "更换",
  "3Qwa8k": "价内看涨期权何时有效?",
  "IfsTgf": "标的价格高于执行价时",
  "Xs42k6": "标的价格低于执行价时",
  "J6ibgj": "期权费为零时",
  "x7u1X5": "期权没有时间价值时",
  "O9KQTO": "当标的可通过行权价低于市价买入时，看涨期权具有内在价值。",
  "qBN9cZ": "价内看跌期权何时有效?",
  "Ti7STP": "期权没有买价时",
  "+zVWjy": "合约新上市时",
  "kBb73c": "当持有者可以高于当前市价卖出时，看跌期权具有内在价值。",
  "Tp7dEM": "平价期权最接近以下哪个条件?",
  "mwTqo4": "标的价格接近执行价",
  "PBOT9O": "期权已到期",
  "FGSuf7": "期权没有期权费",
  "ZsUiHy": "执行价永远为零",
  "hKIYh9": "平价意味着执行价接近当前标的价格。",
  "YZoYNq": "期权费是什么意思?",
  "yfDrxX": "期权合约的成交价",
  "/AzzHb": "期权合约的执行价",
  "BC48si": "股票指数控制的股票数量",
  "4MaiPR": "交易的保证利润",
  "K7A6D0": "期权费是期权的价格。买方支付，卖方收取，不含佣金和费用。",
  "RepBfg": "标准上市的美国股指期权，一份合约通常控制多少股?",
  "9/svvE": "100股",
  "GhETif": "1股",
  "Kd/ANn": "10股",
  "BEqlMW": "1,000股",
  "B2Iut+": "大多数标准上市的股指期权使用100股乘数，但调整后的合约可能有所不同。",
  "clggJl": "到期日最好的描述是什么?",
  "C77WqZ": "期权不再存在的日期",
  "5Cl5zu": "标的公司公布财报的日期",
  "t7jWOd": "经纪商计算佣金的日期",
  "T71nCJ": "执行价自动更改的日期",
  "kCaz1M": "到期后，期权合约将根据其条款进行结算、行权或作废。",
  "HPdXUB": "执行价是哪个价格会发生什么?",
  "eNgunW": "如果期权被行权，标的可被买入或卖出",
  "Z6gXhL": "期权费总是退还",
  "TUeD3e": "经纪商必须平仓",
  "3uxbHc": "证券交易所设定每日最高价",
  "Sjyh8L": "执行价是买卖标的资产的合约价格。",
  "4+TDij": "买入看涨期权到期时的最大亏损是多少?",
  "R5nC8M": "支付的权利金",
  "SyoW8B": "无限亏损",
  "YPr9B9": "执行价加上期权费",
  "Y6YYOZ": "标的资产的总价值",
  "b5JlKo": "买入看涨期权的买方可以选择不行权，因此到期时的亏损仅限于支付的期权费。",
  "w6c5i+": "买入看跌期权到期时的最大亏损是多少?",
  "Xc8e9a": "执行价减去期权费",
  "hpUY07": "标的价格加上期权费",
  "44cTu9": "买入看跌期权的买方最糟糕的到期结果是损失已支付的期权费。",
  "Ngys84": "裸卖开仓期权风险概况?",
  "rTaUGB": "标的资产急涨时潜在亏损无限",
  "FvZOHg": "最大亏损限制为零",
  "XjI0Pk": "无义务仓风险",
  "nEmdKE": "持有至到期保证盈利",
  "TWW7Oi": "卖开仓期权随着标的资产上涨亏损可能更大，因为卖方可能必须按行权价交割。",
  "uWAgVj": "裸卖跌期权主要下行风险是?",
  "6CsUuc": "标的资产远低于行权价",
  "RDn50X": "标的资产无限制上涨",
  "WNUkKD": "期权买方可要求更高行权价",
  "iQnfc7": "合约乘数变为负数",
  "ADqMdd": "卖跌期权卖方即使在大跌后也可能必须按行权价买入标的资产。",
  "dT5kOK": "到期时，买入看涨期权的总收益公式是?",
  "kL8Q1F": "支付的权利金 + 行权价",
  "Cu8vNz": "看涨期权收益等于标的资产高于行权价的部分，至少为零。",
  "7GGV8d": "到期时，买入看跌期权的总收益公式是?",
  "zX1DZu": "看跌期权收益等于行权价高于标的资产的部分，至少为零。",
  "wlcZrg": "到期时，买入看涨期权净利润等于收益减去什么?",
  "iOoylJ": "行权价的两倍",
  "AP8plv": "标的资产的全价",
  "x7s1VY": "买卖价中值",
  "EHo6Ch": "净利润包括为买入看涨期权支付的初始权利金。",
  "0YyldD": "到期时，买入看跌期权净利润等于收益减去什么?",
  "rdWKQa": "行权价加上标的资产价格",
  "NOGmHM": "期权的未平仓合约量",
  "rzJ2Xy": "日交易量",
  "+6Ofbh": "买入看跌期权必须先收回支付的权利金才能盈利。",
  "BgJVaU": "当满足以下条件时，看涨期权将失效?",
  "cOJzY8": "标的资产价格等于或低于行权价",
  "bLJxN5": "标的资产价格高于行权价",
  "5C2N1y": "期权交易量大",
  "3wefRo": "买卖价差窄",
  "ohKV2P": "到期时，看涨期权无行权价值，除非标的资产高于行权价。",
  "53yYGu": "当满足以下条件时，看跌期权将失效?",
  "iiBEKO": "标的资产价格等于或高于行权价",
  "wSdEfs": "标的资产价格低于行权价",
  "p2F83m": "期权隐含波动率高",
  "c/A1XG": "期权价差宽",
  "YBt376": "到期时，看跌期权无行权价值，除非标的资产低于行权价。",
  "e43wLc": "在其他条件相同的情况下，临近到期时期权的时间价值通常会发生什么变化?",
  "kDFYMw": "它减少",
  "L5H8ow": "它必须增加",
  "qLMi7h": "它自动变为内在价值",
  "hg6x2F": "它变为行权价",
  "GMm0cm": "时间价值通常会衰减，因为标的资产可供有利变动的时机减少。",
  "dAqB3D": "到期时，期权还剩余多少时间价值?",
  "4d+8xq": "全部权利金",
  "OvMDdi": "行权价",
  "HuCtj2": "合约乘数",
  "S3yPoo": "到期时，期权价值由结算或行权价值决定，而非剩余时间。",
  "b5xmt5": "买卖价差是指什么？",
  "UHG779": "最高买价与最低卖价之差",
  "hv+B9s": "行权价与到期日之差",
  "eCwOGr": "价差的保证利润",
  "6yO8gD": "看涨期权价值与看跌期权价值之差",
  "zAsNJ6": "价差是指买方出价与卖方要价之间的差距。",
  "NmcAIp": "期权流动性对交易者为何重要？",
  "MiOsQM": "低流动性会使进出场成本更高",
  "8IDmAr": "流动性消除所有市场风险",
  "H+uHTE": "流动性保证行权有利可图",
  "xUCvdd": "流动性改变合约乘数",
  "Qs/n/d": "成交稀少的市场通常价差更大，成交更不可靠，增加了交易成本。",
  "j4qTaw": "未平仓合约量衡量什么？",
  "768IJv": "仍未平仓的未到期期权合约数量",
  "Nd7Y1s": "仅当天交易的数量",
  "GkiIvV": "经纪商收取的利率",
  "xemegc": "标的资产的股息收益率",
  "ShPJI1": "未平仓合约量计算已开立但尚未平仓、行权或到期的合约数量。",
  "vXBXAG": "期权成交量通常指什么？",
  "SUreWy": "某时期内交易的合约数量",
  "GWBWSM": "收盘后仍持仓的合约数量",
  "nSxIMl": "期权的理论价值",
  "GB4Lc2": "合约的到期周期",
  "BrBO26": "成交量衡量某时期的交易活动，未平仓合约量衡量剩余未平仓合约。",
  "F1tCF5": "美式期权通常可在何时行权？",
  "1yuI24": "到期前任何时间，但须遵守合约规则",
  "CmlUXG": "仅在到期时",
  "ospK6h": "仅在到期后",
  "xEzPH0": "仅在隐含波动率为零时",
  "elS+KS": "美式合约允许在到期前行权，而欧式合约则不行。",
  "RTeRHN": "欧式期权通常可在何时行权？",
  "1aBcOs": "到期前任何时间",
  "+/2Tna": "仅在期权价外时",
  "yODrWj": "仅在期权无时间价值时",
  "z1/3iT": "欧式期权的行权仅限于到期日，但该期权通常在此之前可以交易。",
  "J3eAog": "实物交割通常在行权后意味着什么？",
  "yWo9Ua": "交付股票或标的资产",
  "ZIzDA4": "仅交换现金，不交付资产",
  "wtRBX9": "期权费被退还",
  "NgX5uw": "行权价被取消",
  "ybB05q": "实物交割涉及根据合约条款交付标的资产。",
  "9Vd+QF": "现金结算通常在结算时意味着什么？",
  "37x8i6": "交换一笔现金，而不是交付标的",
  "5nIIiF": "交易者收回原始期权费",
  "JhpE+3": "经纪商取消交易双方",
  "VRYD01": "期权自动成为股票头寸",
  "bqiAGH": "现金结算期权以现金结算合约价值，而不是交付股票或资产。",
  "+ahLiH": "行权意味着期权持有人选择做什么？",
  "RGw0yZ": "行使合约权利，以行权价买入或卖出",
  "hCAIUZ": "取消期权，不进行结算",
  "3kh+qC": "更改到期日",
  "ZYgv4C": "将行权价移至市价",
  "pwdo85": "行权是持有人使用期权内嵌的合约权利。",
  "I7PLbp": "指派意味着期权卖方需要做什么？",
  "TG8G7H": "持有人行权后履行合约",
  "EfPNmt": "选择新的行权价",
  "LLCtP8": "收到交易所的额外权利金",
  "jMA3Zi": "在到期前取消期权",
  "841veV": "被指派时，期权卖方必须履行已行权的合约所产生的义务。",
  "EydITW": "买入开仓通常意味着什么？",
  "bZlwHV": "建立新的看涨期权头寸",
  "xpdTft": "平仓现有看涨期权头寸",
  "ywaKmx": "建立新的股票空头头寸",
  "crTjjt": "立即行使期权",
  "DFfu4e": "买入开仓会在账户中创建新的看涨期权头寸。",
  "D6OAkA": "卖出开仓通常意味着什么？",
  "Y0A0qb": "建立新的看跌期权头寸",
  "CE+Eoj": "平仓现有看跌期权头寸",
  "/M93ZC": "按行权价买入股票",
  "PL4f9b": "行使看涨期权",
  "qGW83/": "卖出开仓会建立新的看跌期权头寸并收取权利金。",
  "yq/XlX": "买入平仓通常意味着什么？",
  "fHe8oK": "建立新的看涨期权头寸",
  "Rs1iDM": "卖出标的股票",
  "ObqPiG": "更改到期日",
  "0B9BHp": "交易员在回购先前卖空的期权时进行买入平仓。",
  "vFfz58": "卖出平仓通常意味着什么？",
  "BLKWaJ": "建立新的看跌期权头寸",
  "YJuQS1": "行使期权",
  "/Zzlec": "更改行权价",
  "cykKhA": "交易员在退出先前买入的看涨期权时进行卖出平仓。",
  "Y8PcCb": "备兑看涨期权组合包含哪些头寸？",
  "Tn34f1": "持有股票和卖出相应股票的看涨期权",
  "APp8cC": "持有股票空头和买入看涨期权",
  "boyOAa": "买入看涨期权和买入看跌期权",
  "dzctZl": "卖出看跌期权和卖出看涨期权（无股票）",
  "c3S530": "备兑看涨期权在已持有的股票上卖出看涨期权，若被指派则产生交付股票的义务。",
  "8OPAaL": "保护性看跌期权组合包含哪些头寸？",
  "7GXP/5": "持有股票和买入看跌期权",
  "qFNwCA": "持有股票空头和卖出看跌期权",
  "Kf09dC": "买入看涨期权和卖出看涨期权",
  "C8oOGb": "卖出看涨期权和卖出看跌期权",
  "WWuZQB": "保护性看跌期权通过持有看跌期权来为股票头寸购买下跌保险。",
  "Q0iX3b": "买入看涨期权通常是什么方向的头寸？",
  "3Gnlz+": "始终中性",
  "1EZv+H": "保证收入",
  "RnEtR7": "买入的看涨期权受益于标的资产的上涨，足以弥补支付的权利金。",
  "WfBG0m": "买入看跌期权通常是什么方向的头寸？",
  "0YlJY1": "买入的看跌期权受益于标的资产的下跌，足以弥补支付的权利金。",
  "rJM0Wu": "为什么卖出期权不等于保证收入？",
  "a3b9cf": "卖方收取权利金，但可能亏损或被指派",
  "g5eG1n": "卖方从不收取权利金",
  "kk0AVY": "买方控制卖方账户",
  "WHcvjM": "交易所解除到期风险",
  "3tnEte": "期权卖方权利金是对承担义务和市场风险的补偿。",
  "jXrO2P": "价内/价外性比较哪两项？",
  "9S9hwM": "标的价格和期权行权价",
  "17032Z": "买卖价和账户余额",
  "VwB7WH": "合约乘数和股息",
  "5ODy6v": "券商佣金和交易所费用",
  "n8NiHi": "价内/价外性描述行权价相对于标的价格的位置。",
  "ng2Y6N": "外在价值是哪个名称的别称？",
  "sev5fd": "时间价值",
  "EfrHOZ": "行权价价值",
  "Zc8tAA": "仅行权价值",
  "fVRHYD": "合约乘数",
  "kNkUyn": "外在价值是高于内在价值的权利金部分，常称为时间价值。",
  "l1Ukf+": "在到期时，标的资产高于哪个水平时，多头看涨期权是盈利的？",
  "LJ+XFd": "行权价加上已付权利金",
  "tlDaL8": "行权价减去已付权利金",
  "YzOKq/": "已付权利金减去行权价",
  "7439tP": "多头看涨期权在到期时必须高于行权价加上权利金，才能获得净利润。",
  "ysfN1k": "在到期时，标的资产低于哪个水平时，多头看跌期权是盈利的？",
  "UTCGT1": "已付权利金加上标的资产价格",
  "Yf/9eb": "看涨期权行权价",
  "8s1+iH": "多头看跌期权需要在到期时低于行权价减去权利金，才能显示净利润。",
  "T+02sn": "简单卖出看涨期权的最大利润是多少？",
  "RT9b4h": "收到的权利金",
  "pwHZrr": "无限利润",
  "4eR6hV": "如果期权到期作废，卖出看涨期权的最大收益是保留权利金。",
  "F0RJHh": "简单卖出看跌期权的最大利润是多少？",
  "eBvUSL": "如果期权到期作废，卖出看跌期权的最大收益是保留权利金。",
  "V/8u+O": "0DTE期权有何特点？",
  "FnbA1Q": "在当日到期",
  "Mqvx8d": "权利金为零",
  "Qyhn6f": "行权价为零",
  "KQd/Fe": "不能盘中交易",
  "F4Z2ZC": "0DTE表示剩余到期日为零，因此合约在当日到期。",
  "/y/+FL": "期权链主要显示什么？",
  "bW2qO1": "跨越行权价和到期日的可用看涨和看跌期权",
  "4QOhJ2": "仅公司资产负债表",
  "L8eaHm": "仅历史股价",
  "cxYzD+": "仅券商佣金费率",
  "wqNq11": "期权链按到期日、行权价、看涨/看跌类型组织列出的合约。",
  "BDTDLz": "期现平价主要是什么之间的关系？",
  "Tf8NJu": "看涨期权、看跌期权、标的、行权价、利率和到期日",
  "XkwiWO": "仅期权成交量和未平仓合约",
  "FCxEqv": "仅券商保证金规则",
  "+bbf4C": "仅已实现波动率和股息",
  "H4TFNr": "期现平价将看涨期权和看跌期权价格与标的和行权价的远期经济学联系起来。",
  "E2rgDt": "期权图横轴显示什么?",
  "WTKrlG": "到期标的价格",
  "xdTu0F": "券商佣金",
  "xCX7CJ": "日交易量",
  "uYmUfm": "账户购买力",
  "rkJY04": "到期盈亏图通常绘制利润或亏损与到期标的价格的关系。",
  "n1JOcD": "期权图纵轴显示什么?",
  "pswXCR": "盈亏",
  "CICBj0": "到期日",
  "0GTb1p": "期权代码长度",
  "N7YPU5": "持仓量排名",
  "1NZAQg": "纵轴通常显示策略在每个标的价格下的利润或亏损。",
  "utjWgB": "买入看涨期权到期盈亏线通常呈何种形状?",
  "ZId0TI": "下行有限，虚值以上看涨",
  "E5199j": "下行无限，看涨有限",
  "NypCb+": "每价格下利润不变",
  "/kZ1YU": "波动率上升时固定亏损",
  "x2iuAq": "买入看涨期权最多亏损期权费，随着标的价格超过行权价，利润会增加。",
  "vof0IR": "买入看跌期权到期盈亏线通常呈何种形状?",
  "nrjIHn": "亏损有限（期权费），标的价格下跌时价值上升",
  "mF4L5r": "标的价格下跌时亏损无限",
  "kjabmf": "仅在虚值以上亏损有限",
  "O/yjoP": "买入看跌期权最多亏损期权费，标的价格低于行权价时利润增加。",
  "yuDZ6Y": "卖出看涨期权提前行权风险在接近什么事件时通常更高?",
  "DRoPA3": "标的股票除息日",
  "nd8Uv6": "无交易的周末",
  "dK676u": "无期权交易量的一天",
  "Gv/Byq": "券商网站更新",
  "YK0NwO": "当行权可能帮助看涨期权持有人获得股息时，卖出看涨期权可能在股息附近面临提前分配。",
  "Ve2N2x": "交易者为什么可能使用限价单进行期权交易?",
  "0okBtT": "指定交易可接受的最差价格",
  "20RZaq": "保证在任何价格下成交",
  "Tvaqa5": "消除到期风险",
  "C1/WsZ": "更改期权行权价",
  "g/wv8t": "限价单控制价格但不能保证成交。",
  "6fxFms": "在价差较大的期权中使用市价单的一个主要风险是什么?",
  "33+xEo": "成交价可能远差于预期",
  "X0E0tt": "期权到期日消失",
  "jT/jOD": "合约变为欧式",
  "2dVHx1": "期权费保证改善",
  "JESKPU": "市价单优先成交，并可能以较大的买卖价差成交。",
  "/a7j5A": "Rho主要衡量对哪个输入的敏感度?",
  "IcDFf2": "利率",
  "RIULuy": "时间衰减",
  "r2LgCB": "买卖价差",
  "3DEilM": "Rho估计期权理论价值随利率变化而变化的幅度。",
  "jFD4af": "买入看涨期权通常具有什么Delta符号?",
  "n0F8fC": "正Delta",
  "Xs65bh": "负Delta",
  "cNFThY": "Delta恒为零",
  "7gI2Ek": "Delta等于Theta",
  "peYBSh": "当标的价格上涨时，买入看涨期权通常会增值，因此其Delta为正。",
  "U30ERY": "买入看跌期权通常具有什么Delta符号?",
  "KYqe+l": "Delta等于Vega",
  "ZEkBWN": "当标的价格下跌时，买入看跌期权通常会增值，因此其Delta为负。",
  "+9uuuM": "Delta对冲主要用于减少对什么的风险敞口?",
  "E1x89U": "标的的小幅变动",
  "EY2kaG": "经纪佣金变动",
  "dayF6u": "合约代码变动",
  "RrKmFd": "未平仓合约报告",
  "sEgFYK": "Delta对冲可抵消标的的一阶方向性风险敞口。",
  "afu/QL": "买入期权头寸通常具有哪种Gamma特征?",
  "CkWYrM": "正Gamma",
  "MgmtFa": "市场Gamma为零",
  "bS/GBJ": "Gamma等于权利金",
  "ZoyM6d": "买入期权通常具有正Gamma，意味着Delta以有利的凸性方向变化。",
  "f3IDpn": "为什么在快速市场中卖出Gamma会变得有风险?",
  "95fK5I": "Delta会随着标的变动而逆头寸变动",
  "dlx1f5": "权利金入场后不可变",
  "gqtE6q": "无法行权",
  "1JWmL9": "行权价变成浮动",
  "yYZc3X": "卖出Gamma头寸倾向于在价格下跌时Delta变大，价格上涨时Delta变小。",
  "T0NPAQ": "买入期权通常具有什么Vega符号?",
  "x8sbnl": "正Vega",
  "w78fOA": "负Vega",
  "xHtuJc": "Vega恒为零",
  "b+wP9P": "Vega等于Delta",
  "OuG7kA": "买入期权通常受益于较高的隐含波动率，因此其Vega为正。",
  "C9BvsL": "卖出期权通常具有什么Vega符号?",
  "lBKrnB": "Vega等于Theta",
  "6OHayQ": "隐含波动率上升时，卖出期权通常会亏损，因此其Vega为负。",
  "ofGelD": "买入期权通常具有什么Theta符号?",
  "64tTyu": "负Theta",
  "u8XLVe": "正Theta",
  "ogdhAp": "Theta恒为零",
  "S0X4cf": "Theta等于行权价",
  "bM6T5S": "买入期权通常会随着时间的推移损失时间价值，因此Theta通常为负。",
  "M9E0ER": "卖出期权通常具有什么Theta符号?",
  "y6L4pE": "Theta等于隐含波动率",
  "FZdKH7": "卖出期权通常受益于时间衰减，但它们仍带有其他风险。",
  "DwZEtc": "期权Delta有时被用作对什么的粗略代理?",
  "4JTSBL": "价内到期概率",
  "dCErPf": "最终结算价",
  "Zukr+I": "券商保证金要求",
  "hH57cv": "期权日交易量",
  "OoTF3O": "Delta是概率的粗略代理，但并非精确的概率预测。",
  "vgo0jI": "隐含波动率排名通常用于比较什么？",
  "n0ggZo": "当前隐含波动率与其历史区间对比",
  "yN1gN3": "当前股价与账面价值对比",
  "4D742N": "期权交易量与未平仓合约量对比",
  "Ou3zSv": "行权价与合约乘数对比",
  "lAZkC+": "IV排名将当前隐含波动率置于标的物的历史考察范围内。",
  "8/nclW": "隐含波动率百分位通常询问哪个问题？",
  "mOWk/k": "隐含波动率低于当前水平的次数",
  "ZcFS/L": "股票收盘价高于行权价的次数",
  "iY4GHj": "今日交易合约数量",
  "1UQKTy": "券商要求的保证金金额",
  "vszNIh": "IV百分位将当前IV水平与历史考察期内的观测值进行比较。",
  "NCqXTL": "在其他条件相同的情况下，隐含波动率扩张最直接地有利于哪种头寸？",
  "JmZiug": "多头期权头寸",
  "YmLPQb": "空头期权头寸",
  "aFDhJ0": "已完全到期的期权",
  "MpC5jH": "已平仓位",
  "vynC+/": "较高的隐含波动率会提高期权理论价值，有利于正Vega头寸。",
  "Wdt3Jf": "隐含波动率的压低通常最直接地损害哪种头寸？",
  "4dpUAt": "全现金头寸",
  "S2EAyi": "已到期期权",
  "kVOmt7": "隐含波动率的急剧下降会降低期权价值并损害正Vega头寸。",
  "7FuMn8": "在财报发布前，期权通常定价什么？",
  "ujMgYr": "较高的隐含波动率，因为事件不确定性升高",
  "WBFwwx": "零隐含波动率，因为日期已知",
  "GHdYbI": "无时间价值，因为财报已安排",
  "bpfrwc": "看涨期权买方的保证利润",
  "PaG51d": "已知的事件风险会推高隐含波动率，因为交易者预期会有更大的可能波动。",
  "UdAOi6": "当已实现波动率相对于已售出的隐含波动率如何时，空头波动率交易通常受益？",
  "Z8b6vU": "低于已售出的隐含波动率",
  "b72Oxc": "总是高于已售出的隐含波动率",
  "g2zTeP": "等于股票股息",
  "beL9QN": "与期权定价无关",
  "leHwgD": "当市场波动幅度小于已售期权隐含的波动率时，空头波动率头寸通常受益。",
  "hvwXhU": "在同一到期日买入一价看跌期权并卖出一价较低看跌期权，构建的是哪种结构？",
  "88/1qU": "卖出跨式",
  "TpF3k8": "备兑看涨期权",
  "jN4zaS": "熊市看跌价差是一种定义风险的看跌借记价差，用看跌期权构建。",
  "E7KyNL": "在同一到期日卖出一价看跌期权并买入一价较低看跌期权，构建的是哪种结构？",
  "uCiJ+Q": "牛市看跌价差",
  "lI+Atp": "熊市看涨价差",
  "FTeLyG": "多头跨式",
  "FX8s6M": "保护性看跌期权",
  "JiM3Ep": "牛市看涨价差是一种定义风险的看涨贷记价差，用看跌期权构建。",
  "3AaxyC": "在同一到期日卖出一价看涨期权并买入一价较高的看涨期权，构建的是哪种结构？",
  "8Bpn3x": "保护性领口",
  "vixwQ/": "熊市看涨价差是使用看涨期权构建的风险有限的看跌期权贷记价差。",
  "34X7Vg": "对于简单的借记价差，最大亏损通常是多少？",
  "RgXeg9": "支付的净借记",
  "hk3+pJ": "行权价差加上借记",
  "zQGNmX": "期权成交量",
  "wOJ2WW": "借记价差的最大亏损通常是进入该价差所支付的金额。",
  "OOKn2A": "对于简单的贷记价差，最大利润通常是多少？",
  "83qAyX": "收到的净贷记",
  "9UwENq": "完整的行权价差宽度加上贷记",
  "YOlP23": "标的价格",
  "NvgRjY": "贷记价差的最佳情况是在空头期权有利地到期时保留收到的贷记。",
  "TkQh4u": "对于垂直贷记价差，最大亏损通常是多少？",
  "VGn4tv": "行权价差减去净贷记",
  "7COobq": "行权价差加上净贷记",
  "eIrlu0": "在所有情况下均无限制亏损",
  "UbIjj/": "仅收到的权利金",
  "36Q1z0": "多头期权限制了价差风险，最大亏损为行权价差减去贷记。",
  "cJQSIq": "对于垂直借记价差，最大利润通常是多少？",
  "tJqBAu": "行权价差减去净借记",
  "BhGWBE": "行权价差加上净借记",
  "cwuumt": "在所有情况下均无限制利润",
  "m1OA/Z": "空头期权限制了上涨空间，因此最大利润是行权价差减去借记。",
  "0KOSQH": "多头勒式通常由哪些腿构成？",
  "WGy8xN": "买入价外看涨期权和买入价外看跌期权",
  "gk1rJJ": "卖出股票和买入股票",
  "ijUesj": "卖出看跌期权和买入较低行权价的看跌期权",
  "6Ue4AM": "多头勒式买入不同行权价的看涨期权和看跌期权，寻求大幅波动。",
  "GwVm/e": "空头跨式通常由哪些腿构成？",
  "B3MQwB": "在相同行权价和到期日卖出看涨期权和看跌期权",
  "m6PN/V": "在不同行权价买入看涨期权和看跌期权",
  "w4OdB2": "买入股票和买入看跌期权",
  "Rl7+Qi": "卖出股票和买入看涨期权",
  "/9v2vp": "空头跨式在相同行权价和到期日卖出看涨期权和看跌期权。",
  "iWJX4g": "空头勒式通常由哪些腿构成？",
  "DQYzTY": "卖出价外看涨期权和卖出价外看跌期权",
  "RSLXSy": "买入价内看涨期权和买入价内看跌期权",
  "tWIYvx": "仅买入股票和卖出看涨期权",
  "Bg5psP": "在相同行权价买入两个看涨期权",
  "zU8atn": "空头勒式卖出两边期权，如果标的资产保持在一定范围内则获利。",
  "B7e4T3": "铁鹰最好描述为什么？",
  "HAtdfg": "风险有限的空头看涨价差加上空头看跌价差",
  "s9v3tL": "买入看涨期权并买入股票",
  "bHeSh5": "单个深度价内看涨期权",
  "AArmAC": "没有看跌期权边的备兑看涨期权",
  "znXFiW": "铁鹰结合了两个风险有限的贷记价差，一个在市场上方，一个在市场下方。",
  "3JyvM+": "铁蝶通常有什么特点？",
  "LpkiaU": "在相同的中间行权价卖出看涨期权和看跌期权",
  "4CW4Yd": "只有一个期权腿",
  "TAtU5W": "没有空头期权",
  "uwl7qd": "无期权的多头股票头寸",
  "vzxtMP": "铁蝶通过卖出主体行权价和买入蝶翼来构建有限风险。",
  "O2DMWo": "经典的多头看涨蝶式通常在何种情况下最盈利？",
  "Vy1Ltg": "标的资产结算价接近中间行权价",
  "GCkg5l": "标的资产远高于所有行权价",
  "4rdl9O": "标的资产远低于所有行权价",
  "HogBFY": "隐含波动率变得无关紧要",
  "opGIcr": "多头蝶式以接近主体行权价的结算为目标，风险和回报均有限。",
  "0WBPA8": "日历价差通常具有哪种到期设置？",
  "6RXa4Y": "卖出近期期权，买入远期期权",
  "meFXBc": "仅限相同到期日的两个期权",
  "QTY65i": "多头股票和空头股票",
  "PwLWjE": "无到期日的看涨和看跌期权",
  "Fb8PWo": "日历价差使用不同的到期日，通常是卖出近期期权和买入远期期权。",
  "M5aG3N": "备兑看涨期权通常会限制上涨空间，原因是什么？",
  "aKU3XC": "空头看涨期权可能要求在行权价卖出股票",
  "qAmqet": "多头股票价值无法上涨",
  "o6o5kd": "期权无到期日",
  "X1iQ0j": "支付的权利金无限",
  "s1VZLN": "空头看涨期权产生在行权价交付股票的义务，限制了该水平以上的收益。",
  "0jOUAm": "保护性看跌期权常用于构建什么？",
  "CvQuK2": "多头股票头寸的下行保护底线",
  "lnGTux": "无风险的无限收益",
  "X1cYoo": "保证的股息",
  "nV0gCc": "无对冲的空头波动率头寸",
  "r0/4y2": "看跌期权随股票下跌而增值，有助于在支付权利金后限制低于行权价的下行风险。",
  "QYjBxJ": "领子期权组合通常结合多头股票和哪种期权腿？",
  "3wTnEO": "多头看跌期权和空头看涨期权",
  "dYfOYs": "多头看涨期权和空头看跌期权",
  "/gYNMH": "仅两个空头看涨期权",
  "vVn2yv": "仅两个多头看跌期权",
  "WMSrKc": "领子期权组合通过买入看跌期权获得下行保护，并通过卖出看涨期权来部分抵消成本。",
  "yUI8t9": "为什么风险可控价差比裸卖空期权所需的保证金更少？",
  "ZFXLct": "多头期权腿限制了最坏情况下的亏损",
  "+KJLRC": "风险可控价差不会亏损",
  "x2dmI/": "经纪商在价差中忽略空头期权",
  "J+pJdR": "合约无到期日",
  "uL2AzN": "保护性的多头腿限制了潜在亏损，与无覆盖的空头头寸相比，可以减少保证金。",
  "EsnbQC": "购买力下降最接近指什么？",
  "6w6Hqu": "经纪商为支持头寸而预留的资本",
  "t7zp95": "每日交易量",
  "Ss28Pf": "期权的理论Delta",
  "oRlS0o": "经纪商预留购买力或保证金以覆盖未平仓头寸的潜在风险。",
  "+EMU6D": "提前行权主要可能发生在哪个风格的期权到期前？",
  "lTNQVQ": "美式期权",
  "vX200h": "欧式期权",
  "pxnuWq": "仅已到期期权",
  "XJcWwO": "仅现金头寸",
  "38sh7h": "美式期权可在到期前行权，给空头头寸带来提前行权的风险。",
  "wm191e": "钉住风险最常与到期前哪种情况相关？",
  "qEqYmZ": "标的接近期权行权价",
  "6ZhK1+": "期权无行权价",
  "/8+Pge": "仅市场节假日休市",
  "llMdoM": "合约乘数未知",
  "+ONE39": "当标的接近行权价时，最终的行权和分配结果可能不确定。",
  "IXAcAR": "到期前，卖出持有的期权为何优于行权？",
  "w0YVxr": "卖出可保留剩余的外部价值",
  "T4W7CX": "行权总是创造额外的时间价值",
  "vo7LaV": "卖出可免除所有税费",
  "kWD3rE": "行权改变行权价",
  "6+XRyA": "行权可能损失卖出期权可获得的剩余外部价值。",
  "FSzJTW": "到期时自动行权通常适用于哪些期权？",
  "fenl6O": "价内至少达到经纪商或清算阈值",
  "RdEvOq": "亏损任何金额",
  "lb2Hbu": "盘中从未交易",
  "KsahwX": "仅在期货上列出",
  "wEtR9e": "除非有相反指示，否则清算和经纪商规则通常会自动行权足够价内的期权。",
  "PBtxRb": "在垂直价差中，行权价宽度直接影响什么？",
  "T52zfb": "到期时最大可能的价差价值",
  "JZSxeF": "期权的到期日",
  "pGw1RR": "合约乘数变为一",
  "1WTiNc": "标的股息计划",
  "nC/9u3": "行权价之间的距离决定了垂直价差的最大内在价值。",
  "naZxid": "对于风险可定义期权交易，应根据什么来评估风险回报？",
  "wnOcW6": "最大亏损、最大利润、概率和情景风险暴露",
  "2z40N1": "仅期权代码长度",
  "s90Rm4": "仅昨收价",
  "TtcIEZ": "仅经纪商营销标签",
  "elQ605": "风险可定义不意味着本身有吸引力；收益、概率和情景风险都很重要。",
  "4ywWMp": "对于多腿价差，希腊字母通常如何评估？",
  "0gF50n": "通过对所有腿的希腊字母敞口进行净额计算",
  "CQsjEm": "仅查看输入的第一个腿",
  "nnvYUf": "忽略空头腿",
  "LHICNJ": "用成交量替换所有希腊字母",
  "x4uTah": "价差的总敞口来自所有腿的希腊字母组合。",
  "/4Z4Pq": "Delta中性最直接的意思是什么？",
  "nUjW3P": "在当前标的价格下，净Delta接近零",
  "5ukNxp": "头寸没有任何风险",
  "YLVS+6": "头寸没有Vega或Theta",
  "7DYhMY": "头寸无法被分配",
  "NTnpXt": "Delta中性可降低一阶方向性敞口，但Gamma、Vega、Theta和尾部风险仍然存在。",
  "y3BSKv": "Gamma通常对哪些期权最高？",
  "qVYb2W": "接近到期时的价内期权",
  "LSuBx8": "多年到期的深度价外期权",
  "G7uIdr": "已到期无结算的期权",
  "WTBhCw": "无行权价的期权",
  "8ef6kc": "临近到期时，标的小幅波动可能迅速改变价内期权的Delta。",
  "EO3G51": "时间衰减通常对哪些期权加速最明显？",
  "opfDK8": "短期价内期权",
  "ErX1Jj": "仅长期深度价内期权",
  "khfgIv": "期权结算后到期",
  "lGfGY4": "无权利金期权",
  "h9HoJK": "平值期权外在价值最高，短天期外在价值衰减迅速。",
  "2w37nt": "股指看跌期权通常比同等看涨期权具有更高的隐含波动率，原因是什么？",
  "chkd1i": "下行保护需求和崩盘风险定价",
  "W0HOmZ": "看跌期权没有到期日",
  "1oYLQI": "看涨期权无法行权",
  "RGxr4c": "股指没有标的价格",
  "80qpKP": "下行避险需求和跳空风险通常使较低行权价的看跌期权波动率更高。",
  "RHy1ny": "波动率曲面常以相对于什么的价内度来建模？",
  "5GZUSU": "该到期日的远期价格",
  "EXqxRb": "仅昨日最后一个成交价",
  "yoUhxD": "远期价内度在比较行权价时会考虑利率、股息和到期时间。",
  "v2QNgN": "粘性行权价波动率假设意味着隐含波动率由什么恒定？",
  "Eh7FId": "绝对行权价",
  "bfNNYA": "期权delta",
  "jMMH6/": "投资组合theta",
  "ytQfFB": "券商账户类型",
  "vSg9wu": "粘性行权价假设在标的资产移动时，给定行权价的隐含波动率保持不变。",
  "gsWgUT": "粘性delta波动率假设意味着隐含波动率由什么恒定？",
  "tNF18Z": "期权delta或价内度",
  "n8B1fF": "仅绝对行权价",
  "b7Ax4M": "仅日交易量",
  "u7POtj": "仅行权历史",
  "+bsObq": "粘性delta假设波动率微笑随标的资产移动，因此可比delta保持相似波动率。",
  "Ns/fbs": "波动率微笑描述了哪种模式？",
  "2Ok1jS": "远离平值行权价的更高隐含波动率",
  "/DpuvY": "每个行权价和到期日具有相同的隐含波动率",
  "yfGZFH": "仅开盘时的高交易量",
  "9ol6R5": "标的资产的保证上涨",
  "O2zRVQ": "微笑意味着远离中心行权价的期权可以以比平值期权更高的隐含波动率进行交易。",
  "656mfu": "波动率偏度陡峭化通常意味着什么发生了变化？",
  "qH/q9n": "行权价之间的隐含波动率差变大了",
  "6O5HIP": "所有行权价现在都具有相同的隐含波动率",
  "OZbXDP": "链条中消失了到期日",
  "OzFVy6": "历史波动率无法衡量",
  "Mje8Et": "更陡峭的偏度表明，一个行权价范围部分的波动率溢价大于另一部分。",
  "rQSlOc": "波动率偏度趋平通常意味着什么发生了变化？",
  "k0bFEq": "行权价之间的隐含波动率差变小了",
  "2ey2n3": "所有期权价格都变成了零",
  "atz+DJ": "合约乘数改变了",
  "ZoDmBm": "标的资产停止交易",
  "S1Nqzj": "更平坦的偏度意味着行权价之间的相对波动率差异减小。",
  "pOPoq2": "远期溢价（Contango）下的波动率期限结构通常意味着什么？",
  "xQNyp/": "长期隐含波动率高于短期隐含波动率",
  "KggVBW": "短期隐含波动率总是高于长期隐含波动率",
  "u5ZGpW": "所有到期日都具有零隐含波动率",
  "ZkpbHu": "仅历史波动率重要",
  "HWNKbf": "远期溢价（Contango）描述了跨到期日的向上倾斜的期限结构。",
  "sOFPg5": "逆远期（Backwardation）下的波动率期限结构通常意味着什么？",
  "aFiMYP": "短期隐含波动率高于长期隐含波动率",
  "Af68l7": "长期隐含波动率总是高于短期隐含波动率",
  "Hv5oCL": "所有到期日具有相同的交易量",
  "YbldLH": "期权无法行权",
  "irnkwk": "当近期事件或压力风险的定价高于长期波动率时，通常会出现逆远期（Backwardation）。",
  "N4WySM": "事件波动率最直接地通过比较什么来分离？",
  "tWEPxa": "包含事件的到期日与不包含事件的到期日",
  "LvOtjx": "仅股票的日交易量和未平仓合约",
  "UKl8Bz": "仅深度价内看涨期权",
  "W0nhEV": "仅券商保证金计划",
  "SKmVHC": "事件前后的期限结构可以揭示市场对该事件窗口分配了多少额外波动率。",
  "C4yPeq": "远期波动率试图估计什么？",
  "uoMXIM": "到期日之间未来时间窗口的隐含波动率",
  "39HTEF": "下一笔交易价格（确定性）",
  "tKvut+": "仅当前买卖价差",
  "jELa/t": "卖出期权的精确行权概率",
  "Ucg7r6": "远期波动率从不同的到期价格中反推出未来时间段的隐含波动率。",
  "2BQQb+": "交易者为什么经常使用方差而不是波动率进行跨时间分析？",
  "RLOl4Q": "在常见假设下，方差与时间呈更自然的比例关系",
  "k/7TED": "方差始终等于期权Delta",
  "BH63dE": "方差消除了所有跳空风险",
  "IEseDZ": "方差忽略到期时间长度",
  "AwVzBv": "方差（或波动率的平方）被普遍使用，因为时间聚合更易于处理。",
  "q6BMMB": "波动率风险溢价通常指什么？",
  "dk3MOr": "隐含波动率随时间推移倾向于超过后续已实现波动率",
  "6k4xN0": "已实现波动率每天都超过隐含波动率",
  "Yu6PA7": "券商为每笔期权订单向交易者支付的费用",
  "qhrjcA": "仅买卖价差大小的差异",
  "m/GQp3": "期权卖方通常要求补偿以承担波动率和跳空风险，从而产生波动率风险溢价。",
  "uCFYgW": "期权投资组合中的尾部风险指的是什么？",
  "vPp9pg": "低概率但高影响力的市场变动",
  "mLNGpE": "收盘前最后成交价",
  "HA7wKp": "仅多腿订单佣金",
  "Q+rqjl": "账户中最小的期权头寸",
  "WdIZQs": "尾部风险侧重于可能主导投资组合亏损的罕见但严重的后果。",
  "2T9aeG": "在险价值 (VaR) 用于估计什么？",
  "AxkBXx": "在某个置信水平下，某个时间范围内的损失阈值",
  "2Ikwwq": "所有情景下的确切最大可能亏损",
  "gxirS2": "仅期权的内在价值",
  "3IA2hm": "券商佣金计划",
  "T7dERO": "VaR总结了某个时间范围内、某个置信度下的损失水平，但它不能完全描述尾部严重性。",
  "yCaX3N": "投资组合压力测试主要用于做什么？",
  "te5Wls": "估计大市场和波动率冲击下的结果",
  "eStEom": "保证次日利润",
  "xIQ7a0": "消除所有行权风险",
  "kH1ies": "使每个价差无风险",
  "3gO41r": "压力测试用于探索头寸在超出日常普通变化的大幅不利变动下的表现。",
  "l3f6px": "期权风险的场景网格通常会改变哪些输入？",
  "W7D/qL": "标的价格、时间、隐含波动率",
  "mksNg7": "仅期权代码和券商名称",
  "HNzYGL": "仅历史成交量",
  "Mr8n8O": "仅合约乘数",
  "uzIXOW": "期权对价格、时间和波动率都很敏感，因此场景网格通常会同时冲击这三者。",
  "3kGkyd": "Vanna通常与涉及哪两个变量的敏感性相关？",
  "MiVd8E": "Delta和隐含波动率",
  "HWsrDh": "Theta和券商佣金",
  "ZvYTrg": "未平仓合约量和成交量",
  "x7hGvY": "行权价差和账户类型",
  "uzzd2f": "Vanna衡量Delta如何随波动率变化，或者同样地，Vega如何随标的变化而变化。",
  "kCeVjX": "Volga 衡量什么?",
  "FnangZ": "Vega 对波动率变化的敏感度",
  "HkaN+L": "Delta 对时间的敏感度",
  "dAFStF": "持仓合约数量",
  "XawFKX": "价差的行权价宽度",
  "1yPwep": "Volga 描述了隐含波动率变化时波动率敞口的曲率。",
  "AMq1+1": "Charm 通常描述为?",
  "z3LuDv": "Delta 随时间的变化",
  "5czffg": "成交量随价格的变化",
  "W+nkIo": "分配后的行权价变化",
  "PW0Z3/": "经纪商保证金规则的变化",
  "VohfEx": "Charm 捕捉了 Delta 随时间的衰减，这对于对冲期权组合很重要。",
  "A2isno": "Color 通常与什么相关?",
  "+eFkZ0": "Gamma 随时间的变化",
  "ZszidK": "盈亏图表的颜色",
  "+L1W7G": "期权链中的行权价数量",
  "xozMpA": "交易屏幕上的买入价颜色",
  "Dm8fFB": "Color 描述了 Gamma 随时间的推移如何变化，通常在到期日附近很重要。",
  "sDxNs3": "持有正Gamma并动态对冲，通常在实际价格波动如何时受益？",
  "VbKG5a": "足够大以克服 Theta 和交易成本",
  "lbTvfc": "总是正好为零",
  "Nt90p6": "与对冲频率无关",
  "aOwdzt": "低于所有佣金费用",
  "LZ3gub": "多头 Gamma 可以通过重新对冲来获利，但收益必须超过 Theta 衰减和成本。",
  "oKMem8": "增加 Delta 对冲频率通常会增加对哪种实际成本的敏感度?",
  "YAiRQI": "交易成本和滑点",
  "Psv+rc": "期权的行权价变化",
  "3jQnGW": "到期日移远",
  "KZjZkq": "合约乘数变为零",
  "JhJsME": "频繁对冲可以更好地控制 Delta，但可能产生显著的执行成本。",
  "oavf3n": "离散对冲风险的产生是因为对冲是怎样调整的?",
  "Uw6SQS": "按间隔而非连续调整",
  "kemNpN": "仅在交易开立前",
  "zoIfar": "不考虑标的资产",
  "gBGmJJ": "实际投资组合无法连续对冲，因此跳空和两次对冲之间的变动会产生残余风险。",
  "LYlvi/": "跳空风险对哪种头寸尤其重要?",
  "4Ir4nk": "暴露于隔夜大幅波动的空头 Gamma 头寸",
  "UBul4S": "没有敞口的平仓",
  "iLRwEA": "仅现金余额",
  "OKtP18": "已作废的期权",
  "z6AYM8": "空头 Gamma 头寸可能会因在调整对冲之前发生的剧烈跳空而受损。",
  "w15zIh": "典型的多头日历价差通常具有哪种波动率敞口?",
  "zY3Per": "对长期隐含波动率的正面敞口",
  "Ug94jK": "没有隐含波动率敞口",
  "YIu0zS": "仅对股票股息的敞口",
  "i8S0yK": "按构建的无限负 Delta",
  "+MTmGS": "长期多头期权通常会为多头日历价差带来正的净 Vega，尽管细节取决于行权价和到期日。",
  "kGigSK": "接近空头行权价的多头日历价差通常试图从什么中获利?",
  "XZI3/d": "空头近端期权的加速衰减",
  "YAr1Cf": "多头期权在空头期权到期前到期",
  "FDxp57": "无无限的执行价宽度",
  "noqNi3": "标的即时交付",
  "yEwJrm": "日历价差通常卖出快速衰减的近端期权价值，同时持有远期期权性。",
  "6Fg0VK": "斜跨式价差可以结合期限结构风险敞口和哪种其他风险敞口？",
  "jVhbR8": "不同执行价的方向性风险敞口",
  "XA1jmW": "保证零Delta",
  "beDZNA": "无波动率敏感性",
  "ASqjcy": "无到期风险",
  "2WNAks": "由于斜跨式价差的腿在执行价和到期日上都不同，它们可以携带方向性和期限结构观点。",
  "rpUTBx": "贫民备兑看涨期权通常用什么来替代多头股票？",
  "XT63n+": "长线深度价内远期看涨期权",
  "93xqsr": "仅长线深度价内看跌期权",
  "PPVgFg": "仅长线价外看跌期权",
  "bOfL2J": "仅现金结算期货合约",
  "cZUno/": "该策略使用远期看涨期权作为类股票风险敞口，并卖出近端看涨期权作为对冲。",
  "c5Fdru": "比例价差通常指什么？",
  "aGkO6x": "多头和空头期权合约数量不相等",
  "DyqJcF": "每条腿数量相同",
  "sCK+qZ": "交易无空头期权",
  "mFvWpN": "交易无到期日",
  "iwObWw": "比例价差使用不相等的数量，这可能导致非线性且有时无覆盖的风险。",
  "JvyEhr": "反向价差通常买入比卖出更多的期权以创造什么？",
  "ZP1p+O": "大额波动中的长凸性",
  "4yZOoX": "保证平仓收益",
  "YrNBwZ": "无Gamma风险",
  "qt74a8": "无权利金风险的头寸",
  "7Tr77G": "反向价差通常寻求大额波动中的凸性收益，同时通过卖出较少期权来为多头期权的部分融资。",
  "A26AIO": "断翅蝶式价差与常规蝶式价差的区别在于哪项不均衡？",
  "qMbHJW": "主体与蝶翼之间的距离",
  "e25J2i": "每条腿的合约乘数",
  "e3vo5H": "每条腿的标的符号",
  "yhAosc": "必须缺少到期日",
  "yXAnxq": "断翅蝶式价差将一个蝶翼移得更远，改变了贷记、借记和尾部风险。",
  "fnAXa1": "铁鹰价差中更宽的蝶翼通常会做什么？",
  "4KBowa": "如果贷记不足以增加，则最大风险增加",
  "4kQloQ": "消除所有分配风险",
  "44MBz6": "使头寸成为多头跨式",
  "u5KUx0": "移除隐含波动率的风险敞口",
  "wepiKG": "更宽的定义风险蝶翼可能增加亏损潜力，除非有足够的额外贷记来补偿。",
  "MilC9p": "期权投资组合中的相关性风险很重要，因为会发生什么？",
  "e5muMn": "看似多元化的头寸在压力下可能一起亏损",
  "ZUn1vO": "每个标的总是独立变动",
  "7eQhPP": "相关性消除了波动率风险",
  "JywElM": "相关性仅影响已到期期权",
  "+bpFO3": "压力期间，相关性可能上升，使头寸比预期表现出更相似的行为。",
  "ECCmtY": "投资组合的Beta加权用于表达相对于什么的风险？",
  "aQuBfn": "基准或参考标的",
  "XkPmaZ": "仅账户的现金余额",
  "F3ghc+": "仅期权的到期日",
  "UM7yzj": "观察列表中的符号数量",
  "a5ymAE": "Beta-加权将不同头寸转换为对选定基准的大致风险敞口。",
  "s1vQiw": "集中风险意味着投资组合过度依赖什么？",
  "1O7tJU": "少数标的资产、因子或场景",
  "yqH1RL": "同时存在看涨期权和看跌期权",
  "epL9to": "拥有多个到期日",
  "he90l+": "使用限价单",
  "2th6dN": "当一种主题、代码或场景不利于投资组合时，集中度会放大损失。",
  "MBjFhL": "流动性压力会通过什么方式影响期权投资组合？",
  "Cbw5kX": "扩大价差并增加退出成本",
  "0e6alB": "保证以理论价格成交",
  "dPZjFU": "消除保证金需求",
  "M6DTJZ": "使希腊字母保持恒定",
  "bjrRD7": "在压力下，流动性会消失，价差会扩大，模型化的退出可能变得不切实际。",
  "g9PQad": "期权估值中的模型风险意味着什么？",
  "H8dNZQ": "定价模型或假设可能不符合真实市场行为",
  "n3UUdi": "模型保证始终公平交易",
  "uouIWl": "只有图表颜色可能出错",
  "T4YwLW": "期权没有市场价格",
  "N3WK6O": "模型简化了现实，因此关于波动率、利率、股息和跳跃的假设可能导致错误。",
  "acFF95": "股息假设对哪种期权风险影响最大？",
  "KLDlOf": "股本期权的定价和提前行权决策",
  "x/4Mfn": "期权代码的字体大小",
  "P/iH+d": "上市交易所的数量",
  "vmkkDf": "账户登录方式",
  "0XN5ZZ": "预期股息会影响远期、期权价值以及看涨期权的提前行权激励。",
  "ih9nnG": "利率主要通过什么概念进入期权定价？",
  "Uq1sQR": "折现和标的资产的远期价格",
  "hKuCay": "屏幕上的买入价颜色",
  "Lgqth2": "仅做市商的数量",
  "4/tFCU": "利率影响现值和远期定价，这些都会影响期权估值。",
  "WzJoKx": "局部波动率模型将波动率设为什么的函数？",
  "FbHQzx": "标的资产价格和时间",
  "4az1oG": "仅经纪商佣金",
  "eJUAM6": "仅期权交易量",
  "OYeD6d": "仅账户保证金类型",
  "LPGaNh": "局部波动率模型拟合跨越价格和时间的波动率函数，以匹配隐含波动率曲面。",
  "bdY4yG": "随机波动率模型如何处理波动率？",
  "6ApCTP": "可以随机演变的可变参数",
  "5Itx4M": "一个永不改变的固定数字",
  "z9Cymq": "与期权交易量相同",
  "q+Oaql": "经纪商的保证金利率",
  "6SL5Jw": "随机波动率模型允许波动率本身不可预测地移动。",
  "M11+ty": "跳跃风险对 Delta 对冲很困难，因为可能发生什么？",
  "hi/Mz3": "在调整对冲之前，标的资产可能不连续地移动",
  "rT1kIc": "所有期权的 Delta 都精确地变为零",
  "AhZMW/": "期权溢价不会改变",
  "8m+I9O": "行权价自动调整",
  "QTDiDZ": "Delta 对冲是局部近似，当价格跳跃范围很大时可能会失效。",
  "/GaVeJ": "波动率微笑动态很重要，因为头寸的 Vega 风险敞口会随什么而变化？",
  "ZJlt8R": "标的资产移动和波动率曲面的变化",
  "bGCL9p": "仅用户名",
  "vfv1BU": "仅交易所假日日历",
  "hxcWYS": "仅期权根代码",
  "SmBxmn": "Vega分布于行权价和到期日，因此曲面变动会改变投资组合敞口。",
  "rouLD7": "期权盈亏归因试图通过哪些驱动因素解释损益？",
  "6RZEQJ": "价格变动、时间衰减、波动率变化、融券成本和残差效应",
  "JsAPRt": "仅最终账户余额",
  "t1Fw+F": "仅交易合约数量",
  "z/tt7B": "仅交易使用了看涨期权或看跌期权",
  "fWnTXT": "归因将盈亏分解为驱动因素，以便交易者可以看到论点或风险模型是否奏效。",
  "ziHZAd": "投资组合希腊字母限额主要用于做什么？",
  "ZlsI0w": "在总敞口过于集中之前进行控制",
  "Rg9wDT": "保证每笔交易的利润",
  "nnGV+p": "消除对场景分析的需求",
  "fHtki4": "设置期权的官方结算价",
  "IDD5eN": "风险限额将总Delta、Gamma、Theta、Vega或其他敞口保持在预期范围内。",
  "3T78Ab": "滚动期权头寸会改变风险，因为它会改变什么？",
  "tW+G/2": "行权价、到期日、希腊字母、贷记或借记以及行权敞口",
  "WQWR50": "仅订单标签颜色",
  "x++5vq": "仅代码的法定名称",
  "rLGqs2": "仅历史已实现波动率",
  "plp7nq": "滚动交易是改变头寸经济性而非消除原始风险的新交易。",
  "mIREDE": "期权隐含的预期波动幅度通常从什么推导得出？",
  "AX+i3w": "给定到期日的期权价格和隐含波动率",
  "NnuvBB": "仅公司营收",
  "89ORBd": "仅经纪商购买力",
  "yzR1M2": "仅前一天的未平仓合约量",
  "CLjFLd": "预期波动幅度使用期权价格或隐含波动率来估算一段时间内的市场隐含范围。",
  "PDQvDy": "为什么高盈利概率仍然会隐藏不良的风险回报比？",
  "JNx5nY": "小额频繁的收益可能被罕见的大额亏损所抵消",
  "Sw8q8X": "盈利概率保证了预期价值",
  "2FHZvC": "风险回报比不适用于期权",
  "5biMVc": "定义风险的交易中不可能发生大额亏损",
  "/zlGAo": "仅胜率忽略了亏损大小、尾部风险敞口和预期价值。",
  "Aj9aBn": "在波动率飙升期间，投资组合保证金要求可能会增加，因为什么会上升？",
  "q67lz9": "模型化场景亏损和风险收费",
  "kvnKAL": "期权合约乘数总是翻倍",
  "+x4UCv": "所有多头期权立即变得毫无价值",
  "V4nRH2": "经纪商忽略对冲",
  "zYh2Wt": "更高的波动率和压力情景会增加模型化亏损，需要更多资本。",
  "bZrwK1": "Call/Put、内在价值、时间价值、到期盈亏图，基础备兑与保护性策略。",
  "4p+czn": "Greeks、波动率、垂直价差、跨式/宽跨、铁式结构、保证金、行权与指派。",
  "AEeHzy": "波动率曲面、skew、calendar/diagonal、比例与蝶翼结构、gamma scalping、组合风险。",
  "W6nwjo": "草稿",
  "5hUPMv": "板块",
  "ccXLVi": "类别",
  "wTo1un": "筛选",
  "WCaf5C": "通过",
  "hrgo+E": "归档",
  "kgOBET": "题目",
  "TTrWwx": "答案选项",
  "E1bF/X": "解析",
  "OuR/Ij": "题库",
  "Mc6JFr": "下一组",
  "BFsH4+": "看懂单腿期权和到期盈亏",
  "UVYljC": "看涨/看跌",
  "GSGain": "内在价值",
  "JKh5wf": "到期盈亏",
  "+yZUz6": "备兑/保护基础",
  "Dl50ts": "概念边界",
  "DzUFFm": "公式识别",
  "7v6GTM": "盈亏方向",
  "a+mezc": "理解希腊值、波动率与常见价差组合的关系",
  "45g521": "垂直价差",
  "yNMbw6": "跨式/宽跨",
  "lJK0aS": "保证金",
  "LJV4+Y": "行权/指派",
  "+B3Di8": "敏感度逻辑",
  "mCeTg8": "结构选择",
  "x6sYEM": "风险来源",
  "++1xV9": "处理期限结构、偏斜、动态对冲与组合风险",
  "/0kwWy": "波动率曲面",
  "PvNKew": "日历／对角价差",
  "xeBgEv": "比例/翼式结构",
  "2JXtB+": "Gamma动态对冲",
  "cZpsC8": "组合风险",
  "Y+YQZb": "波动率状态",
  "EoQMlN": "对冲权衡",
  "BvATNn": "组合敞口",
  "nso3Mj": "范围",
  "vjqyim": "{count} 次签到",
  "A1thHV": "暂无签到",
  "XlQWMy": "查看表现",
  "4VYdh2": "打卡汇总",
  "85lhj2": "组数",
  "KV/9Hv": "题数",
  "6NoIUl": "回答正确",
  "AM6uUM": "最近：{board} {score}%",
  "U0VT0Z": "完成一组后开始积累记录。",
  "uJ61dq": "连续 {count} 天",
  "3ROQOj": "入门",
  "ihIcdp": "{done}/{total}",
  "b6HMvT": "请完成上一个阶段以解锁。",
  "Qaq50Y": "{score}% · {done}/{total}",
  "a/IgAO": "完成上一阶段",
  "OLhkJq": "先完成入门",
  "jsrhLf": "先完成进阶",
  "y+qSYj": "需完成入门",
  "/RvHyr": "需完成进阶",
  "ERJjcu": "答错 {wrong} 题",
  "r30YT7": "重做遗漏题目",
  "V8VdhC": "已掌握",
  "BTQ8BM": "已练",
  "3+2MvO": "错题",
  "W/bXoO": "错题练习",
  "4CymrY": "错题重答",
  "zmq2+1": "整组重答",
  "uO5xca": "阶段",
  "HoSM3S": "下一组错题",
  "85cyVg": "继续前进",
  "k0IMj5": "错题已清空，继续前进。",
  "JKgNd/": "补未答题",
  "QdUofP": "跟随市价",
  "QcjNQ/": "停止跟随市价",
  "u/fP3G": "强化练习",
  "+BqxXG": "错题练习",
  "cgGLoX": "3D风险结构可视化",
  "Pwn0lb": "将价格、到期日、波动率和盈亏映射到一个3D结构中，以便您能看到策略在不同市场路径下的变形。",
  "VVZVpP": "多策略管理",
  "vfqHbx": "在一个工作空间中管理单腿、价差和复杂组合，逐层比较成本、希腊字母、盈亏曲线和到期风险。",
  "JJJRKX": "每日期权测验",
  "rmiJIO": "通过每天的几个聚焦问题，强化期权概念、盈亏曲线形态和风险边界。",
  "6RRX7X": "基础",
  "5sSi1z": "需完成基础",
  "F9AZpf": "纽约 (ET)",
  "n6sx52": "洛杉矶 (PT)",
  "mU/tMS": "芝加哥 (CT)",
  "YekgnB": "伦敦",
  "UfMD1l": "巴黎",
  "aUwitQ": "上海",
  "mWF7RS": "东京",
  "rhaGlx": "新加坡",
  "srtRPx": "选择日期和时钟使用的时间区域",
  "IcUakl": "时区",
  "w/uBeK": "伦敦 (GMT/BST)",
  "4FwhdX": "巴黎 (CET/CEST)",
  "1x6hvP": "上海 (CST)",
  "qsO47r": "东京 (JST)",
  "jLCfhX": "新加坡 (SGT)",
  "/OaaHw": "图表时区",
  "W4SaxY": "本地",
  "OHAWov": "打开日历",
  "zq8mtn": "选择日期",
  "u14thJ": "统一日期快捷键",
  "jy3ual": "⚠️ 如开启此功能，在组合视图中，点击顶部日期栏会把所有策略统一到同一日期，需谨慎开启使用。\n\n也可以在高级功能中，为每个策略或日历策略的每条腿选择到期日。",
  "paBpxN": "忽略",
  "vqZNmh": "不再提醒",
  "oDG/cH": "组合策略｜统一到期日｜选择快捷键",
  "o3QhEQ": "⚠️启用顶部日期条，可用作统一策略到期日快捷方式。\n\n在组合视图中点击日期，会将每个策略移至同一到期日。请谨慎使用。\n\n您也可以在“高级”功能中为每个策略选择到期日，或日历策略的每条腿选择到期日。",
  "OhS3ye": "组合策略｜统一到期日｜选择快捷键",
  "dULrW2": "⚠️启用顶部日期条，可用作统一策略到期日快捷方式。\n\n在组合视图中点击日期，会将每个策略移至同一到期日。请谨慎使用。\n\n您也可以在“高级”功能中为每个策略选择到期日，或日历策略的每条腿选择到期日。",
  "JsBPRh": "腿到期日",
  "Vs3d3N": "策略到期日",
  "GjCS6U": "选择模版",
  "V7PbLi": "评估价格：在这个点位上，用来重新计算策略价值的市场价格。",
  "m69vGU": "锚定行权价：把策略结构本身移动到另一个中心行权价。",
  "EM1ADz": "价内外度：相对锚定行权价的距离，用百分比表示。",
  "9KcLVp": "隐含波动率：在这个点位上，用来重新计算策略价值的波动率假设。",
  "1wrbl3": "到期剩余天数。小数表示不足一天；0.40D 约等于 9.6 小时。",
  "w2xzwf": "这个点位上的模拟盈利或亏损。",
  "dKd90M": "这个点位上的期权估值或权利金。",
  "6iH5wI": "模型里由时间流逝带来的估值变化。",
  "4klIB9": "价格移动 1 点时，预估盈亏会变化多少。",
  "QDNL3E": "局部敏感度：价格移动 1 点时，Delta 会变化多少。",
  "S1UHAo": "隐含波动率变化时，预估估值会变化多少。",
  "ARXFpM": "输入轴：沿这个方向扫过一个场景变量。",
  "eIwiyJ": "高度轴：控制曲面的上下高度。",
  "mfidD3": "颜色映射：控制曲面的颜色含义。",
  "m5ZIW0": "保存这个新标签页，还是放弃？",
  "/o2pEx": "检测失败，请重试。",
  "scC4eY": "检测未返回策略。",
  "FVR7hb": "无法保存检测到的策略。",
  "9pjcu2": "市场策略控制台",
  "2ijUGe": "AI检测",
  "uw6J24": "描述你预期的市场",
  "6v14IG": "例如：SPX受Gamma影响被钉住，VIX消退，我想要确定的风险。",
  "+4CIVL": "向AI询问市场背景、策略选择或回测结果。",
  "hQ4Jcl": "编辑模版",
  "Jnt34v": "开启侦测",
  "tly7rx": "检测到的策略",
  "CUs27j": "从您的检测输入生成。",
  "ijQrZ0": "AI",
  "amc+u7": "检测结果",
  "H+Yu1D": "跨VIX分位分析波动率曲面...",
  "2aPsuQ": "评估0DTE结构的时间衰减曲线...",
  "Sl9Keb": "扫描1000+交易日以寻找最佳入场信号...",
  "2T1LPg": "基于风险参数计算头寸规模...",
  "ZwXErf": "校准止损水平以应对盘中波动率峰值...",
  "hS18vC": "AI 未返回可用策略。请重试探测。",
  "djJp6c": "历史",
  "ZYEQ8A": "暂无回测",
  "JXdbo8": "完成",
  "KiXNvz": "运行",
  "cj5UCO": "回测仍在运行。完成后将显示在历史记录中。",
  "mjbpwF": "生成",
  "g/rwmh": "生成策略",
  "k9hDFZ": "上一页",
  "rBj9Ib": "下一页",
  "XdGPuT": "标的",
  "Ab9Hz6": "无生成的策略",
  "qkwNvX": "生成的策略将在此处显示",
  "G1poGQ": "您的策略将锚定至市场。交易时段内为实时价格；交易时段外为最近收盘价。所有行权价、收益和计算均以市场价格为基础。",
  "ik14st": "选择腿",
  "sYlkxi": "切换腿可见性",
  "ehbTjh": "折叠腿",
  "Qc+OIm": "展开腿",
  "o1TZ2s": "编辑腿到期日",
  "mdRqIw": "高级自定义",
  "FHdLKp": "日期",
  "lubTzx": "变动",
  "8JaNdH": "数量",
  "qVGRIE": "数量",
  "s5T2BC": "左侧工作区",
  "SEmZmJ": "右侧工作区",
  "zuLQcI": "退出分屏视图",
  "lJEnpw": "左侧",
  "gAnLDP": "右侧",
  "Hx07be": "打开分屏视图",
  "Q6de0z": "切换盈亏图缩放",
  "rMfXlJ": "1倍",
  "hkfVzy": "2倍",
  "z6x/il": "浮动策略编辑器",
  "iiqewp": "停靠策略编辑器",
  "1fBIQ4": "到期日",
  "/TQJwJ": "折叠所有腿",
  "4wJTeh": "展开所有腿",
  "KiwqS0": "中间工作区",
  "rwVd++": "使用两个页面",
  "MGR8h4": "使用三个页面",
  "QPmWTa": "中间",
  "84ZmIG": "复利",
  "Neixc3": "季度",
  "cEkPVx": "每月追加",
  "uT4OlP": "费用",
  "SRhWkB": "本金",
  "Fp0TV5": "每日 %",
  "4l5eSH": "年化 %",
  "tA69X4": "乐观年化 %",
  "9v+Ku+": "压力年化 %",
  "AwzkSM": "税率",
  "Jr5tMR": "年数",
  "ACdOVs": "每日",
  "viJDaR": "年化",
  "qF90PO": "本金 × (1 + 年化%) ^ 年数 = 结果",
  "KPNNwC": "本金 × (1 + 每日%) ^ 天数 = 结果",
  "oFGEHX": "本金 × 风险收益区间 ^ 年数 = 压力到乐观",
  "oBtvL1": "按月复利 + 每月追加 - 收益税 - 费用损耗 = 账户总余额",
  "gBDHc8": "偏好",
  "QZEMm+": "公式",
  "g12Dke": "增长",
  "qMN4Hi": "风险区间",
  "ZqD/9m": "1. 投入",
  "NroCc6": "2. 增长",
  "3uZSpt": "3. 扣除损耗",
  "Acu9vt": "4. 真实结果",
  "RrCui3": "总览",
  "s/5n4U": "未来价值",
  "Y7nVKh": "总收益",
  "0oSfpG": "复利多出",
  "huQbAJ": "相比简单叠加",
  "WFbMvF": "收益路径",
  "eOjdJQ": "结果图表",
  "TwpPGt": "压力情况",
  "KvvPIn": "乐观情况",
  "UaUhfx": "结果拆解",
  "B1W/gW": "累计投入",
  "qfpvhg": "本金 + 每月追加累计",
  "qfphmq": "账户总余额",
  "w/Fdf3": "最终金额，包含本金、追加投入和净收益",
  "8dB4oX": "摩擦损耗",
  "zrtYq4": "税率和费用造成的增长损耗",
  "3PndDP": "净收益",
  "xixtRJ": "真实结果 - 累计投入",
  "J13tmw": "用上方按键在每日、偏好、标准和高级之间切换。直接编辑卡片即可修改每个模式自己的数值。",
  "hVxfnN": "仓位",
  "rGG6C5": "无法记录录入",
  "HMxOaz": "记录层录入",
  "8pgert": "记录录入",
  "V9/72k": "根据当前模拟器快照创建持仓。这不会下单。",
  "Ix1eQS": "录入价位",
  "VVODGC": "",
  "tTxMax": "没有活动的腿可记录。",
  "NWm89j": "行权价",
  "KfNcvR": "录入贷记",
  "Kv8i2p": "录入借记",
  "ZwpbZp": "合约",
  "qZbedW": "费用",
  "5Qe6P4": "创建持仓",
  "HlAUNs": "",
  "EFFBjB": "",
  "kp0NPF": "计划中",
  "PFtMy9": "已取消",
  "fNSoEC": "暂无仓位。",
  "IUSc2p": "返回仓位",
  "U6qGuO": "仓位",
  "dsrYnm": "入场腿",
  "9R+8FN": "平仓",
  "3jalA3": "出场贷记",
  "gRctwu": "出场借记",
  "REhBx2": "记录平仓",
  "OGYRNS": "已实现盈亏",
  "KtJA+p": "",
  "wbT/gJ": "",
  "BMhsUD": "",
  "JbhGNB": "",
  "2iZLim": "",
  "4GE1HI": "",
  "J0vUhO": "跟踪",
  "0Azlrb": "管理",
  "Px2xWV": "开仓",
  "6TWf/8": "",
  "RSctv1": "构建",
  "BuArN0": "",
  "FChJlk": "",
  "sB2L9d": "",
  "VlqGUg": "暂无持仓。",
  "84hiSA": "",
  "hKxqT+": "已开仓策略",
  "Z/gq7D": "管理仓位",
  "HKSUE6": "无法更新持仓",
  "+lPEdh": "",
  "TNnLP6": "",
  "8Y0yUM": "快照",
  "i+9IKk": "",
  "3Bd9gC": "",
  "T6rVKC": "从策略编辑器快照创建仓位。",
  "djNL6D": "只读",
  "HlljQp": "已跟踪",
  "y4svrI": "净入金",
  "mYAor4": "仓位列表",
  "GvvPSU": "管理状态并查看记录的策略快照。",
  "QLcTUh": "无仓位",
  "Aujn2T": "",
  "BS/tym": "选择一个仓位来管理其记录。",
  "zi7TLb": "",
  "hHAajd": "标记为开仓",
  "8ujEro": "重新打开",
  "0smbqm": "切换时间跟踪",
  "GxcpQO": "切换仓位",
  "Sf2BeB": "尚无仓位",
  "dV3Z2L": "从编辑器记录录入，将策略快照转变为管理仓位。",
  "zsOQUO": "录入波动率",
  "9fW4Zo": "快照腿",
  "EjDonN": "未捕获腿。",
  "5c4I9W": "仓位备注",
  "7KE5O3": "此仓位未记录备注。",
  "PV8Ss8": "仍在跟踪",
  "D5W6Cv": "切换盈亏图",
  "fWKwFM": "编辑器",
  "G4AS6A": "编辑器中无策略",
  "YqTRk9": "在此处添加策略，或切换到策略选择器以从模板开始。",
  "Yv+nFq": "",
  "x/WpE0": "",
  "iOPa8L": "浮动仓位面板",
  "cSCG+O": "停靠仓位面板",
  "JnlBw6": "",
  "ejXUSw": "",
  "17iz0a": "",
  "H4Zyog": "期权链日历",
  "snum61": "",
  "C9FHAZ": "录入状态",
  "MF7Ymi": "净估值",
  "rY0sJm": "开仓价",
  "5+4RCa": "请输入录入金额。",
  "W0vCm2": "持仓已记录",
  "LwRe53": "记录当前策略",
  "LzlMDx": "平仓",
  "ojAeyH": "估算已实现盈亏",
  "J9r6A0": "",
  "ULXFfP": "",
  "lD3+8a": "",
  "vTGdhV": "",
  "W8FUDh": "",
  "vRnoWQ": "平仓金额",
  "oUnE7e": "根据录入借记记录为已收。",
  "jDAoHp": "根据录入贷记记录为已付。",
  "8uebWe": "已收",
  "NbPSRM": "已付",
  "9pOeMV": "",
  "+RhnH+": "空",
  "6pDaQP": "",
  "x1DWtN": "等待市场价",
  "NssJyf": "切换盈亏图价格视窗",
  "Cs33xZ": "窄",
  "PSiaaV": "宽",
  "MHNBjO": "时间详情",
  "VGU4nK": "搜索时间或日期",
  "byP6IC": "已选",
  "7xtXnU": "{cursorDte}DTE / {rangeDte}DTE",
  "fz0z4c": "计划",
  "Akbil9": "显示所有到期日",
  "wDOs0p": "评估价格 (S)",
  "AhXGco": "锚定行权价 (K)",
  "9h+1kW": "价内外程度 (m)",
  "OHUQMR": "到期天数 (T)",
  "/+RN4D": "权利金 (V)",
  "C5xzTC": "权利金",
  "LeZPdd": "重置价格",
  "IIKaw8": "重置 IV",
  "gZkcp6": "市价范围",
  "nYNmvY": "重置市价范围",
  "Ae+QVQ": "折叠所有期权费详情",
  "exJDFA": "展开所有期权费详情",
  "B69cRS": "这里切换的是用哪一类期权来搭这个结构，不会单独把多头改成空头。",
  "uWWKZe": "Call/Put 切换",
  "LEubOZ": "同类收益结构，不同期权构造方式",
  "oScH0Y": "总时间衰减贡献变动",
  "K16u1n": "时间衰减后",
  "N+4Jhz": "时间衰减后当前期权费",
  "cumnix": "当前时间衰减贡献",
  "YS2qOs": "总时间衰减值变动",
  "JBUXUL": "折叠所有腿的期权费详情",
  "+DsLa8": "展开所有腿的期权费详情",
  "9zub-u": "警报",
  "7-Domh": "笔记",
  "-YYC3M": "当日暂无",
  "TiR_Hq": "保存中…",
  "Oc_0wp": "添加备注",
  "2tIG-9": "删除交易",
  "_GCoTA": "清除",
  "YIUs4-": "清除日期筛选",
  "eKEL_g": "挂单",
  "-xJ09d": "向 AI 提问：策略、指标或原理……",
  "gFfm-i": "继续追问……",
  "W_5hwr": "出了点问题。",
  "_kvFI4": "超值套餐",
  "Ia_CZp": "保存失败，请重试。",
  "wX-jrn": "您无权执行此操作。",
  "VA_Z1S": "隐藏",
  "-OtV6h": "PIN 更新失败。",
  "mU_tMS": "芝加哥 (CT)",
  "w_uBeK": "伦敦 (GMT/BST)",
  "J-02wx": "您的账户需要续费",
  "sy-pv5": "邮箱",
  "e_4U0n": "修改 PIN",
  "b07w-D": "层级",
  "n-2mRW": "为盈亏交换红绿颜色",
  "hX_ER9": "通知触发时发送邮件",
  "-NKMAc": "查看所有键盘快捷键",
  "_93KBD": "看懂结构，模拟变化，再做决策。",
  "Y3-Oxq": "您的账户已准备就绪，含 7 天标准功能试用。请使用您的 PIN 码登录。",
  "yUVl6-": "邮箱",
  "RLHw-x": "期权每日一测",
  "Hs_nNW": "立省 53%（原价 $360）",
  "VL_B6x": "your@email.com",
  "xkr-zo": "条款",
  "-dLAnb": "预估总计",
  "RyG-bT": "PIN 无效。",
  "o_DO8l": "购买时使用的邮箱",
  "g5pX-a": "关于",
  "wXVN4_": "安全须知",
  "g_rwmh": "生成策略",
  "SNmzJ_": "尝试其他搜索",
  "wl1b-c": "保存策略后即可在此处查看",
  "J_UkMD": "{count} 个策略",
  "1sODf-": "删除选中项",
  "-TsRJH": "永久删除 \"{name}\"？此操作无法撤销。",
  "ZDo-Xb": "展平",
  "AVI_0j": "拆分",
  "rwVd--": "使用两个页面",
  "nyPHb-": "复制选项卡",
  "Hhi-or": "切换图表/衰减",
  "F62y-K": "登出",
  "0h_lPM": "升级",
  "hOdd5_": "检测到未经授权的访问",
  "qlC_X6": "试用期明天结束",
  "R_eOkj": "专业版",
  "ZQA72N": "",
  "D9JunA": "",
  "mqxR9X": "",
  "aJleeA": "",
  "12Hk45": "",
  "S2lQ2w": "",
  "R-J5ox": "",
  "zNM-4e": "",
  "JZ82fH": "",
  "CzkhrD": "跟进时间",
  "b2wZNr": "",
  "5OteMI": "",
  "WE3OlH": "",
  "KV-O0y": "",
  "rOZptg": "工作区",
  "GGCucD": "",
  "whSpKv": "",
  "6a_-ea": "",
  "RSfB5Y": "",
  "503tJ_": "",
  "C53P3V": "",
  "zmnI0n": "",
  "aLn0xC": "",
  "eBecXg": "",
  "nt9JyD": "",
  "V-jsYt": "",
  "GFQ_0e": "",
  "jE808X": "",
  "dhFkCT": "",
  "9-Ddtu": "下一页",
  "0DTyNc": "",
  "L6TF4V": "",
  "hYOE-U": "邀请",
  "fsB_4p": "已保存",
  "_jJLYy": "交易记录",
  "_xwYHP": "已发送！",
  "8N9wG-": "收件人",
  "0HT-Ib": "已归档",
  "ztdbt-": "删除此通知历史记录？",
  "kF2z_O": "指定用户",
  "HQJg-h": "撰写通知",
  "9a9-ww": "标题",
  "p_iF5T": "搜索用户...",
  "-Nk8iq": "删除通知",
  "X0hrh_": "未找到指南。",
  "J_9jle": "标题 (英文)",
  "_bdKNj": "URL路径",
  "ylNz_0": "新文章",
  "jfk-6j": "未命名文章",
  "pLur_-": "文章标题 (中文)",
  "H_r5m6": "下移",
  "_QToxN": "该邮箱已存在对应用户",
  "rO_m1g": "标记为计划",
  "y-cNoO": "重新生成配音",
  "Di_X8a": "正在生成配音...",
  "-pwUpZ": "连接的账户",
  "-vVZ_G": "连接",
  "pT_nDf": "断开此账户？您需要重新授权才能再次通过此账户发布。",
  "q_uwLT": "停止",
  "_U9cX_": "添加朗读文本",
  "x_kNJT": "结束语",
  "4osWT_": "内部注释（不生成）",
  "eNR-LY": "生成脚本",
  "A_lLjO": "正在生成...",
  "E048_V": "保存为草稿",
  "CjBL-W": "计划（可选）",
  "Rb_hb9": "领英",
  "w-2Vw7": "Shorts",
  "o5_DJA": "进阶",
  "-1HAHt": "个人资料网址",
  "1-MVJi": "确认并发送PIN",
  "zND_qF": "自定义代码",
  "Mjp-Mk": "确认后我们将执行以下操作：",
  "SP-5y6": "生成联盟代码并关联到此 KOL",
  "Qva-p6": "删除KOL",
  "3-UWwF": "激活",
  "Pg73r-": "联盟代码",
  "8A_ETL": "复制并记录为已发送",
  "2XHGT-": "DM 私信 — {name}",
  "_30QJQ": "字符",
  "2_2yg-": "添加",
  "LuKWb_": "先记为潜在客户。对方确认合作意向后，再走入驻流程（发送 PIN + 创建 Pro 账户）。",
  "apr6-g": "二维码",
  "6vl1G_": "编码",
  "EAO_K-": "下载PNG",
  "6_-RUy": "退款扣减佣金",
  "caR-vb": "粉丝价",
  "Wn-3o7": "保存打款记录",
  "p9-GhL": "期间结束",
  "W-1MOm": "方式",
  "PT6kJ-": "参考 (Stripe 交易/PayPal 收据)",
  "Cjv9-J": "希腊字母",
  "EHsGJ-": "波动率",
  "hrgo-E": "下架",
  "E1bF_X": "解析",
  "Zh-5A6": "开启",
  "Ov2lv-": "推荐",
  "-U6ozc": "类型",
  "Vb-qQ4": "使用次数",
  "u_vOPu": "已支付",
  "wcB_Jz": "意见领袖",
  "OuR_Ij": "题库",
  "-OGJYf": "操作",
  "OY-R39": "未退款",
  "VLj-gQ": "近期无新注册",
  "aV_9Na": "新用户（7 天）",
  "_ROgfO": "注册数",
  "IVA_60": "上一篇",
  "FhjNv_": "下一篇",
  "Gr_m46": "文章操作",
  "js-IVa": "{number} 章",
  "YAPyM-": "盈亏分布",
  "4YuB-L": "月度盈亏",
  "_OVhC1": "净值曲线",
  "_o2pEx": "检测失败，请重试。",
  "dM-p3_": "从",
  "nDyaq_": "运行中",
  "r0q_a1": "平衡",
  "18T_KN": "激进",
  "_7BaIL": "创建计划",
  "iF_NIV": "交易",
  "H-Yu1D": "跨VIX分位分析波动率曲面...",
  "G_yZLu": "移除",
  "amc-u7": "检测结果",
  "_clOBU": "每周",
  "Soc-LF": "盈亏平衡点",
  "x_oJ17": "到期日",
  "_HKWfF": "消息正文（可选）",
  "_OaaHw": "图表时区",
  "I-TzDu": "在模拟器中构建策略，开始进行3D可视化。",
  "_Gmbfp": "轻触",
  "zJ-6t8": "$360",
  "iBFdi-": "$98",
  "A98E-C": "可视化策略结构构建器",
  "-jAZf_": "标志中的希腊字母并非装饰，它们是期权的语言：Delta 代表方向，Gamma 代表曲率，Theta 代表时间衰减，Vega 代表波动率敏感度。您持有的每一个期权头寸，在这几个维度上都有各自的读数。",
  "Ys_3BC": "不是投资平台。本产品中的任何内容都不承诺或暗示任何回报。",
  "p1SM-f": "范围与安全",
  "2tO_6R": "承诺、暗示或保证任何策略的任何回报。",
  "0SM_Ve": "风险披露",
  "zE1J_t": "理念",
  "O_7-3q": "期权并非少数人的工具，而是大多数人未被教会如何使用的工具。",
  "S5C-tL": "开始理解期权",
  "V9_72k": "根据当前模拟器快照创建持仓。这不会下单。",
  "mLvz-r": "贷方",
  "5-4RCa": "请输入录入金额。",
  "_MNdbX": "打开模拟器",
  "EfF-uq": "预览 {x} 与 {y}, 按 {z} 着色。",
  "yxhVD_": "流形控件",
  "h19We_": "Y 轴",
  "_AElfC": "曲面",
  "-6V3c-": "流形预览",
  "f-GKc4": "看涨",
  "BS_tym": "选择一个仓位来管理其记录。",
  "OIU_70": "保存策略",
  "Qnw_66": "看多",
  "qcpyb_": "这类结构可能是借方也可能是贷方，取决于参数、行权价距离和当时的期权价格。若净支付是借方；若净收取是贷方。",
  "We_i1W": "建仓时会净收取权利金，现金先流入。收益通常来自保留权利金，风险取决于保护腿、裸卖腿和价差宽度。",
  "kdrNp-": "时间衰减开关",
  "zg8_dK": "策略选择器",
  "z6x_il": "浮动策略编辑器",
  "cSCG-O": "停靠仓位面板",
  "63C-To": "同到期日，四条腿 short put / long put / short call / long call，中间卖、两翼买，识别为铁鹰。",
  "EKd_46": "不同 strike、不同 expiry、同 type，一买一卖，识别为对角价差 / diagonal。",
  "_k_3jB": "两组 calendar，call 和 put 都有，识别为 double calendar。",
  "xC6_Ai": "识别方式：每条腿根据多空、期权类型、行权价、到期日和数量识别。",
  "QcjNQ_": "停止跟随市价",
  "Fj-X-3": "策略名称...",
  "x_atQl": "此模拟器仅用于场景探索，不是投资参考工具。",
  "_Koi6R": "控制场景处在当前到到期之间的哪个时间点。越接近到期，越能看到时间衰减对策略的影响；跳到到期则查看到期盈亏图。",
  "rhSI1_": "模型",
  "_TQJwJ": "折叠所有腿",
  "Qc-OIm": "展开腿",
  "_6UFyr": "恢复默认七彩",
  "Ae-QVQ": "折叠所有期权费详情",
  "4Y_Ab3": "近月到期",
  "DljV7-": "未找到 {symbol} 的数据",
  "hUL-tI": "输入代码进行搜索。",
  "-S8HNF": "恢复默认颜色",
  "_A3g_O": "价差",
  "LjAS-D": "尝试回测",
  "Q-8ExB": "新手引导完成",
  "gZ-1P9": "跳过引导",
  "BMtot-": "选中铁蝶和破翼蝶式，然后点“下一步”。",
  "HA-deI": "很好。把您的第一个策略保存下来吧。",
  "gcYCT_": "{count}天",
  "_qpG_9": "返回分析",
  "nV7Cv-": "合约",
  "_0TOL5": "金额",
  "BAIs-v": "牛市看跌价差",
  "pC_mCh": "空头鹰式",
  "A_jDOX": "比例反向价差",
  "COs1u_": "价内宽跨式",
  "AdnNe-": "双重时间价差",
  "btOI-Z": "新标签页",
  "D3gsD-": "垂直价差",
  "n3Co_5": "净权利金",
  "7rBe4-": "翼宽减净支出",
  "n-Cz2z": "短腿区域收益峰值",
  "X31_VM": "短长腿之间亏损峰值",
  "dW-zxW": "短腿附近收益峰值",
  "VS_Ihf": "第一短看涨附近收益峰值",
  "_HSKER": "方向线性收益",
  "5O_sHw": "反向线性亏损",
  "8MHCc_": "现金流自定",
  "zq_VPt": "偏多接货 · 价格守在卖出看跌上方时获利",
  "iDg_un": "看空 · 价格跌破下方卖出行权价时接近最大获利",
  "oqRva-": "价格钉住 · 获利停在中间行权价附近",
  "9f8-TX": "**多空切换**：多头价内宽跨（双买）或空头价内宽跨（双卖）。",
  "_060cE": "蝶翼宽度",
  "-VExbc": "卖出看跌期权",
  "YPIa-q": "卖出看涨期权",
  "-c77SN": "多头偏移",
  "li9_qa": "空头偏移",
  "-A3wWe": "多头 1 偏移",
  "4pm_91": "价差空头偏移",
  "_TDl2v": "偏倚",
  "tkN_X7": "空头偏移 — 卖出腿相对于标的价格或配对买入腿的位置。",
  "0Ov_mE": "下主体 — 策略中心到下方内侧行权价的距离。",
  "_Boq_3": "上主体 — 策略中心到上方内侧行权价的距离。",
  "_yMgas": "偏斜 — 将中心行权价移离平值。负数 = 下移，正数 = 上移。",
  "DtI-Id": "看涨偏斜 — 移动看涨侧远月行权价。负数 = 下移，正数 = 上移。",
  "-oqPh9": "空头 1 偏移 — 第一条卖出腿距离策略中心的距离。",
  "phcJV_": "价差空头偏移 — 价差中卖出腿距离标的价格的距离。",
  "h7uy_0": "行权价偏移 — 当前方向：{side}。负数 = 低于标的，正数 = 高于标的。",
  "J6M-7z": "卖出看涨 — 当前方向：{side}。这条内侧看涨腿当前为{legSide}。",
  "9_Y8tC": "空头 2 偏移 — 当前方向：{direction}。将第二条卖出腿进一步移向该方向。",
  "ujXZ_g": "看涨偏斜 — 正数将远月看涨腿移向平值，负数移离平值。",
  "veDZ8_": "消费价格指数",
  "fCGF-k": "非农就业人数",
  "9h-1kW": "价内外程度 (m)",
  "_-RN4D": "权利金 (V)",
  "urRYR-": "Vega",
  "HUl-d1": "六月节（调休）",
  "_VnDMl": "其他",
  "TP_cMX": "已结束",
  "_FswN9": "期权买卖：无术语解释",
  "--eaNE": "垂直价差：通俗解释",
  "tfmZ-h": "为何卖出期权不是“免费的午餐”",
  "f-tUCU": "做市商对冲如何影响盘中SPX波动",
  "-ow4kj": "卖出期权结构中的隐性尾部风险",
  "iHFKZ_": "为何Theta策略的Sharpe比率失真",
  "_4MjPl": "在ABG中规划次日交易的最快方法",
  "9v-Ku-": "压力年化 %",
  "QZEMm-": "公式",
  "ZqD_9m": "1. 投入",
  "s_5n4U": "未来价值",
  "B1W_gW": "累计投入",
  "w_Fdf3": "最终金额，包含本金、追加投入和净收益",
  "p8z-Tw": "买入看涨期权赋予持有人哪项权利？",
  "Rw59_r": "时间价值最适合描述为期权价格中的哪一部分？",
  "Ti-nXJ": "期权权利金中高于内在价值的部分",
  "h_uehJ": "到期时的保证利润",
  "_YX34k": "行权价减去权利金",
  "-zVWjy": "合约新上市时",
  "_AzzHb": "期权合约的执行价",
  "9_svvE": "100股",
  "Kd_ANn": "10股",
  "B2Iut-": "大多数标准上市的股指期权使用100股乘数，但调整后的合约可能有所不同。",
  "4-TDij": "买入看涨期权到期时的最大亏损是多少?",
  "w6c5i-": "买入看跌期权到期时的最大亏损是多少?",
  "-6Ofbh": "买入看跌期权必须先收回支付的权利金才能盈利。",
  "c_A1XG": "期权价差宽",
  "4d-8xq": "全部权利金",
  "hv-B9s": "行权价与到期日之差",
  "H-uHTE": "流动性保证行权有利可图",
  "Qs_n_d": "成交稀少的市场通常价差更大，成交更不可靠，增加了交易成本。",
  "elS-KS": "美式合约允许在到期前行权，而欧式合约则不行。",
  "-_2Tna": "仅在期权价外时",
  "z1_3iT": "欧式期权的行权仅限于到期日，但该期权通常在此之前可以交易。",
  "9Vd-QF": "现金结算通常在结算时意味着什么？",
  "JhpE-3": "经纪商取消交易双方",
  "-ahLiH": "行权意味着期权持有人选择做什么？",
  "3kh-qC": "更改到期日",
  "CE-Eoj": "平仓现有看跌期权头寸",
  "_M93ZC": "按行权价买入股票",
  "qGW83_": "卖出开仓会建立新的看跌期权头寸并收取权利金。",
  "yq_XlX": "买入平仓通常意味着什么？",
  "_Zzlec": "更改行权价",
  "7GXP_5": "持有股票和买入看跌期权",
  "3Gnlz-": "始终中性",
  "1EZv-H": "保证收入",
  "l1Ukf-": "在到期时，标的资产高于哪个水平时，多头看涨期权是盈利的？",
  "LJ-XFd": "行权价加上已付权利金",
  "YzOKq_": "已付权利金减去行权价",
  "Yf_9eb": "看涨期权行权价",
  "8s1-iH": "多头看跌期权需要在到期时低于行权价减去权利金，才能显示净利润。",
  "hvAy-w": "合约乘数大小",
  "AwqM5-": "隐含波动率总是低于历史波动率",
  "3sWwQ-": "它们是同一个指标的两个名字",
  "nf2rO-": "买入跨式",
  "-x9iMv": "只有持有多头期权的买方",
  "PP_pAf": "只有做市商",
  "e_kRj_": "因为期权权利金在到期后支付",
  "dc-YqR": "因为所有价差都有无限亏损",
  "_a7j5A": "Rho主要衡量对哪个输入的敏感度?",
  "KYqe-l": "Delta等于Vega",
  "-9uuuM": "Delta对冲主要用于减少对什么的风险敞口?",
  "afu_QL": "买入期权头寸通常具有哪种Gamma特征?",
  "Dh-xiJ": "负 Gamma",
  "bS_GBJ": "Gamma等于权利金",
  "b-wP9P": "Vega等于Delta",
  "Zukr-I": "券商保证金要求",
  "lAZkC-": "IV排名将当前隐含波动率置于标的物的历史考察范围内。",
  "8_nclW": "隐含波动率百分位通常询问哪个问题？",
  "mOWk_k": "隐含波动率低于当前水平的次数",
  "ZcFS_L": "股票收盘价高于行权价的次数",
  "vynC-_": "较高的隐含波动率会提高期权理论价值，有利于正Vega头寸。",
  "88_1qU": "卖出跨式",
  "uCiJ-Q": "牛市看跌价差",
  "lI-Atp": "熊市看涨价差",
  "vixwQ_": "熊市看涨价差是使用看涨期权构建的风险有限的看跌期权贷记价差。",
  "hk3-pJ": "行权价差加上借记",
  "UbIjj_": "仅收到的权利金",
  "m1OA_Z": "空头期权限制了上涨空间，因此最大利润是行权价差减去借记。",
  "GwVm_e": "空头跨式通常由哪些腿构成？",
  "m6PN_V": "在不同行权价买入看涨期权和看跌期权",
  "Rl7-Qi": "卖出股票和买入看涨期权",
  "_9v2vp": "空头跨式在相同行权价和到期日卖出看涨期权和看跌期权。",
  "3JyvM-": "铁蝶通常有什么特点？",
  "r0_4y2": "看跌期权随股票下跌而增值，有助于在支付权利金后限制低于行权价的下行风险。",
  "_gYNMH": "仅两个空头看涨期权",
  "-KJLRC": "风险可控价差不会亏损",
  "x2dmI_": "经纪商在价差中忽略空头期权",
  "J-pJdR": "合约无到期日",
  "-EMU6D": "提前行权主要可能发生在哪个风格的期权到期前？",
  "6ZhK1-": "期权无行权价",
  "_8-Pge": "仅市场节假日休市",
  "-ONE39": "当标的接近行权价时，最终的行权和分配结果可能不确定。",
  "6-XRyA": "行权可能损失卖出期权可获得的剩余外部价值。",
  "nC_9u3": "行权价之间的距离决定了垂直价差的最大内在价值。",
  "e-Pit9": "行权价或虚实程度，以及距离到期时间",
  "nSW_Id": "波动率曲面展示隐含波动率在行权价或虚实程度、以及到期日上的分布。",
  "Od_WwN": "每次到期前波动率必然上升",
  "CxO-nV": "标准日历价差通常如何组合不同到期日？",
  "XAb-zP": "买入股票 + 卖出看涨",
  "-z5UQl": "各腿通常同时有不同到期日和不同行权价",
  "k-cb83": "随着 Delta 变化，重新平衡标的对冲",
  "Kbj-hp": "忽略 Delta，因为 Gamma 永远为零",
  "9_9anH": "Delta 接近零表示组合没有风险",
  "jMMH6_": "投资组合theta",
  "-bsObq": "粘性delta假设波动率微笑随标的资产移动，因此可比delta保持相似波动率。",
  "Ns_fbs": "波动率微笑描述了哪种模式？",
  "_DpuvY": "每个行权价和到期日具有相同的隐含波动率",
  "qH_q9n": "行权价之间的隐含波动率差变大了",
  "atz-DJ": "合约乘数改变了",
  "xQNyp_": "长期隐含波动率高于短期隐含波动率",
  "tKvut-": "仅当前买卖价差",
  "jELa_t": "卖出期权的精确行权概率",
  "2BQQb-": "交易者为什么经常使用方差而不是波动率进行跨时间分析？",
  "k_7TED": "方差始终等于期权Delta",
  "m_GQp3": "期权卖方通常要求补偿以承担波动率和跳空风险，从而产生波动率风险溢价。",
  "Q-rqjl": "账户中最小的期权头寸",
  "W7D_qL": "标的价格、时间、隐含波动率",
  "HkaN-L": "Delta 对时间的敏感度",
  "AMq1-1": "Charm 通常描述为?",
  "W-nkIo": "分配后的行权价变化",
  "PW0Z3_": "经纪商保证金规则的变化",
  "-eFkZ0": "Gamma 随时间的变化",
  "-L1W7G": "期权链中的行权价数量",
  "Psv-rc": "期权的行权价变化",
  "LYlvi_": "跳空风险对哪种头寸尤其重要?",
  "-MTmGS": "长期多头期权通常会为多头日历价差带来正的净 Vega，尽管细节取决于行权价和到期日。",
  "XZI3_d": "空头近端期权的加速衰减",
  "XT63n-": "长线深度价内远期看涨期权",
  "cZUno_": "该策略使用远期看涨期权作为类股票风险敞口，并卖出近端看涨期权作为对冲。",
  "sCK-qZ": "交易无空头期权",
  "ZP1p-O": "大额波动中的长凸性",
  "-bpFO3": "压力期间，相关性可能上升，使头寸比预期表现出更相似的行为。",
  "F3ghc-": "仅期权的到期日",
  "he90l-": "使用限价单",
  "x_4Mfn": "期权代码的字体大小",
  "P_iH-d": "上市交易所的数量",
  "4_tFCU": "利率影响现值和远期定价，这些都会影响期权估值。",
  "q-Oaql": "经纪商的保证金利率",
  "M11-ty": "跳跃风险对 Delta 对冲很困难，因为可能发生什么？",
  "hi_Mz3": "在调整对冲之前，标的资产可能不连续地移动",
  "AhZMW_": "期权溢价不会改变",
  "8m-I9O": "行权价自动调整",
  "_RvHyr": "需完成进阶",
  "BFsH4-": "看懂单腿期权和到期盈亏",
  "-yZUz6": "备兑/保护基础",
  "a-mezc": "连接 Greeks、波动率与常见组合结构",
  "LJV4-Y": "行权/指派",
  "-B3Di8": "敏感度逻辑",
  "--1xV9": "处理期限结构、偏斜、动态对冲与组合风险",
  "_0kwWy": "波动率曲面",
  "2JXtB-": "Gamma scalping",
  "Y-YQZb": "波动率状态",
  "u_fP3G": "强化练习",
  "-BqxXG": "错题练习",
  "JKgNd_": "补未答题",
  "zmq2-1": "整组重答",
  "t88s-R": "{correct}/{total}",
  "_0eRJ0": "仍在水面",
  "-s81D7": "宽幅, 稳定Theta, 厌恶突破",
  "VP5-CR": "排名",
  "fn_VCc": "干净的捕获。Theta已获利, 并且网已守住。",
  "-PnZg2": "压力触及边界。重新调整中心或拓宽网。",
  "jm_spn": "重置",
  "5ir_Y-": "上期盈亏",
  "xWc-eU": "当价格逃离支付区域时, 损失增加。",
  "EWw_tK": "应用",
  "Jm_KMV": "，即表示您同意遵守这些规则。如果您不同意，请勿使用本应用。",
  "EEN_Vn": "是一款期权交易的学习与练习工具。您可以构建交易策略，以历史市场数据进行回测，并记录自己的交易日志。仅用于学习和分析。",
  "q-1zzm": "5. 交易有风险",
  "-y4k3A": "请妥善保管您的登录 PIN，不要与任何人分享。若有人滥用您的账户，责任由您承担。我们有权关闭任何违反规则的账户。",
  "_N55ps": "登录即表示您同意我们的<terms>条款</terms>和<privacy>隐私政策</privacy>。",
  "SMpO_p": "您的工作区已准备就绪。可以先打开模拟器，也可以继续前往你的页面。",
  "hKxqT-": "已开仓策略",
  "Z_gq7D": "管理仓位",
  "T_TkAZ": "1. 我们收集什么",
  "66uD_i": "4. Cookie和存储",
  "-Vq92J": "6. 市场数据",
  "X-9MhG": "8. 我们使用的其他服务",
  "kaSaA-": "我们可能会更新本政策。如果您在我们做出更改后继续使用本应用，即视为同意新的政策。",
  "9R-8FN": "平仓",
  "KIT-yN": "KOL",
  "E-sBOl": "推广页",
  "2rme_A": "链接可能已过期、输入错误，或指向我们不再支持的持仓。请重新生成并从上次中断处继续。",
  "0_hL28": "扫码获取特别折扣",
  "9uOFF3": "总览",
  "TwyMau": "账户",
  "H8KGyc": "进入",
  "nfCIAB": "先塑造实时想法，再结合当前市场视角进行调整。",
  "GKJwb2": "先用历史条件检验这个想法，再决定是否信任这条路径。",
  "7JlauX": "探索",
  "Sgjt/h": "计划、笔记、跟进",
  "J5SK/Y": "不离开工作区，也能继续理解结构和场景直觉。",
  "rDDJrh": "把剧本、理论和个人参考内容都放在交易流程附近。",
  "emRpaU": "先构建，再回测，继续管理，让学习始终在旁边。",
  "Y031tJ": "四条清晰路径。",
  "zsr0Bz": "英",
  "pq4H+f": "中",
  "Ggk7AI": "快捷",
  "Qp1beM": "路径",
  "nMU5CU": "关闭快捷菜单",
  "BNUGy3": "快捷入口",
  "uTpQql": "灵活收益结构。",
  "v9Ifdn": "取决于所选结构。",
  "bkSZJQ": "先读懂收益形状，再判断这个结构适合放在哪里。",
  "xAYGIp": "策略识别",
  "LYaNlL": "上一页",
  "5m4j06": "场景",
  "kbLBuY": "收益",
  "iEGVli": "在编辑器中打开",
  "sV4Od1": "识别",
  "rC5MFC": "把理论和笔记放近一点。",
  "eAVGJm": "用短练习加深理解。",
  "efMi6Q": "一边记录，一边学习。",
  "gCPWDs": "把结构放进历史市场窗口里，检查这条路径会怎么走。",
  "8lNlab": "评估",
  "ENLxT7": "回看结果、分布和回撤，理解跑出来的结论。",
  "DBLZok": "用历史把实时想法转成证据，再回看结果真正说明了什么。",
  "uZhtgC": "把计划、笔记和跟进放在一起。",
  "4kHh7T": "设好提醒，别错过触发。",
  "sq5Q6i": "把计划、记录和跟进放近一点。",
  "merVER": "先从策略选择器开始，选出你想构建的结构。",
  "Hip/9D": "策略编辑",
  "U0grza": "直接进入模拟器，调整腿、到期日和场景输入。",
  "hGmjyd": "多维视图",
  "ESeBco": "在行动前，从价格、时间和波动率三个维度看清这个结构。",
  "fPRM6u": "先选定构建任务，再进入最适合这一步的具体工具状态。",
  "TM7t+9": "理论、笔记、参考",
  "TIyAUw": "理论测验",
  "H8omW5": "计划、笔记、跟进",
  "3AN/qQ": "阅读，记录，学习。",
  "POmYVs": "当前价",
  "aGDJAf": "执行价层级",
  "6xIl78": "最大亏损",
  "Cbb1Tl": "标的价格轴",
  "mv038n": "亏损",
  "iZuO+L": "",
  "xzpER/": "腿部拆解",
  "YkiQAL": "",
  "FTOUP0": "建仓方式",
  "S2YvkH": "",
  "YhFsJZ": "最佳结果",
  "uJt9jq": "最差结果",
  "UfFKzs": "核心取舍",
  "QcPYA1": "",
  "D+cOTU": "简洁",
  "0ZKlnA": "构建想法。",
  "AsGLcB": "跟进行动。",
  "sBTHWA": "继续学习。",
  "ysKI9M": "构建，跟进，继续学习。",
  "CriC9+": "三条清晰路径。",
  "yxMO/D": "",
  "w6wvRs": "",
  "KnmXQK": "",
  "BS/GfP": "基于结果的统计分析",
  "bkuEsA": "",
  "yRzfvN": "基于历史数据检测策略。",
  "hyG4lk": "",
  "dvvmBd": "",
  "dRXcgr": "阅读。写作。学习。",
  "+BOjEB": "构建、跟进、学习。",
  "v5mQ0g": "",
  "QNcfGl": "打开 AI 助手",
  "83dK3t": "切换语言",
  "DmLT3x": "策略盈亏平衡点",
  "pWLD9k": "单腿盈亏平衡点",
  "LwNE4P": "",
  "lHTKOw": "",
  "kY3puQ": "",
  "RW6EPP": "",
  "64eQSi": "",
  "Ygb6zP": "",
  "hNQgV6": "情景价值",
  "Jt539a": "",
  "zLe/Bm": "",
  "b3m7Qj": "",
  "fvYGqw": "波动率曲面",
  "l9AsX1": "演化",
  "OhHRZC": "",
  "is3xT4": "偏空震荡",
  "vN5UMz": "极端波动",
  "jd7vvb": "偏多震荡",
  "RthpHx": "平值",
  "o4nK1a": "",
  "qshK65": "更高行权价",
  "tumygV": "",
  "eRG040": "实值 call",
  "U4q1Cq": "实值 put",
  "hthCof": "更低行权价",
  "qZWAws": "",
  "QFyd0k": "虚值 call",
  "i5jmd4": "虚值 put",
  "3duexM": "K",
  "pdvyWG": "X=执行价  Y=隐波",
  "RsN9fb": "怎么看",
  "kHSm6T": "平值=中间  微笑=两翼  偏斜=左右",
  "FerxgH": "调什么",
  "72J2HQ": "底部=执行价  线上=期权状态",
  "m3QEyd": "标签",
  "URnLt5": "曲面入门",
  "S3/spm": "微笑 / 偏斜",
  "d3F21T": "主曲线",
  "N8vlzX": "IV 维度：中性曲线。微笑调两翼，偏斜调左右。",
  "tOLiE6": "调曲线",
  "rrtc8x": "平值高度",
  "PFydfr": "微笑强度",
  "QnQQoF": "偏斜方向",
  "ff/mVe": "更高执行价",
  "G7WT4X": "更低执行价",
  "zyEKqh": "看不同执行价的隐波怎么变化",
  "5+Ryq+": "看市场把哪一段期权定得更贵",
  "eOzzvZ": "判断平值附近的期权是贵还是便宜",
  "Si68Ku": "判断远离平值的执行价是不是更贵",
  "5szZx6": "微笑",
  "3BNF2D": "判断左边贵还是右边贵",
  "H/YSKc": "这会影响哪条腿更贵、哪里更容易收权利金，以及同一个方向判断更适合用哪种结构",
  "kecDjD": "对策略的影响",
  "aYTWNA": "",
  "2mslAl": "",
  "EMqgIx": "微笑与偏斜",
  "CbtTJS": "这体现了市场已经把哪条腿定得更贵、哪里更容易收权利金，以及同一个方向判断更适合用哪种结构",
  "VFYflW": "平值高度",
  "SH7hMe": "微笑强度",
  "LnqezJ": "偏斜方向",
  "TRMKTx": "平值高度（IV抬升期权价值）",
  "YR5Qd7": "微笑强度（IV弯曲期权价值）",
  "lQJZEc": "偏斜方向（IV偏斜期权价值）",
  "NSGEGW": "",
  "yiqRQ+": "",
  "G0oNDp": "入场阶段",
  "+j/nTL": "近月临近到期",
  "E51Zau": "远月剩余价值",
  "3zsyWK": "",
  "1je8ei": "",
  "aH2IPa": "",
  "8y0S8d": "近月 / 远月",
  "oWhl3q": "",
  "2gNueF": "近月衰减",
  "80BH+K": "",
  "s0RKGh": "",
  "YMud9H": "",
  "b2YSHg": "",
  "kEbpGv": "",
  "HK2YLk": "",
  "AVy9hX": "",
  "GYLXGH": "",
  "AwuckA": "",
  "fJEnlJ": "策略逻辑",
  "LBAO/g": "读图重点",
  "H80v0L": "",
  "vcJKg0": "收益驱动",
  "tZalIy": "演化逻辑",
  "xJndTG": "策略形态",
  "njQGZU": "情景价值",
  "YVhhoJ": "结构变化",
  "okssvp": "",
  "3XXs8X": "",
  "35O26j": "",
  "R1zRbp": "",
  "aLa94q": "",
  "3bhK1l": "",
  "ozeZer": "",
  "LsSnF8": "",
  "rCbU8t": "单腿作用",
  "r1WoeC": "先看这条策略最核心的盈亏形状",
  "5TO/qO": "看每一条腿如何塑造整体结构",
  "47THGZ": "平滑估值曲线，看这个情景下整套仓位值多少钱",
  "JFDl6V": "看这个情景下结构本身怎样变化",
  "L4SIT/": "两个月份都还保留着时间价值",
  "SUFSMm": "近月权利金在衰减，但远月那条腿仍保留价值",
  "3aDl0c": "近月那条腿几乎衰减完了，剩余价值主要落在远月上",
  "sjVZ1y": "灵活盈亏形态",
  "eBQdu2": "取决于所选结构",
  "+pe1+p": "这是时间价差的教学视图；进入编辑器后可以模拟真实的近月与远月到期日。",
  "+GqWXc": "教学演示，不构成投资建议。",
  "XbPGhw": "判断平值附近的期权是偏贵还是偏便宜",
  "0xWY3M": "判断离平值更远的执行价是否被定得更贵",
  "vEjvuR": "判断左侧更贵还是右侧更贵",
  "C7H+3G": "这能看出市场已经把哪条腿定得更贵、哪里更容易收权利金，以及同一判断更适合哪种结构",
  "5R/3cy": "看市场把哪些执行价定得更贵",
  "hOnZIP": "平值看高度，微笑看两翼，偏斜看左右。",
  "WDg9jp": "做多波动率",
  "pI8lK1": "做空波动率",
  "w6TaQO": "",
  "0g8Akl": "",
  "ojntBk": "",
  "CmdS8J": "",
  "m76Yof": "",
  "UlIivX": "",
  "lhlGQJ": "",
  "Nbweyr": "越接近到期，时间价值通常越少",
  "vfb2ib": "",
  "vslFF1": "",
  "KGNFrW": "",
  "8xfBde": "",
  "GC32hy": "",
  "USSaBZ": "",
  "SMkPMc": "",
  "qB7XvW": "当前价会影响盈亏平衡点和盈亏区间",
  "tDBbJ0": "会移动盈亏平衡点和盈亏区间",
  "7sRl4n": "改变结构会改变盈亏形状",
  "7Yr4un": "会改变盈亏形状",
  "FoOT5b": "越接近到期，时间价值通常越少",
  "AP4HpE": "如果市场预期波动更大，期权通常会更贵",
  "IAgODN": "预期波动越大，期权通常越贵",
  "3ub+Pr": "当价格进入目标区间，而盈亏形状能高效放大这段走势时，它就会赚钱。",
  "T8Alt0": "当价格波动或隐含波动率扩张带来的增值快于时间衰减时，它就会赚钱。",
  "gajccF": "当价格在目标区域附近停留得足够久，让有利区间占主导时，它就会赚钱。",
  "Y9Uso1": "当实际波动保持受控，而卖出的权利金衰减快于风险扩大时，它就会赚钱。",
  "QjUTos": "当近月衰减快于远月，且价格维持在目标附近时，它就会赚钱。",
  "j35Ll6": "观察标的、时间和波动率在入场后如何重塑这条盈亏曲线。",
  "YBQEVt": "观察盈利区如何随着时间流逝和标的移动而收窄、扩张或漂移。",
  "qEJk2S": "先看近月如何衰减，再看远月如何保值，以及时间差缩小时优势如何减弱。",
  "2NH+OA": "用标的、时间和隐含波动率去看这个结构会打开、塌缩，还是把风险转移到别处。",
  "bp32eT": "先找到峰值，再标出两个盈亏平衡点，然后看离开目标区间后价值如何迅速衰减。",
  "3Pe4bk": "先定位主要盈利区，再结合盈亏平衡点和尾部斜率，看收益在哪一刻转成风险。",
  "VYqDD1": "先看中间区域，再检查盈亏平衡点以及超出区间后的下滑速度。",
  "PUhNdb": "这个结构最适合价格待在一个明确区间里，而不是一路单边走开。",
  "bd+L8a": "这个结构把市场判断变成一条风险和收益都清晰的盈亏形状。",
  "1nQSHb": "时间价差使用两个到期日，围绕目标区间交易时间衰减。",
  "uv80fC": "这个结构交易的是波动幅度或隐含波动率，而不只是方向。",
  "h+J769": "先判断这个策略想要波动扩张、收缩还是停滞，再评估它真正需要的走势。",
  "PQTbS7": "基础形态",
  "UJqwvM": "间距",
  "D1Uz5j": "延伸",
  "8g7Ize": "宽度",
  "JsYi24": "目标位",
  "OGyLiW": "增加下行风险",
  "T49dIJ": "限制上涨空间",
  "X8y889": "下行敞口",
  "31vPJB": "下行保护",
  "niMFMe": "下行风险",
  "vH83i4": "保留完整方向敞口，但需要支付更高的前期成本。",
  "6uqwRP": "可能是贷记结构",
  "HTKZ58": "可能是借记结构",
  "j2O9lr": "用较低建仓成本换取结构中某处被封顶的收益。",
  "Y4kH1Y": "混合成本结构",
  "aGuQRr": "成本接近持平示例",
  "vbAobL": "净贷记示例",
  "wdUpET": "净借记示例",
  "D44sEH": "先收取权利金，但结构会放弃开放式的上行或下行空间。",
  "26HIAR": "形态锚点",
  "oZrayB": "该执行价上方的上行敞口",
  "WmUO79": "上行封顶",
  "BTV5BY": "上行敞口",
  "NaCRvw": "上行空间溢价，理论上的收益无上限",
  "cFt1IF": "下行空间收益，理论上的有限。",
  "EoQSyG": "",
  "eZSeUm": "模拟",
  "gl72aL": "",
  "ZyC1Or": "",
  "t7fDEh": "",
  "EUvmpg": "",
  "vnoR5E": "切换图表模式",
  "sua8E+": "估值演化",
  "GUWKJj": "当前估值收益 = 当前期权理论价值 - 入场成本",
  "3x2mRT": "结构演化",
  "V1PxU5": "到期收益 = 到期内在价值 - 入场成本",
  "p1f/Zg": "",
  "T2fDWS": "",
  "62ZMuT": "",
  "2Z2SYe": "",
  "xhaXU6": "",
  "it6Lig": "",
  "5IpTGY": "",
  "V2qutI": "",
  "KMhYEj": "",
  "iaHymw": "结果",
  "q652Os": "",
  "vYJBUA": "",
  "Rw9YBD": "",
  "6L4FfQ": "",
  "fWLNSP": "",
  "jP50Y1": "",
  "a27KAu": "",
  "uny3Zy": "",
  "eKMwyO": "",
  "W8q84/": "",
  "Qd6TUe": "",
  "AzbpbJ": "",
  "WALls3": "",
  "OSrJqf": "",
  "dwAKh7": "",
  "x1WrOG": "",
  "1r5WAv": "模拟",
  "s7P+qL": "",
  "EsXBfX": "",
  "ok28lD": "",
  "RqvNlN": "",
  "l04uqe": "",
  "VqA/F3": "",
  "J5WRS0": "",
  "xGPfE6": "",
  "92PLGP": "",
  "xqfj1F": "",
  "O891d+": "",
  "MQX1+C": "",
  "y4Kmfl": "",
  "CibGFE": "",
  "14UPZd": "",
  "g/5fR9": "",
  "Lz8cQH": "",
  "z0ZUdA": "",
  "OSaAhq": "",
  "0VV/sK": "目标",
  "x+TnuT": "",
  "hToxqm": "",
  "A70IcO": "",
  "75xfmS": "",
  "bml41Q": "",
  "RnEuh3": "",
  "UqZj7h": "",
  "e1AGQx": "",
  "ryvLhy": "",
  "sB8Qok": "",
  "LI4qKz": "",
  "5m2UdW": "",
  "TJxvmF": "",
  "00RNoT": "看每一条腿如何塑造整体结构",
  "83tmCn": "入场后，标的、时间和IV会重塑盈亏曲线",
  "vd1dvM": "更多模拟，在编辑器中打开",
  "24csDg": "",
  "BiNHi4": "",
  "OOeMkR": "",
  "dLFYnK": "切换为浅色主题",
  "q1cJmR": "切换为深色主题",
  "wckWTD": "",
  "lIHxtZ": "",
  "rXhNCK": "",
  "Y9Gzht": "开仓前",
  "tcRcb1": "",
  "LaDLwd": "",
  "iYkvUs": "",
  "cd7SUX": "持仓中",
  "mQ3Eo4": "",
  "I3UTV0": "",
  "vU2smf": "",
  "Rim8Gk": "退出/调整前",
  "DibMp3": "",
  "uvPr01": "",
  "winovY": "",
  "5XhxxK": "",
  "jbbk4T": "",
  "kanVDo": "",
  "h/ATbA": "",
  "1y6ZvF": "",
  "HSjRiQ": "",
  "y0H+MJ": "添加纪律项目",
  "k0LN3Z": "",
  "4RnUsH": "",
  "jSkymQ": "编写纪律项目",
  "ac9b1r": "",
  "t/mMfG": "",
  "DTlfoQ": "",
  "Madx7z": "",
  "0IdT6s": "",
  "lqsPas": "",
  "QIo3vC": "在承担风险前记录交易设定。",
  "Erpjc0": "",
  "IEl/4S": "",
  "/bWHKQ": "",
  "kcCzpD": "预期路径",
  "o9oWvO": "记录持仓后的实际变化。",
  "AXyxRF": "",
  "yO3Oho": "",
  "cMTAHl": "",
  "d4fa4a": "",
  "SuNbhB": "把结果转化为下一次更清晰的行动。",
  "Fjcyew": "",
  "emrMOH": "",
  "9SOTnE": "",
  "VebPCm": "",
  "j0Nz9M": "平仓后",
  "Ze8zCw": "",
  "SJvjM7": "",
  "coS9Fv": "",
  "cwfcI8": "在此写下发生的事情",
  "aJ/bsX": "拖动排序",
  "AghqfS": "",
  "F/ra6i": "",
  "yNMB0z": "",
  "rKTGWM": "",
  "7k60cr": "",
  "cppYdx": "",
  "A2Vevp": "",
  "3VVq6S": "",
  "/njdSY": "",
  "RHHml1": "",
  "djDTEE": "",
  "+kl/la": "",
  "V8plku": "仓位关联",
  "kgzJWc": "",
  "X2Mc+X": "",
  "KaRqOW": "",
  "wgUD8V": "",
  "d+qgix": "",
  "ieQTWi": "",
  "zdqVqW": "",
  "pQ8zrY": "",
  "32fkJv": "",
  "B5dTDe": "腿编辑",
  "BVOGIF": "打开完整编辑器",
  "e4nyd0": "",
  "3SisNf": "",
  "xLigG0": "",
  "YPhP7f": "",
  "9xIPKk": "",
  "UQFsGY": "",
  "v3q7Dn": "",
  "pvAQ9t": "",
  "6TGcPB": "",
  "hlnge7": "",
  "HcDoMa": "",
  "DqAgp9": "",
  "GDTZlE": "",
  "jtZHLu": "",
  "TdLXUj": "",
  "/UcIEd": "",
  "CMNQ2+": "",
  "UtNq1Y": "",
  "29RoP0": "",
  "lBXDfZ": "",
  "H/vOBM": "",
  "ASv306": "两侧有保护",
  "qj/R2V": "",
  "fzEmQd": "",
  "BI5kiU": "",
  "FKTD9Z": "",
  "2Iw4HH": "风险有上限",
  "YSbrjx": "",
  "BlvBhi": "",
  "+6gnu4": "",
  "VpmEYp": "",
  "p8NZpy": "",
  "L/Faeg": "",
  "gaDP0G": "",
  "AZJT7B": "方向策略",
  "KAkNww": "",
  "w/mKVP": "",
  "+zcshH": "",
  "b9j5Fe": "",
  "VAoNhR": "",
  "fXgU1r": "",
  "eL5VGF": "",
  "feNeqB": "",
  "B19UqF": "",
  "QwubtG": "区间与收取权利金",
  "NJTp7U": "",
  "Jc3sr6": "",
  "oTG2Vc": "",
  "k11uss": "",
  "EzbZ/f": "",
  "v321M1": "",
  "Ri2ksN": "",
  "o+G+4U": "",
  "hQLHh6": "",
  "OI67OR": "",
  "fOHg42": "",
  "ghpVwG": "",
  "+wFYts": "",
  "9E9TPs": "",
  "N86bAc": "",
  "vHaMRE": "",
  "86M0G7": "",
  "VB31VS": "",
  "PiIdng": "",
  "XYzYe4": "",
  "Mc58bs": "",
  "XUD2fC": "",
  "Vr2gJc": "",
  "Trr67T": "",
  "+blglH": "策略识别",
  "Lme2ev": "",
  "kCofht": "",
  "t4hHjd": "",
  "MUMXRu": "多维视图",
  "Hz5F0J": "",
  "9V2B+p": "",
  "30brZ7": "",
  "2GUgWX": "",
  "yLii5v": "",
  "tE2cGi": "平值隐含波动率",
  "lt4G2f": "",
  "5X16Pl": "",
  "8w44AT": "",
  "JZ+mP+": "",
  "HPwHsh": "",
  "dXlgaM": "",
  "qj/uec": "",
  "fitytV": "",
  "xPsrSx": "",
  "fOQVw6": "",
  "jYjaHs": "",
  "D97TsO": "",
  "OQQkqD": "计划、笔记、跟进",
  "XLFi41": "",
  "soCLV+": "待办清单",
  "UfVx9o": "",
  "716vD/": "",
  "wNCblV": "显示盈亏阶段",
  "5yMehU": "隐藏盈亏阶段",
  "7pXrnq": "日",
  "Z0jnBj": "归档 · {year}",
  "hJ6EC5": "历史年份，包含存档仓位、已实现结果和日期化的复盘笔记。",
  "8JJ/KH": "成本基准",
  "0VMZU5": "借记均价 $1.96",
  "TQaZmF": "48笔已平仓交易",
  "+KgWt/": "5906均价",
  "CHLuYQ": "-$28k",
  "mrOnjM": "模式",
  "9w5c2P": "存档方向书",
  "2dZYch": "+$11.2k",
  "649SQD": "贷记均价 $1.08",
  "Tv3gzx": "存档收益书",
  "jK4np8": "+$2.1k",
  "vCahpp": "",
  "R+J5ox": "复盘",
  "PFn91i": "",
  "3iNcfb": "",
  "mdxPio": "{year} 年",
  "yABxM/": "年度簿记 · {year} 归档",
  "avWSMa": "存档年份保持相同的视觉系统，但内容明确为历史性的：已实现结果、已平仓记录和过去的复盘路径。",
  "947I6g": "周期",
  "gSM0WL": "年度 · {year}",
  "VmnY82": "选定的年度记录。",
  "NGKqPT": "借记均价 $2.68",
  "ANQM1C": "持仓天数",
  "sYMLag": "实盘+计划记录",
  "zpv8jG": "5988均价",
  "N/wcOE": "-$36k",
  "QJWHzz": "下一步",
  "k9bZQY": "打开当前计划",
  "tAZ+YS": "借记 $2.80",
  "fddwUI": "看涨跨式价差",
  "iSfLPg": "+$184",
  "RAhSDR": "贷记 $1.34",
  "iesPLO": "铁鹰漂移",
  "8ObPam": "-$42",
  "Q4/nm9": "观察中",
  "7qBnyG": "借记 $5.10",
  "v+DE/u": "日历修复",
  "IZFEUg": "就绪",
  "H2A4l0": "",
  "5aHLfb": "Q1",
  "UyEWSu": "",
  "4W8x5a": "",
  "0Y/8yJ": "Q2",
  "FRY/1/": "",
  "mkNzuO": "",
  "zvczgi": "",
  "GxOlOe": "",
  "sbDnP2": "年度记录 · 当前年份",
  "y+C2aN": "当前年份应统一所有内容：实盘记录、计划结构以及解释该记录如何形成的复盘轨迹。",
  "wBpAA8": "规划期 · {year}",
  "Kv1dj0": "未来规划年份，包含分阶段策略、预测结构，尚无已实现成交。",
  "KCfzO/": "计划均价 $3.04",
  "5Kx7yd": "未来年份",
  "B8EZ5K": "6054均价",
  "GSahCH": "-$41k",
  "Vfvggz": "计划地平线",
  "08b5tn": "计划 $3.20",
  "DqeRtW": "阶梯滚动图",
  "X4ZEP3": "计划 $1.42",
  "056NtU": "收入修复图",
  "7YSPmO": "",
  "b2WrSS": "范围",
  "RXpxPU": "",
  "Xy+vz/": "",
  "W+J13o": "年度簿记 · {year} 规划期",
  "hWeW8R": "计划年份应保持相同的界面，但舞台上的所有内容都应显示为路线图：建议的敞口、预测的时间和未来的审查锚点。",
  "3uGLNA": "无数据 · {year}",
  "P1SQsM": "空年份范围。尚未附加任何历史记录或未来计划。",
  "thiOfy": "--",
  "UG5qoS": "无数据",
  "acoEBu": "暂无数据",
  "cjO0aw": "尚无仓位数据",
  "CNkoci": "空年份",
  "QrBDX3": "",
  "Q2yxVw": "年度簿记 · {year} 空区间",
  "uFQT3Y": "空年份在同一时间系统中保持可导航性，但内容状态是明确的：没有实时账簿，没有存档，也没有附加的未来计划。",
  "t8QlFE": "一月",
  "3mcx52": "一月",
  "0TR0PD": "二月",
  "lsI6+i": "二月",
  "T5W0CV": "三月",
  "Ntypeb": "三月",
  "h7xti1": "四月",
  "vICE/x": "四月",
  "zUpHdf": "五月",
  "xBaHKe": "六月",
  "040rfl": "六月",
  "trR2dv": "Q3",
  "NGWumB": "七月",
  "iPtQUl": "七月",
  "lINtN6": "八月",
  "2eQSom": "八月",
  "TFf5u+": "九月",
  "aV/c/P": "九月",
  "gNixBN": "Q4",
  "EuK7yR": "十月",
  "6Uae/q": "十月",
  "pn+jQD": "十一月",
  "OOkYHt": "十一月",
  "SsiZK7": "十二月",
  "g7daoL": "十二月",
  "Yai4KM": "月份 · {month}",
  "he6DvA": "{year} 年内的归档月份。",
  "mEqBuO": "已存档月份",
  "0zFji5": "-$2.8k",
  "BQ4Nrb": "存档平均值 $1.96",
  "ZHON+n": "已存档月度账簿",
  "3Cpnbk": "+$880",
  "BWcg7B": "",
  "fD1pCO": "",
  "dxDfXh": "月度簿记 · {month} 归档",
  "U+VcDy": "月、周和日应继承选定的年份基线，而不是像独立的时间线那样运行。",
  "CLPpG7": "{year} 年内的规划月份。",
  "ODrLpl": "未来月份",
  "SJycpz": "-$3.6k",
  "v1aogz": "计划 $3.04",
  "DTDjo3": "月度路线图",
  "G3ot+x": "",
  "m+2DvV": "",
  "+tjG21": "月度簿记 · {month} 规划",
  "pUic6k": "选择计划年份后，月份视图应保留在相同的年度范围内，而不是跳回到当前实时年份。",
  "ZnW07R": "{year} 年内暂无月度数据。",
  "1bDyQq": "空范围",
  "k0mPiS": "尚无月度数据",
  "KOIMkh": "空月份",
  "yNOpGx": "",
  "dVt6TW": "月度簿记 · {month} 空状态",
  "sqll8V": "即使所选年份没有内容，月视图也应保持可导航，因为时间系统仍需要一个连续的层级。",
  "azA/mf": "实时框架",
  "RE27Wb": "第 {week} 周",
  "cA9+ey": "{year} 年 {month} 的第 {week} 周。",
  "LsYasz": "计划平均 $2.84",
  "J7RKUv": "借记平均 $2.36",
  "SGcXj+": "7天窗口",
  "G4D7FM": "锚定至月份",
  "NVKmtq": "限定至范围",
  "FHJmd5": "计划周度图",
  "gcVGVu": "锚定周度读数",
  "uFtAgz": "尚无周度数据",
  "1P516t": "周度范围快照",
  "PxG3cX": "限定",
  "a4xGoS": "",
  "3ofJNz": "",
  "E4+csi": "{year} 年 {month} {start} - {end} 日",
  "Xub7tu": "周度簿记 · {month} 第 {week} 周",
  "6geTOm": "选择月份后，周度导航应读取该月份的内部细分，而不是不相关的近期周度轮播。",
  "To52hH": "快照 · {weekday}",
  "O0SopU": "{year} 年 {month} {day} 日快照。",
  "buUDsH": "计划日度图",
  "fsuPbC": "存档日度标记",
  "MFxZsc": "日度范围",
  "Ny8bRn": "单日",
  "mMFdJj": "锚定至日",
  "kkZpF7": "限定至日",
  "wt4GvW": "计划日度路线",
  "fyqUlv": "锚定日度读数",
  "aTX7LJ": "1D",
  "qRAGY7": "尚无日度数据",
  "LWQD4g": "",
  "RfuRgx": "",
  "Xo62q2": "{weekday} {month} {day}",
  "aG8fX1": "",
  "rlkTbu": "{year} 年 {month} {day} 日 · {weekday}",
  "SscrMt": "日度簿记 · {month} {day}",
  "ZBNq6u": "选择月份后，日度导航应在同一年度基线下简单地遍历该月份的内部日期。",
  "Q5w5/Q": "日范围",
  "+yklh7": "周范围",
  "ptW4Sw": "月范围",
  "eK9wmJ": "年范围",
  "7i4by+": "在日历面板内阅读所选日期间隔内的内容。",
  "rucdxS": "将所选周度窗口内的内容视为一个连续的操作框架进行比较。",
  "Lf5SJy": "将所选月份视为一个计划和回顾的弧线，在同一年度框架内进行阅读。",
  "xy5li8": "在不离开共享页面基线的情况下，将所选年份视为一个存档或计划范围进行阅读。",
  "P2jhG/": "",
  "eEVxHv": "",
  "d/eX2N": "",
  "QtydSL": "",
  "1leDN6": "",
  "/UNyqw": "",
  "oHEUmB": "",
  "wPi8nQ": "",
  "2IacYt": "",
  "x8A60T": "",
  "i4EBJ/": "",
  "BdfJek": "",
  "uhQeRj": "",
  "MTDDcS": "",
  "mGDpYA": "",
  "h6XDMT": "",
  "ZqHTTf": "",
  "Dn82AL": "",
  "TV+4BK": "",
  "q1WWIr": "",
  "dLG3u7": "",
  "d0nItl": "",
  "gpLEe7": "",
  "p3x/Zx": "",
  "8IM6iW": "",
  "VRgMWX": "平稳",
  "Yd0jwk": "",
  "QcCEzs": "",
  "Z35MUj": "",
  "XNnzyV": "",
  "v3Pp+0": "",
  "LzD3TV": "",
  "/TlAIY": "",
  "Up1NJA": "",
  "MK4sNo": "",
  "52EzDA": "",
  "pXYUJ2": "借记 $4.90",
  "NapaKO": "6月21日",
  "DOCgI8": "BTO",
  "Q/7Pyf": "贷记 $2.10",
  "SKMqP4": "STO",
  "zFieBl": "贷记 $0.00",
  "3JsS/z": "贷记 $1.24",
  "4G8OvL": "借记 $0.52",
  "Lvm8Pd": "贷记 $1.08",
  "vRZyBJ": "借记 $0.46",
  "Pgj0YV": "贷记 $2.80",
  "xGKP8X": "借记 $7.90",
  "1wWWtl": "6月28日",
  "C4MfxN": "STC",
  "MSrN2L": "BTC",
  "EpYUBA": "展期",
  "qW14/k": "标记至计划",
  "YhE3pd": "删除计划",
  "iNBANA": "打开备注",
  "YQu3Ik": "",
  "UptFhO": "",
  "jq2QOE": "",
  "9c9hyM": "",
  "x7b7+O": "",
  "YpVoLg": "追踪",
  "U9Qcze": "还在等待实际处理决定的提醒。",
  "95stPq": "已完成",
  "IggcLQ": "已经在提醒台中处理完成的提醒。",
  "D/0ALU": "",
  "GLMUC9": "提醒台已经查看过的项目。",
  "Xv5TXk": "至少已经触发过一次的实时提醒。",
  "XrPiAZ": "到价提醒",
  "XMapyU": "到价提醒",
  "IB/nH0": "",
  "zuFWKo": "到期提醒",
  "W30VkQ": "",
  "yktVOZ": "跟进提醒",
  "NFIFi2": "把这条到价提醒挂在关联仓位上，确保下一步动作始终明确。",
  "9CquDh": "创建一条到价提醒，并回到提醒台统一处理。",
  "Pvdacj": "在时间节奏变成漂移之前，把到期窗口重新拉回视野。",
  "P5OygY": "记录一条带日期的待办，让它能在提醒台里查看并完成。",
  "8vxcEz": "估算已实现盈亏",
  "5dgeW5": "在选定的时间基线内已平仓并标记。",
  "y1Dzrb": "持平",
  "HYWpzj": "此切片包含的管理仓位。",
  "frdDRv": "胜率",
  "qcaDSl": "当前框架内的正面已实现结果。",
  "cCC/bL": "平均持仓",
  "DuutHc": "审查或退出前持有的平均天数。",
  "/ph2Jr": "当日",
  "/OKfdV": "",
  "aNSYkp": "",
  "aUlaGf": "",
  "wuoGjw": "",
  "I0gynI": "",
  "uhVPuZ": "",
  "kVm/25": "看涨看涨结构",
  "o9fe8I": "看跌对冲结构",
  "VHJRnP": "区间收入结构",
  "xCcmTM": "日历修复结构",
  "0tOalt": "自定义管理结构",
  "NW+B5A": "此切片的利润由最强的结构家族驱动。",
  "wh3Z4O": "尚未为此切片附加任何结构归因。",
  "DOMFkY": "等待已关闭的结构结果。",
  "BYHcyk": "按策略",
  "UXy2ZL": "代码集中度是此地大部分已实现结果的定义因素。",
  "zP+YKA": "尚未为此切片附加任何代码归因。",
  "zKKyck": "等待代码级别贡献数据。",
  "qWAtAh": "按代码",
  "rFzPCl": "账簿状态显示了是持仓、计划中还是已平仓的工作驱动了结果。",
  "2PPkMi": "尚未为此切片附加任何状态归因。",
  "VdTTjB": "等待基于状态的贡献数据。",
  "9OEa4w": "按状态",
  "TnJOL7": "",
  "A6J6xi": "",
  "hFCpuX": "",
  "W6XCMl": "",
  "L+/Zz0": "",
  "+3G/tv": "",
  "ySa57T": "",
  "cHrKI3": "",
  "Dzn6x/": "",
  "5DFT+z": "工作区派生",
  "2KtWqT": "内部",
  "fgZsGY": "经纪商/已导入",
  "QG6+rR": "外部",
  "MtAlTm": "组合分析",
  "aJicJg": "经纪商和已导入结果（在所选窗口内）",
  "iFsDVR": "加载中",
  "Y/W1GU": "此时间切片中计入的已导入成交",
  "OqsNmH": "来自已导入和经纪商关联记录的胜率",
  "pl/OMC": "来自已导入日历史的风险调整后结果",
  "o4ALsy": "日均",
  "DvHrgo": "每交易日的平均已实现已导入盈亏",
  "2UbPGs": "",
  "L0QIW6": "",
  "+zLDzU": "",
  "ia6pkv": "",
  "3yPX6x": "",
  "LQMvlK": "",
  "BsPtZ8": "",
  "znl1Ug": "",
  "U9X8xb": "",
  "yGpf+1": "",
  "iUzw/Y": "",
  "9q8J6I": "",
  "TKrnrf": "",
  "HEWSSl": "",
  "1YQTU5": "",
  "wOHidA": "",
  "novf+I": "",
  "5iUJDQ": "",
  "Tunfr8": "此切片中的已导入结果由一两个底层头寸主导",
  "hZILDu": "此切片尚未附加任何已导入的交易代码归因",
  "ggjiYf": "等待已导入的交易代码结果",
  "yFWp4Y": "组合模式保留工作区框架，但允许已导入的交易代码结果主导归因读取",
  "fPSSeS": "组合模式已就绪，但此切片尚未附加任何已导入的交易代码数据",
  "VAVAGE": "交易",
  "SUwKav": "已导入的交易历史显示此底层资产是所选窗口中的主要已实现贡献者",
  "fMem24": "趋势一致，并保持足够紧凑以实现收益，无需后期修复",
  "6mMtIR": "已导入的交易历史显示此底层资产是所选窗口中最大的已实现拖累之一",
  "kDMp5i": "一旦行情减弱，风险敞口暴露时间超过了收益改善所能证明的程度",
  "hV3tWH": "",
  "ls+I8K": "",
  "st0RXH": "",
  "6cmWxp": "",
  "Dbm0y4": "",
  "8Fza0/": "",
  "ZkBOqX": "",
  "X5CuFe": "",
  "doCWOs": "",
  "bXMD1U": "",
  "xam41d": "",
  "6284DG": "",
  "jLU0Vk": "",
  "ipOW2l": "",
  "v8yPEd": "",
  "9B6xEr": "",
  "lKa9YM": "",
  "29x37I": "",
  "lN636e": "",
  "L2i4RU": "",
  "XmXue/": "",
  "9O3+yK": "",
  "TY2/ws": "",
  "1k7+ot": "",
  "WL8RAU": "",
  "l5lY4b": "",
  "r4YUIS": "",
  "/Cwnyo": "",
  "g1aplD": "",
  "AmjVQ5": "",
  "+SIzpk": "",
  "TK8bb1": "净值曲线",
  "2qsDw4": "",
  "F1d4A9": "",
  "SaqU2A": "回撤",
  "r9XqL3": "",
  "pGghuM": "",
  "9WBD0z": "月度热力图",
  "4kq6EB": "",
  "QMjxmM": "",
  "tfQGFI": "盈亏分布",
  "AwRFBj": "{count}笔交易，胜率{winRate}%",
  "sLWbBX": "一旦所选窗口有足够的经纪商关联历史可供细分，已导入的归因将在此处显示",
  "GfDX12": "一旦此切片有足够本地结果历史可供总结，工作区派生的归因将在此处显示",
  "X4a9zL": "尚无归因数据",
  "6oGvmt": "尚无本地归因",
  "WAdW1B": "",
  "ADG3SL": "",
  "ntdglZ": "",
  "rnasOq": "",
  "oeAC65": "打开工作区",
  "IQvXuv": "打开完整日历",
  "i2PGGG": "",
  "s+vdyj": "周范围",
  "K3uyvq": "月",
  "L0skFL": "",
  "T8JZHe": "周一",
  "C4ENlv": "周二",
  "2NqUgh": "周三",
  "FC0AP4": "周四",
  "hFYE2M": "周五",
  "3Hv4Fb": "周六",
  "1Aday2": "周日",
  "lgWRdR": "",
  "4kDsZn": "",
  "hcvD+s": "",
  "lAXvBg": "",
  "toq+PX": "",
  "zcGLYc": "",
  "WfYZhD": "",
  "EUq2CH": "",
  "dN+2Xq": "",
  "mYmjNf": "",
  "rJ+29b": "",
  "78Gbn1": "SPX",
  "nIiewT": "NDX",
  "5tx9gM": "所有代码",
  "PzhJ/E": "所有仓位",
  "qMgtSE": "隐藏腿",
  "7i7IG/": "展开所有腿",
  "/uA3qY": "尚未为此仓位附加腿部详情。",
  "WryeSo": "",
  "xASBIU": "",
  "6KzRnU": "",
  "lhQMR9": "",
  "/6ZxZW": "提醒创建入口可以分散在仓位、日历详情和工作区其他位置，但统一在这里集中处理。",
  "KA/Qci": "快速添加",
  "0cR79l": "快速添加到价、到期或待办提醒",
  "HCrRaj": "待办",
  "2T6YJ4": "如果这条提醒需要从提醒台直接跳回实盘仓位，就在这里关联仓位。",
  "FfjQnD": "关联仓位",
  "w3nB9e": "未关联仓位",
  "7fN+4u": "提醒队列",
  "bVTJka": "未处理提醒",
  "141Ym7": "已完成提醒",
  "HQ8QMs": "{count} 个提醒",
  "9mLiUs": "这条提醒已准备好在提醒台中处理。",
  "tFFMkF": "暂停",
  "3y9DGg": "恢复",
  "39ou17": "尚未关联",
  "5bpQsu": "标已查看",
  "4Y2K5+": "标已完成",
  "/diypV": "打开关联仓位",
  "4OADrX": "当前筛选下暂无提醒",
  "0b0ca1": "切换处理状态或提醒类型筛选，或者从左侧快速添加新的提醒。",
  "zWkvNO": "时间线",
  "qFsEJC": "归因",
  "HtMahR": "外部导入",
  "pZCOqy": "在读取外部时间线前导入经纪商历史。",
  "obnOhI": "归因标题",
  "VB7wED": "一次使用一个维度，以便贡献度、胜率和平均结果在同一表格中保持可比性。",
  "Otefae": "维度",
  "J+jj1H": "盈亏",
  "f6+ZSh": "平均盈亏",
  "LJOoay": "主要贡献者",
  "HDOhEU": "",
  "uSb+iE": "",
  "Vwya4c": "",
  "Wv+bxD": "主要拖累者",
  "Oy/Lgi": "交易最多",
  "YCQYiv": "尚无导入活动",
  "u5A6nB": "{count} 笔已导入交易使此成为所选范围内审查最繁重的头寸。",
  "1KLl6N": "一旦在此窗口中出现已导入的执行，最活跃的标的将显示在此处。",
  "6zhrlX": "按天",
  "3GYJE1": "",
  "S39Gkm": "",
  "lLev9A": "",
  "5+llIK": "",
  "5jeq8P": "未知",
  "l+Y3wK": "当你需要完整上下文时，可以在这里直接创建提醒；其他位置的轻入口也仍会汇入这个提醒台。",
  "TGPaXZ": "处理流",
  "8uJp5t": "随处创建，在此管理。",
  "waJLKW": "已关联",
  "TVD6+L": "打开提醒创建器",
  "dasH9w": "先在这里处理当前提醒队列，只有当提醒需要交易上下文时，再跳回关联仓位。",
  "LKHGSu": "已完成提醒会继续留在这里，形成完整闭环，而不是消失在背景里。",
  "qYUjnv": "",
  "EAys4o": "",
  "sYlYoV": "",
  "FYhx9Y": "目标价格",
  "l3AfOI": "到期日期",
  "YPJZm4": "当下一步动作取决于实时价位时，用到价提醒。",
  "9nP/nT": "当时间窗口比价格更重要时，用到期提醒。",
  "mce0oj": "当某项跟进工作仍属于交易流程时，用待办提醒。",
  "3itOWt": "保存提醒",
  "cYB+Qo": "在这里结合上下文创建，在这里统一处理。",
  "IofwcD": "如果这条提醒需要跳回实盘交易上下文，就给它关联仓位。",
  "31au/S": "先清理当前提醒队列，只有需要时再跳回关联仓位。",
  "vFIiJa": "让已完成提醒保持可见，形成闭环。",
  "eQ4RBQ": "当前焦点",
  "DyZCQw": "已查看提醒",
  "JAk24c": "已触发提醒",
  "uicJuJ": "已查看项目会继续留在这里，直到它们被完成或重新变成待处理动作。",
  "7wcWEw": "已触发提醒会把真正发生的事件提出来，方便提醒台快速反应。",
  "3ku6nj": "活动队列",
  "yKC86Y": "已闭环",
  "FnKIAW": "已确认",
  "WrxQgp": "实时触发",
  "UQ8n6q": "当前没有符合这个类型的活动提醒。可以新建一条，或切换到其他队列。",
  "EmPWUU": "当前没有符合这个类型的已完成提醒。处理完成的提醒会落在这里。",
  "gJ1PKF": "当前没有符合这个类型的已查看提醒。确认过的提醒会收在这里。",
  "P3+PEx": "当前没有符合这个类型的已触发提醒。实时触发的提醒会显示在这里。",
  "KCtlGt": "",
  "MT0tUs": "当前没有符合这个类型的未处理提醒。可以新建一条，或切换提醒类型。",
  "sSlvqz": "当前没有符合这个类型的已完成提醒。处理完成的提醒会显示在这里。",
  "DekliR": "",
  "+t2n0L": "",
  "M3RBk2": "",
  "zvQKpZ": "无提醒",
  "MpadSB": "",
  "VtbQZf": "",
  "sXyuGt": "路由与验证",
  "Jdy2Mu": "计划与复盘",
  "EbNaDn": "知识库",
  "UuA+7N": "研习结构与案例",
  "JiVlcN": "追踪转化、代码和支付",
  "nG6XOe": "运营用户、KOL和系统流程",
  "0MZgz/": "",
  "jLwPtz": "四种沉浸式路径.",
  "syVNlr": "",
  "ehV3rk": "展开顶部控件",
  "uRf8T2": "收起顶部控件",
  "3bok0w": "事件日",
  "yAGd/7": "事件窗口",
  "34jtTc": "将宏观信息保持在与检查表和日志提示相同的日期基线上。",
  "z1SWb+": "在不离开工作区的情况下，将所选时间范围视为一个宏观序列。",
  "CRJk7g": "高影响力",
  "9yK8v8": "覆盖天数",
  "IM6CNm": "宏观日历",
  "CykfDS": "今日交易事件",
  "Meph9+": "所选范围内事件",
  "PTfLbg": "正在加载经济事件...",
  "yFXsYM": "目前无法加载经济事件。",
  "p31OA7": "所选范围内无计划的宏观事件。",
  "16VAw9": "用户、创作者与平台运营。",
  "bOXzfU": "在一个后台管理整个平台。",
  "LEIWu5": "",
  "Dc6tD1": "在开头添加策略",
  "JvUqIl": "添加策略",
  "jET2Cb": "",
  "OZ7IJt": "",
  "8TSY2E": "计划开始",
  "FKrKuf": "为此计划构建第一个策略",
  "DJoyyo": "以此具体结构开始计划，然后从中优化到期日、腿和后续操作。",
  "T0u4+b": "",
  "7y8CwF": "",
  "J6erL0": "",
  "LmszdP": "",
  "cRq2o3": "",
  "OG4jW1": "",
  "FTRFir": "",
  "MicBq3": "盈亏图",
  "6yXxQg": "",
  "Kxveh8": "",
  "Me8aoK": "",
  "vvfc+i": "",
  "L4htnl": "",
  "wsRADk": "当前结构",
  "ruY471": "衰减",
  "3PynKw": "",
  "R9an/c": "展开股票上下文",
  "lf7wkB": "收起股票上下文",
  "tASou1": "",
  "ENh52H": "",
  "rzbYbE": "目标",
  "VLwJl5": "起始资本",
  "Pru4XK": "增长速度",
  "d57f4E": "年",
  "TxzXTj": "目标余额",
  "H136aY": "复合计算器",
  "ZBALng": "当前计划",
  "/Lm9LW": "",
  "wut5a4": "设置金额，选择回报范围，然后查看下方结果。",
  "TwULfc": "填写您的投入计划、增长速度和拖动假设。",
  "gQDjJL": "在下方输入核心输入值，并在审查面板中阅读结果。",
  "Gv2IsN": "资本基数",
  "EwwhwW": "设置起始金额和您的定期追加。",
  "4nDMs1": "选择回报假设和时间窗口。",
  "HC8xUj": "滑点",
  "j7hpnr": "调整税费和减缓复利的年度成本。",
  "26J+tl": "实际结果",
  "Ptd9Fx": "每月追加、增长、税费后的预测账户价值。",
  "DlhY7e": "预测余额",
  "1pAREv": "所选周期后的未来价值。",
  "WNOZk6": "总收益和复利收益对比简单增长。",
  "cZKGLj": "预期范围",
  "0Cfd9+": "所选周期内的压力情景至乐观情景。",
  "w/Ei8V": "投入计划",
  "ZL6k3I": "起始资本加上累计月度追加。",
  "4Op0mv": "增长、税费后的期末价值。",
  "EtNEo8": "税费",
  "UpmMpb": "来自年度成本和收益税的估计拖累。",
  "FbQ+Qa": "",
  "3Dw73J": "难度",
  "kc79d3": "主题",
  "7sOOGa": "",
  "xGKjzC": "",
  "Bh7Pr8": "",
  "oWjhon": "",
  "affGSV": "工作空间已准备就绪。",
  "Ph6B7A": "选择要进入的页面。",
  "fJBWP+": "在审查前后制定、比较和优化工作计划。",
  "RCJQN7": "",
  "v0/OuK": "",
  "fkddTu": "",
  "yf8d6P": "",
  "o17egY": "",
  "wDoOmo": "",
  "+EfZbW": "",
  "BmMst+": "",
  "W4SJiq": "",
  "NDx+B0": "个人",
  "uIjuqR": "",
  "2bfWlg": "运行历史回测并在一处集中流程中阅读结果。",
  "U7f4Pj": "利用历史背景对策略进行压力测试，然后再执行。",
  "vLMUJn": "",
  "IfPEOm": "",
  "YA1Ydf": "剩余天数",
  "k1oTSN": "剩余周数",
  "wU87pu": "剩余月数",
  "EpzWvP": "剩余交易日",
  "aVqg31": "",
  "zyFak8": "",
  "Cu3Cty": "",
  "6TAbq7": "",
  "AXAZ81": "",
  "HEcmzy": "",
  "B7FmSB": "",
  "b1MFe5": "",
  "ihLLsB": "",
  "qxqUH4": "",
  "jGlX0H": "",
  "tE7rAB": "",
  "328xyg": "",
  "+moS6q": "",
  "4gGZKe": "",
  "94tpVh": "",
  "upfFH7": "",
  "vSI3k7": "",
  "+h5YDP": "",
  "cJiL6Q": "",
  "RvwGpR": "资金进度",
  "pOcHR4": "",
  "UieAfL": "目标收益率",
  "D56UMu": "",
  "yxR2GM": "",
  "uten//": "",
  "LOjo1W": "",
  "kh5daL": "",
  "f909GS": "",
  "1G04pn": "总收益率",
  "hpeBcW": "",
  "Y2eIQv": "",
  "GQOqLK": "",
  "sOQYAI": "",
  "GihqFN": "",
  "NBULhT": "",
  "TdsTSW": "",
  "jcdXhn": "",
  "H21AE9": "",
  "XjqrY+": "",
  "8IxKlF": "",
  "aw5UGn": "选择一个仓位以聚焦详情面板。",
  "+51nyq": "打开复合计算器",
  "g/CgSO": "",
  "ka8VLG": "剩余",
  "ZMEBqN": "",
  "0oMyHq": "",
  "fZb224": "",
  "a6WBHp": "",
  "2vylZJ": "",
  "Pn18TY": "",
  "z4gijG": "已部署",
  "OMjWgd": "",
  "NhtScg": "",
  "2SOCUK": "",
  "E8l5n/": "",
  "MT7W2m": "",
  "WH1NGy": "",
  "0WJNP/": "收益率",
  "epEfUW": "当前收益率",
  "3KPDRD": "计划进度",
  "S6yUtO": "",
  "dwcbtR": "",
  "dxViiu": "",
  "pR/og2": "",
  "+uNQ2J": "",
  "DI5Mf5": "",
  "y7hxzt": "",
  "FQ6OqK": "",
  "tYvY9B": "受众。推荐。支付。",
  "1SREsW": "一旦此账号关联到创作者档案，推荐链接、转化指标和支付历史将在此处显示。",
  "a18IzS": "在同一工作空间中跟踪创作者表现、活动链接和支付历史。",
  "s6uMnZ": "已支付",
  "9qmSHn": "",
  "DNVZco": "",
  "Do1Pfd": "章节",
  "TlE0E9": "",
  "3fcIhq": "",
  "5y+k/P": "",
  "kVksmE": "",
  "DzFCjY": "",
  "EajxCs": "",
  "2LSu6I": "",
  "RDwKyy": "目录",
  "uOThCV": "",
  "UmO4Nm": "",
  "BlIbeP": "范围: {label}",
  "MGmJmm": "",
  "Kt+t8D": "",
  "TDUfVk": "已开始",
  "EQpfkS": "已完成",
  "yrhXAw": "已跳过",
  "J9uqCq": "盈利因子",
  "92KWuG": "平均每日",
  "HHFpcy": "最佳日",
  "Kvv2xH": "最差日",
  "C/SEYq": "平均盈利",
  "in443e": "平均亏损",
  "b2X2MN": "最大回撤",
  "qyNB9S": "连胜(胜/负)",
  "YZJLdk": "",
  "OqsfAQ": "策略架",
  "VNFzdA": "进入多选",
  "zblqVV": "使用方形按钮清除或选择所有可见的交易路径。已选择“{count}”。",
  "zxDhDV": "使用方形按钮选择当前过滤器下所有可见的交易路径。",
  "ZYZEIJ": "",
  "jUgIp7": "",
  "5xsO4S": "",
  "tdqI3t": "",
  "EU6fL6": "",
  "wghYFq": "",
  "E483ZS": "",
  "qv1bNN": "返回到运行",
  "KAeJLW": "加载运行失败：",
  "7b4tym": "每日日志",
  "WzEqfA": "无每日结果——窗口中的每一天都被跳过了。",
  "fp8A9b": "",
  "f61qxY": "",
  "wPIuj1": "",
  "gSkcsv": "",
  "Zy9EH3": "",
  "FjgLbn": "",
  "aOeR06": "",
  "g0Dddx": "目标进度",
  "PODzei": "",
  "2semsi": "",
  "yM8mOb": "",
  "pk0m01": "",
  "H1+DAV": "",
  "38Oeg3": "",
  "X+EqZ8": "活跃目标",
  "yaMHMB": "",
  "V3AvlJ": "",
  "F77KSL": "已准备",
  "y2BOm7": "准备进度",
  "HoiRnc": "添加目标",
  "WgB4iI": "目标名称",
  "O68FsC": "",
  "mF5VmC": "",
  "MfPGQ8": "",
  "EDdXjJ": "",
  "kbWBdL": "",
  "izGJrM": "",
  "uVRNsH": "",
  "ylcSU7": "",
  "lhosUF": "",
  "4C54BE": "",
  "98Dgqw": "",
  "ISMqUj": "",
  "liHw2l": "",
  "OCHcnX": "",
  "c8EWLR": "没有已平仓记录",
  "xhuziM": "",
  "t+zeEh": "",
  "UxKqs1": "",
  "+9FDmS": "",
  "XA9G8i": "",
  "lqcIoX": "",
  "onvTQK": "",
  "ZRnjnA": "在一个工作台里追踪实时计划、状态、提醒和后续动作。",
  "HyXHxS": "把计划继续往前带，同时把追踪、提醒和复盘都留在同一个工作台里。",
  "gTWKP4": "切换市场上下文",
  "ukTSHR": "打开工作区日志台，在这里记录笔记、日记条目和后续动作。",
  "nLF6pl": "进入当前交易时段的专注检查清单流程。",
  "IYQEjY": "趁计划还新鲜，把过程写下来。",
  "D+v5e+": "追踪",
  "+vBFap": "提醒",
  "tjy+Qy": "",
  "OecV5i": "",
  "C7HS+o": "",
  "h9JZyj": "",
  "TIV+K4": "",
  "Ffoibm": "",
  "HuFBN2": "",
  "mM70Zn": "",
  "D7Jd3E": "",
  "t72y18": "",
  "jfEXVT": "",
  "QV3gnF": "",
  "u8cKRM": "",
  "ak4CxX": "",
  "uYAYib": "",
  "493J7R": "对比",
  "HJEJo0": "",
  "dxs3Xf": "",
  "ZiHOF+": "",
  "q1Cd7m": "",
  "R8uptB": "",
  "/z18UI": "",
  "XiZDyN": "",
  "lE/Uhu": "",
  "X/AllT": "",
  "u5Pvdb": "",
  "9Obw6C": "",
  "DegD68": "",
  "A20+WU": "{count} 个持仓",
  "bz+S/R": "{count} 个活跃",
  "T/faTw": "查看计划",
  "8YKEEW": "打开提醒",
  "m9Vy8g": "此切片当前没有实时交易。一旦交易激活，持仓将在此显示。",
  "RBaP0R": "无仓位",
  "5oJyQm": "查看未平仓",
  "V8AUHl": "当前没有观察项。在您尚未操作时，观察仓位将在此显示。",
  "G44uIC": "无仓位",
  "sK5w2c": "没有排队的交易计划匹配此切片。计划中的想法将在进入实时账簿前在此显示。",
  "lyeh4t": "无仓位",
  "3qxSi8": "打开日志",
  "0mUCwt": "打开分析",
  "trTp5v": "此切片内尚未有任何平仓。一旦准备好进行审查，已完成的交易将在此显示。",
  "q5OQqU": "空状态",
  "VxGfLi": "",
  "E5Skre": "计划头寸",
  "pbdPil": "关联已平仓仓位",
  "ZaNKvA": "开放头寸",
  "IzWm6A": "观察仓位",
  "g+82aF": "低情景",
  "HW6TEk": "高情景",
  "B7hDsY": "价差",
  "cWSBD2": "",
  "jo/9jA": "",
  "38Do7I": "",
  "Mu4Zak": "当前金额",
  "KU8hIn": "每日收益",
  "ZAcA/p": "当前余额 + 日度利润 × 天数 = 结果",
  "/dghlY": "日度金额",
  "JKwQVq": "完整计划",
  "4sbRjG": "预估总额",
  "111iCD": "复利结果",
  "DuPR6M": "添加总计",
  "jIQfri": "复利收益",
  "otpFqZ": "简单增长",
  "LklIBh": "",
  "wd3BlC": "",
  "5GX1/c": "/日",
  "vubFDg": "公式和详情",
  "UyGvrt": "切换公式和详情",
  "D4WV+v": "",
  "PVfXey": "更新当前目标",
  "LAWWFB": "进度详情",
  "GvVSWW": "",
  "UQ/4Dp": "删除当前目标",
  "E9B59G": "",
  "v1DI5v": "",
  "0QVxyP": "",
  "v0/kjz": "",
  "MZ726w": "目标金额",
  "hCCnsx": "利润目标",
  "BgtKWR": "已获得",
  "hpk3xG": "今日变化",
  "mQf8uG": "",
  "aH4De2": "来源",
  "sE/hzK": "",
  "YXdf6z": "展开工作区导航",
  "3C0JhM": "收起工作区导航",
  "nPfjAm": "",
  "UK8nP5": "",
  "jbAzo+": "",
  "CICR28": "",
  "zcHp4J": "",
  "/5O7cd": "",
  "k4ehb8": "",
  "1u3nel": "",
  "0amr7u": "",
  "HU+CXC": "",
  "k7z/Pq": "",
  "Kr9TyW": "",
  "UKxoV8": "",
  "o7pSXU": "",
  "mF/Rfy": "",
  "Nm7Q9V": "",
  "h0ThDc": "",
  "TSFYfF": "",
  "itPgxd": "个人",
  "lMd87l": "",
  "KGbGs2": "",
  "g8TbGL": "",
  "yPcmjR": "删除分享",
  "XMBWlE": "",
  "QxAyiy": "举报帖子",
  "mPwa4i": "",
  "6fIVdc": "删除这条分享？",
  "P0YP21": "",
  "0LXu1Q": "",
  "o/jz/J": "",
  "cjaQiR": "",
  "xZ4l7m": "",
  "LJO1+5": "",
  "33fpXI": "",
  "VQKcQM": "",
  "OKhRC6": "分享",
  "j4O6sa": "",
  "F1S4Un": "",
  "TEh92x": "正在加载分享…",
  "lzekKe": "还没有分享。",
  "Cm4hzz": "",
  "00LcfG": "加载更多",
  "Rtle8V": "暂时无法删除这条分享，请重试。",
  "xgAriz": "无法举报此帖子。请重试。",
  "7NbAR6": "暂时无法加载分享。",
  "P4Uhwi": "加入于",
  "yFYhfh": "我的分享",
  "i5iqdQ": "",
  "z3CZC8": "",
  "4vfCLI": "",
  "s2qDjw": "",
  "hnvuOt": "3D模型",
  "cix1k0": "策略中心",
  "wAkqRb": "",
  "0ftPbd": "",
  "Erteph": "",
  "/zJNSJ": "",
  "1SsFzC": "策略结构、持仓、调整、模拟与复盘都归在一起。",
  "hneo2M": "新建策略",
  "bAseEN": "没有符合当前筛选的策略",
  "nNLJjQ": "先在模拟器中保存策略结构；之后的计划、持仓和风险视图都会归在这里。",
  "PNznQe": "",
  "bAAMgg": "",
  "xrk6zg": "已更新",
  "C7GTz7": "",
  "PFl2MC": "",
  "/UFyqv": "",
  "huzQoM": "",
  "tPA6w8": "",
  "FEmWwD": "入场金额",
  "ELYSz2": "",
  "2m6qy3": "",
  "j+EC1l": "创建持仓",
  "L5SNld": "",
  "s9xNrU": "3D",
  "pQWXW5": "",
  "ZAP5ED": "",
  "bwH2te": "构建策略",
  "BvmTwT": "所有策略",
  "XTaeXP": "",
  "uQz8hM": "",
  "dJ9LEC": "",
  "LCtB9d": "",
  "rY3BMb": "",
  "degEDy": "",
  "UeUdzQ": "预估到期盈亏",
  "wbOAPK": "",
  "TM51kh": "",
  "QUqsid": "",
  "EvJAQk": "预期价格",
  "jWTYge": "",
  "BJTHjJ": "",
  "ARn/6E": "隐藏盈亏图",
  "nFYl3i": "显示盈亏图",
  "rflQ3H": "打开到期日历",
  "hEWFuM": "按卖盘价买入",
  "5ES07g": "按买盘价卖出",
  "D7cFlD": "期权链",
  "sljfYe": "延迟行情数据",
  "CusOhC": "关闭期权链",
  "fvRdJl": "正在加载期权链…",
  "ekPjBv": "此代码尚无期权链。",
  "fQFNOL": "看涨期权",
  "3CnRXM": "看跌期权",
  "+xQVdw": "",
  "JDqPbs": "所有行权价",
  "xHbBSG": "",
  "y867Vs": "成交量",
  "48zn4v": "买盘",
  "G3iHK5": "",
  "WoTb6U": "删除腿",
  "blCQ5S": "已选腿",
  "wtvuvm": "净收入",
  "yYT0mU": "净支出",
  "j04HZg": "添加到当前策略",
  "jM8gSj": "打开期权链",
  "921USi": "",
  "FIMqSt": "期权链",
  "NWx9PZ": "模拟时间",
  "LafLIR": "持仓量",
  "6CybPN": "腿",
  "cfsCjO": "折叠策略详情",
  "Ii0MuK": "展开详情",
  "Nwy3ES": "",
  "8btK1j": "",
  "dNDw/G": "隐藏高级",
  "S68YvP": "",
  "2kdJjJ": "启用策略",
  "2k510C": "禁用策略",
  "1LgskT": "所选单腿",
  "jz8yDB": "期权腿",
  "4jYCiP": "减小数值",
  "FosG/W": "增大数值",
  "ZG9Btv": "折叠腿",
  "gxVTxh": "展开腿",
  "Y/Y5ET": "净权利金",
  "0khqwt": "",
  "yhbaGN": "",
  "qYYUGr": "风险/回报",
  "eVbSIz": "剩余到期日",
  "q8T+VR": "打开腿操作",
  "D5lF77": "添加腿",
  "uqe58g": "细分",
  "GgXq9Q": "收起全部策略",
  "xGK5Yf": "展开全部策略",
  "PCMwKt": "折叠策略希腊字母",
  "o0JYvv": "展开策略希腊字母",
  "SOUbFB": "",
  "JkS37H": "撤销",
  "Ol4RmZ": "删除策略",
  "s9/62P": "收起所有腿编辑器",
  "otQRp2": "展开所有腿编辑器",
  "YiU4iO": "策略数量",
  "KI5I3A": "减少策略数量",
  "VUhEPq": "增加策略数量",
  "3uHRgG": "",
  "eCDIXn": "展开详情",
  "/Uq4Ju": "保存策略",
  "hNbOOf": "跟踪为计划",
  "QKfFuP": "记录开仓",
  "eT5fu8": "只保存策略结构；下次打开时自动使用最新市场数据。",
  "szzw91": "保存此刻的市场场景，并从现在开始跟踪变化。",
  "qqq6Bj": "记录实际开仓成交，用于跟踪持仓盈亏，不会发送订单。",
  "fNrfbJ": "策略名称",
  "9DmoZI": "开始跟踪",
  "H0yWw8": "",
  "ZCYCYL": "",
  "zQGnBO": "",
  "8DTS67": "",
  "vBmXwW": "",
  "C5r0jV": "",
  "QDIVBy": "{count} 个观察中",
  "79vSlY": "{count} 张未平仓",
  "PhNAow": "{name} ({index})",
  "xiUnhw": "复制策略",
  "9NTFsx": "编辑参数",
  "2xZOBx": "",
  "xx93Pk": "拆分腿",
  "tVHHUm": "启用腿",
  "4Did0d": "禁用腿",
  "DemWZ8": "盈亏由组合中启用的合约决定",
  "Eb8pjw": "启用合约的综合表现",
  "shXrKt": "启用合约的综合尾部风险",
  "4EfPob": "比较行权价变化对盈亏的影响",
  "6xKZQd": "观察时间损耗与波动率的影响",
  "WPGhnF": "检验临近到期时的极端情景",
  "fSQm0K": "盈利来源",
  "teYMtl": "主要风险",
  "BE7W44": "学习要点",
  "MswSOP": "更改策略颜色",
  "kCH/EY": "",
  "3C6wS6": "恢复默认青色",
  "VET/x9": "使用七彩",
  "P3hnF8": "七彩",
  "wG5E1e": "行情数据尚未就绪。",
  "GHE9Li": "无法保存策略。",
  "KgAlAZ": "添加笔记",
  "sGT01a": "买方",
  "a/w/Q7": "卖方",
  "ZRVz5i": "做多",
  "SM6l1T": "做空",
  "Q5CLtp": "计划",
  "REPmkQ": "{count} 项",
  "i1xha+": "筛选策略",
  "AcxDgz": "激活",
  "oWF/LY": "{count} 条记录",
  "F68eRq": "策略、持仓与计划，集中管理。",
  "Yu4xGX": "策略与进度，集中管理。",
  "YaaCeG": "无法保存记录",
  "UrXd48": "跟踪策略",
  "uH5KjE": "开始策略",
  "pr8cNO": "记录当前场景并跟踪后续变化。",
  "PccU8y": "记录策略开始的时间。",
  "VsSLqs": "策略快照",
  "XodTRg": "激活策略",
  "GmtdWK": "记录策略激活的时间。",
  "NbxUGS": "无法结束这条记录",
  "PpsgXy": "结束策略",
  "3Ttjp9": "记录最终金额并结束跟踪，不会发送订单。",
  "oWB9B8": "份合约",
  "u6JRVj": "收到金额",
  "RZOWZ0": "支付金额",
  "QepAyc": "预计结果",
  "ZvxA7c": "结束跟踪",
  "Oun8cx": "1 腿",
  "pIHAne": "",
  "LYFtoH": "",
  "uxg/+P": "",
  "++tsyM": "",
  "1L2EsP": "",
  "MxvjnI": "",
  "Jkw7XW": "",
  "MkqCNo": "",
  "owbAvK": "",
  "zVCv7s": "无法删除此策略",
  "a6oaVu": "删除策略？",
  "6XJF1k": "",
  "n8z1UT": "",
  "tT8QI2": "",
  "2DqmFm": "",
  "QpFy3j": "",
  "Ud3I4Q": "",
  "PUbCDt": "",
  "vO7Wm+": "",
  "aK7qaA": "",
  "YwZOVR": "",
  "Xck+Pa": "",
  "ejq7YJ": "",
  "igT3Ky": "",
  "8CoqDb": "",
  "8jUssJ": "",
  "lHTQL5": "",
  "vXO3KT": "",
  "JcbNIN": "",
  "symUmC": "",
  "O8sPBp": "",
  "99d3u8": "",
  "nBBzLI": "",
  "jBB20E": "",
  "4e4IBN": "常见分析",
  "iPvSfw": "",
  "XHyQii": "",
  "967ocB": "",
  "CnT6i2": "",
  "xNc/LU": "",
  "tiyAER": "",
  "kcI3XT": "",
  "rpUa7B": "",
  "vJYGI9": "",
  "gvdRcN": "",
  "47btq4": "",
  "GextOJ": "",
  "81TsOv": "",
  "kcl+X/": "",
  "InWqys": "可选",
  "IlWPV3": "",
  "gypEjO": "",
  "M9YFIy": "较高",
  "lV1z4D": "",
  "hjL3cr": "",
  "JfcloF": "",
  "kyK0pf": "",
  "PLRHJY": "哪里方向风险变化最剧烈？",
  "bVQNTS": "",
  "rC6Oo5": "",
  "UyohPt": "",
  "jTBbjB": "此自定义设置显示了什么？",
  "2nmoyn": "",
  "ut57CS": "",
  "lKv8ex": "",
  "oakP5u": "",
  "t2Wr8I": "",
  "+fICx5": "",
  "6FQuCT": "",
  "fJtU/0": "",
  "Xz6L7F": "",
  "OBOO4P": "",
  "fEuHiU": "",
  "+CwN9C": "系统",
  "GMkCeU": "",
  "Tv5Z+X": "",
  "UAQFhR": "时间损失",
  "RJSsw9": "方向风险",
  "0p+P7U": "价格风险",
  "PKDUWy": "波动率影响",
  "T6/D9t": "隐含波动率影响",
  "5/a75U": "你想看什么？",
  "ImGggI": "",
  "v0gvt4": "视图模式",
  "EucS2p": "预设",
  "8OVzW9": "策略监控",
  "qASFUi": "按标的整理已保存策略与持仓。",
  "SI6P08": "{count} 个已保存",
  "SGxHBU": "{count} 个已结束",
  "e9dpNj": "{count} 个持仓",
  "aaiLWk": "观察",
  "SuKWbK": "无法移除这条观察记录",
  "yuH0RE": "移出观察？",
  "QLmtVd": "这会移除观察记录，但保留已保存策略。",
  "Ba9TBp": "观察策略",
  "hL+SjR": "记录当前场景并观察后续变化。",
  "V9NpQ/": "移出观察",
  "aCusF0": "记录最终金额以关闭此持仓，不会发送订单。",
  "c/KtHQ": "",
  "mgo2bA": "",
  "HaJCMM": "",
  "bW7B87": "新建",
  "QuMTHd": "",
  "Sq7vTV": "隐含波动率 (σ)",
  "UQ9JP3": "标的 (S)",
  "VtTdd+": "剩余天数 (T)",
  "uhQRhf": "执行价 (K)",
  "+DZFrO": "随着标的价格和时间的变化，此策略会盈利还是亏损？",
  "fnsj/r": "随着标的价格和时间的变化，价值损失最快的地方是哪里？",
  "n6j13i": "随着标的价格和时间的变化，方向风险最剧烈的地方是哪里？",
  "LKgp2i": "随着标的价格和隐含波动率的变化，盈亏如何变化？",
  "vbLKb3": "",
  "7hG0HG": "",
  "m2UwW+": "",
  "3i8EGi": "",
  "teLZyZ": "",
  "uMhpKe": "",
  "wS/QCK": "",
  "M72L3e": "",
  "k5Y6O1": "按标的追踪仓位与收益。",
  "RWeRsK": "情景分析",
  "K+gPxc": "",
  "ESxvVN": "",
  "RGxEzX": "",
  "7gXbKb": "",
  "6IG8DH": "市价范围",
  "j/9/gP": "市价范围",
  "35Xk1O": "",
  "QjWeGV": "",
  "oLDdcJ": "",
  "SY0ypw": "重置时间",
  "QZ7TJg": "市场情景",
  "hfHIMh": "相对位置",
  "k7mulv": "执行价位置",
  "t5TDW6": "选择情景组合",
  "Tug3Yd": "对比市场价格与到期时间。",
  "BK7S5v": "对比市场价格与隐含波动率。",
  "RIQBTj": "对比到期时间与隐含波动率。",
  "w70y+u": "对比市场价格与策略的相对执行价位置。",
  "ugvSib": "对比到期时间与策略的相对执行价位置。",
  "JrvqM2": "对比隐含波动率与策略的相对执行价位置。",
  "kJr9Mt": "对比市场价格与策略的锚定执行价。",
  "zgbIhh": "对比到期时间与策略的锚定执行价。",
  "9eGy+E": "对比隐含波动率与策略的锚定执行价。",
  "MUU/vO": "曲面高度显示盈亏。",
  "i/fLev": "曲面高度显示估算权利金。",
  "Zs9Hrp": "曲面高度显示时间损耗。",
  "P0t08k": "曲面高度显示方向暴露。",
  "tqGpjk": "曲面高度显示方向暴露的变化速度。",
  "bv1G5w": "曲面高度显示波动率敏感度。",
  "YXiMJp": "颜色对照盈亏。",
  "+YVCkb": "颜色对照估算权利金。",
  "CcDKhH": "颜色对照时间损耗。",
  "Hizyyp": "颜色对照方向暴露。",
  "xKR0+K": "颜色对照方向暴露的变化。",
  "dOcINH": "颜色对照波动率敏感度。",
  "zoD8DG": "辅助对照",
  "C/XZB/": "已保存策略",
  "quef2J": "",
  "m5YjUB": "这个策略在哪里赚钱或亏钱？",
  "wDeNYA": "策略价值如何变化？",
  "VH2j5I": "哪里时间价值损耗最快？",
  "ttJxO5": "哪里方向暴露最大？",
  "ME92gX": "哪里最受波动率影响？",
  "KldXu9": "选择研究目标",
  "X67VJv": "研究目标",
  "n1gFwy": "情景条件",
  "Vgl536": "辅助颜色",
  "4tBtHB": "{count} 腿",
  "buhQLp": "股价与时间",
  "nLxSRs": "股价与波动率",
  "uz7Su3": "时间与波动率",
  "e2yCwg": "股价与相对位置",
  "rYq1Qo": "时间与相对位置",
  "Ny5QiA": "波动率与相对位置",
  "eVif46": "股价与锚定行权价",
  "bka2Mb": "时间与锚定行权价",
  "ATgrw6": "波动率与锚定行权价",
  "dewaOi": "此日期无策略到期",
  "O76gjS": "选择标记的到期日",
  "HcD4ZV": "",
  "HMqRQ2": "",
  "QiyWMl": "",
  "34kvk+": "",
  "f3EDZG": "",
  "1Y71eM": "",
  "RZIqmN": "",
  "CKwxFw": "移除工作区",
  "ddusVS": "移除 {ticker} 工作区？",
  "fK/moZ": "这会将工作区从模拟器中移除。保存的策略和仓位不会被删除。",
  "wL8pmk": "移除{ticker}工作区",
  "hLJUDy": "每个标的工作区最多保留 6 个策略。请先移除一个再添加。",
  "HY4QmJ": "管理当前策略",
  "a7sjI9": "这会将策略从当前模拟中移除。此操作无法撤销。",
  "Jn3Yzo": "",
  "Ed3JX/": "",
  "9M+0Cp": "",
  "sNBU0C": "",
  "qJPn4K": "同时观察中",
  "XzYiqY": "停止观察",
  "QpLG3I": "胜率 {value}",
  "1kopXZ": "在模拟器中编辑",
  "c9C2jQ": "在模拟器中调整",
  "k2faTL": "再次模拟",
  "fp1oz4": "无法重命名此策略",
  "uxZZAv": "重命名策略",
  "LVwPTo": "仅修改名称，不改变策略结构。",
  "BaAi7W": "已实现盈亏",
  "GrjpeW": "已保存策略使用当前市场价格估算入场权利金。",
  "R61VBV": "市场数据不足，暂时无法计算收益图。",
  "it6Hed": "观察以来",
  "KP3wT9": "观察基准价",
  "K0UL2X": "观察基准权利金",
  "qSbUIV": "标的仓位",
  "TkYSWl": "此分类下暂无仓位",
  "J/be1v": "摘要与收益图",
  "vjhtoP": "搜索标的",
  "z6/6z0": "没有匹配的标的",
  "/qOQTh": "1 个仓位",
  "6uudZw": "快速选择标的",
  "mAArDz": "没有观察中的计划",
  "CfejBq": "没有激活的仓位",
  "mLUgce": "清除搜索或更改筛选以查看更多标的。",
  "Nph2An": "在模拟器中保存策略结构后，会显示在这里。",
  "HNFYuR": "想在入场前持续关注时，可将策略加入观察。",
  "abznLW": "需要跟踪真实持仓时，可激活策略。",
  "Cdgcco": "记录退出后，仓位会显示在这里。",
  "M0AnzG": "已估值 {priced}/{total}",
  "EFFrWP": "暂无法估值",
  "mh3wPC": "部分仓位缺少估值数据，因此暂不显示组合总计。",
  "RId5Lt": "退出权利金",
  "u5YJzV": "退出时标的价",
  "BPLXi7": "持有时间",
  "Aj6ic0": "现价",
  "+7PjfV": "1 天",
  "rBP1bd": "{minimum}–{maximum} 天",
  "fhGzJi": "调整",
  "SyaPvp": "取消关注",
  "BVHMie": "{ticker} 已保存 {limit} 个策略。请先删除一个再继续保存。",
  "BiB/BX": "已保存 {limit} 个策略。请先删除一个再继续保存。",
  "PsYRHM": "选填详情",
  "32mZgz": "",
  "LbDL8A": "",
  "B7tn7j": "",
  "3Hcl9v": "备注 (可选)",
  "soYk0t": "{count}腿策略",
  "C0KAWD": "模拟数量已达上限",
  "tqzR26": "该标的已在模拟 6 个策略。请先从当前模拟中移除一个；如需保留，请先保存到 Monitor。",
  "LhmaKI": "模拟器已满",
  "jHbe5J": "移除一个策略后继续。如需保留，请先保存到 Monitor。",
  "h3yrDm": "移除一个策略后继续。",
  "mPKS81": "结算",
  "ey6L2t": "结算策略",
  "aF6qZf": "",
  "iCfiPt": "",
  "qGo2T0": "",
  "ehpJHf": "",
  "Nzd+T6": "",
  "oz2JkI": "平仓价格",
  "FwKpko": "",
  "7gTVBT": "",
  "WteJEQ": "",
  "2RjA5a": "系统将计算每一腿的内在价值",
  "2PKjNz": "各腿结算",
  "4n3J7u": "作废",
  "sjHccx": "净结算",
  "ssWDCg": "",
  "dtQbQa": "",
  "Qfb5ZZ": "无法平仓此腿",
  "M1wP5r": "单腿平仓",
  "6qZEsJ": "平仓此腿的全部或部分。其余腿保持活动。",
  "0BfMZB": "开仓数量",
  "pQaa3l": "平仓数量",
  "FAYrr7": "收到现金",
  "ekYUAx": "支付现金",
  "K+j13M": "",
  "2ObwR3": "在单一时间线上回顾决策、提醒、笔记和结果。",
  "orEaKq": "全部类型",
  "sVZZBm": "多腿",
  "9GOVoo": "",
  "Wdn0g5": "选择策略",
  "6uqYl0": "将完整的已启用层栈一起进行测试。",
  "wMtTB8": "搜索已保存的策略",
  "3vuznk": "无策略匹配此搜索。",
  "M4tVEs": "在运行测试前，在构建器中保存策略。",
  "LXGl/Z": "层",
  "eoy4Hp": "入场 VIX",
  "4fSUVQ": "累计",
  "D0e0dO": "证据解读",
  "AnP70a": "净盈亏",
  "qHWGQ6": "样本",
  "CVbVx/": "观察到的最强环境",
  "RHgEMy": "分类历史不足",
  "Gegff6": "观察到的最弱环境",
  "Oq18qN": "证据覆盖率",
  "w5J3rx": "使用引擎 v3 重新运行",
  "DGEdM8": "分类的即时状态",
  "JRt1Y+": "策略表现稳健的区域",
  "NNl+dA": "行使用前 20 个交易日的趋势。列使用入场前已知的波动率。",
  "ZykpY3": "状态标签中无未来数据",
  "Orc8Zk": "分布",
  "Cicdhm": "净结果分布",
  "qiXByh": "平均盈利",
  "j4hRpT": "平均亏损",
  "z4WB6T": "本次模拟的定义 — 以及非定义",
  "vrvoJA": "这是一项每日重新锚定的 0DTE 模拟，使用历史标的K线和建模的期权曲面。它不是历史期权链成交的回放。结果包括配置的佣金和滑点假设，应作为进一步研究的证据，而非预测。",
  "hFOSzs": "",
  "XzG/F0": "",
  "wV5tV1": "",
  "V7B6sf": "",
  "orRafe": "",
  "ml6MGS": "",
  "zgi72u": "",
  "Ft/Z/U": "",
  "/vWP7U": "下跌趋势",
  "VGzSsa": "横盘趋势",
  "Khs765": "上升趋势",
  "hGVzL2": "低波动率",
  "+sCi5u": "正常波动率",
  "7NXkmR": "高波动率",
  "CRfCS+": "无样本",
  "quDnKR": "盈利",
  "uJC5Gu": "月度净结果揭示业绩是持续的还是集中的。",
  "pvvecH": "回测仍在运行。完成后将显示在历史记录中。",
  "9aiN0H": "策略证据实验室",
  "5cgRKt": "查找策略的有效范围 — 及其失效之处",
  "peeoVO": "根据特定时间点市场状况测试完整的层堆栈。目标是发现边界，而不是制造完美曲线。",
  "63HmTZ": "模拟了 0DTE 证据，而非历史期权成交",
  "36kFgk": "选择策略",
  "T+Yi2v": "每个启用的层将作为一个整体进行定价。",
  "2JGrIX": "每笔入场风险预算",
  "1iGwtF": "执行假设",
  "+5G/dd": "每张合约佣金",
  "jD8Z8R": "每条腿滑点",
  "zGCamv": "止损填充乘数",
  "wmcjss": "投资组合止损",
  "oBCTRB": "目标收益",
  "7X0lYn": "跳过入场价以上 VIX",
  "lSnDtJ": "此堆栈包含一个价差结构，这是每日 0DTE 模型无法诚实代表的。",
  "BBqO55": "实验合约",
  "w1dDaa": "启用的层",
  "b7wHG1": "未选择",
  "K5Tpjo": "重新入场",
  "m9W7iM": "每个可用会话",
  "qh1A9U": "开盘至收盘 · 0DTE 模型",
  "hlRm5H": "波动率输入",
  "aIOGJq": "前收盘 · 特定时间点",
  "4lafrr": "引擎",
  "mN1jia": "投资组合 v3",
  "LoScLL": "正在运行模拟...",
  "K3ZtTt": "运行证据测试",
  "QqF84d": "新的不可变运行已保存到历史记录。",
  "L1la1q": "证据历史",
  "mjueyV": "已保存的运行",
  "d3wxHm": "正在加载历史记录...",
  "KQ3GFX": "尚无证据运行。",
  "CYW7pR": "发现策略能够维持的市场条件——以及策略失效的市场条件。",
  "4DCLAA": "证据实验室",
  "KmU3uu": "状态标签的历史记录不足",
  "GfKYkN": "构建.管理.学习.探索.",
  "XKQk8u": "",
  "eqVonM": "历史价格仍在准备中，请稍后重试。",
  "g2zN7a": "请选择过去 30 年内的日期。",
  "+6NTUJ": "当前标的不可用。",
  "qLc/ld": "无法加载回放，请重试。",
  "eXEJxQ": "逐个交易日回看真实市场路径。",
  "sCVeHP": "投资回放",
  "H1uM24": "如果当时投入",
  "kgY7gK": "",
  "yf5J0B": "",
  "ziX7Yd": "投入日期",
  "yJM83C": "投入金额",
  "EtLbXH": "回放至",
  "RRpyqd": "准备历史数据",
  "UuYZob": "开始回放",
  "3YoDVt": "首次回放某个标的时，准备复权历史数据可能需要一点时间。",
  "FmlIES": "账户价值",
  "/nWK9w": "起始日调整为 {date}",
  "nn6jif": "投入本金",
  "93Co9g": "当前收益率",
  "TZiwuY": "回撤 {value}",
  "Uiqc6K": "累计盈亏",
  "uXD/hw": "账户历史路径",
  "GufXy5": "价值",
  "v9vLyy": "回放日期",
  "J3ca41": "播放",
  "ORpWSn": "重新回放",
  "0IvXvc": "",
  "lQuxVk": "入场收盘价 {price}",
  "kLjr0K": "",
  "fLujAx": "",
  "AmMdtW": "",
  "hJmKKm": "",
  "mtZEwW": "当前无法准备历史价格，请稍后重试。",
  "/w1vqX": "",
  "yItLEv": "收益口径：复权价格，包含分配。",
  "x2hUPj": "收益口径：收盘价，不包含分配。",
  "amSNGJ": "复权价格 · 包含分配",
  "i5y1bt": "收盘价 · 不含分配",
  "QR/fls": "共 {count} 个交易日",
  "cnXZYK": "修改条件",
  "VMy/tf": "时间衰减需要有期权定价的未到期仓位。",
  "Pk3ehr": "",
  "wNZNym": "",
  "HHH8MR": "行权价",
  "Mf1C6g": "记录日期",
  "EaG+NV": "更改{direction}颜色",
  "Hwkt6M": "方向颜色",
  "Ob2IQq": "为{direction}使用{color}",
  "H1pTIh": "自定义颜色",
  "1ewn0M": "",
  "GIxo6M": "输入实际净收盘价。这不会下单。",
  "9pPnOu": "",
  "d87NVT": "",
  "//oVg4": "",
  "8RRiO7": "",
  "6rix6a": "每份合约",
  "Ma8x1D": "价格 × 100",
  "i8OeMM": "选中总计",
  "Zr+XyS": "净价/股",
  "eatQ+I": "收到贷记/股",
  "WL6scr": "支付借记/股",
  "lYTQYA": "",
  "ikscQi": "已调整",
  "yotyOA": "完成合约",
  "4NAQB9": "完成合约",
  "FxmdBZ": "",
  "+2aGV+": "",
  "ShK4oL": "实际实现",
  "VZKdlL": "如果现在持有",
  "o6wlr7": "",
  "7Jm7U6": "原始到期日",
  "lyO9rK": "",
  "drCPHM": "3D 情景分析",
  "S4AT72": "从模拟器或策略追踪打开 3D，然后拖动进行旋转，捏合进行缩放。",
  "azPI3X": "",
  "tdD1nb": "",
  "KtOx6f": "",
  "G1o2xi": "",
  "r2vLpN": "",
  "j/CGgc": "",
  "zWgbGg": "今天",
  "axdrpv": "",
  "Kx8/LF": "",
  "AvlQWk": "",
  "5yX3zS": "",
  "tLmmJ5": "",
  "TP4O4w": "",
  "qhKwsq": "",
  "4CrCbD": "社区",
  "OgFVBm": "",
  "m14PFT": "",
  "O99new": "",
  "jAZBxq": "继续计划、查看待处理事项，或打开工作工具。",
  "WDGRkr": "",
  "SB9QZo": "",
  "qqZK6t": "",
  "LRd/yT": "",
  "Gn2VdB": "新计划",
  "gR7wv2": "",
  "jgA03X": "",
  "Af5zIY": "",
  "PgyBwv": "",
  "1DH9Kx": "策略模拟器",
  "sVyJTO": "",
  "Lvr/gV": "",
  "5M7fFl": "",
  "r9enQs": "",
  "u1LIFh": "",
  "OJ1+vZ": "",
  "VMIM8/": "分析",
  "rH7N0y": "添加提醒",
  "dPPOTD": "提醒标题",
  "g8LcJ6": "",
  "xYlSos": "",
  "CC23WL": "",
  "7Y6Yvq": "关联记录",
  "rU9N3P": "",
  "CBW/UM": "",
  "Eiz6nH": "",
  "Scy8j4": "",
  "fs71KS": "",
  "8keCZ9": "尚无已实现结果可归因。",
  "7adwjN": "在仓位记录已实现结果后，细分才有意义。",
  "FgydNe": "查看",
  "jiqZ1b": "此范围内无记录数据",
  "SvcjQR": "",
  "SMRyVm": "",
  "bprpCN": "",
  "AA5h7P": "绩效",
  "e/xwdG": "分析视图",
  "EZg1R6": "总盈利",
  "zpD/0L": "总亏损",
  "JcVSMb": "每日盈亏",
  "9ZrS92": "下行风险",
  "Junogh": "比率",
  "E8Y4V6": "月度风险",
  "UMDxfE": "标的影响",
  "9/YgbO": "操作构成",
  "VGeLeR": "所选范围内暂无数据。",
  "M0jCcC": "综合交易表现",
  "xbT8uC": "总盈利、总亏损、盈利因子与胜率。",
  "bP90Np": "每日盈亏波动",
  "T5nqnj": "所选范围内每日已实现盈利与亏损。",
  "ZLa2+w": "账户回撤",
  "amtN3U": "当前累计盈亏与历史峰值的距离。",
  "Hv3fWK": "月度下行波动",
  "jUUD3T": "以美元计的每日下行偏差。",
  "RclZvT": "索提诺与夏普",
  "HnHZaz": "对比总波动与仅下行波动下的收益效率。",
  "P+HPf+": "月度风险调整趋势",
  "yPUoCW": "月度盈亏与夏普、索提诺比率。",
  "rkEB8J": "高风险月份标的影响",
  "SZhz7l": "下行偏差最大的三个月内，各标的的总波动影响。",
  "W/V07i": "高风险阶段操作构成",
  "MdJtKA": "下行偏差最大的三个月内，各类交易操作的出现频率。",
  "hVd0t5": "深度",
  "qO0CLS": "每日盈亏图",
  "Gwj33k": "月度风险调整图",
  "OVN7ar": "总盈利、总亏损、盈利因子与胜率。",
  "IOEUlR": "高风险月份内各标的的总波动影响。",
  "PealYP": "高风险月份内各类交易操作的出现频率。",
  "plPkUe": "合约风险回报图",
  "+5EqeI": "日波动率",
  "bBjg5A": "总变动",
  "47GLQV": "合约风险回报图",
  "6rjbuI": "",
  "8qoL2w": "",
  "awORoU": "月度盈亏",
  "hCQDkn": "美元",
  "SBQKrs": "",
  "flNDyb": "",
  "n+pyZL": "",
  "T2eT7q": "",
  "B62vXg": "",
  "DF3ZNU": "月度风险图",
  "SKUBqE": "",
  "lyIDn9": "",
  "jLHPJ/": "",
  "smN0U9": "",
  "NbzvTY": "",
  "uzitTn": "",
  "KWDHT9": "",
  "FzwzBR": "所有月份",
  "uAOtqE": "",
  "W2JBdp": "",
  "NCrEJK": "",
  "MkqXHo": "",
  "vjpxbk": "",
  "FgLW41": "",
  "jiagjO": "",
  "MaiJgZ": "",
  "Vob6h4": "全天",
  "pFK6bJ": "查看全部",
  "HBLmBD": "选定日期",
  "OsDomv": "",
  "FAgFwk": "",
  "8mRNBD": "上个月",
  "PqmLVn": "下个月",
  "tD1OSX": "本月无计划的宏观事件。",
  "6FCDEI": "",
  "O7d0lx": "",
  "aLToUw": "",
  "iVMyn1": "关闭并返回今日",
  "O5faII": "检查到期时间。",
  "s8II5l": "高于",
  "GRJ4NR": "低于",
  "3HepmQ": "",
  "Mvi3A8": "触发条件",
  "B25Wur": "提醒类型",
  "YTVz0Q": "合约到期",
  "W3rByC": "提醒频率",
  "nluNPP": "提醒一次",
  "ysT8nU": "备注 (可选)",
  "dTW4m3": "",
  "PL5iZt": "{ticker} 目标未设置",
  "FjPVFv": "提醒类型筛选",
  "V7d8KW": "新提醒",
  "tvknXg": "关闭提醒表单",
  "PudL2i": "{count}个策略",
  "bqaYyQ": "模拟工作区",
  "b7DoAL": "切换模拟工作区",
  "KZ2tDm": "时间衰减与摘要",
  "d2ptXk": "盈亏图与摘要",
  "azOzo6": "该到期日已满",
  "16SA2D": "请移除或停用该日期下的一张策略后再继续。",
  "pig+2F": "选择月份",
  "HppWvq": "选择年份",
  "HyXxFo": "移除一个策略后继续。",
  "NHiyMS": "",
  "mO9Gth": "",
  "GROuBQ": "",
  "J4ufji": "",
  "uJidkb": "",
  "My9ikc": "",
  "ST/WAh": "旧策略已禁用",
  "z2Wj6U": "",
  "vsxI5f": "超过6个策略上限的旧策略已被禁用。建议删除它们。",
  "ug3KqU": "",
  "eYTEFf": "此到期日已达到6个策略的上限",
  "KByOMa": "请删除至少一个策略以继续。",
  "b/P0+i": "请删除或禁用至少一个策略以继续。",
  "sk3w9O": "所有策略使用同一颜色",
  "DWmFUp": "工作台",
  "TdbPNK": "",
  "GcPFLS": "",
  "0/DoJD": "期权理论",
  "3XCd6h": "测试期权概念、盈亏逻辑、Greeks、波动率、策略与风险。",
  "rMsbd3": "",
  "zzRO1L": "",
  "8xAox2": "",
  "qS4o5w": "",
  "QSwMUN": "",
  "Ci8kNI": "通过互动工具学习期权、验证想法并探索市场行为。",
  "SD8vZq": "",
  "c54D7x": "个人空间",
  "0oagnH": "正在加载动态…",
  "/jLzlC": "暂时无法加载动态。",
  "ebmS5D": "",
  "cPIKU2": "已关注",
  "Q8/qWQ": "个人资料内容",
  "W2IrK2": "你选择分享的记录会汇集在这里。",
  "nYrKWp": "编辑个人资料",
  "s5Emdj": "关注动态暂时很安静。",
  "IR584b": "你关注的人发布的内容会出现在这里。",
  "OJ4QAX": "设为仅自己可见",
  "lzpH+r": "设为公开",
  "uhu5aG": "公开",
  "SsCPKP": "仅自己",
  "pKoYZo": "无法更改这条分享的可见范围，请重试。",
  "myPKoT": "无法分享这条记录，请重试。",
  "UDDCEP": "分享一条记录",
  "ro28YS": "要分享的记录",
  "yvueWX": "写下你的观察、收获，或想记住的事……",
  "UU+20q": "添加分享",
  "U9geyY": "无法加载这个个人主页。",
  "mrwfXX": "分享",
  "ieGrWo": "关注",
  "mn0wOp": "暂无公开分享。",
  "oWTc7R": "这个人的公开记录会出现在这里。",
  "izWS4J": "取消关注",
  "RO7SH9": "无法取消关注，请重试。",
  "4j1TGZ": "打赏",
  "nu7lfM": "",
  "xLyys3": "",
  "OdFwTY": "",
  "WkCxZH": "",
  "1iMLiQ": "",
  "QlQTcO": "",
  "oW4V3y": "",
  "DXH72L": "",
  "yGGPTl": "",
  "GoxIKu": "",
  "fTyZWZ": "",
  "HiRJWP": "",
  "zO0qP9": "",
  "SA5wTS": "大家主动分享的文字会出现在这里。",
  "cE4Hfw": "发现",
  "zJz52d": "阅读大家主动分享的文字，也看见每段记录背后的人。",
  "JHVH0I": "期权学习",
  "ZtYLWo": "从理论、结构识别、波动率曲面到策略选择，逐步建立直觉。",
  "ZB28Lo": "实验室",
  "kKSmWY": "回看历史投资，并探索复利如何改变长期结果。",
  "eDR8ff": "识别与曲面",
  "AvuUur": "先识别策略形态，再切换到波动率曲面、微笑与偏斜。",
  "8u/vIb": "选择与决策",
  "cRLxCh": "选择市场路径，预览结构后再带入工作台。",
  "GUOD64": "理论、视觉识别与策略选择构成一条完整学习路径。",
  "TF4jYh": "阅读大家主动分享的文字，没有点赞、评论或热度排名。",
  "8L4PNF": "用历史路径与长期数学建立投资直觉。",
  "eGs7OB": "这里暂时还没有分享。",
  "nvKfQd": "",
  "sdGmEY": "更换头像",
  "UkpJTd": "添加头像",
  "34SlJb": "头像上传失败",
  "W/oZ+0": "",
  "3+uiEp": "",
  "6YRG1x": "",
  "TuUEex": "",
  "XNFZvO": "",
  "S0t4oK": "",
  "DF51N9": "",
  "AfV8Ul": "",
  "YPkK3T": "",
  "t3ri2W": "",
  "cKpNAN": "",
  "Z3jPLh": "",
  "AAVBvC": "",
  "JNt1ol": "",
  "Dr5pOI": "",
  "x5Tz6M": "举报",
  "h60i5I": "",
  "SN9suK": "切换计划",
  "0ah2ud": "空间",
  "dDDZFq": "记录原因、变化，或值得记住的事。",
  "xYMPX8": "删除记录",
  "QOAy/W": "提醒",
  "zxb1ad": "删除提醒",
  "uMDKU0": "查看记录",
  "Vhoe1W": "查看提醒",
  "v+W2VX": "编辑记录",
  "0Bs6+z": "编辑提醒",
  "NMrDl2": "提前 1 天",
  "M56JXA": "持仓到期日",
  "TG6+iC": "",
  "NU+Tp9": "到期前提醒",
  "LllhGb": "到期时",
  "jp6xlw": "到期前2天",
  "WIcstJ": "到期前3天",
  "oPB7iw": "到期前5天",
  "XiWq/N": "7天",
  "tDp15p": "提醒操作",
  "V32rQQ": "提醒已完成",
  "Lr869H": "提醒已重新开启",
  "Gyxm/c": "无仓位匹配这些筛选器",
  "rutc7s": "关闭筛选器以查看更多仓位。",
  "bZdq0G": "折叠所有仓位详情",
  "fOG9Tb": "展开所有仓位详情",
  "GpVe0K": "上一页提醒",
  "U68BxZ": "下一页提醒",
  "mhd4Pl": "当前选择日期无提醒",
  "/Ko9ai": "仅显示当前选择区间",
  "c/3qIY": "选择区间",
  "6ezdTh": "当前选择区间无提醒",
  "mj+wKn": "价格提醒没有日期，请在提醒列表中查看。",
  "8BelZy": "以官方日程为准。",
  "wkuwe/": "无日期的价格提醒列在下方。",
  "e/4+7o": "",
  "0GYIv1": "",
  "86dZiZ": "收起日历日期",
  "jfd62c": "展开日历日期",
  "YRuoh4": "日志档案",
  "HVlTPw": "每一个结果都有记录可查",
  "Gb+H0H": "策略表现",
  "Okb++K": "开始日期",
  "oCPsJO": "结束日期",
  "MugprC": "策略筛选",
  "OvdZnF": "搜索日志",
  "N6hzBP": "搜索记录",
  "AgxEdc": "记录数",
  "2zcF3r": "使用策略数",
  "BTOaG+": "正在加载日志……",
  "l91xat": "这个范围内还没有匹配的记录。",
  "ZOBM3s": "正在计算策略表现……",
  "u742eI": "这个范围内还没有策略结果。",
  "ZF3UAC": "已记录结果",
  "K6D2oR": "平均收益率",
  "f44DGG": "加权收益率",
  "dmYawT": "收益率基准",
  "Khd8hB": "暂时无法保存，请检查内容后重试。",
  "uKCtWZ": "快速记一笔",
  "zy4alF": "今天做了什么？",
  "H2Fkv0": "记录值得记住的决策、行动或结果……",
  "DeBTRd": "关联策略",
  "Mha8H1": "不关联策略",
  "q0Kuyy": "关联仓位",
  "21Q3VS": "不关联仓位",
  "lkCAc0": "收益率",
  "OCA3sD": "收益率 %",
  "xZ37Lr": "风险本金",
  "KPnZUE": "最大风险",
  "ei+BEq": "占用保证金",
  "ZMhGma": "自定义基准",
  "mqBgL6": "收益率基准金额",
  "71dF2T": "基准金额",
  "1FRs5j": "收益率只相对于当前仓位或策略的基准计算，不代表总账户收益率。",
  "26dBrx": "记录收益前，请先选择策略或仓位。",
  "YCmLQY": "请输入计算收益率所使用的基准金额。",
  "7LEv2e": "已保存到日志",
  "eenrEq": "查看记录",
  "K44Zv4": "添加收益结果",
  "fddyTp": "保存记录",
  "RdBrVZ": "记录与表现",
  "gTmB65": "整理成书",
  "DYOY1w": "无策略",
  "AxcbfN": "收益和收益率只属于本次策略记录，与总账户无关。",
  "KOi+Q8": "记录结果前请选择策略。",
  "Tj5OOs": "平均收益",
  "PCkXpo": "这次策略使用未能保存，请重试。",
  "zQMdKr": "策略快速分析",
  "BEQM/3": "这个策略表现如何？",
  "cWuj1m": "独立于日志、仓位和总账户表现。",
  "5lBm4i": "使用日期",
  "sE7l6a": "选择策略",
  "BLxCJJ": "备注（可选）",
  "Z18Sal": "已记录本次策略使用",
  "89GI54": "记录一次使用",
  "P63eRT": "查找和回顾你的日志记录",
  "tBAhGz": "日志记录",
  "q3mviY": "",
  "kG2Tha": "",
  "4wqBb0": "",
  "VD7W7e": "",
  "x9YTOO": "记录方式",
  "JvTkkv": "",
  "Wszvu5": "",
  "Hf+ScA": "",
  "uKrnCj": "",
  "/aGEU3": "",
  "sNNjry": "",
  "h0fMSv": "",
  "bQzhba": "",
  "B1n5f4": "",
  "r7nsaT": "日记库",
  "cQXn8s": "",
  "u/dHu6": "",
  "Iebqbs": "",
  "iWX4BF": "",
  "U5un08": "",
  "2K2PqS": "",
  "JUy35T": "",
  "AsY9t9": "",
  "eF7TQV": "发生了什么？",
  "nsJz3L": "",
  "vxyZvO": "",
  "6fHJ/z": "",
  "3J3325": "",
  "kBzccm": "",
  "lBM4e+": "",
  "mgUIOO": "",
  "Kya/tc": "",
  "9uMYRM": "",
  "TEwaMo": "",
  "/IcyD4": "",
  "0yGWvs": "",
  "HzxBtL": "",
  "R/O+Pr": "",
  "3UlhP9": "",
  "bNr074": "",
  "UXINgs": "",
  "LIEz8v": "",
  "+H0KdM": "",
  "i/xhf/": "",
  "cWU24G": "",
  "8I+ZZA": "",
  "y2L1So": "",
  "NrGJCu": "素材库",
  "joksMw": "原始记录，随时整理",
  "FIkBBb": "随手记、复盘和保存的证据会自动汇集在这里。找到有价值的素材，再加入书稿。",
  "SgxQDY": "还没有素材。首页和日志流程中保存的记录会自动出现在这里。",
  "OST3Je": "把零散记录沉淀成可复用的体系和可发布的作品。",
  "4Uym7L": "自动归集原始记录",
  "x7Hwvx": "书稿",
  "1i9hrz": "组织、编辑与发布",
  "NpWjvV": "交易",
  "77DlKj": "纪律",
  "ln1cCQ": "达成记录",
  "gga3Sg": "记一笔",
  "/rjEyD": "自定义大类",
  "Jq3FDz": "内容",
  "+3Pb5I": "今天想记录什么？",
  "Tati7h": "",
  "1WBA2E": "",
  "pDpej6": "",
  "eEOtmw": "策略",
  "EL3RLA": "这条记录未能保存，请重试。",
  "G+doj9": "搜索内容",
  "pJ+8Yp": "全部日志",
  "Sk1/Iq": "还没有内容，从上面记下第一笔吧。",
  "B36BqE": "关联已平仓仓位（可选）",
  "AMQ7e4": "关联已平仓仓位",
  "MH2zfW": "记录、筛选和回看，都在这里。",
  "nZhN4r": "记录内容",
  "5xZNJG": "编辑内容",
  "I5NCub": "日期筛选",
  "Er9Eoe": "选择日期范围",
  "V7ambj": "管理章节",
  "tp3bMN": "{count} 条内容",
  "i8L+Sb": "重命名章节",
  "VsSsWh": "上移章节",
  "X220vi": "下移章节",
  "3IOFp2": "新建章节",
  "AuCMP7": "删除空章节",
  "J3fNDZ": "本月",
  "sfETQk": "链接位置",
  "Rs4gxr": "",
  "QMju4t": "",
  "SLMbdJ": "书名",
  "ZLW3Ul": "书籍描述",
  "YDP1qm": "策略、纪律和成长。",
  "ZjmERS": "日志",
  "2QMJGu": "页面导航",
  "BrM+Z3": "笔记、想法和参考。",
  "CJPZ0G": "",
  "NVV46j": "无匹配条目。",
  "UVUM06": "",
  "Mnz0ky": "",
  "mqdE+m": "取消编辑",
  "nZCHBx": "继续编辑",
  "FmeFqm": "您的未保存更改将丢失。",
  "XTHxOY": "放弃草稿?",
  "65lBRh": "",
  "naqthO": "",
  "vcSMRI": "编辑序言",
  "vFu9WZ": "序言",
  "sonIZt": "序言内容",
  "wkgkho": "写下这本书的开篇。",
  "caXC2M": "保存序言",
  "KhHXvT": "序言保存失败，请重试。",
  "1HcI++": "Guide 内容准备中。",
  "qKqtMC": "正文",
  "Zqekct": "二级标题",
  "BDbgCL": "三级标题",
  "Dkkmwm": "加粗",
  "k1MVLc": "项目列表",
  "atzUcB": "引用",
  "JBWS0c": "链接",
  "0XWmRm": "分隔线",
  "dDT6ro": "Markdown 源码",
  "mPtUKl": "编辑模式",
  "jr4+vD": "Markdown",
  "ofZ+d8": "链接地址",
  "wMVWy/": "粘贴网址或内部链接",
  "PxD4Pq": "应用链接",
  "2D+lW9": "格式工具",
  "qGq2PB": "LaTeX 公式",
  "R2FZEu": "输入 LaTeX 公式",
  "g2V+es": "斜体",
  "SOtMvF": "下划线",
  "lH8y+X": "删除线",
  "lbsCQS": "编号列表",
  "DiyLPv": "增加缩进",
  "OgfsxZ": "减少缩进",
  "jWDuFc": "左对齐",
  "KPMC7r": "居中对齐",
  "Bz/qc/": "右对齐",
  "FeZ3P6": "插入内容块",
  "freMIM": "插入",
  "naT454": "更多排版",
  "VdY5ev": "文章内容",
  "fxaAxF": "开始写作",
  "3XyF4d": "重做",
  "pQDBN2": "编辑工具",
  "waJ7A0": "简洁模式",
  "uffpjN": "编辑器模式",
  "FB//Ed": "编辑记录",
  "33nRAu": "返回简洁编辑",
  "zQ2tar": "打开沉浸编辑",
  "HedEP7": "粗体",
  "qDkbVY": "斜体",
  "Ow3y0w": "下划线",
  "U3P/wo": "删除线",
  "n+Ksiy": "链接文本",
  "bAF3vO": "格式化编辑器",
  "TkEsoc": "版本历史",
  "Oz15Gx": "恢复先前保存的版本。",
  "T3X93o": "正在加载版本...",
  "jILjsZ": "无法加载回放，请重试。",
  "+ENgFX": "尚无先前版本。",
  "koEb6E": "正在恢复...",
  "mLjSWa": "编辑文章",
  "qun7iY": "关闭编辑器",
  "l15cuw": "文章标题",
  "5UoW6K": "高亮",
  "34+BA1": "高亮文字",
  "79IWia": "表头",
  "/jd9eE": "单元格",
  "ggs9Fm": "分隔线",
  "IeBejt": "表格",
  "pYX859": "正在删除…",
  "fuE1Tt": "删除“{title}”？此操作无法撤销。",
  "qWkX3u": "关闭序言编辑",
  "zoRlVy": "写下这本书的开篇说明…",
  "EBbTja": "为这本书写一篇序言",
  "9Gfkxq": "打开完整编辑器",
  "Hqbl28": "重命名标题",
  "4mxaJq": "编辑目录",
  "PeGD0K": "选择章节",
  "6S1aiy": "",
  "hyoYZk": "",
  "qk7XcY": "",
  "4pxKg9": "",
  "8cb9D1": "",
  "+BkYsh": "",
  "Esw9HU": "{number} 篇",
  "NL+7/t": "",
  "kcCZue": "删除章节",
  "2Ebnuv": "",
  "jS+JJ0": "",
  "7PZ1fl": "",
  "vF39hG": "标记纪律项目不完整",
  "wNUbR3": "标记纪律完成",
  "bbplxV": "编辑纪律项目",
  "sJCpUQ": "新建纪律项目",
  "rAMgEh": "添加问题",
  "6O5P7o": "期权标题",
  "AFhCIe": "删除选项",
  "tQubym": "",
  "0LHTxP": "复盘笔记",
  "Z21NKx": "一站式管理持仓、观察、计划和已平仓位。",
  "8ltzxx": "",
  "8L/qBP": "策略回顾",
  "ruVgHA": "按策略洞察",
  "nSFlbh": "独立于账户总表现回顾各项策略。",
  "rhSRQb": "",
  "PVAlnq": "",
  "zEJOhp": "最大亏损",
  "PXvL+A": "",
  "xXWCKF": "",
  "qrBpaw": "",
  "ntUAqx": "策略记录",
  "xr6MNz": "无法加载策略结果",
  "B8cD7i": "",
  "kQtFZa": "",
  "BQRVjs": "总体",
  "xK7rmd": "洞察",
  "IdOS2k": "分析页面",
  "4HDD85": "尚无策略结果",
  "5HvJug": "尚无策略记录",
  "6ADOnZ": "最大利润",
  "gR2Nki": "{count} 次使用",
  "zriMHc": "累计收益",
  "iJGa+V": "总亏损",
  "r22s3o": "无法更新此策略记录，请重试",
  "j769oH": "无法删除此策略记录，请重试",
  "5bTvdk": "编辑策略记录",
  "sGQ2Ff": "更新交易详情或移除此记录",
  "s+lPP3": "全部",
  "4b7v6u": "收益率",
  "hCCWuZ": "上一周期",
  "87vJSX": "",
  "I2z5s/": "下一周期",
  "jVJu3S": "",
  "KMvTTa": "选择周期",
  "NJOkzk": "",
  "21Zvz8": "",
  "r3/8SV": "常用",
  "bcbNYV": "{count} 个标的",
  "91RukZ": "按标的筛选策略表现",
  "K2A9LO": "全部标的",
  "4LeXxR": "策略预览",
  "jGzgJI": "加入工作台",
  "lwsE+O": "盈亏曲线",
  "W5wAqT": "悬停预览",
  "oyz4yy": "",
  "vMaDp6": "判断涨跌方向",
  "vSu746": "比较用于看涨、看跌或不同方向风险不对称的有限风险策略。",
  "CEoGfK": "买入较低行权价的看涨期权，同时卖出较高行权价的看涨期权，降低成本，盈利和亏损均有上限。",
  "OCbHib": "盈利有上限",
  "JLmqw+": "买入较高行权价的看跌期权，同时卖出较低行权价的看跌期权，预期适度下跌，盈利和亏损均有上限。",
  "Zwyi64": "两侧行权价间距不等的蝶式组合，两侧风险不同，可按预期价格调整结构。",
  "I7/6Bs": "不对称",
  "G2Sx1j": "目标价位",
  "wmS2kr": "判断价格区间",
  "YDnaXb": "比较依靠价格停留在一定区间、时间流逝或收取权利金的策略。",
  "oF+IUK": "卖出看跌与看涨期权，再买入两侧保护；到期价格落在两个卖出行权价之间时，可保留全部净权利金。",
  "BngmX1": "铁蝶",
  "zdskl7": "卖出同一行权价的看涨与看跌期权，再买入两侧保护；到期价格在中间行权价时，盈利最大。",
  "W08Ku7": "中心价位",
  "qhTEzo": "到期临界风险",
  "tgPdmY": "卖出看跌期权，并卖出看涨价差，收取净权利金，上涨和下跌两侧的风险不同。",
  "auhBZZ": "两侧风险不同",
  "+B/js+": "判断波动与时间影响",
  "/aXvb7": "比较受价格波动、隐含波动率和时间流逝影响的策略。",
  "GVA13j": "买入同一行权价的看涨与看跌期权；到期前无论向哪边大幅波动，都可能带来盈利。",
  "kd49zH": "双向波动",
  "6fFeZ0": "凸性",
  "jA01Oi": "买入不同行权价的看跌与看涨期权，通常需要更大的价格波动才能在到期时回本。",
  "0dusgQ": "大幅波动",
  "wjuBgH": "双向",
  "3OgfpA": "买卖同一行权价、不同到期日的期权，利用不同期限的时间价值变化。",
  "POMyDy": "期限结构",
  "DNnPtu": "相同行权价",
  "q3w6vj": "持仓保护与调整",
  "uw/XvT": "保护或调整持仓",
  "AonZ0n": "比较用于缓冲下跌、收取权利金或调整现有持仓风险的策略。",
  "KZzSw0": "持有股票并卖出看涨期权，收取权利金，同时限制股票上涨带来的收益。",
  "Lxvmvp": "收取权利金",
  "NdO7IB": "持有股票",
  "2MUZlt": "现金担保看跌期权",
  "oZOUBW": "预留买股资金并卖出看跌期权，收取权利金，被指派时按行权价买入股票。",
  "XPX/Qj": "指派",
  "mcEaAi": "买入看跌期权，为股票下跌提供保护；期权本身最多亏掉支付的权利金。",
  "HZemdo": "下跌保护",
  "EYHw8t": "权利金风险",
  "mX8/sM": "通过盈亏曲线和风险收益特点，比较不同策略。",
  "avVNaX": "策略画廊",
  "9aH0w1": "",
  "F/BpPU": "",
  "5NEEmc": "按涨跌方向、价格区间、波动率和持仓保护，比较不同策略。",
  "LXi25y": "日涨跌",
  "l8cLKS": "波动率指数",
  "neBHLb": "策略画廊",
  "SHVbsj": "每日收益率",
  "zbSUYV": "/天",
  "w4OOda": "复利计算器",
  "CclPLT": "回放历史路径，建立投资直觉。",
  "tvJaK7": "每日收益金额",
  "RGAAlJ": "{count} 天后金额",
  "49QoLz": "输入每日收益或每日收益率，查看指定天数后的金额。",
  "IMf/rJ": "累计收益率",
  "/Q2cl9": "回放一笔投资",
  "sMCIP4": "选择标的、日期和金额，然后逐日回放。",
  "5yUsUe": "回放",
  "aRAHZZ": "正在加载消息…",
  "sqAJjf": "消息暂时无法加载。",
  "HrjtOq": "计划 · 分析",
  "xEmB4k": "模拟 · 追踪",
  "AEMqJg": "学习 · 理论",
  "gRCJ7H": "日志 · 分享",
  "ddYOuk": "",
  "9hV8ca": "",
  "GD0smy": "",
  "IoUxKH": "交易计划日历",
  "+xDdOy": "事件、提醒和关注点",
  "c4fSUd": "回放历史市场窗口",
  "zZ8y5V": "多腿策略分层建模",
  "gjDKIh": "3D价格、时间、波动率和盈亏",
  "CMqgq2": "盈亏图、希腊值和波动率曲面",
  "nlAzCg": "期权理论与策略识别",
  "4mBq9J": "个人笔记和回顾知识库",
  "+8xPrz": "复合场景和上下文感知解释",
  "I0VKdA": "",
  "FrVMmz": "",
  "BofgE8": "",
  "xlN9Jm": "为复盘和风险理解而构建 — 非交易指令、执行或投资建议。",
  "BDz+kL": "开启 7 天完整体验",
  "iHrXPr": "无需信用卡。试用后选择套餐。",
  "I7Js/P": "",
  "qhbpLN": "到期时间线",
  "F++dDy": "决策笔记",
  "k96yNe": "本季度",
  "rhKUnG": "回顾中心",
  "HNqVXJ": "仓位和决策回顾",
  "He/QjJ": "",
  "KXDsqf": "",
  "QsSnjN": "",
  "q1RXbA": "",
  "xWredQ": "",
  "xX/4d/": "",
  "QOfEfC": "",
  "QUtV63": "",
  "9/EK8d": "",
  "Kp8Otr": "",
  "CtNvkT": "将市场事件、到期日、个人提醒和历史背景整合到时间线中，而不会将日历变成交易信号。",
  "wim34p": "市场规划",
  "Fl6Fj2": "将市场时间、事件和提醒集中在一个地方。",
  "8QPOWk": "宏观",
  "iWKF7c": "事件前回顾",
  "BeiV54": "开放市场回放",
  "znF9Ou": "构建分层期权结构，阅读盈亏图和希腊值，通过价格、时间和波动率来理解风险如何变化。",
  "yUdneB": "结构与维度",
  "8rQjEd": "在承担风险前模拟结构。",
  "0MxxVa": "盈亏与希腊值",
  "sJEG3n": "剩余到期时间",
  "KQRIu5": "多维模型",
  "cob9oz": "研究理论、识别结构、保存回顾笔记、测试复合场景，并将解释转化为个人知识体系。",
  "kAajM8": "学习循环",
  "FYXy5I": "将每次回顾转化为可复用知识。",
  "0PUDb+": "上下文感知指导",
  "v++xuR": "知识库与笔记",
  "Zkykx8": "期权理论",
  "tIh0Js": "知识工作空间",
  "UjDl7O": "范围与安全",
  "8PzAbn": "为复盘而构建，而非交易指令。",
  "VT73Hz": "ABG 不处理订单、不持有资金，也不告知您买卖什么。它为您提供工具来记录、建模、理解和回顾您自己的决策。",
  "loab8/": "阅读范围与安全",
  "wxFA74": "会员方案",
  "lG8JCg": "一个工作空间。选择您的节奏。",
  "tY0TGv": "",
  "e0TgZU": "",
  "c6lgV1": "",
  "hQGHPn": "超值套餐",
  "7fF4u5": "",
  "y5kU5D": "",
  "AtKmjK": "",
  "bFqd6W": "$28",
  "wQe8+4": "通过有效的推荐链接，创作者会员可享受每年98美元的优惠。",
  "EaucLA": "查看套餐",
  "ay2jWV": "",
  "ifHnAv": "",
  "FC0/2B": "最灵活",
  "2C6TrW": "年费",
  "crSaNx": "创建者会员价",
  "wTvTWn": "$14/月",
  "0C/Hg6": "月度订阅",
  "NfdlMJ": "创建者优惠",
  "e1W6D1": "灵活",
  "m9D650": "持仓复盘与分析",
  "00gImr": "连接持仓、时间线、笔记、提醒、表现、回撤和归因。",
  "1eoYHD": "市场规划与结构建模",
  "I2Ipi/": "使用市场日历、事件、回放、层叠策略、盈亏图、希腊字母和3D分析。",
  "Hts+kb": "理论与个人知识",
  "+Znf1h": "学习期权理论，保存复习笔记，测试复合场景，并请求上下文解释。",
  "6TS3ZE": "",
  "9Ivgx9": "",
  "J2kzjM": "无需信用卡",
  "vbef6J": "",
  "nRON+p": "",
  "2GT2Ur": "",
  "7VfySi": "",
  "2w/L2T": "",
  "AGIt+l": "创作者会员价已生效：一年 $98。",
  "D+5vWg": "7 天完整体验",
  "eoGRih": "创作者或推荐码",
  "1SvspN": "正在验证……",
  "ogtrq7": "推荐码已生效",
  "Uca73P": "选择创作者年费 · $98",
  "FaijsO": "选择年费方案 · $168",
  "NE8OEv": "选择月费方案 · $28",
  "XPdDS1": "",
  "Ld/KaS": "完整工作区访问权限",
  "4CNgZG": "仅用于分析与复盘，不构成投资建议",
  "/kBA+Y": "不提供订单执行或资产托管",
  "W4wtnh": "不提供投资建议",
  "AUqvOO": "集中保存笔记与复盘记录",
  "Uq+RRg": "注册或购买后，登录 PIN 将发送到你的邮箱。",
  "VKLw8l": "购买即表示您同意我们的<terms>条款</terms>和<privacy>隐私政策</privacy>。",
  "bstZjx": "",
  "zgE4dq": "1 年仅需 $98",
  "ksarQ6": "",
  "nU1LTV": "",
  "/YZuK0": "",
  "qYVylU": "",
  "Bsa1nG": "",
  "a1HS4h": "",
  "FSsQd+": "以 $98 购买 αβΓ✻1 一年，原价 $168",
  "My2ZiO": "2026年8月",
  "dZga36": "SPX · 08:30 ET",
  "33XGsD": "SPX · 2025–2026",
  "eVpmiZ": "",
  "JKM9QQ": "",
  "rgcCAJ": "规划 · 模拟 · 复盘 · 理论",
  "Z5mRIq": "$8",
  "MLLhO6": "选择周费方案 · $8",
  "tNtnts": "限时",
  "Nmp6Tk": "免费开启 7 天完整体验",
  "mji/Oj": "免费体验 7 天",
  "8c1D4a": "尚未开通？查看方案",
  "Rcp4Jx": "官网首页",
  "x4GQmc": "让每一个决策都可复盘。",
  "CjV8nU": "复盘工作区",
  "TxtDTD": "关闭策略面板",
  "5ssZnI": "免费开启 30 天完整体验",
  "ypZrg5": "开始享有30天完整访问权限，之后选择适合您回顾节奏的套餐。",
  "TS+9k4": "含 30 天标准功能试用。无需信用卡，也无需邀请码。",
  "qypl0c": "您的 30 天标准功能试用已激活。",
  "UVBdRr": "开启 30 天完整体验",
  "ZLUQfl": "免费体验 30 天",
  "j59G7j": "快速跳转",
  "Ui5ANs": "撤销本次编辑",
  "PzutAl": "行权价编辑模式",
  "+IbuDO": "拖动图表修改行权价；重新锁定后恢复收益查看。",
  "2g9D/w": "退出沉浸式",
  "TpgjfJ": "进入沉浸式",
  "VGa8CT": "收起并适应屏幕",
  "2xTrVi": "展开完整内容",
  "tOxzip": "修改时间",
  "c5cNas": "Markdown 编辑器",
  "8typ4g": "代码块",
  "vjnqOs": "记录信息",
  "khVfqL": "复盘日期",
  "8h0sA8": "查看全文",
  "RTOuyx": "分享内容",
  "BjCf6E": "有新内容",
  "9YtkTN": "请等待 {seconds} 秒后再发布，当前内容仍会保留。",
  "xac7x3": "已达到每小时发布上限，当前内容仍会保留；约 {minutes} 分钟后可重试。",
  "ZYR+2M": "已达到今日发布上限，当前内容仍会保留；约 {hours} 小时后可重试。",
  "xy9fIB": "刷新帖子",
  "1Vd442": "编辑帖子",
  "b3KIxg": "此分享无法更新。请重试。",
  "08bjdS": "编辑分享",
  "6SSNQY": "分享内容",
  "sIcQ7Q": "理论",
  "I+1HSy": "试用中",
  "PLWLj4": "账户已过期",
  "CUVzHJ": "订阅会员",
  "uWYDYQ": "您的 30 天完整功能试用已激活。",
  "C8RLOp": "明日到期",
  "vMnQkW": "{days} 天后到期",
  "Pgb3Xj": "已订阅",
  "o2jbDD": "永久会员",
  "R/6nsx": "订阅",
  "D1sYbh": "会员来源",
  "1Ns+S9": "永久使用权限",
  "3wNgxT": "试用用户",
  "u4eb+l": "订阅会员",
  "FBaarm": "订阅会员",
  "hOVnhg": "创建永久会员账户、生成推广码，并通过邮件发送登录 PIN。此操作不可撤销。",
  "pDD3Q8": "已关联现有用户 {email}，并授予永久使用权限",
  "fwHVIj": "创建永久会员账户",
  "DmD2Gj": "已开通永久权限",
  "2aSWG6": "合作开通后授予永久权限",
  "f0rQnJ": "需要会员资格",
  "zwnM1o": "创建免费 αβΓ✻1 账户——享 30 天完整功能",
  "uR6yCB": "",
  "QHOTHT": "按会员来源分类",
  "NaJZGd": "先记为潜在客户。对方确认合作意向后，再走入驻流程（发送 PIN + 创建会员账户）。",
  "q/GFui": "含 30 天完整功能试用。无需信用卡，也无需邀请码。",
  "sMDnEL": "$128",
  "CNHiAh": "好友推荐价",
  "d9tr31": "分享优惠价",
  "JutoQW": "好友优惠",
  "U5Q5TI": "年度优惠",
  "fKO/1/": "好友推荐定价有效：每年 128 美元。",
  "RoPF5Z": "年度分享优惠有效：每年 128 美元。",
  "k2g/bo": "继续好友年度 · 128 美元",
  "fFMBmp": "继续年度优惠 · 128 美元",
  "MDMGka": "",
  "0CKb+L": "扫描年度股份优惠",
  "Ws/DRi": "一年 ¥128 · 原价 ¥168",
  "ME+0W0": "会员分享",
  "4Im69U": "朋友通过您的链接可享受每年 128 美元的价格。当他们成功注册或购买后，您和他们都将获得 20 天会员资格。",
  "C2PLjd": "分享 αβΓ✻1 年度会员优惠：$128/年（原价 $168）：{url}",
  "oVTz5V": "分享链接已生成",
  "+fkGwM": "预览年费分享卡",
  "KhmBbD": "年度会员",
  "A8NtAB": "打开分享卡",
  "dt8xha": "分享 $128 年费优惠",
  "qxHg3H": "每年",
  "yLOx6H": "分享卡",
  "cCGg3D": "98美元分享卡",
  "ZFu/dr": "扫描创作者年度优惠",
  "BRLIKd": "一年 ¥98 · 创作者专享",
  "mOBsIb": "创作者分成",
  "3zhDZd": "创作者代码: {code}",
  "FRXOmD": "已举报",
  "DYXaO9": "此帖子因多次社区举报而被折叠。",
  "8VkHvE": "显示帖子",
  "c1owGb": "订阅会员和认证创作者可公开发帖。",
  "4lqEYb": "新账号将在24小时后才能分享外部链接。您的笔记仍在。",
  "/WN/Am": "社区禁止发布推荐链接和优惠链接。",
  "yOKMFr": "订阅会员和认证创作者可发帖。试用会员可阅读、关注和举报帖子。",
  "4sKrx+": "已验证创作者",
  "tS9FPC": "输入券商报告的已实现盈亏。",
  "1IEGYF": "输入官方结算值，各腿将自动计算。",
  "NhmG6m": "输入标的参考价格，以估算行权与指派结果。",
  "OJUasc": "现金结算",
  "B2p6Bi": "券商结果",
  "0VNDuE": "实际已实现盈亏",
  "V+qFDZ": "官方结算值",
  "BUH8zP": "标的参考价格",
  "QPsBe2": "使用券商对账单中的最终金额",
  "pMLhyY": "用于估算行权与指派",
  "y3j4Us": "预计结果",
  "drqP2L": "交割",
  "0bRwOS": "已行权",
  "iZDRGO": "已指派",
  "871J/6": "到期作废",
  "beB5uE": "股",
  "b3Xwdd": "净交割股数",
  "MXoK1F": "行权价现金流",
  "YTCJ+M": "预计经济盈亏",
  "w7l1MV": "",
  "j0flF1": "",
  "xbLYzR": "",
  "hZAbHh": "",
  "QymVWS": "",
  "KXZgWI": "",
  "vjiRBI": "",
  "fRsDjv": "",
  "YGjx60": "",
  "lBPGKn": "不包含手续费和滑点。",
  "5seIFh": "",
  "0RQE9x": "",
  "uGgflT": "",
  "igP5pm": "",
  "r61vXi": "",
  "bLhIW7": "",
  "ZT3gnU": "",
  "0EOCcV": "",
  "KyusnX": "",
  "kz8clV": "",
  "pxJVCs": "",
  "WG6Bk8": "",
  "sD1P1G": "",
  "buvmCH": "",
  "swmmao": "",
  "wJvOz9": "",
  "mSxsgB": "",
  "T6XxNn": "",
  "nuwvvH": "",
  "c210+r": "",
  "Y8vWSj": "",
  "Kmj8DH": "到期收益率",
  "koHr5l": "",
  "mkdMMA": "",
  "XI8acX": "",
  "r8Qi9l": "",
  "yzkFsz": "",
  "lAhYH1": "",
  "+iIoZY": "",
  "eA6wa8": "",
  "rFhJRe": "",
  "uHu2Sk": "到期最大收益",
  "q2eIh9": "查看到期最大收益计算方式",
  "AVd+xC": "到期最大收益计算",
  "p63vhH": "到期最大收益 = 所有腿到期 P&L 合计的最大值",
  "p1z5P5": "最大到期 P&L",
  "+6Slr9": "到期最大收益 = 净权利金 × 数量 × $100",
  "p0zI0G": "每条腿",
  "g6ipyD": "多头腿 P&L =（到期内在价值 − 建仓权利金）× 数量 × $100",
  "L9co0M": "空头腿 P&L =（建仓权利金 − 到期内在价值）× 数量 × $100",
  "xHdj1x": "权利金收益率",
  "GEdPVY": "风险收益率",
  "WQP2ut": "查看风险回报比说明",
  "ThUvIL": "已隐藏",
  "qcR7fS": "无法更新此持仓",
  "7j1Mgp": "暂无已归档持仓",
  "kIhdMY": "暂无已隐藏持仓",
  "bOaUqZ": "已归档持仓仍参与统计，可在此恢复。",
  "sO3Bze": "已隐藏持仓不参与统计，可在此恢复。",
  "R46+3v": "永久删除",
  "YS4On5": "无法永久删除此持仓",
  "53EorX": "确认永久删除此持仓？",
  "EVMb+G": "此操作会永久删除该持仓并从所有统计中移除，且无法撤销。",
  "YjHnYx": "{count} 个已归档",
  "mU7A0p": "{count} 个已隐藏",
  "Rwykbl": "不参与统计",
  "T5INbY": "无法归档此持仓",
  "YMmEiS": "无法隐藏此持仓",
  "EneU0Y": "确认归档此持仓？",
  "O9Sipg": "确认隐藏此持仓？",
  "dugfnJ": "此持仓将移至“已归档”，并继续计入绩效统计，之后可恢复。",
  "8mP0pJ": "此持仓将移至“已隐藏”，并从绩效统计中排除，之后可恢复。",
  "CfWiRl": "归档持仓",
  "q8NSOn": "隐藏持仓",
  "zuox0y": "无法恢复此持仓",
  "3+4hrG": "确认恢复此持仓？",
  "vfMsL9": "恢复后，此持仓将重新回到原列表。",
  "m2mTdA": "确认恢复",
  "f6a7e/": "已结算",
  "rbt2f5": "当前列表",
  "Vq5OSe": "删除此模板？",
  "CSYtw1": "已定价",
  "OS3U7j": "包含已归档，排除已隐藏",
  "Qgz2Vn": "累计绩效",
  "DavTn1": "权利金收益率 = 最大获利 ÷ |净权利金金额|",
  "ntSWBx": "风险收益率 = 最大获利 ÷ 最大风险",
  "BKkRR/": "风险回报比",
  "xH2LbA": "查看当前盈亏计算方式",
  "+1wV10": "当前盈亏计算",
  "tqVx9+": "当前盈亏 = 所有启用腿当前 P&L 合计",
  "u2u58G": "净权利金金额",
  "6W2ZmW": "查看最大风险计算方式",
  "XUY2vI": "最大风险计算",
  "ZxyPEz": "最大风险 = 价差宽度 × 数量 × $100 − 净权利金金额",
  "RZSlBw": "到期最大获利",
  "UGgwfe": "最大风险 = 净支出权利金 × 数量 × $100",
  "5B7K4Q": "最大风险 = 到期盈亏曲线中的最大亏损金额",
  "H53Wpt": "包含多个到期日 · 已隐藏到期预估",
  "gDdkZX": "预估到期盈亏",
  "g8ZbQ5": "预估持有至到期",
  "b8P01l": "剩余腿",
  "JiHVub": "预计盈亏",
  "usj2t3": "",
  "fM6GQY": "展开浮动摘要",
  "t3hz64": "收起浮动摘要",
  "auHFt2": "",
  "D2fOEw": "",
  "QyUQq+": "",
  "oSsiNe": "",
  "YBC5VF": "空头铁鹰",
  "yOyjUj": "手动回报",
  "2c55rc": "系统回报",
  "7jnhmW": "匹配系统计算",
  "R4U5+E": "差值: {value} 个百分点",
  "rn+3KN": "多头铁鹰",
  "yIhdyQ": "每份合约成本/最大风险",
  "G8q69c": "",
  "dnwAd5": "",
  "piVZo7": "输入总盈亏，以及手动回报或每份合约成本/最大风险",
  "PmxNCO": "回报方式",
  "179XvX": "风险回报比",
  "BtKQe5": "",
  "u26zQm": "个交易日前",
  "hYXp3+": "个交易日后",
  "ygzclX": "说明交易日倒计时",
  "fdCHpx": "交易日倒计时规则",
  "O0bpOT": "选过去日期，看已过去多少天。",
  "q6FHAm": "选今年剩余日期，看今年还剩多少天。",
  "n4kral": "选下一年的未来日期，看距离未来有多少天。",
  "PEFUSo": "回放对比",
  "uJEoDm": "",
  "9+47tk": "回放记录",
  "R6o5e6": "",
  "3NFImi": "",
  "PZq4TK": "",
  "MPgaZN": "",
  "Jntx35": "",
  "WYbDBm": "",
  "LKdoSU": "",
  "fY9Z+m": "",
  "VfYQcJ": "对比投资",
  "3SIWSd": "选择 2 至 4 个标的，使用相同的日期和金额进行对比。",
  "7/HD7G": "",
  "o+3W1i": "单一标的",
  "nxrU3P": "",
  "c/uCg0": "开始对比",
  "8vlp1n": "对比日期",
  "QGdayO": "播放对比",
  "0NN2tx": "重新播放",
  "Ndu2ZU": "",
  "l/jMQT": "",
  "pRxfb2": "",
  "bl9ddh": "",
  "Ubh9y+": "",
  "a3OTvB": "",
  "pusZVz": "删除回放记录",
  "8xZJRI": "对比标的",
  "X0Q709": "移除 {ticker}",
  "0YBpXl": "添加对比标的",
  "SIINHZ": "添加标的",
  "UdiaLk": "每个标的投入",
  "q31qNa": "完成的对比将保存在这里。",
  "PfIjVc": "",
  "0rcw3j": "",
  "Yge0jU": "这会永久删除该回放记录，且无法撤销。",
  "78QP/e": "删除回放记录？",
  "7NvtcR": "",
  "QJmVFF": "",
  "hDwJ64": "此标的完成的回放将保存在这里。",
  "xSylqQ": "",
  "Nixnbe": "",
  "rgU42E": "账户历史路径",
  "sEQvxE": "回放记录标的",
  "vdf86g": "",
  "4NYwZZ": "",
  "pWLUu3": "2–4 个标的",
  "C+N8w0": "",
  "/Zj5Ed": "一次投入",
  "b1Ou36": "每季度",
  "oyG65W": "每半年",
  "dqD39h": "每年",
  "dhHjsg": "快速开仓",
  "QYSyb0": "选择合约并确认开仓成交信息。",
  "ktMgsf": "期权类型",
  "bgusDi": "确认开仓",
  "BP+63j": "总成本",
  "1F+vfO": "投入方式",
  "S9zGng": "每次投入金额",
  "0DDl29": "每个标的每次投入",
  "pNxPUP": "投入于 {date}",
  "a7681X": "",
  "EkEDjD": "",
  "drC9cz": "",
  "HYZ2SW": "一次投入 {amount}",
  "Dtin70": "",
  "XcJtpJ": "",
  "wiKa1c": "{amount} × {count} = {total}",
  "fu/B91": "{amount} × {count}",
  "f8ox16": "每个标的：{amount} × {count} = {total}",
  "JZ8i8E": "每个标的一次投入 {amount}",
  "FffCH1": "自建书",
  "HKCOwy": "开仓时间",
  "5YhudP": "待结算",
  "G2Knv1": "请使用官方结算点位，不要使用 Monitor 显示的最后报价",
  "sPWQ7D": "稍后结算",
  "yYCJE5": "现在结算",
  "qo0qUR": "预估到期盈亏",
  "/UizCK": "当前期权报价不完整，所以当前收益只是估算；到期收益按结算点位计算。",
  "HnxG15": "组",
  "0kQziN": "提醒标题（达到目标价格时提醒）",
  "n816xf": "提醒标题（到期日当天提醒）",
  "Et5m+a": "提醒标题（仓位到期前 1 天提醒）",
  "vLT+cB": "提醒标题（仓位到期前 {days} 天提醒）",
  "kFKkq8": "提醒标题（在指定日期和时间提醒）",
  "ZF2HrZ": "便签",
  "jg0VR7": "添加便签",
  "+8P2r8": "查看便签",
  "o6N36n": "编辑便签",
  "BmsYb3": "复盘日志",
  "iQ+Ird": "为什么交易？",
  "B3Q5mz": "触发条件",
  "2IedGT": "失效条件",
  "KFbhjh": "是否按计划？",
  "/O88mD": "调整",
  "5nn4KD": "情绪",
  "M5ze/8": "做对了什么",
  "plz2Da": "哪些没做好",
  "gfKKsY": "下次改进",
  "RDzOWw": "自定义问题",
  "pIPOc5": "复盘内容将自动保存于日志",
  "DPEFal": "查看日志",
  "exuj/3": "",
  "ieSWnu": "无法加载地区分布",
  "YMDBNH": "地区分布",
  "SdDIj4": "地区分布数据暂不可用。IP 定位功能上线后，将在此显示登录地区。",
  "aMwxYb": "国家或地区",
  "8sPgXj": "最近 {days} 天",
  "eZHLOh": "已定位",
  "0U6tmb": "未定位",
  "Or9ItZ": "各国家或地区登录次数",
  "qqZZ0R": "地图加载失败",
  "YJ60t1": "排名",
  "C8jiL6": "",
  "Ji/tE8": "",
  "v9AqkR": "",
  "h5ns+e": "",
  "kL41aZ": "无法加载审计日志",
  "wzICIz": "没有符合筛选条件的事件",
  "Ho0rsi": "搜索事件数据",
  "zSOvI0": "筛选条件",
  "/x74Ok": "共 {total} 条事件",
  "ED9RG5": "审计日志",
  "xhnYsq": "第 {page} 页，共 {pageCount} 页",
  "kmM+gk": "无法加载管理员列表",
  "ybfgy3": "暂无管理员",
  "t5nDnD": "账户授权",
  "MSaCKq": "环境配置授权",
  "wHvmSN": "账户与环境双重授权",
  "iyTlP5": "",
  "m6paUd": "不能撤销自己的管理员权限",
  "U4mRh8": "",
  "7qAhyB": "操作未成功，请重试。",
  "yAaNQA": "管理员",
  "WusR4d": "",
  "tnRDuU": "撤销权限",
  "hQZhn8": "以该用户身份登录",
  "V6RrPC": "",
  "pg6z4S": "注册数",
  "MFCbl3": "登录次数",
  "hrAQpD": "提醒触发次数",
  "TpORFZ": "无法加载总览",
  "du1laW": "",
  "+EKK8l": "用户概况",
  "uRrOCr": "",
  "irFBKn": "最近 7 天",
  "IluOt9": "最近登录",
  "U/56Rw": "",
  "26tyS2": "",
  "nZ1VHG": "",
  "f4JKQ4": "",
  "1lkU0S": "",
  "DkTXT8": "",
  "ohjvu+": "活跃用户",
  "UQSrcT": "",
  "CnpuAf": "日活跃用户",
  "+btGfn": "",
  "z/pi6K": "周活跃用户",
  "WuTp3E": "",
  "LVeTxv": "月活跃用户",
  "fPN/3P": "",
  "hSNxZT": "查看全部套餐",
  "UeqQ5C": "转换公式",
  "XYsvl5": "删除消息",
  "fsgo1a": "确定要删除这条消息吗？此操作无法撤销。",
  "S+o8nA": "删除消息？",
  "v4Mlb8": "消息删除失败，请重试。",
  "f1rHKt": "管理员可访问整个管理后台。撤销操作会移除账户的管理员授权；通过环境配置授予的权限，需要在环境配置中移除。",
  "I4sDCe": "",
  "Tpy00S": "",
  "8KJDMW": "查看平台运营情况，管理用户、获客渠道、内容与系统。",
  "nL6Jl0": "用户留存",
  "eWzMDx": "激活率",
  "J0wSmC": "7 天内已激活",
  "VjUyuG": "注册批次",
  "Ao+O+Q": "注册时间",
  "agOXPD": "人数",
  "2lC6PV": "用户黏性",
  "xkWJu2": "7 日均值",
  "+a+2ug": "会员数",
  "l8wanU": "新增注册",
  "CQOyVR": "统计天数",
  "CPpsOf": "趋势",
  "CcM05v": "暂无登录记录",
  "NLeFGn": "至",
  "zyDnZa": "清除日期",
  "wRwX/G": "每周事件数",
  "4dL5F5": "初始本金",
  "ZxJs61": "计划已完成",
  "NiE9MV": "还差 {count} 次",
  "KSQJ7U": "次",
  "2wHwuR": "当前收益",
  "E/Kkr0": "完成本次",
  "YuCFAO": "第 {count} 天",
  "uurNRY": "已完成 {count} 次",
  "VTuB5J": "目标收益",
  "Gs9Kfp": "回到顶部",
  "//uGU4": "到期后假设",
  "UGe/dl": "等待报价",
  "qgw8AH": "现金流",
  "H24iSt": "删除此策略？",
  "Na3L+7": "编辑合约",
  "2rO17V": "此策略及其合约将被移除。交易日志将保留。",
  "uQVmjH": "返回编辑",
  "uRtNMW": "1 选择结构",
  "LY+2as": "2 编辑合约",
  "y5iRD+": "3 查看收益图",
  "dhPbpj": "直接编辑名称。每个合约可独立设置到期日和数量。",
  "e8Bk1E": "删除此腿",
  "KgeekN": "每股权利金 · 美元",
  "Hn90P4": "添加合约",
  "h3gzda": "取消更改",
  "WUV28A": "正在保存…",
  "Q1NxeC": "保存并查看损益图",
  "ekXood": "无限制",
  "zGWqEw": "不同到期日：使用旗舰模型比较时间价值。",
  "pkpaI1": "",
  "SGPNh4": "添加合约以开始模拟。",
  "vHiAre": "到期时的策略收益图",
  "uNxDFh": "到期价格",
  "5mbT1F": "模拟盈亏",
  "r/Hdwg": "移动滑块仅更改场景，不更改合约。",
  "MMd4lt": "到期模型 · 不含手续费",
  "2cQYUL": "铁鹰价差",
  "iZppcE": "蝶式价差",
  "5JiUi1": "买入看涨期权",
  "mnZbrH": "买入看跌期权",
  "tWrG9I": "自定义合约",
  "xey8lP": "2.0 通用",
  "rVbKiP": "",
  "1eSZed": "保存失败。您的更改仍在此处。请重试。",
  "+rBfGg": "策略已删除",
  "03mQgY": "策略库",
  "fa1iCm": "选择一种结构，然后选择其标的股票代码。",
  "fNCCY7": "基础",
  "DKLopw": "策略结构",
  "lZh4DD": "移除自选",
  "pYaV6+": "添加自选",
  "et5yHf": "",
  "7gNiiK": "",
  "CFS8/C": "主导航",
  "aEp+N8": "界面版本",
  "3z1ihQ": "1.0 旗舰",
  "NhOQhO": "",
  "R5Vc+F": "策略概览",
  "VxyqWZ": "所有结构",
  "50bxrQ": "",
  "VoFF/J": "正在加载工作区…",
  "1RrqRr": "无法加载工作区。",
  "62nsdy": "重试",
  "muh87+": "",
  "USQbHO": "今日日程",
  "OHv56o": "",
  "8g9U95": "",
  "H3AR3E": "到期日计划",
  "wXmakI": "选择日期",
  "c3eTb6": "",
  "B+yA9l": "此日期无策略到期。",
  "fW5KSG": "提醒和任务",
  "8iO53k": "股票代码工作区",
  "lFUgob": "",
  "ObGhob": "选择结构",
  "YGAlXb": "切换股票代码工作区",
  "K1Fap+": "选择标的",
  "A8QzWU": "当前策略",
  "++2QjX": "多重到期日",
  "U7BK5a": "",
  "yYeCWE": "盈亏模拟",
  "RQVoCk": "当前策略 · 到期视图",
  "hzmswI": "分组",
  "BpZUWo": "此结构使用了高级功能。",
  "mPBRAK": "在 1.0 Flagship 中打开",
  "NQ6Oca": "合约编辑器",
  "ctiPi5": "编辑全部",
  "iL0n4U": "减少数量",
  "3ZPs5M": "增加数量",
  "C+TT7f": "",
  "Y3NN5e": "从策略开始",
  "BnasDI": "我的",
  "47MEOU": "个人工作区",
  "AEzWZu": "",
  "2W0f9h": "",
  "uE6ELS": "未提供",
  "knZ+VT": "",
  "YSuGxS": "选择您的标的交易空间",
  "zfy9tc": "将此日期应用于当前策略中的每个合约。",
  "3n8o15": "应用更改",
  "ZBVds5": "",
  "ygnIVa": "易于学习 · 日常使用",
  "Bgy7EN": "日程、策略库、合约编辑和盈亏模拟。",
  "BnyM4B": "深度分析 · 全套工具",
  "Y835m9": "策略监控、3D模型、波动率曲面和期权学习。",
  "Q7UFcU": "",
  "N9aL82": "为每个合约到期日选择交易日。",
  "rlzoEL": "功能概览",
  "HV1Wo6": "",
  "s+pBQT": "",
  "Fd4y+V": "浏览和收藏策略结构。选择一个结构，然后选择一个标的开始构建。",
  "OhHiCw": "管理您的个人详细信息和界面偏好。",
  "dZ8hKy": "日程和提醒、策略分析、投资回顾和复利增长计算。",
  "zwn9ey": "构建分层策略，管理期权合约，监控已保存的策略，并在3D中检查跨价格和时间的盈亏。",
  "UvYitw": "浏览策略选择，识别盈亏形态，研究波动率曲面、微笑和偏斜，并练习期权理论和希腊字母。",
  "awmryh": "个人资料、关注的创作者和分享的帖子、书籍和笔记、消息以及账户设置。",
  "L3S5GE": "选择日期以查看当日日程。",
  "zdLDux": "确认删除",
  "Z0OIGW": "买入 {strike} {type}",
  "4jBZs/": "卖出 {strike} {type}",
  "XyQ6Tz": "构建合约组合。",
  "ebizDo": "报价快照",
  "0TW6Fq": "此选择无可用期权报价。",
  "M9qpSD": "买入/卖出价",
  "e4WZAu": "卖出/买入价",
  "70jbDq": "您的选择",
  "6tTb3Y": "选择买入或卖出报价。您的合约将在此显示。",
  "86rWuG": "移除所选合约",
  "2wnqME": "{count} 个合约已选",
  "Q4yHuA": "添加所选合约",
  "itWRRt": "从期权链添加合约",
  "PwJJQJ": "编辑PIN",
  "RsD3Mg": "中文",
  "lJlH1M": "翻转盈亏颜色",
  "NoC/ht": "参考价",
  "KkwoIE": "未提供市场价格。请输入参考价以设置初始行权价；您之后可以编辑每个合约。",
  "fYd71s": "策略组数",
  "apDkIS": "最佳结果",
  "vAz6ml": "最差结果",
  "YK27+4": "每组合约数",
  "t8KawU": "未命名的条目",
  "8JXfhE": "阅读条目",
  "AjSNyH": "无法删除此条目。请重试。",
  "r5knpq": "搜索标题或备注",
  "gVLnrh": "无法加载日志条目。",
  "KYAHKF": "尚无日志条目。",
  "WOab0k": "无法加载更多条目。请重试。",
  "o7CI6C": "编辑日志条目",
  "i1rX6C": "删除条目",
  "Wi3+7C": "快速记录、复盘回顾",
  "R8Q6VQ": "将此二维码放在创作者的个人主页或视频中，扫码即可打开其专属页面。",
  "FvZfKT": "盈亏图预览需要完整报价和后续到期日的隐含波动率。",
  "3UBNqL": "所选腿的盈亏图",
  "8vIenI": "估算于首次到期",
  "goYBDH": "到期时",
  "OxAaln": "美元 · 每腿1合约 · 中间价估算",
  "YKIOP9": "显示买卖盘价标签",
  "pN8oP2": "显示买卖方向标签",
  "vXL/X1": "无法保存偏好设置。请重试。",
  "u40kFh": "跳至平值",
  "8oG2ji": "股票价格预览",
  "fyFJ6K": "对比标的",
  "7GfSfn": "看涨、看跌、买方与卖方",
  "Nz17S4": "",
  "uyL+Ww": "看涨期权的买方有权按行权价买入标的，看跌期权的买方有权按行权价卖出标的。买方支付权利金；卖方收取权利金，被指派时须履约。现金结算的期权以现金结清差额，不交付股票。",
  "YuvBNe": "",
  "/7ti6w": "",
  "xUn3rM": "行权价与到期日",
  "5wAbxe": "",
  "ArYJa/": "行权价是合约约定的价格，不是当前市价。到期日限制了权利的有效期。标的价格高于行权价时，看涨期权处于价内；低于行权价时，看跌期权处于价内。但扣除权利金后，价内期权也可能亏损。",
  "wl9edf": "",
  "C0/RPB": "",
  "fxc6IF": "权利金、内在价值与时间价值",
  "3Om/Xv": "",
  "29xQyw": "内在价值是期权处于价内的金额，其余价格为外在价值，反映剩余不确定性、时间和融资等因素。隐含波动率是由期权市场价格反推的波动率参数，并不保证未来真的会这样波动。",
  "5PvJYb": "",
  "dhnd3R": "",
  "d3EsQM": "看懂到期盈亏",
  "Fs7RgO": "",
  "dd/LXF": "买入看涨期权的每单位到期盈亏＝max（标的价格－行权价，0）－权利金。买入看跌期权则为max（行权价－标的价格，0）－权利金。卖出期权反转正负号，再乘以数量，将各腿相加。股票持仓另计价格变动的盈亏。",
  "exjjhi": "",
  "0ben7v": "",
  "M2ZZ4j": "风险、指派与结算",
  "iPwlEG": "",
  "QPNhOW": "卖出的美式期权可能在到期前被指派。即使卖出腿被指派，保护性的买入腿也不会因此自动行权。不同产品的现金结算、股票交割、交易时间和行权规则不同。保证金是担保资金，不是最大亏损。",
  "cJ59WL": "",
  "ZTidxf": "",
  "RRseuU": "标的价格每变动 1，期权价值大约变多少。",
  "UMcNDu": "Delta衡量期权对标的价格的小幅变动有多敏感。买入看涨期权的Delta为正，买入看跌期权为负；卖出则反转正负号。将各腿的Delta按多空方向和数量相加，就得到组合的方向敞口。",
  "YHkh00": "",
  "AhMRBz": "Delta不是收益率，也不是保证盈利的概率。它会随价格、时间和波动率变化。Delta接近零的持仓，仍可能有较大的Gamma风险和波动率风险。",
  "4jzRlF": "标的价格变动时，Delta 又会变多少。",
  "sCgtPB": "Gamma衡量标的价格每变动1时Delta的变化。买入普通看涨或看跌期权的Gamma为正，卖出则为负。临近到期时，平值附近的Gamma可能很大，小幅价格变动就能迅速改变方向敞口。",
  "8yPNH6": "",
  "O7iIpD": "正Gamma有利于应对较大的价格变动，但买方通常要承担时间损耗。负Gamma造成的损失可能超过一天正Theta带来的收益。",
  "ZzqFIV": "时间过去一天，期权价值大约变多少。",
  "5P1Ugu": "Theta估计标的价格、波动率等因素不变时，时间流逝对价值的影响。买入期权通常为负Theta，卖出通常为正Theta。价差组合的净Theta取决于标的价格与各行权价的位置关系。",
  "6EqYjQ": "",
  "C+R2pN": "不能用今天的Theta乘以剩余天数预测最终盈亏。时间损耗并不恒定，正Theta是承担其他风险的补偿，不是每天固定到账的利息。",
  "3eGHie": "隐含波动率上升 1 个百分点，期权价值大约变多少。",
  "MVjrrk": "Vega衡量期权对隐含波动率的敏感度。买入普通期权的Vega为正，卖出则为负。不同的行权价和到期日可以有不同的隐含波动率，所以单个净Vega无法描述所有波动率变化。",
  "BjUh7m": "",
  "nIqrMR": "即使看对了价格方向，隐含波动率下降也可能让期权亏损。日历价差需要分别关注不同到期日的隐含波动率。",
  "e4UhvA": "Rho",
  "a/Z+Ai": "利率上升 1 个百分点，期权价值大约变多少。",
  "TA0hGI": "Rho衡量期权对无风险利率参数的敏感度。在标准欧式期权模型中，买入看涨期权的Rho为正，买入看跌期权为负。期限越长，利率的影响通常越大。",
  "I2oghv": "",
  "QTAib9": "利率只是影响因素之一。实际利率公告还可能带动标的价格和隐含波动率变化，不能只靠Rho判断总影响。",
  "OupIqH": "买入看涨期权，用权利金换取上涨收益；卖出则收取权利金并承担履约义务。",
  "ifg8Yt": "做多：买入一份看涨期权。做空：卖出一份看涨期权。相同行权价和到期日下，两者的期权盈亏相反；如果卖方同时持有对应股票，组合风险会不同。",
  "hitmfO": "花3买入100看涨期权：到期盈亏平衡点为103，最大亏损3，上涨盈利无上限。标的到110时赚7；卖出同一期权则亏7。",
  "T0hkRO": "买方最多亏掉全部权利金。无股票覆盖的卖方，上涨方向的亏损理论上无上限，最大盈利只有收到的权利金。",
  "+YzjqV": "买入看涨的 Delta、Gamma、Vega 为正，Theta 通常为负；卖出时符号相反。时间损耗可能抵消小幅上涨带来的收益。",
  "CFx3it": "看对方向还不够，涨幅需要弥补成本，并在到期前发生。读盈亏图前先确认买入还是卖出。",
  "JkP069": "买入看跌期权，获取下跌收益或保护持仓；卖出则承担相反的风险。",
  "431t17": "做多：买入一份看跌期权。做空：卖出一份看跌期权。以股票交割的合约，卖方被指派时可能需要按行权价买入标的。",
  "BNdW86": "花3买入100看跌期权：到期盈亏平衡点为97，最大亏损3；标的跌到零时最多赚97。标的到90时赚7。",
  "UkVZlP": "买方的风险是支付的权利金。标的跌到零时，卖方每单位可亏损行权价减去收到的权利金，最大盈利仅为权利金。",
  "yrqxhH": "买入看跌的 Delta 为负，Gamma、Vega 为正，Theta 通常为负。即使股价小幅下跌，隐含波动率下降也可能使期权跌价。",
  "aIlHmR": "保护有成本，也有期限。股票最低跌至零，因此看跌期权的盈利有上限。",
  "ZKc6CF": "放弃部分股票上涨收益，换取权利金，同时仍承担股票下跌风险。",
  "n13Cu0": "持有股票，同时卖出与持股数量对应的看涨期权。一份对应100股的期权，需要100股股票覆盖。",
  "Zbk0SM": "按100买入股票，再以2卖出105看涨期权。到期盈亏平衡点为98；标的达到105或更高时，组合最多赚7。标的跌到零时，每股亏98。",
  "aL65fL": "权利金只能缓冲部分股票亏损。股票可能被交付给期权买方，也可能提前被指派。没有对应股票的卖出看涨期权不属于备兑。",
  "kM9nvG": "股票使组合的 Delta 为正；卖出的看涨期权降低 Delta，并带来负 Gamma、负 Vega 和通常为正的 Theta。",
  "vg4fnB": "应把股票和期权一起计算。仅有卖出看涨期权，不能证明持仓已有对应股票提供覆盖。",
  "B7+rau": "收取权利金，同时预留现金，以便被指派时买入标的。",
  "cLRBuo": "卖出一份看跌期权，并预留足够现金，能按行权价买入合约对应数量的标的。",
  "R/gQw3": "以2卖出95看跌期权，每单位标的预留95现金。到期最多赚2，盈亏平衡点为93；标的跌到零时，每单位亏93。",
  "BnF3Ta": "被指派时，买入价可能远高于市价。预留现金能保证履约，但不能避免亏损。",
  "VDPqUh": "卖出看跌的 Delta 为正，Gamma、Vega 为负，Theta 通常为正。股价急跌并伴随隐含波动率上升时，两种变化都可能不利。",
  "STkqoK": "只有实际预留了足额资金，才是现金担保。还需考虑被指派后持有股票的结果。",
  "e61oeW": "卖掉较高行权价以上的上涨收益，降低买入看涨期权的成本。",
  "LlJ2em": "买入较低行权价的看涨期权，卖出较高行权价的看涨期权，数量和到期日相同。",
  "lacWLV": "买入100看涨、卖出105看涨，净支出2。到期盈亏平衡点为102；标的达到105或更高时最多赚3，处于100或更低时最多亏2。",
  "U2SSlX": "两腿完整且到期日相同的情况下，到期最大亏损为净支出，最大盈利为行权价间距减去净支出。",
  "sKkxpW": "Delta 为正，上涨通常有利。两份期权的 Gamma、Theta、Vega 部分抵消，净值的正负会随股价位置变化。",
  "G2JUzO": "到期股价超过卖出看涨的行权价后，再上涨也不会增加盈利。若两份期权分别处理，指派可能留下股票持仓风险。",
  "3iob3p": "放弃较低行权价以下的额外下跌收益，降低买入看跌期权的成本。",
  "HPabQm": "买入较高行权价的看跌期权，卖出较低行权价的看跌期权，数量和到期日相同。",
  "GB3LJS": "买入100看跌、卖出95看跌，支出2。到期盈亏平衡点为98；标的处于95或更低时最多赚3，达到100或更高时最多亏2。",
  "mu5sM7": "组合保持完整时，到期最大亏损为净支出，最大盈利为行权价间距减去净支出。",
  "SKe32X": "Delta 为负，下跌通常有利。时间和波动率的影响部分抵消，净 Theta、Vega 取决于股价和剩余时间。",
  "O4ab51": "到期股价跌破卖出看跌的行权价后，再下跌也不会增加盈利。降低成本的代价是放弃这部分额外收益。",
  "wlWItf": "判断价格不会跌破某一区域，收取权利金，并用更低行权价的看跌期权限制亏损。",
  "cQo4qh": "卖出较高行权价的看跌期权，买入较低行权价的看跌期权，数量和到期日相同。",
  "nxbpAV": "卖出100看跌、买入95看跌，净收入2。到期盈亏平衡点为98；标的达到100或更高时最多赚2，处于95或更低时最多亏3。",
  "ZO4QNR": "到期最大亏损为行权价间距减去净收入。收到的权利金是最大盈利，不是风险上限。",
  "urNFVi": "Delta 为正，上涨通常有利。股价接近卖出看跌的行权价时，Theta 常为正、Gamma 常为负，但符号会随股价位置变化。",
  "PxjyoF": "较高的小赚概率，也可能对应较大的单次亏损。盈利金额、亏损金额和指派义务都需要看。",
  "qXLJbo": "判断价格不会涨破某一区域，收取权利金，并用更高行权价的看涨期权限制亏损。",
  "DtTi8N": "卖出较低行权价的看涨期权，买入较高行权价的看涨期权，数量和到期日相同。",
  "YPuvmQ": "卖出100看涨、买入105看涨，净收入2。到期盈亏平衡点为102；标的处于100或更低时最多赚2，达到105或更高时最多亏3。",
  "r6ub9G": "组合保持完整时，到期最大亏损为行权价间距减去净收入。单独平仓或行权其中一腿，会改变这个上限。",
  "OMKl/2": "Delta 为负。股价处于盈利区域时，时间流逝可能有利；股价上涨时，Gamma 可能让方向风险迅速变化。",
  "Zc92v8": "股价不一定要下跌：到期保持在卖出看涨的行权价以下，也可以盈利。回本价取决于实际收到的净权利金。",
  "o7Hfqc": "押注价格留在一个区间内，并在区间两侧买入保护。",
  "HETCGT": "标准卖出型：买入低行权价看跌，卖出较高行权价看跌，再卖出更高行权价看涨，买入最高行权价看涨。四腿到期日相同；全部反向就是买入型。",
  "d47Y66": "买入90看跌、卖出95看跌、卖出105看涨、买入110看涨，净收入2。到期价格在95至105之间最多赚2；跌到90以下或涨到110以上最多亏3。盈亏平衡点为93和107。",
  "389DqI": "两翼等宽时，到期最大亏损为翼宽减去净收入；不等宽时，须检查较宽的一侧。反向组合则在远离中间区间时盈利。",
  "R+4vCr": "卖出铁鹰在中间区域，Theta 通常为正，Gamma、Vega 通常为负。股价接近任一侧保护区时，Delta 会偏离零。",
  "Zi30VD": "中间区域平静，不代表风险小。急涨急跌或波动率上升，都可能在股价到达到期回本价之前造成持仓亏损。",
  "ABo40h": "将卖出期权的盈利集中在一个目标行权价附近。",
  "wbfcP1": "标准卖出型：在中间行权价同时卖出看涨和看跌期权，再买入更高的看涨和更低的看跌期权保护两侧。全部反向就是买入铁蝶。",
  "r9lyjn": "卖出100看涨和100看跌，买入95看跌和105看涨，净收入3。到期价格恰好为100时最多赚3；超出两翼时最多亏2。盈亏平衡点为97和103。",
  "1YnkEa": "两翼等宽时，到期最大亏损为翼宽减去净收入。最大盈利只出现在一个价格点，不是一整段区间。",
  "hOitYG": "卖出铁蝶在中间位置，Theta 通常为正，Gamma、Vega 通常为负。临近到期时，小幅股价变化也可能使 Delta 大幅变化。",
  "WaI2om": "理论上的最高盈利点，不代表容易按该价格平仓。交易费用、指派和中心附近的价格波动都会影响结果。",
  "WGk8eA": "用1∶2∶1组合，押注到期价格接近中间行权价。",
  "mBVJ3+": "买入蝶式：买入低、高行权价各一份，卖出中间行权价两份。全部使用看涨或全部使用看跌，到期日相同。两翼等宽时，盈亏图呈对称帐篷形。",
  "yl5UoK": "买入95看涨、卖出两份100看涨、买入105看涨，净支出1。到期价格为100时最多赚4；超出两翼时最多亏1。盈亏平衡点为96和104。",
  "Ow2Gjw": "买入等翼蝶式，最大亏损为净支出。将各腿反向就是卖出蝶式，其最大亏损集中在中间行权价。",
  "p7W9W8": "买入蝶式虽然需要付钱，但在中间位置，Theta 可能为正，Vega 可能为负。股价靠近或越过两侧行权价后，符号可能改变。",
  "Tcz8cA": "“买入”描述组合方向，不代表任何价位下 Gamma 都为正。应核对实际买卖方向和合约组合。",
  "FKIyan": "用不等宽的两翼，把更多风险移向一侧。",
  "9CoAPT": "ABG使用四腿：买入一份基准期权，分别在两个可调行权价卖出期权，再买入更远的一翼。两个卖出行权价重合时，就是常见的1∶2∶1破翼蝶式。",
  "t4ubMg": "买入100看涨，卖出105和110看涨，再买入118看涨，支出1。到期价格在105至110之间赚4；低于100时亏1，高于118时亏4。盈亏平衡点为101和114。",
  "UVtIHD": "两翼不等宽，两侧尾部亏损也不同。必须分别计算；开仓净支出不一定就是最大亏损。",
  "W/d7UO": "两侧风险不对称，Delta、Theta、Gamma 的分布也不对称。改变两份卖出期权的行权价，还会改变盈利区的形状和宽度。",
  "zJhQaG": "名称不能完全决定盈亏形状。本页采用四个行权价，需同时核对两个卖出价和两侧保护价，不能直接套用普通蝶式。",
  "uz3Bl8": "把蝶式的单点盈利目标，拓宽成一段到期盈利区间。",
  "8evuwR": "买入最低和最高行权价，卖出中间两个行权价，全部使用看涨或全部使用看跌，到期日相同。外侧两翼等宽时，两侧尾部亏损相等。",
  "Dvv3Oz": "买入90看涨，卖出95和105看涨，再买入110看涨，支出2。到期价格在95至105之间最多赚3；超出两翼时最多亏2。盈亏平衡点为92和108。",
  "/RZGMw": "外侧两翼等宽时，多头鹰式的到期最大亏损为净支出，最大盈利为一侧翼宽减去净支出。",
  "s5zIRd": "股价位于中间盈利区域时，临近到期的时间损耗可能有利。Delta、Gamma、Vega 会在各行权价附近变化。",
  "OTHV7l": "普通鹰式与铁鹰的图形可能相似，但使用的合约和初始收支不同，应看具体组合。",
  "VcZkvB": "反转同类期权鹰式，押注到期价格落在两翼之外。",
  "madbjF": "卖出最低和最高行权价，买入中间两个行权价，全部使用看涨或全部使用看跌，到期日相同。",
  "tKy6ze": "卖出90和110看涨，买入95和105看涨，净收入2。到期价格在外侧行权价之外时最多赚2；在95至105之间最多亏3。盈亏平衡点为92和108。",
  "vWq5iw": "中间区间是最大亏损区。两翼等宽时，最大亏损为一侧翼宽减去净收入。",
  "b3PzNI": "股价位于中间区域时，波动率上升通常有利，时间流逝通常不利。股价离开中间区域后，方向风险会变化。",
  "+8W6O6": "本页“空头鹰式”是反向的纯看涨或纯看跌鹰式；部分资料用同一名称指铁鹰，需核对实际组合。",
  "cOvaFW": "将裸卖看跌与看涨信用价差组合，收取权利金，承担不对称风险。",
  "DaHhnq": "标准型：卖出较低行权价的看跌，卖出较高行权价的看涨，再买入更高行权价的看涨。反向型使用裸卖看涨与看跌信用价差。",
  "ew6v10": "卖出95看跌和105看涨，买入110看涨，净收入6。到期价格在95至105之间最多赚6；高于110时赚1。下方盈亏平衡点为89，标的跌到零时亏89。",
  "unPQiD": "只有总净收入不小于看涨价差的宽度，标准型才没有到期上涨亏损。裸卖看跌仍有很大的下跌风险；反向型则有裸卖看涨的上涨风险。",
  "DFs++f": "常见方向在盈利区域内，Theta 通常为正，Gamma、Vega 通常为负；卖出的看跌期权使组合偏向看涨。",
  "hZ/YRQ": "例中的净收入是假设。只有实际净收入足够覆盖看涨价差的宽度，才能消除上涨端的到期亏损。",
  "QzI+F8": "买入数量多于卖出数量，押注某个方向出现大幅变动。",
  "N2tCaO": "看涨型：卖出一份较低行权价看涨，买入两份较高行权价看涨。看跌型：卖出一份较高行权价看跌，买入两份较低行权价看跌。",
  "Fh3p6J": "卖出100看涨，买入两份105看涨，净收入1。到期价格低于100时赚1，为105时最多亏4；盈亏平衡点为101和109。高于109后的上涨盈利无上限。",
  "y5W4eB": "价格小幅走向双倍买入的行权价，可能比不动更糟。看涨型上涨盈利无上限；看跌型的下跌盈利受标的零价格下限约束。",
  "ZrdbUt": "多买的期权可带来正 Gamma、正 Vega，但净风险随股价变化。时间流逝可能扩大买入行权价附近的亏损。",
  "ZnHdGB": "建仓收钱不代表没有风险。需要看清最容易亏损的价格区间，以及股价要移动多远才能离开该区间。",
  "OzTyY7": "卖出数量多于买入数量，押注适度变动，同时承担额外尾部风险。",
  "zRBntP": "看涨型：买入一份较低行权价看涨，卖出两份较高行权价看涨。看跌型：买入一份较高行权价看跌，卖出两份较低行权价看跌。",
  "KDwuId": "买入100看涨，卖出两份105看涨，净收入1。到期价格为105时最多赚6；高于111后开始亏损，上涨亏损无上限。处于100或更低时保留1的收入。",
  "tE3POI": "多卖出的一份看涨没有保护。看跌型在大跌时亏损扩大，只有标的跌到零才到达亏损上限。",
  "0wMsdG": "股价接近双份卖出的行权价时，Gamma、Vega 可能为负，Theta 可能为正。股价越过目标后，原本有利的方向可能转为不利。",
  "HH9xXM": "比例价差不一定有固定的最大亏损。除了行权价，还要看每个行权价上买卖了多少份。",
  "zx5Zt7": "押注适度上涨，用额外卖出的一份看涨期权补贴开仓成本。",
  "ss1E2b": "买入一份较低行权价看涨，卖出一份中间行权价看涨，再卖出一份较高行权价看涨，到期日相同。",
  "n9DlDT": "买入100看涨，卖出105和110看涨，净支出1。到期价格在105至110之间最多赚4。盈亏平衡点为101和114；高于114后，亏损可无限扩大。",
  "tIrl/a": "上涨尾部有一份未覆盖的卖出看涨。价格处于最低行权价或以下时，亏损等于净支出，但这不是最大亏损。",
  "p9SurY": "组合最初可能偏看涨，大涨后却变为看跌。两份卖出的看涨期权，常使较高行权价附近的 Gamma 为负。",
  "EYMTYl": "名称中的“牛市”不代表涨得越多越好。额外卖出的看涨期权，会使超过目标的大涨带来风险。",
  "ooMITQ": "卖出低行权价看涨、买入两份更高行权价看涨，在获得大涨收益前有一段亏损区。",
  "JIKYT4": "卖出一份较低行权价看涨，分别买入两个更高行权价的看涨各一份，到期日相同。",
  "FqvPpm": "卖出100看涨，买入105和110看涨，净收入1。到期价格在105至110之间最多亏4。盈亏平衡点为101和114；高于114后，上涨盈利无上限。",
  "HQR2pH": "主要到期亏损在中间区间。若开仓有净收入，它能保护价格较低的一侧，但不能保护两个买入行权价之间的亏损区。",
  "/axBar": "组合最初可能偏看跌，大涨后又变为看涨。Gamma、Vega 取决于三个行权价对应期权的相对影响。",
  "P71uFD": "名称只描述初始结构。行情不动或大幅上涨，都可能比中等幅度上涨的结果更好。",
  "IneWt/": "卖出高行权价看跌、买入两份更低行权价看跌，在获得大跌收益前有一段亏损区。",
  "DL6H0T": "卖出一份较高行权价看跌，分别买入两个更低行权价的看跌各一份，到期日相同。",
  "2q8JE4": "卖出100看跌，买入95和90看跌，净收入1。到期价格在90至95之间最多亏4。盈亏平衡点为99和86；标的跌到零时最多赚86。",
  "8nK0NZ": "适度下跌到买入行权价附近，可能造成最大亏损；跌得更深时，额外买入的看跌期权才发挥作用。",
  "8abvaa": "股价下跌时，方向风险可能从看涨转为看跌。时间和波动率的变化，会影响中间亏损区域和大幅下跌后的结果。",
  "JGL58P": "能应对暴跌，不代表任何跌幅都受保护。仍需看清会发生亏损的价格区间。",
  "PkyZG1": "押注适度下跌，同时额外卖出一份更低行权价的看跌期权。",
  "E1wJcP": "买入一份较高行权价看跌，分别卖出两个更低行权价的看跌各一份，到期日相同。",
  "rm4Htp": "买入100看跌，卖出95和90看跌，净支出1。到期价格在90至95之间最多赚4。盈亏平衡点为99和86；标的跌到零时亏86。",
  "JewXfd": "额外卖出的看跌带来较大的下跌风险。净支出只代表上涨一侧的尾部亏损，不是最大亏损。",
  "i2cejU": "组合最初可能偏看跌，大跌后却变为看涨。卖出看跌的行权价附近，负 Gamma 可能加快这种变化。",
  "Us2nh6": "名称中的“熊市”不代表跌得越多越好。额外卖出的看跌期权，会改变跌破较低目标后的盈亏方向。",
  "l5KxAv": "将看涨与看跌组合，形成近似线性的方向敞口。",
  "FkOmjZ": "合成多头：买入看涨、卖出看跌，行权价和到期日相同。合成空头：两腿全部反向。",
  "0R6U3t": "买入100看涨，卖出100看跌，净支出1。到期盈亏＝标的价格－101。标的为110时赚9，跌到零时亏101。两腿反向，盈亏也反向。",
  "MaeEWP": "很低的净权利金，可能掩盖类似持股的风险。多头型下跌亏损很大，空头型上涨亏损无上限。",
  "9vMTuP": "在理想的同一行权价欧式模型中，看涨与看跌的 Gamma、Vega 相互抵消，Delta 每单位接近 +1 或 −1。融资、分红和行权方式仍会影响结果。",
  "Yxbi+Z": "“合成”不代表风险低，也不代表操作和期货完全相同。两份期权各有自己的结算义务。",
  "gzmEWL": "用不同的看涨、看跌行权价表达方向判断，中间保留一段平坦区间。",
  "qCkWEu": "多头组合：买入价外看涨、卖出价外看跌。空头组合：两腿反向，到期日相同。",
  "SWWeis": "买入105看涨，卖出95看跌，净支出1。到期价格在95至105之间亏1。盈亏平衡点为106，上涨盈利无上限，标的跌到零时亏96。",
  "lpvx7T": "多头组合中卖出的看跌带来大跌风险。两腿反向后，卖出的看涨没有覆盖，上涨亏损无上限。",
  "1bpbOC": "与同一行权价的合成持仓不同，这两份期权的 Gamma、Vega 通常不能完全抵消。股价接近任一行权价时，净风险会变化。",
  "GquDRZ": "两个行权价之间的间隔，使它不同于股票或同一行权价的合成持仓。回本价还需要计入初始收支。",
  "LPmAJ0": "围绕同一行权价，押注价格变动幅度，而不只判断涨跌方向。",
  "Gx43kE": "买入跨式：买入相同行权价、相同到期日的看涨与看跌各一份。卖出跨式：同时卖出两份。ABG默认使用卖出型。",
  "tRzqcg": "买入型例子：买入100看涨和100看跌，合计支出6。到期价格为100时最多亏6，盈亏平衡点为94和106。标的为112时赚6；同时卖出则盈亏反向。",
  "kf2Pu5": "买入跨式最多亏掉权利金。卖出跨式的最大盈利为净收入，上涨亏损无上限，下跌亏损也可能很大。",
  "TgISMx": "买入跨式的 Gamma、Vega 为正，Theta 通常为负；卖出时符号相反。Delta 接近零，并不代表没有波动风险。",
  "gA0yoL": "",
  "uLPhJ+": "拉开看涨与看跌的行权价，改变成本和盈亏平衡所需的价格变动。",
  "/dM/z9": "买入型：买入较低行权价看跌和较高行权价看涨，到期日相同。卖出型：同时卖出两份。ABG默认使用卖出型。",
  "VJ35oN": "买入95看跌和105看涨，合计支出4。到期价格在95至105之间最多亏4，盈亏平衡点为91和109。卖出两份则在中间保留4的收入，但两侧都有尾部风险。",
  "WbMNt/": "买入型最多亏掉全部权利金。卖出型上涨亏损无上限，下跌亏损也可能很大。",
  "ywQ5mP": "买入宽跨式的 Gamma、Vega 为正，Theta 通常为负。相较类似跨式，行权价更远通常成本更低，但需要更大幅度的股价变化才能回本。",
  "Co1Z0D": "卖方的盈利区间更宽，不代表两端亏损有上限。较远的行权价还可能较难成交。",
  "bP3q2B": "买入双向波动收益，同时偏重下跌方向。",
  "7dBTyv": "买入一份看涨、两份看跌，行权价和到期日相同。",
  "63DRck": "买入一份100看涨和两份100看跌，合计支出9。到期价格为100时最多亏9，盈亏平衡点为95.5和109。标的为90时赚11，为110时赚1。",
  "qPGnha": "三份买入期权可能亏掉全部权利金。上涨盈利无上限，下跌盈利受标的零价格下限约束。",
  "0zPh/b": "三份买入期权带来正 Gamma、正 Vega。多一份看跌使组合更偏向下跌，同时更高的总权利金通常增加时间损耗。",
  "hfk04Z": "它不只是更便宜的看跌交易。额外买入期权增加了成本，也增加了回本所需的股价变动。",
  "DM7Wu3": "买入双向波动收益，同时偏重上涨方向。",
  "N8XJwe": "买入两份看涨、一份看跌，行权价和到期日相同。",
  "VzG2yu": "买入两份100看涨和一份100看跌，合计支出9。到期价格为100时最多亏9，盈亏平衡点为91和104.5。标的为110时赚11，为90时赚1。",
  "dCISfA": "到期价格接近共同的行权价时，可能亏掉全部权利金。上涨盈利无上限，下跌盈利在标的跌到零时达到上限。",
  "aruSUY": "买入期权带来正 Gamma、正 Vega。额外的看涨期权使组合偏向上涨，Theta 通常为负。",
  "PnssQl": "需要同时比较额外上涨收益和额外权利金。买卖数量的不对称，与共同行权价一样重要。",
  "50hD5f": "组合一份价内看涨和一份价内看跌，开仓价格中已包含内在价值。",
  "j0QtT0": "买入型：买入较低行权价看涨和较高行权价看跌，到期日相同。卖出型：同时卖出两份。两份期权的价内区间重叠。",
  "OMRUwt": "买入95看涨和105看跌，合计支出13。到期价格在两行权价之间时，组合最低价值为10，因此最多亏3。盈亏平衡点为92和108；标的为110时赚2。",
  "PueJci": "买入型到期最大亏损为净支出减去行权价间距。卖出型上涨亏损无上限，下跌风险也很大。",
  "N1VyN7": "买入方向的 Gamma、Vega 为正，Theta 通常为负。较高的权利金含有内在价值，不能全部当作可能损耗的时间价值。",
  "/OAOqN": "卖出的价内期权可能被提前指派。买入方向的两个行权价之间有固定差额，因此最大亏损小于支付的总权利金。",
  "aMFcQo": "利用近期与远期期权价值变化的差异。",
  "5OI/pV": "卖出近期到期的期权，买入同类型的远期期权。行权价相同是日历价差，不同则是对角价差。ABG的偏斜参数可以移动远期行权价。",
  "UlS9lO": "以2卖出近期100看涨，以5买入远期100看涨，净支出3。首次到期时，若标的为100，卖出腿的内在价值为零；若剩余看涨此时值4，组合赚1。剩余期权的价值并非预先确定。",
  "2kQ/QB": "常规同一行权价的买入日历价差，作为完整价差管理时，风险通常为净支出。但首次到期的最大盈利和盈亏平衡点并不固定；对角价差和指派风险须另行分析。",
  "S4dyyz": "买入日历价差在行权价附近，Vega、Theta 常为正，但仍取决于股价和两个到期日各自的隐含波动率；两者未必同步变化。",
  "2he0U8": "近期到期时，远期期权仍有剩余时间价值。不能把两份期权都按到期归零计算，还需考虑剩余价值及指派后可能出现的股票持仓。",
  "xldPBp": "在两个不同的目标价格附近，各放置一组时间价差。",
  "6pOg5D": "卖出近期看跌和看涨，并买入对应的远期期权。每对行权价相同，就是双日历价差；移动远期行权价，则形成双对角价差。",
  "bihyAJ": "在看跌行权价95、看涨行权价105分别建立日历价差，合计支出4。首次到期时，若卖出腿归零、远期期权合计值5，则赚1。剩余期权价值不同，结果也不同。",
  "w3ZEPW": "首次到期的最大盈利和盈亏平衡点，取决于剩余期权的价值。各腿分别被指派、行权价偏移或单独处理各腿，都可能带来超出简单净支出估算的风险。",
  "LCNv95": "两组时间价差将风险分布在两个行权价附近，但 Theta 并非处处为正。近远期波动率、行权价差异和超出目标的股价变化都会影响结果。",
  "//100j": "图上有两个盈利峰，不代表整个区间都能盈利。需分别看两个到期日，以及近期合约结算后还剩什么持仓。",
  "UbB/KS": "从单独的期权腿构建盈亏，而不依赖策略名称。",
  "9r06tj": "逐腿选择看涨或看跌、买入或卖出、数量、行权价和到期日。将全部期权及股票持仓的价值按方向相加，再计入开仓现金流。",
  "7e2ouY": "同一到期日，买入一份100看涨、卖出一份105看涨，净支出2，就构成牛市看涨价差：最大亏损2，最大盈利3，到期盈亏平衡点为102。",
  "JBz+kx": "自定义组合没有统一的最大亏损。额外卖出数量、不同到期日或停用保护腿，都可能让有限亏损变成未受保护的尾部风险。",
  "I0BU4G": "组合希腊值需要按数量和买卖方向相加。Delta 较小，不代表 Gamma、Theta、Vega 也小；市场变化后，原有抵消可能消失。",
  "DXFbWj": "应先核对参与组合的合约及数量。即使名称或图形熟悉，修改后的组合也可能与原来的策略不同。",
  "4bqjIU": "",
  "Tgo9+/": "",
  "XWgDwK": "",
  "t2vEex": "",
  "0WEvae": "",
  "0GLWeP": "",
  "lWVgwX": "期权价值",
  "VzAcve": "",
  "8PqlkR": "",
  "a7wlKq": "",
  "n//2Ig": "",
  "y8xGL8": "了解 {greek}",
  "cQgyKS": "完整讲解",
  "KqIZhj": "",
  "KV+O0y": "练习",
  "oaxd6l": "",
  "VqRNsA": "学习栏目",
  "+EhIrw": "练习主题",
  "V4mLb8": "全部主题",
  "yoo4hj": "正在加载练习…",
  "EvBEFF": "",
  "mQtyow": "",
  "rT/Blv": "",
  "sJgi7E": "",
  "3RqjzB": "",
  "lBO+mc": "怎么组成",
  "4U6SDb": "",
  "qL5sIC": "",
  "bdDoH7": "",
  "fLRF1S": "",
  "LAzUYg": "",
  "/L4u95": "",
  "5eZQtm": "",
  "XV8feW": "",
  "E7KLhm": "",
  "ufxDe1": "",
  "aKVz1J": "",
  "4xtgTx": "策略讲解",
  "l9EhxQ": "学习期权基础、希腊值和策略原理，再通过练习巩固。",
  "7jQMlt": "策略讲解",
  "N04Qbk": "",
  "J9rYXa": "",
  "Ovw9as": "较晚到期",
  "eW2nXZ": "较早到期",
  "Uy/ngw": "",
  "PrQaZD": "",
  "fiXytS": "到期时标的价格",
  "YVjNS+": "",
  "PItgQo": "",
  "0pZxwl": "该主题暂无题目",
  "KxXYNo": "当前题目已完成。可以复习，或选择其他主题。",
  "DELZc+": "当前范围暂无题目，请选择其他主题或难度。",
  "OBUa70": "选择练习",
  "vBWmSA": "复习已掌握的题目",
  "BXcWnh": "",
  "PA0H1e": "",
  "OV4nnq": "",
  "THFYhZ": "",
  "KsYMaJ": "",
  "7Jycsl": "",
  "ibclZ4": "",
  "VAOcMk": "",
  "S/sBb2": "",
  "CnZsqk": "",
  "gsuLMm": "",
  "k02xvB": "",
  "5obZZq": "",
  "WAy9Pb": "",
  "Ml4GTV": "",
  "z1a0A6": "",
  "LYwANe": "",
  "veu1zk": "",
  "uqnKvn": "",
  "c+FzY/": "",
  "6mgXRp": "",
  "3HNYQm": "",
  "c21AGD": "",
  "2/ox9m": "",
  "X6UpkC": "",
  "t/vPLd": "",
  "J1D0Dm": "",
  "RuRaM7": "",
  "BhOaq4": "",
  "JqqV7H": "",
  "dJ5o0A": "",
  "7gEq6g": "",
  "Iyy7ck": "",
  "ENzd9t": "",
  "RLeIue": "",
  "l7NXnF": "",
  "XaBr/Q": "",
  "HEE9sj": "",
  "XLBhOP": "",
  "AB80Hw": "",
  "UI79fv": "",
  "kKNriT": "",
  "leJigO": "",
  "1UzD2q": "",
  "CI0hLS": "",
  "21hxsO": "",
  "n6YkrM": "",
  "lpx7z4": "",
  "WXNaqV": "看涨期权给你买入的权利，看跌期权给你卖出的权利。买方付钱获得选择权，卖方收钱承担履约义务。",
  "tTxuro": "花3买入按100买入标的的权利。到期时标的价格为110，这项权利值10：每单位盈利＝10－3＝7，未计费用。",
  "44y5By": "买方可能亏掉全部权利金；卖方的亏损可能远超收到的权利金。",
  "qTSdtP": "行权价是合约约定的买卖价格；到期日是这项权利终止的日期。",
  "DJwDMa": "花5买入行权价为100的看涨期权。到期时标的价格为102，期权值2，每单位亏3，未计费用。价格到105才盈亏平衡。",
  "hN8Ptz": "看对方向还不够。价格需要在到期前走到位，并覆盖买入成本。",
  "pdzl9f": "权利金就是期权的价格：当前行权的价值，加上剩余时间带来的额外价值。",
  "7J7sd4": "标的价格为103，行权价为100的看涨期权卖5。其中内在价值为3，额外的2是时间价值。到期时标的仍为103，期权就只值3。",
  "UIc/D0": "标的价格不变，期权价格也可能变化。时间价值在到期时归零。",
  "tmX8Q6": "到期盈亏＝持仓到期价值－买入时的净支出，或加上开仓时的净收入。",
  "HNkTm0": "买入100看涨期权、卖出105看涨期权，合计支出2。到期时：标的价格为100，亏2；为102，盈亏平衡；为105或更高，赚3。均按每单位计算，未计费用。",
  "KMGp3F": "到期盈亏不等于现在的持仓价值。每单位金额还要乘以合约乘数和数量。",
  "S0Z+x6": "卖出期权就承担了履约义务；被指派，意味着卖方需要履行这项义务。",
  "gN+mLS": "卖出行权价为100、以股票交割的看跌期权。若标的跌到70时被指派，你仍须按100买入，每股价差亏30，尚未计入权利金和费用。",
  "cTMnIH": "保证金不是最大亏损。还要确认合约是股票交割，还是现金结算。",
  "akZ80T": "例中金额均按每单位标的计算，未计费用。",
  "4G8vdH": "",
  "8xgvHN": "希腊值表示期权对不同因素变化的敏感度。以下均假设其他因素不变；Gamma衡量的是Delta的变化。",
  "ST8IDo": "例：Delta为＋0.50，标的涨1，期权每单位价值约增加0.50。",
  "SIZXyl": "例：Delta为0.50、Gamma为0.04。标的涨1后，Delta约为0.54，这是新的Delta，不是盈利。",
  "NB50AF": "例：Theta为－0.08，过去一天，期权每单位价值约减少0.08。",
  "vyqzYR": "例：Vega为0.12，隐含波动率从20%升到21%，即上升1个百分点，期权每单位价值约增加0.12。",
  "jigGk3": "例：Rho为0.04，利率从4%升到5%，期权每单位价值约增加0.04。",
  "9gDH72": "各主题答题表现图",
  "Y59dAk": "看涨期权：给你买入的权利。\n看跌期权：给你卖出的权利。\n买方：付钱，获得选择权。\n卖方：收钱，承担履约义务。",
  "60sOVb": "行权价：合约约定的买卖价格。\n到期日：这项权利终止的日期。",
  "6PqMEg": "以股票交割合约为例：买方付权利金获得权利；卖方收权利金，被指派时须履约。",
  "zX8mxy": "期权买卖双方的权利与义务",
  "6fpLnn": "期权",
  "+tCOWZ": "买方的权利",
  "VgY0qi": "卖方被指派时",
  "M6msls": "按约定价买入",
  "KfnBTY": "按约定价卖出",
  "fbpcKJ": "行权价是约定的买卖价格；到期日是权利终止的日期。",
  "U6qM8/": "以下用同一个例子：花 3 买入看涨期权，行权价 100，30 天后到期。",
  "Y+QOjo": "行权价",
  "GYkWVG": "约定的买入价格",
  "YjvJn3": "到期日",
  "RP3hYa": "30 天后",
  "2eCe/p": "这项权利到期",
  "hTgCxK": "到期时，时间价值归零。",
  "t09Ouk": "买入时，标的价格也为 100，立即行权没有价差。",
  "RE3ors": "权利金的组成",
  "8WlOCe": "金额均按每单位标的计算，未计费用；实际金额还要乘以合约乘数和数量。",
  "imMkmn": "到期时标的涨到 110，期权价值就是 110 − 100 = 10。",
  "OpxkQd": "到期盈利计算",
  "ecS8Dj": "到期期权价值",
  "dl1keI": "已付权利金",
  "IL4Qg4": "同一期权在不同到期价格下的盈亏",
  "0h1Wff": "到期标的价格",
  "qLHsyu": "买方盈亏",
  "zfp8hv": "盈亏平衡：100 + 3 = 103。只涨到 102，仍然亏 1。",
  "Nhyb/n": "",
  "x6ZRnG": "这份看涨期权的最大亏损",
  "Mjayw+": "买方最多亏",
  "sM3cVf": "裸卖看涨最多亏",
  "4AyL7g": "没有上限",
  "skb8c+": "同一个例子，到期标的价格为 110 时，买方赚 7，卖方就亏 7。",
  "/Xpuju": "被指派就是需要履约：股票合约按行权价交割股票；现金合约支付结算金额。",
  "pfxoQZ": "例",
  "MS7D8w": "希腊值表示期权对不同因素变化的敏感度。以下均假设其他因素不变。",
  "q8GYfK": "跟涨跌的力度：标的动一点，期权跟着动多少。",
  "3aw3iz": "看涨：标的远高于行权价时，跟涨跌更紧；远低于时，反应更弱。\n买入看跌则与标的反向变化。",
  "x7eKRk": "Delta 的加速器：标的价格变动时，跟涨跌的力度也跟着变。",
  "9C7XNZ": "通常，接近行权价、又快到期时，Delta 变得最急。\n远离行权价时，变化较缓。",
  "T3TSr7": "时间损耗的速度：过一天，买入的期权通常会损失多少价值。",
  "vihVVD": "接近行权价时，越临近到期，每天损耗通常越快。\n远离行权价时，每天损耗的金额往往较小。",
  "E/ooga": "波动预期的音量钮：预期涨跌越剧烈，普通期权通常越贵。",
  "pix5zF": "同样的波动预期变化，Vega 越大，价格反应越大。\n离到期越远，通常越敏感；临近到期，通常越弱。",
  "ykjiCT": "利率敏感度：利率动一点，期权价格受多大影响。",
  "aLORUc": "利率上升：看涨通常变贵，看跌通常变便宜。\n离到期越远，影响通常越大；快到期时较小。",
  "mmF3Pf": "价格变化的幅度：股票涨 1 元，期权价格大约涨或跌多少元。",
  "7zH6LI": "同样的股价涨跌，看涨期权在股价远高于行权价时，价格变化较大；远低于时，变化较小。\n看跌：股价涨，期权价格通常跌；股价跌，期权价格通常涨。",
  "g2zyYf": "Delta 的加速器：股价变动时，Delta 本身会变多少。",
  "0FgqMs": "对波动预期的敏感程度：市场预期股价波动变大时，普通期权价格通常会上涨。",
  "OslHg3": "价格变化的幅度。",
  "gxb72O": "比如 Delta＝0.5，其他条件不变时：",
  "EidxI5": "股票涨",
  "8Ez65Z": "1 元",
  "oGkLU3": "期权价格大约涨",
  "e51EAt": "0.5 元",
  "BtE1qb": "看涨：同样的股价涨跌，股价远高于行权价时，期权价格变化较大；远低于时，变化较小。\n看跌：股价涨，期权通常跌；股价跌，期权通常涨。",
  "WS8064": "Delta 的加速器",
  "wugPXb": "时间损耗的速度",
  "AW8s1f": "对波动预期的敏感程度",
  "PaEsdS": "预期波动变大，普通期权通常变贵；同样的波动预期变化，Vega 越大，价格变化越大。\n离到期越远，通常越敏感；临近到期时较弱。",
  "eXKj0T": "利率敏感度",
  "devz9w": "比如 Delta＝0.5、Gamma＝0.04，其他条件不变时：",
  "osrPrr": "Delta 大约变为",
  "kGQ3oZ": "0.54",
  "4voegA": "比如 Theta＝−0.08，其他条件不变时：",
  "9DzSVK": "时间过去",
  "uDMPDT": "期权价格大约跌",
  "eHPr4L": "0.08 元",
  "zIRb1e": "比如 Vega＝0.12，其他条件不变时：",
  "CKLcxn": "隐含波动率上升",
  "D8Wqtt": "20% → 21%",
  "5bJ+Jx": "0.12 元",
  "pbDpUK": "比如 Rho＝0.04，其他条件不变时：",
  "dP+85H": "利率上升",
  "gZm9JC": "4% → 5%",
  "C7rvyQ": "0.04 元",
  "BDfESy": "价格变化的幅度",
  "XadlV3": "以上是近似估算。期权价格按每股计算，整张合约需乘以合约乘数。",
  "jv7cwP": "接近行权价、又临近到期时，同样的股价变化通常让 Delta 变化更大。\n远离行权价时，Delta 的变化通常较小。",
  "ZP3/iH": "标的价格每上涨 1，Delta 大约变多少。",
  "me0X6x": "买入期权通常会随时间贬值。接近行权价时，越临近到期，每天损耗通常越快。\n远离行权价时，日损耗金额往往较小。每天损耗并非固定不变。",
  "87Hjz3": "定价使用的无风险利率上升 1 个百分点，期权价值大约变多少。",
  "lA9OPP": "希腊值表示期权对不同因素变化的敏感度。以下以普通股票期权为例，其他定价条件不变。",
  "Mk3Iy7": "买入与卖出：同一期权、相同数量，卖出持仓的希腊值正负号与买入相反。",
  "NzZoeS": "多个因素会同时变化：即使股价上涨，看涨期权也可能因时间损耗或隐含波动率下降的影响更大而跌价。",
  "BwnwWr": "理论上无上限",
  "1ZSRb3": "买入标的，价格",
  "+M7CqF": "所有期权的到期日相同。",
  "9HBUv2": "期权净收入",
  "bGbPPs": "期权净支出",
  "1T7PlY": "初始总支出",
  "ngoOEX": "到期回本价",
  "ZdOaAg": "到期最多赚",
  "PjOosS": "到期最多亏",
  "Xy6kv5": "假设近期到期时，卖出的期权价值归零，剩余期权合计价值为",
  "tYW8sC": "持仓盈利",
  "/OddsD": "剩余价值只是示例假设。近期到期时的最大盈利和回本价取决于剩余期权的价值。",
  "1NTfJP": "支付权利金，买入一份看涨期权。",
  "0jTBSK": "预期股价在到期前上涨，用有限成本参与上涨。",
  "8gDIe8": "最多亏掉全部权利金，盈利理论上没有上限。",
  "IyaEgY": "股价上涨、隐含波动率上升通常有利。\n其他条件不变时，时间流逝通常不利。",
  "uPBmvR": "看对上涨方向也可能亏钱。回本价指到期时；提前卖出的盈亏还受剩余时间和隐含波动率影响。持有至到期需留意自动行权。",
  "jNSorb": "支付权利金，买入一份看跌期权。",
  "lKVEtl": "预期股价在到期前下跌，或为已持有的股票提供下跌保护。",
  "Gc747z": "最多亏掉全部权利金。股价到期跌至零时，盈利最大，为行权价减去权利金。",
  "bIljXn": "股价下跌、隐含波动率上升通常有利。\n其他条件不变时，时间流逝通常不利。",
  "24hlLf": "小幅下跌可能不足以弥补买入成本和时间损耗。回本价只针对到期；提前卖出的价格还受其他因素影响。持有至到期需留意自动行权。",
  "b5YD3k": "卖出一份看涨期权，没有对应股票或其他期权提供保护。",
  "yLW76h": "预期到期股价不超过行权价，从而保留收到的权利金。",
  "TVMAmL": "最多赚收到的权利金。股价持续上涨时，亏损理论上没有上限。",
  "qsF360": "股价上涨、隐含波动率上升通常不利。\n其他条件不变时，时间流逝通常有利。",
  "uGtd+R": "收到权利金不等于已经赚钱。美式期权可能被提前指派，产生交付股票的义务；所需保证金也可能增加。",
  "bSYvdv": "卖出一份看跌期权，被指派时承担按行权价买入标的的义务。",
  "n5QwNC": "预期到期股价不低于行权价，从而保留收到的权利金。",
  "vlCgJW": "最多赚收到的权利金。股价跌至零时，每单位标的最多亏行权价减去权利金。",
  "5SdyRu": "股价下跌、隐含波动率上升通常不利。\n其他条件不变时，时间流逝通常有利。",
  "kNOKbq": "被指派时，可能需要以远高于市价的价格买入股票。保证金不是最大亏损；预留足额买入资金，才是现金担保。",
  "pqVS1c": "买入看涨期权",
  "9zkYCX": "裸卖看涨期权",
  "iQ+lPX": "买入看跌期权",
  "qCdQEA": "卖出看跌期权",
  "MNk85U": "1. 是什么",
  "6zTvRE": "2. 为什么用",
  "vWT1rl": "3. 怎么算",
  "4dMChc": "4. 怎么变化",
  "WDvESB": "5. 风险与易误解之处",
  "f1ysks": "例中价格为教学假设，金额按每单位标的计算，未计费用；整张合约需乘以合约乘数。到期盈亏以示例组合完整为前提，提前平仓或行权、指派后的结果可能不同。",
  "s77/wt": "股价大幅变化也不保证买方盈利，还需要覆盖权利金，并考虑隐含波动率下降的影响。应核对实际买卖方向是否与示例一致。",
  "BlCV+X": "卖出近期到期的期权，买入同类型的远期期权。行权价相同是日历价差，不同则是对角价差。",
  "rwDBoG": "最多亏：支付的全部权利金。\n最多赚：理论上没有上限，因为股价没有固定的上涨上限。",
  "b1xc2R": "其他条件不变，标的每上涨 1 个价格单位，期权每单位价值约变化 Delta：正数为涨，负数为跌。",
  "HelADF": "在其他条件不变时，股票每涨",
  "5ugQQF": "：",
  "QOjuw7": "Delta＝",
  "eW015n": "，期权价格约涨",
  "sW5YQu": "−0.5",
  "5l4WKl": "，期权价格约跌",
  "Hwl7Hv": "正数为涨，负数为跌",
  "JUfWg+": "在其他条件不变时，Delta 原为 0.5，股票每涨",
  "Cf1wf1": "Gamma＝",
  "0DBLpk": "，Delta 约变为",
  "9Tfhlv": "股价上涨时，正 Gamma 让 Delta 增大，负 Gamma 让 Delta 减小",
  "yc9yHQ": "在其他条件不变时，时间过去",
  "OPEbqF": "Theta＝",
  "USw6Qj": "，持仓每股价值约减少",
  "u5n2eD": "，持仓每股价值约增加",
  "HTqXwB": "负数表示时间损耗，正数表示时间流逝对持仓有利",
  "LKD/8v": "在其他条件不变时，隐含波动率从 20% 升至 21%，即上涨",
  "z5qjdP": "1 个百分点",
  "MKXMYj": "Vega＝",
  "Dvdctb": "正数受益于隐含波动率上涨，负数受益于下降",
  "pnvbub": "在其他条件不变时，无风险利率从 4% 升至 5%，即上涨",
  "VAlW65": "Rho＝",
  "IE6v1q": "正数受益于利率上涨，负数受益于下降",
  "Rj0Sd6": "数据日期：{date}（美东）",
  "/VQpyO": "{date}到期",
  "Fb02M5": "暂无有效平值 IV",
  "9M96QK": "交易中",
  "q2GeJ7": "盘前",
  "xlwRpL": "盘后",
  "pYDJi3": "休市",
  "pizY2a": "交易状态",
  "7tqSOi": "{ticker}：{date}（美东）",
  "0O2BkM": "ATM IV：{date}（美东）",
  "yefR6Y": "ATM IV 到期：{date}",
  "WVr1QB": "推广链接",
  "rwb0M0": "添加渠道链接",
  "XNrWgU": "链接可重复使用。需要分别统计不同平台或活动时，再添加专属链接。",
  "LAWbIE": "请分享对应渠道的链接或分享卡。通用二维码不区分渠道；链接转发后仍计入原渠道。",
  "OROnnO": "使用人数不等于访问或扫码次数。付费人数与佣金不计入已退款订单。",
  "Z1xMl5": "未命名渠道",
  "ySey5M": "不限使用次数",
  "rCQZuH": "使用上限：{count} 人",
  "94YT0b": "",
  "1D1CET": "",
  "j83w0v": "重命名渠道",
  "/xYsBJ": "渠道名称",
  "jYZep+": "例如：小红书主页、X 简介",
  "XwJ+oH": "使用人数",
  "zzLV/+": "付费人数",
  "pP1R8y": "功能分栏",
  "TkYZBT": "客户",
  "ujG2R1": "推广",
  "B+uzbw": "订单与佣金",
  "glTTlD": "后台导航",
  "VNMoVv": "掌握运营情况，优先处理待办事项。",
  "MUUNrD": "了解每位客户的会员状态、来源与下一步跟进。",
  "EQelVe": "查看创作者与推广渠道带来的客户和转化。",
  "Hh+1AP": "集中查看订单、退款与创作者佣金。",
  "OJNUL8": "统一管理书库、题库与社交内容发布。",
  "Vf8WU1": "查看操作记录，管理后台访问权限。",
  "m6lDC9": "运营管理",
  "GU7MQx": "返回产品",
  "mbVtNk": "产品分析",
  "k26pcw": "跟进待办",
  "u3lsRD": "会员周期",
  "NAidKb": "通知",
  "8pSzl8": "创作者与渠道",
  "MDjCOx": "推荐码",
  "X7jl6w": "订单",
  "Qcar/2": "佣金结算",
  "2YjM5/": "社交发布",
  "t0lUqz": "操作记录",
  "n2haU6": "客户、收入与待办，一眼掌握。",
  "Tk/BFR": "新增客户",
  "u1zcPD": "已注册账户",
  "9fFUJh": "已完成的付款",
  "DzzxOZ": "不含已退款订单",
  "ud+HGc": "按活跃客户去重统计",
  "J8cAGG": "待处理",
  "U2ovSU": "点击进入处理",
  "A0hXXD": "客户跟进",
  "m8DyqM": "沟通记录、跟进时间与下一步行动",
  "+wzGTM": "待结算创作者",
  "eGKhde": "会员续费跟进",
  "f5haIV": "查看即将到期与近期注册的客户",
  "nz0okQ": "客户概况",
  "/Tv1tX": "每日变化",
  "hILBnf": "点击查看客户档案",
  "TeM9UL": "打开客户档案，即可添加沟通备注并安排下一次跟进。",
  "H62Zq/": "{count} 项已逾期",
  "Vqhn1a": "备注或下一步行动",
  "LNdZab": "记录沟通内容，以及下一步需要处理的事项。",
  "1TVtQr": "跟进时间（可选）",
  "KASrlC": "设置时间后会加入跟进待办。保存备注不会向客户发送消息。",
  "mFRqx3": "保存备注",
  "9AanEp": "暂无跟进或备注",
  "SRJo9I": "标记完成",
  "j7sRXm": "按当前筛选统计",
  "vQt5XU": "订单记录",
  "+VcRi3": "搜索订单",
  "HZUgIf": "搜索邮箱或订单编号",
  "6D+yYX": "付款状态",
  "fvK8Qi": "全部状态",
  "iLe1MK": "没有符合条件的订单",
  "hkENym": "客户",
  "qNTqBe": "查看客户",
  "qxrDKi": "创作者佣金",
  "Bts3K2": "仅看待结算",
  "PPO9Jt": "佣金不含已退款订单。点击创作者可查看打款记录并登记结算。",
  "qhXbDi": "暂无待结佣金",
  "LUrJwE": "推广渠道",
  "UW3ZZn": "通用二维码",
  "m/jplS": "备注与跟进",
  "xh2pgL": "客户档案",
  "9vPzIO": "累计实付",
  "5O2wWW": "获客来源",
  "NHzoVK": "未记录推荐来源",
  "yIuROp": "待结佣金",
  "D1+T5B": "{name} 浏览了{page}",
  "P+gUTH": "页面",
  "aZ5Y8/": "系统事件",
  "e9uDQ/": "技术详情",
  "EwRIOm": "用户",
  "WqRRne": "事件数量趋势",
  "82gNYF": "事件类型",
  "+NmCFj": "页面浏览",
  "Z3EDd9": "登录会话",
  "TzhzIH": "创作者",
  "f+sh2j": "后台操作",
  "rMu3el": "已保存策略",
  "HtN6s8": "日志记录",
  "ofHC1Q": "数据导入",
  "UAJe/C": "功能操作",
  "L75jXl": "购买页",
  "77MbQy": "登录",
  "lbpe3v": "退出登录",
  "KQvWvD": "已删除",
  "NZ3zNR": "访问",
  "bhEK7m": "更新客户信息",
  "zqD/ym": "删除客户",
  "ZH86SI": "邀请客户",
  "X/n0XY": "发送登录邮件",
  "nZCsq4": "添加客户跟进",
  "SJl0MA": "更新客户跟进",
  "LH4hW1": "显示 {total} 条中的 {shown} 条记录",
  "0OBzsv": "暂无创作者",
  "kyCLGJ": "注册时间",
  "7sujJr": "付费转化",
  "M1w9up": "待付款",
  "qrkQuq": "该渠道的客户",
  "ljxw1z": "全部客户",
  "4GbUB6": "这里列出使用过该推广码的客户。打开客户档案，可查看付款记录并添加跟进。",
  "B8Sffs": "返回创作者",
  "bVjFta": "搜索客户",
  "RYhDwR": "搜索姓名或邮箱",
  "M/IYmR": "仅看通过该渠道付费的客户",
  "t7oXQZ": "{count} 位客户",
  "gk/lxB": "没有符合筛选条件的客户",
  "h/0Uuh": "查看渠道客户",
  "6uJSpm": "该客户的订单",
  "lNZuWl": "全部订单",
  "uJxidV": "查看该客户全部订单",
  "y+W1RE": "请记录已经完成的转账，此操作不会自动汇款。",
  "HOtWVl": "记录创作者打款",
  "wbtiQC": "PayPal",
  "mtIIl7": "银行转账",
  "3yNuzn": "支付宝",
  "50PPGB": "上涨时有利",
  "N+X4BT": "上涨时不利",
  "Eq+YDY": "下跌时有利",
  "U9gFEK": "下跌时不利",
  "rX4Xug": "仅说明价格方向对单腿的影响，整体盈亏需结合成本与其他腿判断。",
  "rera5g": "调整现价、行权价、剩余天数和 IV，观察曲线变化。",
  "CoL84c": "上涨 {percent}%",
  "1nu76R": "下跌 {percent}%",
  "OPM0Uk": "持平 0.00%",
  "qV8zK8": "模拟当前价",
  "3oAPV2": "到期最大获利",
  "ppwkqZ": "策略编辑器",
  "U0ffq+": "",
  "vpPReE": "查看您的日程和提醒，恢复您最新的策略，并记录您的思考。",
  "s6XQcz": "构建与管理策略，编辑合约、模拟盈亏，记录并回顾交易表现。",
  "J/8GN4": "",
  "xd9Tg8": "",
  "lsldEw": "",
  "jtM9t3": "偏移",
  "At+qYb": "策略偏移",
  "yNTQV1": "",
  "OxA18g": "",
  "fhRvUH": "",
  "m7+C5p": "记录收益",
  "B/LMTA": "总盈亏 · 美元",
  "wx5z2a": "输入实际总额。亏损请用负数。",
  "0mjohm": "保存记录",
  "Clc5VX": "",
  "teIgL2": "",
  "V5rFLm": "无法加载记录。",
  "XwMFkW": "",
  "t+bEk6": "",
  "r9UO79": "保存到策略概览",
  "hjhiGx": "",
  "wL7VAE": "操作",
  "aM7X/v": "",
  "s3jIMU": "今日总计",
  "04xho7": "",
  "yw6I5x": "未记录盈亏",
  "Lc9nUH": "删除记录",
  "46Fylq": "保存策略以添加记录。稍后填写实际盈亏。",
  "soxcCb": "",
  "XFsQ5h": "已保存的策略将在此显示。准备好后添加实际盈亏。",
  "a3sxXl": "所有记录",
  "inyj8R": "无匹配记录。",
  "otDHS/": "记录页面",
  "YQWCHn": "",
  "0fwVtw": "模板已保存",
  "V+A++8": "保存模板",
  "1Pa+yj": "",
  "/9p+Ih": "已保存模板",
  "dQvZ+J": "使用模板",
  "+roKUl": "选择有效的参考价和到期日。",
  "/Poesi": "应用模板",
  "3/D6e1": "已保存的模板",
  "VpMTSI": "在策略编辑器中保存模板，以便在此处重复使用。",
  "YrB0ys": "",
  "6+1iQP": "",
  "tPnIFR": "",
  "O/gg1T": "",
  "Xoo57t": "",
  "EeT2/f": "",
  "xt/05r": "",
  "8OwsMB": "",
  "Sx1Uwe": "",
  "jvpn6p": "",
  "tRmqQy": "",
  "7JliuJ": "",
  "yavEmc": "",
  "ZKpONT": "",
  "TiVRW8": "",
  "T1YmHj": "",
  "z2kRTL": "",
  "hTwx0V": "",
  "HK3ph8": "原理",
  "Ay2kn4": "",
  "EjihVD": "",
  "xrCRnH": "示例",
  "PTUbAv": "",
  "y1Qr81": "级别",
  "sIMS7i": "进度",
  "sizjHY": "无法保存进度。",
  "Ypr9T5": "回答错误",
  "0f7XX1": "使用策略",
  "LqqOqn": "在相同的行权价和到期日买入看涨期权和看跌期权构成多头跨式组合；卖出两者构成空头跨式组合。此结构使用多头版本。",
  "XbpSci": "盈亏 / 美元",
  "myEN8w": "",
  "AF4uR2": "",
  "/nJRat": "日志已保存",
  "4ft8js": "新日志",
  "OzLnvL": "",
  "+MdLK1": "",
  "w8Ytzi": "",
  "GY2cud": "",
  "icQTOf": "",
  "7Uersh": "偏移模拟 · 已输入期权费 · 不含手续费",
  "el7vse": "输入有效的合约详情以查看模拟。",
  "gHwYMn": "距离当前标的价格的变化",
  "DAZzlO": "结构预览",
  "JnGz7H": "结构预览 · 添加期权费以计算净盈亏。",
  "zjM3hE": "到期模型 · 期权费之前",
  "kzgjIu": "",
  "5IP7AP": "点差",
  "gyuZSt": "策略点差",
  "Ri9b0M": "放弃策略",
  "uc6+G/": "策略详情",
  "FcYnDI": "记录的合约详情不可用。",
  "G0pvVI": "删除此策略及其记录的盈亏？",
  "/FxJV7": "删除此已保存策略？",
  "E6+QMz": "复制策略",
  "c7ayat": "查看策略",
  "yCrIg2": "快速记录提醒、查看到期待办",
  "3UiyM0": "删除失败。请重试或撤销删除。",
  "xn0hvm": "",
  "INal7Z": "",
  "LYRMA4": "",
  "iHnCNH": "",
  "s+mcli": "",
  "g9YA+g": "允许在此浏览器中存储会话，以便在您登录时保留您的草稿。",
  "m//P6A": "",
  "LpPTTX": "",
  "XdkIfb": "",
  "C1kEyj": "",
  "FtGkMl": "",
  "O81lSB": "免费探索 · 无需注册",
  "t/247F": "SPY · 教学示例",
  "5JCulU": "参考价 $500。所有行权价和权利金均为教学示例，并非实时报价或交易建议。",
  "prLyDg": "重置示例",
  "GTGGea": "探索结果",
  "7yaXGQ": "请输入有效的合约参数以计算结果。",
  "lSGulb": "到期盈亏平衡价格",
  "vzQ5Hf": "无单独盈亏平衡点",
  "gvW2sZ": "编辑合约",
  "OievG4": "权利金按每股计算，每份标准合约对应 100 股。",
  "DkP//w": "保存此策略",
  "X4f3ZX": "保存到您的账户，并在您的工作区中继续。",
  "AhefpM": "",
  "esqR0t": "",
  "QMBuiP": "",
  "wTbis3": "登录并保存",
  "MRH20P": "",
  "EX+sDo": "无法创建您的账户。请重试。",
  "ff2VGL": "发送中…",
  "huqKGl": "创建账户",
  "k/jPgQ": "已有账户？登录并保存",
  "oimOv6": "创建账户即表示您同意我们的",
  "3mvL2Q": "和",
  "zPTUNy": "",
  "5WQIxl": "",
  "75Igg9": "",
  "xhTizm": "",
  "B31L9E": "",
  "aJIteR": "",
  "jwLnuC": "",
  "Y6enmG": "",
  "yBMfHE": "",
  "bAoCbO": "",
  "evf6uW": "利润/亏损",
  "sk5Zj9": "",
  "SOFS55": "",
  "2Sacas": "",
  "gGWQNq": "",
  "EMaQ3z": "",
  "b8UUhS": "",
  "zLLA3l": "关于ABG One",
  "LD7iMR": "",
  "flbu0O": "",
  "XTROyJ": "请先填写完整的合约参数和权利金，再保存。",
  "h6oI1g": "探索策略",
  "clUcU+": "保存您的进度",
  "ZCxE6c": "您的选择在本标签页中保存最多24小时。在此处登录以保存到您的账户。",
  "emZo12": "查看您的电子邮件以获取登录PIN，然后返回此处登录并保存您的选择。",
  "RBZX5n": "此电子邮件已有关联账户。请在下方登录以保存您的选择。",
  "Bz+H46": "价格仅供示例，未计入费用。到期盈亏不考虑提前指派，也不反映到期前时间价值和波动率的变化。修改行权价会保留已输入的权利金，不会获取新的市场报价。",
  "8RpXfZ": "允许此浏览器使用会话存储，以便您在登录时保留所选内容。",
  "mr//Om": "无法更新您的收藏。请重试。",
  "A87nSW": "未找到课程",
  "t+AQEb": "返回期权理论",
  "1PNi68": "选择一种结构。阅读理论或在模拟器中探索。",
  "UUmUhU": "探索每种结构的工作方式、其收益和风险。",
  "6n79hD": "保存您的选择",
  "g7lrTa": "此临时草稿已失效。返回期权理论以重新开始。",
  "5R+Yvx": "正在保存您的选择…",
  "reycA5": "您的选择未能保存。它仍在此标签页中可用。请检查您的连接和工作区容量，然后重试。",
  "09CmBC": "访客答题进度在本页面保留。",
  "jRMMXS": "此共享示例无效。显示的是默认示例。",
  "RUr0KH": "分享情景",
  "zU/q1N": "链接已复制",
  "xHblRN": "到期情景",
  "21yJ8q": "探索此示例",
  "fhwTpA": "来源",
  "9yvKsm": "",
  "Jjn7Fh": "学习期权、模拟策略、记录和回顾。",
  "aIRWQB": "返回主页",
  "OGqTOQ": "访客",
  "26VckP": "公开学习",
  "mU9gmg": "已查看学习页面",
  "CUhO2T": "打开模拟器",
  "y6m90b": "已调整模拟",
  "cpJyPS": "已分享情景",
  "e867RK": "完成注册",
  "AqRInY": "访问次数",
  "lzgH40": "Google",
  "coc2HA": "Bing",
  "aZPSPA": "ChatGPT",
  "KCWNcP": "Perplexity",
  "ANPQ0A": "其他来源",
  "4nxb8Y": "直接访问或来源未知",
  "rELDbB": "刷新",
  "jCNpEL": "周期",
  "Rfvi9/": "最近30天",
  "mgYBYo": "最近90天",
  "uF2NdB": "统计所选时段内首次记录的访问，包括首页。同一次访问中的每种操作只计一次；各项占比均以总访问次数为基数。",
  "CHCrij": "访问次数不等于独立人数。连续 30 分钟没有记录到操作后，再次操作会算作一次新访问。注册和保存分别统计，不要求完成前面的所有操作。",
  "sw3be0": "无法加载学习报告。请重试。",
  "u8VxaO": "暂无访问记录",
  "pXT+QZ": "这里只显示启用统计后记录的访问。可以选择更长的时段，或在有人访问公开页后再次查看。",
  "TfOMuw": "占访问次数的 {rate}",
  "OGtlNI": "访问来源",
  "3/EJKn": "来源依赖浏览器提供的引荐信息。“直接访问或来源未知”也可能包含未提供来源信息的搜索或 AI 访问。",
  "TciE4Y": "访问入口（前 20）",
  "mLL1Y9": "入口页面是一次访问中最先记录的公开页。即使访客随后探索了其他策略，注册和保存仍归到这个入口页面。",
  "B7Ew7K": "3D结构探索",
  "jR5jnf": "从示例开始，无需保存策略。",
  "7PJxiI": "示例结构",
  "y1De/5": "示例参数",
  "tgcX/z": "情景价格",
  "fk++Xe": "SPX 教学示例以 6,500 为基准，使用理论权利金和统一 IV，参数不代表实时报价。调整 IV 或期限时，建仓估值和整个曲面都会重新计算。",
  "FRXWaB": "分享此视图",
  "74IwYA": "在1.0中继续",
  "nuCr1U": "复制此链接以分享",
  "UT3At6": "我的策略",
  "ibJhP/": "{name} · 3D示例",
  "1cuxDr": "从3D教学示例创建。构建器使用工作区的市场和波动率设置。",
  "XDM1kj": "保存结构并进入构建页",
  "tjjaLH": "构建器使用您的工作区的市场和波动率设置。",
  "mYxrWG": "无法在构建器中打开此结构。检查您的策略限制或重试。",
  "xXZUk/": "探索示例",
  "5YL/Su": "3D期权探索",
  "IPBLX8": "正在加载3D探索器…",
  "MQUznC": "3D期权探索器",
  "rRay9x": "探索期权结构如何随价格、时间和隐含波动率变化。从看涨期权、看跌期权、价差、跨式或铁鹰开始，旋转曲面，切换盈亏和希腊值。无需账户，也无需已有策略。",
  "11Fv+Z": "解读曲面",
  "cZTNgU": "曲面上的每个点是两个选定输入的模型结果。盈亏显示了模型从示例入场值计算出的变化。Delta、Gamma、Theta和Vega显示了不同的敏感性。使用分析预设来探索问题，或在手动模式下选择自己的坐标轴。",
  "1Ku6j1": "示例使用理论期权价格、跨行权价的恒定波动率且无交易成本。它们解释了模型行为；它们不预测回报或代表可执行的市场价格。",
  "pDJPZc": "源自3D教学示例。",
  "Ja0jYM": "选择进入构建页时使用的场景",
  "msBkD8": "保留示例场景",
  "Sy5zGH": "保留价格 {price}、IV {iv}% 和 {days} 天期限，结构行权价仍以 6,500 为基准。",
  "NHq17t": "切换实时行情",
  "MGVQP1": "按最新 SPX 价格重新定位结构，使用实时 IV，并保留 {days} 天期限。",
  "CwcrV0": "正在等待SPX市场数据…",
  "k7XPlu": "将更新整个 SPX 工作区共用的价格和 IV。原有策略会保留，并选中新导入的结构。",
  "jIZ8TK": "从示例开始",
  "PDvqYH": "进入构建",
  "/PQsop": "返回3D并选择一个场景继续。",
  "xrZqQc": "激活工作区访问以继续此场景。",
  "4Zuvkw": "获取访问权限",
  "/F7o1/": "无法打开您的场景。它仍在此选项卡中可用。请检查您的连接和策略限制，然后重试。",
  "45oVvw": "正在构建中打开您的场景…",
  "DW3a0t": "返回3D",
  "LUc3cr": "您的浏览器无法保存此策略。请启用标签页存储后重试。",
  "H19twt": "无法加载您的结构。重试",
  "yKosLC": "继续构建",
  "4J+y64": "用此结构构建",
  "EePJda": "当前构建",
  "Ed2qZj": "当前构建 · {name}",
  "3GLH+d": "示例",
  "QVZeAu": "示例 · {name}",
  "1HGbXh": "探索更多",
  "7uLFdD": "无法打开此结构。请重试。",
  "4xvTgw": "关于此示例",
  "ugzzHK": "恢复默认值",
  "/2yBU5": "探索期权结构如何随价格、时间和隐含波动率变化。从看涨期权、看跌期权、价差、跨式或铁鹰开始，旋转曲面，切换盈亏和希腊值。",
  "R1y05T": "登录，探索更多",
  "ivmaje": "新用户",
  "4bItbH": "免费注册，体验 30 天",
  "td3oqq": "已有账号？输入 PIN 登录",
  "+FkQSx": "看不同条件下的策略表现",
  "v9R8gC": "假设标的价格",
  "e6nsuh": "点击登录",
  "ozDeJH": "只统计公开 3D 页，也包括从首页等页面进入 3D 的访问。各项占比以 3D 访问次数为分母。",
  "TBZsnf": "在同次访问中，点击 3D 页的登录入口后注册成功，才计入转化。同一操作只计一次，周期按首次访问 3D 的时间筛选。",
  "OVPMr3": "无法加载 3D 统计，请重试。",
  "fqL72s": "本期间还没有记录到公开 3D 的访问。启用统计前的访问无法补计。",
  "iyZFBV": "显示访客最先打开的公开页。例如“首页 → 3D → 注册”，这里归到首页，同时计入上方的 3D 转化。",
  "Nrw5ql": "新增注册",
  "Eryyuj": "{activated} 已激活 · {pending} 等待首次登录",
  "oBPPMi": "成功使用 PIN 登录后计为已激活",
  "RZdYTT": "已激活的新账户",
  "EPxDEa": "等待首次登录",
  "ieGdWc": "验证后继续",
  "Nb+iu7": "完成验证后，我们会向邮箱发送登录 PIN。",
  "Bo4x4i": "邮件请求过多。请稍后再试。",
  "UEP7qP": "暂时无法发送 PIN，请重新验证后再试。",
  "/y8HkO": "免费使用 2.0 通用",
  "mIBoDj": "免费使用 2.0 通用，需要深入分析时再订阅 1.0 旗舰。",
  "yK89ew": "创建免费的 αβΓ✻1 账户，开始使用 2.0 通用",
  "dz5v8V": "免费使用",
  "qxOTzD": "日常使用，免费开放，无需订阅。",
  "Xlse6c": "订阅解锁完整工具，深入分析策略。",
  "BYQXtY": "策略构建器",
  "sQvErU": "构建多层策略并管理期权合约。",
  "iQxcII": "策略监控",
  "LcBX1S": "随市场变化，持续追踪已保存的策略。",
  "G9KZDq": "3D 分析",
  "51eRAk": "在 3D 模型中查看价格、时间变化下的策略盈亏。",
  "+2MV36": "研究波动率曲面、微笑和偏斜。",
  "zHXtYK": "浏览策略选择，识别盈亏形态，练习期权知识。",
  "YjxxNd": "一个账户，两种使用方式",
  "mWwUwa": "免费开始，按需进阶",
  "pQ5Dpb": "用 2.0 通用安排日程、构建策略、模拟盈亏。需要深入分析时，再订阅 1.0 旗舰。",
  "7bG1Ok": "轻松上手，满足日常使用。",
  "zdZbzZ": "无需订阅",
  "KnaLVT": "市场日历和提醒",
  "2oeacV": "策略库和合约编辑",
  "v9/wMP": "交易日志与收益记录",
  "wQrXPf": "期权理论与练习",
  "xJVV/l": "进入 2.0 通用",
  "+e/Mjn": "无需绑卡，不限试用天数。",
  "PZ2Hhe": "从价格、时间与波动率，深入理解策略。",
  "A0liQK": "包含 2.0 通用的全部功能",
  "ZOu65Y": "分层策略构建与监控",
  "vBgQ/W": "价格与时间维度的 3D 盈亏分析",
  "SFsjLy": "波动率曲面、微笑与偏斜",
  "e1een/": "选择 1.0 旗舰",
  "RffUJ+": "订阅到期后，2.0 通用仍可免费使用。",
  "IfDLmh": "当前方案",
  "tBA2++": "开始使用 2.0 通用",
  "sqGgEG": "订阅 1.0 旗舰",
  "texxbY": "创建免费账户，登录码将发送至您的邮箱。",
  "Fpz2xN": "选择上方的订阅时长，继续完成支付。",
  "7Xx8IX": "继续支付",
  "ShH/MK": "创建免费账户",
  "XQgDzP": "我需要订阅才能使用 ABG 吗？",
  "cXalwh": "不需要。2.0 通用免费使用；需要 1.0 旗舰的深入分析工具时，再订阅即可。",
  "B6ZSFg": "我需要第二个账户吗？",
  "svTylK": "两套界面共用一个账户，随时可以回到 2.0 通用。",
  "OvkNAz": "免费注册 · 2.0 通用",
  "hRFN9U": "账户使用期间，我们会保留您的数据。旗舰版权限到期后，仍可继续使用免费的通用版。您可以随时申请删除数据。",
  "uNuVSs": "旗舰访问已结束",
  "wxdvRr": "个人知识笔记本",
  "UmnFCA": "记录交易思考与复盘心得，逐步建立自己的知识体系。",
  "9M+Btn": "从日常记录，到深入分析。",
  "f8Wb2g": "从日常学习记录，到深入分析复盘。",
  "EoWUbn": "宏观事件日历、交易表现分析、投资回顾、复利计算与计划。",
  "yzoE8S": "多层策略构建、到期模拟，以及行权价与点宽的精细调整。",
  "W0dUH1": "策略追踪",
  "4mrhCR": "分层策略构建与追踪",
  "yvAvsI": "多层策略构建、到期模拟，快捷微调行权价与点宽。",
  "NPhwev": "多层策略构建、到期模拟，快捷调整行权价与点宽。",
  "B3xAC5": "快速开始策略",
  "mqs6T/": "理论测试",
  "UwBPRJ": "学习进度",
  "Dr13kE": "继续上次",
  "8Orgfi": "开始学习",
  "J9+DGS": "无法加载题目。",
  "mgm/go": "快速记录提醒、查看到期待办",
  "MzeY/9": "快速记录、复盘回顾",
  "kPRXyx": "快速记录、复盘回顾",
  "g26B7+": "策略记录、盈亏总览",
  "GhJzE3": "策略构建",
  "ygG456": "先理解结构，再构建策略。",
  "QiIw/s": "先理解结构，再构建策略。",
  "H9bg9B": "每日",
  "Fmg7CX": "构建与管理策略，编辑合约、模拟盈亏，记录并回顾交易表现。",
  "Qf74lF": "学习期权基础、希腊值与策略结构，收藏常用策略，通过测试巩固理解。",
  "ftxzPu": "快速记录提醒、查看到期待办，记录与复盘交易，继续上次学习。",
  "IRbYgl": "快速记录提醒、查看到期待办，记录与复盘交易。",
  "ox9XYI": "快速记录提醒、查看到期待办，记录与复盘思路。",
  "NQEV8/": "快速记录提醒、查看到期待办，记录与复盘思路。",
  "05muiR": "申请审核中",
  "Ilv0jd": "申请已通过",
  "wJfSNK": "申请已提交，审核通过后即可使用 KOL 看板。",
  "rOeXWb": "申请已通过，刷新后即可进入 KOL 看板。",
  "s1u1Vq": "刷新审核状态",
  "v0N8B2": "申请成为 KOL",
  "hHQgTJ": "介绍一下你的内容和受众。审核通过后，我们会为你开通 KOL 看板和推广码。",
  "CvXn/g": "申请未通过",
  "r/YHV4": "可在下方补充或修改资料后重新提交。",
  "DR+23P": "联系邮箱",
  "CzoQvD": "公开主页链接",
  "cvtlil": "账号名（选填）",
  "oawD4b": "内容与受众介绍（选填）",
  "WIKG6H": "申请提交失败，请检查资料后重试。",
  "BX2m3F": "提交申请",
  "g4xMRn": "KOL 申请",
  "8FwoEX": "无法加载申请。请重试。",
  "7BIjuP": "暂无待审核申请",
  "gg41yf": "佣金 (%)",
  "cBdv6t": "审核说明（未通过时必填）",
  "D4+bxc": "通过后将绑定申请人的账号，授予永久使用权限并生成推广码。审核说明对申请人可见。",
  "x7gRnZ": "无法保存审核。刷新后重试。",
  "mgwARF": "通过并开通",
  "+uc1nO": "不予通过",
  "J6M9RB": "KOL 信息加载失败，请重试。",
  "eWgjM2": "审核通过后，你将获得",
  "8xhFJu": "免费使用旗舰版",
  "0X7cYa": "审核通过后，免费使用 1.0 旗舰版。",
  "9+1x9N": "默认 20% 推广佣金",
  "P3A7yR": "通过你的推广码产生的有效付费订单，均可获得佣金。",
  "I7eTD1": "粉丝专享 $98 / 年",
  "EgPbvX": "粉丝使用你的推广码，年费由原价 $168 降至 $98。",
  "62wdi4": "专属推广工具与看板",
  "NY8HFB": "获得专属推广码和分享卡，随时查看转化、佣金与打款记录。",
  "fN/DPV": "认证创作者身份",
  "z0KMKL": "在社区发布内容，并展示认证创作者标识。",
  "GphbZH": "佣金比例以审核确认为准。按 20% 计算，每笔 $98 的有效订单可获得 $19.60 佣金；退款订单不计佣金。",
  "L+AgmB": "好友通过你的链接购买，可享受 $128 年费优惠。",
  "H1CYrB": "KOL 与粉丝同享 $98 / 年",
  "CoCWPv": "你和粉丝均可享受 $98 年费优惠，原价 $168。KOL 登录后即可享优惠，粉丝使用你的推广码购买。",
  "tloLHf": "佣金比例以审核确认为准。按 20% 计算，每笔 $98 的有效订单可获得 $19.60 佣金；退款订单和本人购买不计佣金。",
  "+O+xBF": "创建免费的General账户，生成其联盟代码，并通过邮件发送PIN。现有会员访问权限保持不变。",
  "q/lD8z": "已关联现有用户 {email}；会员访问权限不变",
  "+hTUJX": "创建免费General账户，享￥98年付KOL优惠",
  "W9gzl6": "审批将关联申请人账户并创建推荐码。KOL与粉丝可享￥98年付价格；会员需单独购买。审核备注对申请人可见。",
  "Zf7Od0": "KOL 与粉丝专享价",
  "bym6gd": "历史赠送天数",
  "hrh0Gw": "您写的一篇帖子",
  "C0w/rb": "你的用户名",
  "9Bdywh": "对于您已认识的创作者",
  "2nQgvn": "您好 {name},\n\n我一直在关注您在 {platform} 上的内容，并且很喜欢您关于 {topic} 的帖子。\n\n我正在与 ABG ONE 合作，这是一个期权策略和回测工具。您是否有兴趣进行创作者合作？\n\n您和您的粉丝可以以每年 $98 的价格订阅，而不是 $168。您的推荐链接是 getabg.one/{slug}，符合条件的粉丝购买可为您赚取 {commission}% 的佣金。自行购买和已退款的订单不获得佣金。\n\n如果您有兴趣，我很乐意分享更多详情！",
  "MR6Iqp": "详细",
  "f+Y10W": "用于更正式的介绍",
  "+TPulf": "您好 {name},\n\n我是 @abg_one，也创作有关美股和期权的内容。您关于 {topic} 的帖子引起了我的注意。\n\nABG ONE 是一个期权策略和回测工具，我们邀请 {platform} 上的创作者与我们合作。\n\n合作包括：\n1. 您和您的粉丝均可享受每年 $98 的订阅价格，而常规价格为 $168。会员资格需单独购买。\n2. 您的专属推荐链接：getabg.one/{slug}。\n3. 符合条件的粉丝购买可获得 {commission}% 的佣金。自行购买和已退款的订单不获得佣金。\n4. 一个用于跟踪转化、佣金和付款的仪表板。\n\n我们欢迎诚实的反馈和真实的内容。如果您有兴趣，我可以分享产品演示和合作详情。\n\n期待您的回复！",
  "++CQB/": "随意",
  "eCJ2h8": "用于更轻松的初次接触",
  "TlSuVf": "您好 {name}！\n\n我也创作有关美股和期权的内容，并且很喜欢您关于 {topic} 的帖子。\n\n您是否有兴趣与 ABG ONE 合作，这是一个期权策略和回测工具？您和您的粉丝可以享受每年 $98 的价格，而不是 $168。通过 getabg.one/{slug} 的符合条件的粉丝购买可为您赚取 {commission}% 的佣金；不包括自行购买和退款。\n\n如果您有兴趣，我很乐意发送详情！",
  "rNMiia": "创作者账号已核验",
  "oOmpTH": "创作者认证",
  "uUy2wT": "核验你的公开创作者账号归属。此标识不代表法定身份或金融执业资质认证，也不代表平台认可所发布的内容。",
  "PG8SRN": "KOL 推广合作单独审核，提供推广优惠和佣金。创作者认证与 KOL 合作互不自动开通。",
  "lDukr2": "KOL 推广合作",
  "LsyfBy": "无法加载认证信息，请重试。",
  "VU8368": "创作者标识和社区发布权限已开通。认证不包含会员优惠，也不代表专业执业资格。",
  "v7oUfK": "验证账号归属",
  "czcSwN": "请将以下验证码放到所填公开主页的简介中，并保留至管理员完成审核。",
  "JdAFKw": "申请正在等待审核。管理员会核对主页上的验证码，仅提交链接不会获得认证。",
  "XlBMzK": "认证已撤销",
  "ja7YtT": "认证未通过",
  "J/vcCY": "填写公开主页及一篇原创内容的链接，获取验证码后将其放到主页简介中。无需提交身份证件或敏感个人信息。",
  "SkUbN6": "创作者名称",
  "SNGt6J": "公开主页链接",
  "dCyf13": "原创内容链接",
  "YMkrg6": "补充说明（选填）",
  "BkN56Z": "申请提交失败，请检查填写信息后重试。",
  "lJhjLq": "获取认证验证码",
  "D+SvYz": "KOL 审核仅用于推广合作，创作者账号认证需另行申请。",
  "bSYYzg": "申请创作者认证",
  "TYDU5O": "核对公开账号归属及原创内容样本。此审核独立于 KOL 合作，不认证法定身份、金融执业资质或投资建议。",
  "vh/xzj": "待审核",
  "ev3rDM": "已认证",
  "iG52Ww": "暂无相关申请",
  "jvnB1y": "认证记录",
  "6XFO/C": "已批准",
  "5qaD7s": "已拒绝",
  "NsR8eR": "已在所填公开主页找到一致的验证码，并核实账号归属。",
  "8+wvAx": "已核对内容样本的作者，并检查是否违反社区规则。",
  "9pa0x2": "核验依据或处理原因（申请人可见）",
  "oKMkXN": "审核操作失败，请刷新列表后重试。",
  "KEYvbc": "通过认证",
  "VzIOKf": "拒绝",
  "BCyfIg": "撤销认证",
  "1+1Hds": "审核历史",
  "PSUtcs": "垃圾信息或误导性推广",
  "SOfYdT": "骚扰或仇恨言论",
  "iIAx22": "有害或非法内容",
  "v7H5PN": "其他问题",
  "TQVOqM": "举报原因",
  "xM5ArJ": "我们会审核你的举报，不会向作者透露你的身份。",
  "X4dRES": "提交举报",
  "WLTizY": "屏蔽用户",
  "Qh6A+a": "无法屏蔽此用户。请重试。",
  "ROvgi3": "您将无法再看到对方的社区帖子，也无法互相关注。现有的关注将被移除。您可以在设置中解除屏蔽。",
  "KW3uMH": "正在屏蔽...",
  "Up5U7K": "屏蔽",
  "nDejmx": "解除屏蔽",
  "1ctlqi": "无法解除屏蔽此用户。请重试。",
  "skNNbV": "已屏蔽的用户",
  "p3eIzE": "解除屏蔽不会恢复之前的关注。",
  "vqJ2Cy": "无法加载已屏蔽的用户。重试",
  "JUddXg": "没有已屏蔽的用户。",
  "NGouzK": "用户已被屏蔽。您可以在设置中管理已屏蔽的用户。",
  "5+NtAh": "社区举报",
  "grfUHB": "举报人",
  "ZKJI84": "举报后正文已修改",
  "53wI5L": "此帖子在社区中不再可见。",
  "CAZE2E": "本次处理将一并结案这篇帖子的所有待处理举报。",
  "Q/oTBs": "审核备注",
  "6JZeyv": "无法保存此审核。请刷新以检查是否已处理。",
  "yBwLaS": "隐藏帖子",
  "23o/Oc": "驳回举报",
  "x9mO/b": "帖子已隐藏",
  "/lWTag": "举报已驳回",
  "yb28IP": "无法加载举报，请刷新重试。",
  "VUhaqI": "暂无举报。",
  "WbCnuv": "待审核",
  "1qfPw2": "帖子选项",
  "C69xts": "关注操作未成功，请重试。",
  "Yuh2yS": "无法加载此列表。请重试。",
  "538G00": "尚无关注者。",
  "u+OB6Y": "尚未关注任何人。",
  "ARj3cJ": "无法加载关注数。重试",
  "qtWLmt": "赞",
  "4OB335": "不赞",
  "JVwcs6": "取消收藏",
  "4WSbF7": "收藏",
  "v8o2Nm": "操作未成功，请重试。",
  "xI2csf": "还没有收藏的内容。",
  "lsqh6j": "收藏的内容会出现在这里。",
  "VyP9+l": "还没有点赞的内容。",
  "5n5BSA": "点赞的内容会出现在这里。",
  "L+t7yr": "我喜欢的",
  "hdqC44": "我的收藏",
  "4sfKEB": "我关注的",
  "5gIWIu": "切换动态",
  "k0fraU": "已收藏",
  "8/YhTK": "全部动态",
  "l67Qtm": "您将无法再看到对方的社区帖子，也无法互相关注。现有关注将被移除。您可以在“发现”菜单中解除屏蔽。",
  "NOmhZm": "用户已被屏蔽。您可以在“发现”菜单中管理被屏蔽的用户。",
  "JVxlmb": "关注我的",
  "xJKibQ": "无法加载关注者。重试",
  "OKXv4I": "帖子数",
  "opri2O": "人数",
  "1cI1mA": "聚焦洞察，看见关键。",
  "OYKAqF": "快速开始",
  "wQXAv+": "{step} / {total}",
  "zezuLf": "选择标的工作区",
  "We1y4G": "在下方添加工作区，选择你想分析的标的。",
  "ABDm1s": "在下方添加一个策略，之后可继续编辑腿详情。",
  "Kl2Mao": "引导状态保存失败，请重试。",
  "/4tOwT": "跳过",
  "h+vI/j": "发布需创作者认证",
  "Xqfld1": "仅认证创作者可发布。订阅不包含发布权限。您仍可阅读、关注、点赞、收藏和举报帖子。",
  "YPDmud": "{start}–{end} / {total} 项",
  "A8Vn9q": "选择工作区",
  "7I5hYr": "策略模拟",
  "R1O9di": "基础结构",
  "ovr52i": "我的模板",
  "oGAqgT": "策略流程",
  "j6x71P": "转到策略构建器",
  "13mnyu": "转到策略模拟",
  "gE/XdF": "转到策略概览",
  "nSmKfC": "更改策略到期日",
  "XBVRCo": "选择到期日",
  "gJOXzn": "应用于所有合约",
  "MeGdHj": "将此到期日用于新策略。",
  "EE/sp8": "正在加载到期日...",
  "r1nMz3": "可用到期日",
  "WN5lCH": "交易日",
  "8iD1fY": "选定到期日",
  "U/+d+C": "只改单条合约日期，可在对应合约行中编辑。",
  "oRPMUF": "您可以在编辑器中调整单个合约日期。",
  "6Hca8c": "同步至",
  "ge6D/c": "四条腿定义两侧边界。添加后可逐条调整。",
  "48gLpx": "用两档行权价限定区间。添加后可逐条调整。",
  "vRR065": "买入高档 Put，卖出低档 Put。添加后可逐条调整。",
  "iTADZf": "围绕中心行权价构建。添加后可逐条调整。",
  "ETev4J": "一条 Call，从简单开始。添加后可逐条调整。",
  "7uLCb3": "一条 Put，独立调整。添加后可逐条调整。",
  "R49Wra": "同档 Call 与 Put 的组合。添加后可逐条调整。",
  "gNMjJl": "从期权链挑选合约。",
  "/iMMxS": "第一步：为 {ticker} 选择一种结构",
  "ji6oXc": "查看收益模拟",
  "EzjwhO": "自由组合",
  "bZ5yLj": "你的结构",
  "RegPoj": "合约腿数",
  "h4DDCx": "示例净权利金",
  "Um3WQs": "从期权链自选",
  "QThAQH": "选择合约",
  "9KHvD/": "{days} DTE",
  "+v9Ok5": "示例收益图",
  "5gfsxq": "示例权利金 · 填完所有合约权利金后，显示按填写数据计算的收益。",
  "5r79gy": "示例盈亏 / 美元",
  "W/vRg3": "示例价格仅用于展示，不会写入合约",
  "kyF6s5": "{name}合约",
  "mSJ0dz": "月历",
  "tr+EKe": "写一条复盘",
  "nZxxhf": "新建复盘记录",
  "cXZ3+s": "可关联一条策略，也可以独立记录。",
  "W6iocE": "关联策略",
  "M8SEnW": "不关联 · 独立记录",
  "K9dnUB": "记录标题",
  "RhsDlp": "例如：为什么调整了这条合约",
  "avbgBi": "构建笔记",
  "OZserT": "调整记录",
  "altbih": "记录内容",
  "cT7liw": "最初的判断、本次修改、后续结果……",
  "+iB0Qw": "{count} 条合约",
  "44xSOg": "{dates} 到期",
  "BC1G69": "写复盘",
  "Flp5EE": "当天到期",
  "XkzUAq": "1 条合约",
  "JCRkgU": "记录时间",
  "/5WAhg": "美东时间",
  "yGcAsT": "正在加载复盘…",
  "sQDKyM": "复盘提醒",
  "HlwPE3": "当天已有 {count} 条复盘",
  "DX/Uv6": "收盘后，留一页笔记。",
  "MGQGLm": "个人复盘提醒 · 美东时间",
  "8sf72h": "盘前",
  "cnTUAk": "当天有 1 条策略到期。",
  "ZSdmVQ": "当天有 {count} 条策略到期。",
  "EaXqqJ": "当天已有 1 条复盘",
  "h1vUvt": "今日",
  "eDvEED": "日程",
  "flJCao": "概览",
  "roIfV8": "区间结构",
  "lQbuj+": "方向结构",
  "m68fwH": "基础结构",
  "AcgWRN": "波动率结构",
  "nuELd+": "{count} 组",
  "flHGiq": "详情不可用",
  "Q3Y5Ha": "持仓模拟",
  "h51RnY": "策略组合",
  "6NctwV": "显示策略",
  "fWqQu0": "专注图表",
  "ECxnAP": "尚无工作区",
  "RaHmdD": "选定策略模拟",
  "345vkD": "无法读取此策略的合约。",
  "sPfikH": "策略与合约",
  "tZrr+Z": "合约明细",
  "UbyCXD": "此工作区中没有已保存的策略",
  "dA+8QI": "构建并保存策略，即可在此查看。",
  "3ZV73A": "前往策略构建",
  "QRc6t9": "当前：{strategy}",
  "FHEMLC": "按标的筛选",
  "haUZ5n": "更多标的",
  "I5NMJ8": "更多",
  "42snre": "持仓",
  "SFtla8": "模拟日期 · 东部时间16:00",
  "TcbFwU": "模拟日期",
  "+SZRM6": "此选择中无已保存策略",
  "9ARwAj": "缺少参考价。无法获取投资组合总额。",
  "i15Ej2": "请选择一个不晚于最早到期日的有效模拟日期。",
  "cAKP9Z": "无法读取部分合约。无法获取投资组合总额。",
  "jucSLD": "权利金尚未填全，整个组合暂用示例权利金；填全后按填写数据计算。",
  "Zb4mMB": "各标的按相同涨跌幅、同一模拟时点计算。",
  "l1qrcl": "汇总此标的全部策略，按同一模拟时点计算。",
  "Y91rSh": "投资组合模拟损益",
  "I6GAt0": "组合盈亏 · 美元",
  "neuWSe": "标的统一涨跌幅",
  "3uzad/": "{ticker} · 模拟价格",
  "fqJmun": "标的模拟价格",
  "Yz6ZwB": "投资组合情景变动",
  "DG0+uu": "组合模拟盈亏",
  "qMbu8u": "区间最高盈亏",
  "zuiHKU": "区间最低盈亏",
  "0aCg+/": "情景估值 · 不含费用 · 最晚模拟至首个到期日：{date}",
  "CXLPcV": "缺少合约波动率时按 22% 估算，结果为模型估值。",
  "5HH0zv": "缺少行情的标的使用工作区参考价。",
  "quBPTZ": "参考价",
  "4wElnx": "组合模拟",
  "kh1KeO": "模拟标的",
  "lmWtqo": "组合收益",
  "Ci95k0": "到期日不同：此合计假设各合约到期时的标的价格相同，不代表同一天的持仓估值。",
  "SjQMC5": "组合策略到期收益",
  "U2FDW0": "组合策略模拟",
  "qu5E+x": "转到持仓模拟",
  "xL3oqN": "保存到收益概览",
  "Cogg6U": "转到收益概览",
  "svEqhD": "收益概览",
  "WuGkfJ": "收益",
  "0oKuZ4": "记录平仓",
  "3CPnXG": "输入您的实际成交。此操作仅记录平仓，不会下单。",
  "mDf+/j": "买入 → 卖出",
  "WEmdT9": "卖出 → 买入",
  "jfDRZ8": "入场价 · 每股",
  "q74E/l": "平仓价 · 每股",
  "xGFQ8M": "平仓合约数量",
  "JeWUUO": "平仓日期",
  "e+K2vL": "本次平仓手续费 · 美元",
  "RvTyWy": "确认后将自动保存至收益概览。",
  "l2Pi/e": "确认平仓",
  "wxzZci": "无法加载平仓记录。请在模拟或平仓前重试。",
  "Z4bwA9": "已记录平仓。已实现盈亏已保存至收益概览。",
  "6NQ6Bu": "无法记录平仓。请检查价格和剩余数量后重试。若仓位在别处已更改，请先取消并刷新。",
  "E4A3mp": "开仓 · 买入",
  "kV1QnC": "开仓 · 卖出",
  "CW6XwF": "STC · 平仓",
  "IiAeN0": "BTC · 平仓",
  "wJmiSU": "图表显示剩余未平仓合约。",
  "NDdXKX": "所有合约已平仓。已实现盈亏已保存至收益概览。",
  "MZ+S/I": "平仓策略",
  "fhfSHc": "平仓明细",
  "mmF0Vi": "平仓范围",
  "rbYjy2": "整条策略",
  "FwabZ1": "平仓价",
  "hIT1Zf": "{contract}的平仓价",
  "q2t5pQ": "{contract}的数量",
  "AF3I9+": "添加入场价",
  "HvG5s7": "{contract}的入场价",
  "8ymITT": "手续费 · 美元",
  "OuYJ7F": "价格按股计算。仅记录；不发送订单。",
  "Er0cd7": "剩余 {remaining} / {total}",
  "3fcUbU": "已平仓，已实现盈亏已计入收益概览。",
  "d2qC6D": "平仓所选单腿",
  "k+jlMP": "BTC / STC · 平仓",
  "krfuyl": "无法记录平仓。请检查您的价格或刷新仓位，然后重试。",
  "PophnD": "补充开仓价",
  "Gzw24e": "平仓费用",
  "MrJM2v": "仅作记录，收益自动计入概览。",
  "O9mUCU": "每股收盘价",
  "rDS2Ev": "开仓价/股",
  "vW80BU": "平仓价/股",
  "vd8ZAT": "已平仓",
  "WOFp4a": "全部平仓",
  "ZHselI": "模拟时点收益",
  "UDdxHp": "对照到期曲线",
  "luKKRk": "不同到期日：已到期合约按模拟价格结算，其余按模拟时点估值。",
  "MfCKsM": "模拟日期策略收益",
  "i5oP4n": "上次到期",
  "tzm01n": "缺少行情时采用假设 IV",
  "Yjb6JF": "合约隐含波动率",
  "sfUw+e": "隐含波动率调整",
  "BeguqH": "到期时，隐含波动率不再影响收益。",
  "3oRjFS": "IV 调整 {points} 个百分点",
  "nJRWCA": "重置模拟",
  "R1aEXn": "到期最大收益",
  "B6a/9X": "到期最大亏损",
  "JU9yiP": "理论估值 · 未计费用及提前行权",
  "HR5dPj": "模拟条件",
  "2uavLm": "恢复当前价格、当前时间和基准隐含波动率。",
  "t5tSFK": "全部重置",
  "EYTjSo": "假设 IV",
  "snb1ZU": "回到当前",
  "bu7bsg": "{time} · 预计盈亏",
  "jAfo6c": "到期盈亏 / 美元",
  "UPQyHx": "预计盈亏 / 美元",
  "y269Y9": "保存选项",
  "0MwWFQ": "保存为模拟",
  "U3nrnL": "保存为概览",
  "0EMLB9": "开始模拟",
  "PWeUbj": "存入概览",
  "MVpSCW": "推演持仓盈亏",
  "64eVDw": "稍后补录收益",
  "LcvOVT": "当天有事项",
  "oZI+Us": "完整记录",
  "1QER8V": "标的（选填）",
  "clknDE": "不关联标的",
  "RokZsg": "该标的暂无已保存策略，可快速记一笔。",
  "NceOkd": "记录范围",
  "aysJvP": "快速记一笔",
  "EUIi10": "显示盈亏",
  "dYgLxd": "隐藏盈亏",
  "pqYR6Y": "从每日汇总和收益概览中删除此记录？",
  "Uym+w+": "今日收益",
  "iPv7db": "本月收益",
  "MtaFwz": "查看累计",
  "SNUidU": "当日收益",
  "zCYmSr": "月收益",
  "I3IAZH": "收益图",
  "Up4Gz3": "{count} 项待办",
  "KFvx8w": "距所选日期",
  "q4Qeln": "本年剩余",
  "FL1mQT": "{count}个交易日",
  "s7ZzY9": "已过交易日",
  "rMo5L2": "已过去",
  "LFo5aY": "个人复盘提醒",
  "pbQZea": "UTC",
  "h0W8DM": "时间",
  "+ICdVm": "保存日期",
  "THumjI": "全部日志",
  "X7grYV": "已记录收益",
  "fu5x2o": "暂无已记录收益。",
  "RYpASu": "待记录收益",
  "c1GLGz": "暂无待记录收益。",
  "0jQplV": "删除策略和盈亏",
  "+p1waH": "编辑收益",
  "QKG4ab": "盈亏调整",
  "37Hd+s": "编辑平仓",
  "4szKlZ": "平仓日期",
  "C5c66h": "无法删除策略。请重试。",
  "+AbGsu": "记录日期",
  "x3WH1N": "开仓日期",
  "pD4hJR": "盈亏详情",
  "0J97KX": "此工作区无持仓",
  "sR7qpA": "日志类型",
  "u1NvcM": "关联日志",
  "OrTR8C": "独立日志",
  "IZnGEU": "还没有关联日志。",
  "5Y1XUa": "还没有独立日志。",
  "GplR9g": "暂无复盘",
  "YxMnIj": "暂无日志",
  "n3VxC3": "持仓详情尚未准备就绪。请重试。",
  "H3xn92": "关联策略已失效。",
  "MnpUD7": "查看详情",
  "bUe80+": "详情已删除",
  "f55DWz": "待办",
  "l4FdDg": "新建待办",
  "mZjbAx": "编辑待办",
  "7HVRgC": "待办内容",
  "uw8SSn": "删除待办",
  "jqowuF": "添加待办",
  "ItDqLZ": "{count}项",
  "YrTaSr": "2.0",
  "kt44+R": "进入 2.0",
  "duziu7": "通用版",
  "CzQCpn": "1.0",
  "VS4wIO": "进入 1.0",
  "yed+rm": "了解旗舰版",
  "++EEjI": "旗舰版",
  "utj1/p": "包含 2.0 通用版全部功能，并新增以下功能：",
  "/M0jfm": "宏观日历与交易表现分析",
  "IrKPeO": "策略选择与盈亏形态识别",
  "UmkJCu": "对比不同策略，学习识别盈亏形态。",
  "UM7Ot1": "创作者、书籍与消息",
  "5YBB0f": "随行情变化查看已保存策略，编辑合约、调整行权价与价差宽度，并模拟盈亏。",
  "KB109+": "多层策略构建器",
  "rsEYOJ": "组合多个策略层，并分别调整每层参数。",
  "7C9eJ1": "进阶策略监控",
  "MQuJ1/": "在基础策略追踪之上，分析希腊值、风险指标与时间衰减。",
  "IeSXNb": "开发中",
  "+MEUNc": "创作者主页、分享帖子、书籍、笔记和消息功能正陆续完善。",
  "19FC4d": "回顾与分析",
  "AsQByo": "宏观经济事件、交易表现、回顾与分析，以及复利增长规划。",
  "UMKDTc": "去构建页",
  "+f9XbS": "构建页里的策略保存后会出现在这里。在构建页打开策略的 ••• 菜单，选择“保存”或“观察”。",
  "HZetdf": "还没有追踪的策略",
  "yvoT3+": "还没有交易记录",
  "7RUct4": "导入 Robinhood 导出的交易记录 CSV，这里就会显示总盈亏、交易日历和绩效分析。",
  "2uzHxT": "导入 CSV",
  "pCWKud": "3D 模型",
  "EdBvQ5": "识别与曲面",
  "Cr6WNE": "3.0",
  "KOv/OJ": "页面标签",
  "QztlXg": "这一页的 3.0 版本还在制作中。",
  "HL9Hyq": "打开 1.0 版本",
  "ebsyku": "我的交易表现",
  "O022IZ": "全部合计",
  "2ip6TD": "{count} 个策略叠加",
  "cyfLan": "+ 添加标的",
  "QLYibs": "最大亏损",
  "UvxD/d": "价格一直往不利方向走，亏损会继续扩大",
  "eV+wmZ": "到期时落在最不利的区间",
  "teADxz": "最大收益",
  "SgXUPO": "价格往有利方向走得越远，赚得越多",
  "dz/i4w": "到期时落在最有利的区间",
  "TxpTEx": "没有单一盈亏平衡点",
  "NYvBK0": "到期时需比现价涨 {pct} 才开始赚",
  "LtnD+9": "到期时比现价跌 {pct} 以内仍不亏",
  "GJBcCc": "现在",
  "SPjHkt": "每涨 1 点，约赚 {amount}",
  "jQdTVj": "每涨 1 点，约亏 {amount}",
  "lLc5pq": "每过一天，时间价值约少 {amount}",
  "duaBkR": "每过一天，约多赚 {amount}",
  "SkdHny": "波动率每升 1%，约赚 {amount}",
  "cxwyPx": "波动率每升 1%，约亏 {amount}",
  "0SmzU+": "价格变动时，Delta 变化的速度",
  "tnZjAX": "进阶分析",
  "W/V6+Y": "折叠",
  "0oLj/t": "展开",
  "55ru1f": "先选一个标的",
  "1peGKq": "每个标的单独存放自己的策略，就像文件夹。",
  "1XBnBy": "为 {ticker} 构建第一个策略",
  "2nvHVU": "先选一个结构，之后可以再调整到期日、行权价和各条腿。",
  "kaaf1E": "现在",
  "eO1PKn": "到期时赚多少",
  "v+dq4Y": "各条腿 · 保存 · 观察",
  "G4cWHH": "在左边选一个策略，再来调整它。",
  "1OaCCr": "今天到期",
  "0wjTjz": "还剩 {count} 天",
  "I97lFf": "收起日期",
  "XkNUgy": "更多日期",
  "fSFsx5": "行权价整体下移",
  "6vaHZI": "行权价整体上移",
  "1osJ1h": "数量（张）",
  "BtANKA": "已收权利金",
  "mDtdP3": "还没有策略",
  "n1Whvj": "切换",
  "s3YoNc": "现在浮盈",
  "ofK0y+": "现在浮亏",
  "p4gDwk": "盈亏图：到期时各价位的盈亏",
  "i/HCb7": "现价 {price}",
  "OJXshN": "盈亏平衡 {price}",
  "+MqqK2": "这条腿行权价下调",
  "MJUbr7": "这条腿行权价上调",
  "CodIlO": "价格 {amount}",
  "xuXvQ+": "打开这条腿",
  "GjsXP1": "关闭这条腿",
  "C+KAE3": "存到策略库",
  "U8o7F2": "保存并追踪",
  "F3VvGB": "无上限",
  "mPeAtj": "现在",
  "esup98": "赚",
  "saddNP": "亏",
  "2q3DnK": "{ticker} 到期时低于 {price}",
  "cCnkS1": "{ticker} 到期时高于 {price}",
  "SvEt3U": "{ticker} 到期时在 {low}–{high} 之间",
  "s/lD8x": "盈亏平衡",
  "QFz89W": "最大亏损 {amount}",
  "VzWia2": "；",
  "2L5PQy": "希腊值 · 时间衰减 · 3D",
  "rDk0BN": "换策略",
  "41HBlh": "{date}到期 · 今天到期",
  "Aq0OpM": "{date}到期 · 还剩 {count} 天",
  "fjpowc": "{ticker} 价格",
  "o0/SZQ": "AI 助手",
  "fhywne": "各条腿",
  "p9QToR": "付出的权利金",
  "LUwWqv": "离卖出行权价 {pct}",
  "cZ1FA9": "{count} 天后",
  "WYjFFK": "保存时 {ticker} {price}",
  "roKzgy": "我已经开仓了",
  "FGyUEN": "结束追踪",
  "Xwb/1h": "跌 2%",
  "6kdJPp": "不动",
  "FJkSzV": "涨 2%",
  "8LKNRv": "如果 {ticker} 到期时…",
  "5Ws83M": "形态",
  "YJ1BK1": "在构建页做好策略后点“保存并追踪”，它就会出现在这里，并显示实时盈亏。",
  "NbMCpc": "我正在追踪的策略",
  "17bpAU": "总计",
  "SW6RNm": "现在合计",
  "zDN2m+": "{count} 个策略 · {winners} 赚 {losers} 亏",
  "t9e9y5": "最坏情况合计最大亏损",
  "TqbLpg": "每个策略都在最不利的位置到期时",
  "SVNm5M": "本周到期",
  "Cby8i2": "有一个明天到期",
  "lXMl+7": "未来 7 天内",
  "KTPiJ1": "已结束的策略（{count}）",
  "IwgvVf": "假如…",
  "LPYl7s": "左右 = 价格",
  "4AFT73": "越往右价格越高。曲面往上抬升的地方，代表涨得越多赚得越多。",
  "blJfvv": "前后 = 时间",
  "bNkdoW": "越往后离到期越远；越靠近到期，曲面越接近到期那天的折线。",
  "EZMIZb": "上下 = 盈亏",
  "PYWf+D": "高于零点地面是赚，低于是亏。最低最平的那片就是最大亏损。",
  "hBpqPJ": "价格和时间一起变，会赚还是亏？",
  "0va1RP": "怎么看这张图",
  "X1BkPN": "波动偏低",
  "kYXgI/": "波动适中",
  "Oibvak": "波动偏高",
  "ETzlVJ": "{name} 今天到期",
  "TaqQu7": "{name} 明天到期",
  "qHyTW1": "收盘前看一下",
  "Hlnpps": "现在浮盈 {amount}",
  "UvZ16D": "现在浮亏 {amount}",
  "eCQt9W": "去看看 →",
  "AhvSpr": "{name} 离卖出行权价 {pct}",
  "NPW35l": "再走约 {points} 点就会开始亏",
  "qffCWd": "可能带来较大波动",
  "UJQfky": "宏观事件",
  "YuycZQ": "美股开盘中",
  "/jrcCT": "美股已收盘",
  "4+0ilE": "今年还剩 {count} 个交易日",
  "c0IFFx": "今天 {pct}",
  "8PvMjZ": "我的策略今天",
  "9vPqc1": "{count} 个策略在追踪 · {winners} 赚 {losers} 亏",
  "ql3gYo": "未来 7 天没有到期",
  "L3gu8h": "最近一个：今天",
  "kCPMIt": "最近一个：明天",
  "zB7rG3": "最近一个：{count} 天后",
  "Y2CVS0": "一切正常，现在没有需要处理的。",
  "xwoKl5": "VIX {value}（{mood}）",
  "FL82mv": "累计盈亏走势",
  "echqSA": "最大回撤 {amount}",
  "rX+nJg": "导入交易记录",
  "E0NcxQ": "近 3 个月",
  "lPShsT": "今年",
  "74vgSJ": "时间范围",
  "TLFZUH": "来自导入的 Robinhood 交易记录",
  "v3FUUN": "这段时间没有交易，试试更长的时间范围。",
  "SZxMzN": "关键数据",
  "f3tYS8": "平均每个交易日 {amount}",
  "31CMuF": "共 {count} 笔交易",
  "HH3P1N": "需要同时有赚有亏的交易",
  "CauQjJ": "每亏 $1，平均赚回 {amount}",
  "ed7fzy": "最大回撤",
  "4BEceR": "从最高点最多跌了这么多",
  "NiX9uT": "每一点 = 当天收盘时的累计结果",
  "hreg2u": "{month}每天的盈亏",
  "hrUnBT": "哪个标的最赚钱",
  "CTpgXu": "投资价值的变化",
  "mKlmhg": "最低点 {pct}",
  "Y4CW7K": "一次性投入",
  "g7bjQR": "每周",
  "YaEHga": "每月",
  "QT7hEe": "每季度",
  "561yCs": "每年",
  "DlTYle": "如果当时买了，现在怎样？",
  "Ff3npZ": "选一个标的、日期和金额，按真实历史价格逐日回放。",
  "y4Eo2M": "回放设置",
  "n5QvJy": "从哪天开始",
  "zgEYiS": "怎么投",
  "/bIiUw": "每次（美元）",
  "c0XrfH": "回放到",
  "As4HMM": "回放中…",
  "i2ZE5B": "{ticker} · {date} 起",
  "rjJ0yv": "现在值",
  "wYBYdt": "共投入 {amount}",
  "x9zwkN": "盈利",
  "fzH6GY": "平均每年",
  "o4hKqH": "中途最多跌过",
  "6EswL/": "投入的本金",
  "aZbPsq": "之前的回放",
  "BYG8vL": "两个行权价之差 − 成本",
  "W2KShT": "付出的成本",
  "gsKVsH": "到期刚好在中间行权价",
  "8r1p+j": "风险一侧的翼宽 − 收到的钱",
  "Yc4o3e": "收取的权利金",
  "v3ow+a": "翼宽 − 收到的权利金",
  "wU1eH/": "大跌时类似卖出看跌",
  "hYNHGG": "两笔权利金合计",
  "Gi+vNw": "近月到期时价格正好在行权价",
  "bytjHw": "行权价 − 买入价 + 权利金",
  "HvQYdV": "股价下跌（减去收到的权利金）",
  "xwKYHW": "行权价 − 权利金（股价归零时）",
  "4IXRIN": "跌得越多越赚",
  "QcpLur": "会涨或会跌",
  "k7moAa": "不怎么动",
  "CKtwZR": "会大动",
  "IhweV7": "保护持仓",
  "7/leLd": "你对 {ticker} 接下来怎么看？",
  "YwrXpc": "策略说明",
  "YPRgOM": "在工作台试一下",
  "B7h6uL": "了解原理",
  "X5pxp9": "看图识策略",
  "wa2P/1": "这是什么策略？",
  "ibUSAQ": "第 {current} 题 / 共 {total} 题",
  "cC1L4r": "横轴：到期时的价格 · 纵轴：盈亏",
  "WsGXkp": "✓ 正确答案",
  "Alz3GP": "您的选择",
  "xmF49T": "答对了！",
  "iLuOpJ": "差一点——正确答案是{name}",
  "K1enjE": "盈利：{profit}。风险：{risk}。",
  "6jxIJE": "在工作台中打开",
  "Oi87/W": "波动率微笑",
  "+20iSw": "市场把哪些行权价定得更贵？",
  "6FPUFh": "课程目录",
  "3OOWoV": "日志分类",
  "3DWBhG": "+ 写一篇",
  "87ZCAe": "日志列表",
  "hsiZMg": "还没有日志。可以写下计划、复盘，或想坚持的交易纪律。",
  "3kbIhS": "未命名",
  "QXYeHk": "无分类",
  "fBWFdu": "发生了什么，学到了什么，下次会怎么做…",
  "skHT4P": "删除此条目？",
  "3QmPY0": "关联策略：{ticker} {name}",
  "OkD4xZ": "选一篇日志，或者写一篇新的。",
  "PhY7Pq": "走到一半",
  "xhcwmC": "到期前一刻",
  "luTJgk": "模拟时间",
  "LTWMkP": "美东 · 离到期还有 {days} 天 {hours} 小时",
  "6EeYsX": "模拟时浮盈",
  "q/zar5": "模拟时浮亏",
  "f+4VqO": "模拟时",
  "LHWk5F": "看中间的高度",
  "ZOnZYq": "平值期权偏贵：买期权更贵，卖期权收得更多。",
  "X3e30b": "平值期权偏便宜：买期权更便宜，卖期权收得更少。",
  "yxDmP5": "平值期权价格在正常水平。",
  "zG1F8i": "看两边翘得多高",
  "4tfRtm": "离现价远的期权被额外加价——市场在为大行情买保险。",
  "Iw+I3j": "两边很平：市场不太担心大行情。",
  "D87sC9": "两边弯曲程度正常。",
  "KJ0lGx": "看左右哪边更高",
  "mAmTqc": "左边更高：大家更怕下跌，看跌期权更贵（指数常见）。",
  "O7GXCr": "右边更高：大家更怕大涨，看涨期权更贵。",
  "LgPglG": "左右大致对称。",
  "hCblsN": "不同行权价的隐含波动率",
  "DkxIgq": "贵",
  "vVI22b": "便宜",
  "/9FTru": "现价附近（平值）",
  "gwN7SL": "你调的曲线",
  "xdvBUY": "每次几道题，还没答对过的题优先出现。",
  "w1DTYJ": "本级别已掌握",
  "j1R+QE": "上次得分",
  "UdtpV7": "主题",
  "dgp0C9": "题目数量",
  "uS55uE": "这个组合还没有题目",
  "9hGA1m": "开始练习",
  "+23axj": "这一组做完了",
  "P768k7": "答对",
  "mSlTjl": "再练一组",
  "ksbZO4": "换难度或主题",
  "++l7ni": "不太对",
  "CpNb11": "看结果",
  "FoHB5c": "续订",
  "Oj9Phc": "管理订阅",
  "PCSt5T": "偏好设置",
  "dIfgoA": "互换盈亏颜色",
  "/kN3Yy": "记住这一句",
  "JIOlLn": "{done} / {total} 已学完",
  "Jvdbat": "每日一练",
  "1bUTsf": "{section} · 第 {number} 课",
  "9miVrB": "怎么变化",
  "hH7EXB": "受什么影响",
  "+jvttV": "做一道练习",
  "+o/8P3": "下一课：{title} →",
  "knUjT2": "标记为学完",
  "P1bU4o": "{days} 天",
  "ewgnOI": "{hours} 小时",
  "KJ+H2j": "恢复现在",
  "1t0KYX": "和现在一样",
  "hVvJRR": "比现在高 {pct}%",
  "HDBEbb": "比现在低 {pct}%",
  "yCle8w": "离到期还有",
  "lfhGP4": "市场预期的波动大小，越高期权越贵",
  "T77nEZ": "这种情况下",
  "keXWWi": "比现在多赚 {amount}",
  "ejzuSU": "比现在少赚 {amount}",
  "QIUyHQ": "价格风险",
  "pZx3uk": "波动率影响",
  "dPIOSt": "看哪个指标",
  "jOWhbe": "盈亏",
  "IXb0HA": "时间损耗",
  "ADK15s": "+ 写分享",
  "NHQVSv": "时间损耗",
  "5yFKER": "方向变化速度",
  "4blH1o": "波动率敏感度",
  "Yt0EtO": "在这一点赚或亏多少",
  "brRlK6": "整个仓位在这一点值多少钱",
  "nLZ0Sc": "光是时间过去一天，赚或亏多少",
  "O5yrxl": "价格涨 $1 时赚或亏多少",
  "RHIj7h": "价格变动时，方向数字变得多快",
  "rCWeDL": "波动率升高 1 点时赚或亏多少",
  "PVGcgq": "便宜",
  "CJrA88": "贵",
  "9idWIv": "时间让你亏",
  "f/cK7p": "时间让你赚",
  "F4GXad": "看跌",
  "t4yQLQ": "看涨",
  "0mTVq9": "变化快",
  "GNMXeA": "几乎不受影响",
  "MLYgNV": "影响很大",
  "h/1/v5": "高度看什么",
  "ZFsxcy": "颜色看什么",
  "UAYQOz": "横轴 × 纵轴",
  "RrLcW9": "高度 = {name}",
  "YRHtS6": "颜色 = {name}",
  "PWpQsY": "删除这个策略",
  "noADbl": "{name} 会从工作台移除。正在追踪的策略不受影响。",
  "u/yZzt": "本篇目录",
  "QjmqN6": "小标题",
  "B2GmBO": "加粗文字",
  "k5KdCo": "链接文字",
  "3/XSUG": "格式",
  "JfaoH6": "继续编辑",
  "2oVFY7": "保存失败，你写的内容还在，请再试一次。",
  "7jg/ge": "本子名称保存失败。",
  "bEffjZ": "本子移动失败。",
  "odDlvt": "章节移动失败。",
  "n+mflb": "日志删除失败。",
  "Gj4ztn": "本子删除失败。",
  "rZCxYP": "本子名称",
  "kAEQyV": "好的",
  "jeQ2Zg": "本子",
  "Io+AJO": "+ 新建本子",
  "G91Z0C": "目录 · {count} 章",
  "U9O2UX": "本子上移",
  "fptBhp": "本子下移",
  "kehJ5O": "改名",
  "hdoPUE": "删除本子",
  "k5IwIp": "这个本子还是空的，写下第一章吧。",
  "vK2Mer": "本子",
  "J7KTJS": "不放进本子",
  "UrYcLf": "删除这个本子？",
  "e++AM/": "「{name}」和里面的 {count} 篇日志会一起删除，删除后不能恢复。",
  "d9+mTP": "「{title}」会被删除。",
  "FnxuYO": "创建或重命名",
  "IPmY+p": "第 {number} 章",
  "pO99pv": "确定",
  "Ldc2c7": "数学公式",
  "kb3HsS": "今年剩余交易日",
  "uaLaoc": "{date} 至今的交易日",
  "Q4g24h": "距 {date} 还有的交易日",
  "8OVI1m": "今天 · {date}",
  "gSqFNc": "这天没有宏观事件和到期",
  "cxme7e": "{name} 到期",
  "rkFB/J": "美东 {time}",
  "nIDN2t": "常引起市场波动",
  "tKX8iy": "影响较小",
  "+0CDAs": "计划",
  "Wia3rk": "设置初始金额和每日目标，然后勾选每日达成的日期。",
  "k45Tc7": "还没保存，会自动重试",
  "0DQlON": "已保存到账户",
  "jwn+FG": "定一个每天的目标，每个达成的交易日打一次卡。",
  "NrVp1o": "计划设置",
  "kxleqd": "每日目标按",
  "TOefst": "每天 %",
  "9GG2Xx": "每天固定金额",
  "nQxsCH": "起始资金 ($)",
  "VjtXzx": "每天目标 ($)",
  "EVkL9+": "每天目标 (%)",
  "zSVA42": "修改这几项后，计划会从第 1 天重新开始。",
  "sI6Dzc": "计划结果",
  "efRTJ2": "{count} 天后",
  "Rk2moj": "第 {done} / {total} 天",
  "3ocoxe": "当前余额 {amount}",
  "wjja+z": "第 {day} 天目标：赚 {amount}",
  "nM92Ob": "{from} → {to}",
  "y6KAzd": "撤销上一天",
  "e8bHkL": "今天达成了",
  "YMu/qW": "计划完成：{amount}",
  "JgLxsC": "重新开始",
  "18WUUn": "第 {day} 天：{amount}",
  "69lfhL": "已完成的计划",
  "sL+Hht": "{count} 天：{from} → {to}",
  "7IND0c": "{month} 全部",
  "iKR+lr": "收起",
  "Xyw7Y4": "本月全部",
  "W0hZ6y": "本月没有宏观事件和到期",
  "9Ruc/8": "正在开启…",
  "MC+lq0": "{loss}；{breakeven}",
  "soTyye": "{loss}，最大亏损 {amount}；{breakeven}",
  "7h/SxN": "每月定投",
  "psQHJx": "收益区间",
  "2SEDWH": "扣税费后",
  "cVSCKc": "每月投入 ($)",
  "8v8RsN": "年化收益率 (%)",
  "u8/88U": "差年份收益率 (%)",
  "f91VBA": "好年份收益率 (%)",
  "QLRDAT": "每年费用 (%)",
  "/yFqrS": "收益税率 (%)",
  "7LOg9A": "P 是起始资金，C 是每月投入，r 是年化收益率，t 是年数。收益按月计入。",
  "S+cLw1": "期末余额",
  "BagSEj": "总投入",
  "yNgteA": "收益赚到",
  "9F0rji": "同一笔钱分别按差年份和好年份的收益率增长，实际结果通常落在两者之间。",
  "VkmOv5": "收益差时",
  "VR8YzH": "收益好时",
  "RX1uhE": "区间中间值",
  "Cgz/r6": "先按“收益率减去费用率 (f)”增长，再对超过本金的收益扣税 (τ)。",
  "c7hs9J": "被税费吃掉",
  "bsDIPy": "长期计算器",
  "p1S7eD": "按年算的长期账：每月定投、收益区间，以及扣掉费用和税之后的真实数字。",
  "wExAzx": "计算器",
  "oaOXL5": "好年份",
  "23WQaV": "差年份",
  "H5+NAX": "余额",
  "AOI6LI": "{count} 年",
  "Ml9tvh": "起始资金",
  "xHq4Li": "每月投入",
  "yHtrxp": "年化收益率",
  "F3SSRi": "年数",
  "02kxaz": "月收益率",
  "ipVR6L": "总月数",
  "lEZtMy": "收益按月计入。",
  "qvIbAr": "差年份收益率",
  "AFOIvX": "好年份收益率",
  "YaszIl": "实际结果通常落在两者之间。",
  "1J4iw+": "每年费用率",
  "ipPKTM": "收益税",
  "PpwHOQ": "扣费后余额",
  "efRJbv": "只对超过本金的那部分收益扣税。",
  "zI9KAp": "月收益率",
  "mVOmC6": "月数",
  "LVtqqd": "起始资金增长到",
  "NpVbMA": "每月投入增长到",
  "Ige1p7": "扣费后收益率",
  "tfPbAr": "扣费后余额",
  "cjLie9": "应税收益",
  "m8nbuJ": "根据您的数字",
  "5RxU8A": "起始资金",
  "lzHKMD": "年化收益率",
  "GOATn6": "月收益率",
  "AxDOiG": "月数",
  "pB56Qq": "差年份收益率",
  "Ubu1HL": "好年份收益率",
  "7IZjHh": "每年费用率",
  "at71Gf": "按扣费后收益率算的期末余额",
  "7B1zNd": "收益税率",
  "Y8MZw9": "不扣费用的期末余额",
  "Cv0Ftj": "每月投入",
  "HJHKrH": "税款",
  "FZRjGr": "起始资金 × 按月复利 + 每月投入 = 期末余额",
  "xLK8c0": "起始资金 × (1 + 年化收益率) ^ 年数，差年份和好年份各算一次",
  "iyrIuv": "按月复利 + 每月投入 − 费用 − 收益税 = 到手余额",
  "g4IidV": "收起",
  "vsJ4NZ": "计算详情",
  "Kv2YtY": "期末余额",
  "60yoJI": "到手余额",
  "7VnwiS": "按月复利",
  "5d/WPc": "每月投入",
  "bnkkcI": "月度收益率，由...折算",
  "Dp+l9/": "年化收益率",
  "rrWnge": "，",
  "y1s/tR": "差年份",
  "1LUj1M": "和",
  "M9rHAA": "好年份",
  "/3DFFw": "各算一次",
  "KFTdWf": "月复利，扣除收益率",
  "fAPZhr": "费用",
  "DOCOhb": "收益超额税",
  "zOgCNz": "投入本金",
  "iuVrr4": "（",
  "iZcM81": "）",
  "7ojO80": "按月复利",
  "p00N+q": "复利",
  "oFSwDy": "正在看：",
  "I+VW5X": "去构建页打开 →",
  "RM2hgl": "示例数据",
  "OPkC7N": "有一年交易记录时，这一页会是这样",
  "yPp6MA": "这里是示例数字。导入你的 Robinhood 交易记录 CSV 后，这一页会显示你自己的结果。",
  "ADMDcn": "+ 添加提醒",
  "zS3+iV": "比如：复盘上周的铁鹰交易",
  "Q7Mnz2": "日期（可不填）",
  "9TErKa": "我的提醒 · {date}",
  "HUksLW": "我的提醒",
  "Ry+OxB": "写日志 →",
  "tQpQon": "标记完成",
  "iJH4/q": "买入看涨 {strike}",
  "MtrTNy": "明天",
  "BYcrvD": "卖出看跌价差 {high} / {low}",
  "0euVT9": "离卖出行权价 {pct}",
  "Pfhg1a": "这是示例。在构建页做一个策略，点“保存并追踪”，这里就会显示你自己的实时盈亏。",
  "hATZi0": "盈亏图",
  "GJ1lEe": "{name} 已到期",
  "6dCRsS": "写个复盘，或者在追踪页删除它",
  "I47tqT": "已到期",
  "1WRwEc": "没有匹配的策略",
  "XU4+MR": "这个到期日已经有 {count} 个策略，到上限了。换一个日期，或者先删掉一个。",
  "0pw0c/": "+ 写一章",
  "1qpYGC": "修改本子名称",
  "K2j+2b": "写第一章",
  "pwkxHX": "为什么做这笔，什么情况说明看错了。",
  "ZbAsgg": "行情怎么走的，你做了什么。",
  "rvTvnU": "结果怎样，下次保留什么、改什么。",
  "HFiPBh": "直接写，或点上面的提示开个头。",
  "MguPVS": "打开复盘",
  "4nsgGd": "观察中：还没下单，盈亏按保存时的价格模拟。已经下单了？点「我已下单」，填上成交价。",
  "ZZ8kH3": "持仓中：盈亏按你的成交价算。在券商那边平掉了？点「我已平仓」，结果才会算进成绩。",
  "rd8yH4": "我已下单",
  "9MhYEk": "到期结算",
  "eAWf7Y": "我已平仓",
  "09vZkf": "不再追踪",
  "wRc1f0": "已实现",
  "wuQ1NN": "已隐藏（{count}）",
  "vpgI/5": "恢复追踪",
  "Oz2JSv": "恢复追踪这个策略？",
  "Xg8WOp": "不再追踪这个策略？",
  "s4WD3R": "它会回到追踪列表。",
  "ReAOgJ": "它会从追踪列表拿掉，也不再算进成绩。写过的复盘还在，之后可以在页面底部「已隐藏」里恢复。",
  "TqZwQH": "记录成交",
  "5hL+P2": "确认已下单",
  "Org0a+": "记录平仓",
  "GGTOGW": "现在没有在追踪的策略。",
  "CyY0OO": "每股价格",
  "MZ+Ksj": "每股",
  "TznxKJ": "保存时自动算的",
  "Jy5OxW": "改成我的成交价",
  "ZbAkDy": "删除这个追踪的策略？",
  "iRH/Yw": "删除后追踪页上就没有了，写过的复盘还留在日志里。",
  "Rfp0wT": "按你填的成交价",
  "r9wemy": "保存时自动估算的，直接改成你的实际成交价就行。",
  "9P8Aa0": "每股权利金",
  "UpiJbj": "恢复估算",
  "E+jB60": "股价 {price}",
  "qkpDfj": "已完成：{text}",
  "BNJagY": "取消完成",
  "BznORn": "尚无条目。记下您今天所见或所学。",
  "Em4YSu": "今天的日志",
  "zVmice": "日志 · {date}",
  "cO4q4O": "今天还没写。",
  "HwqI7M": "这天没有写日志。",
  "V47K8v": "全部日志 →",
  "77Iatp": "股价 S",
  "WGXTdT": "行权价 K",
  "yYsILG": "价内程度 m",
  "bFdR14": "波动率 σ",
  "dfU1kx": "剩余天数 T",
  "bFbJbG": "越往右，股价越高。",
  "LiEK40": "越往右，行权价越高。",
  "2BsvyJ": "越往右，行权价比股价高得越多。",
  "nDuBJg": "越往右，波动率越高。",
  "qzW1Xi": "越往右，离到期的天数越多。",
  "h5gpvE": "越往后，股价越高。",
  "UVziCU": "越往后，行权价越高。",
  "rF1pvZ": "越往后，行权价比股价高得越多。",
  "CTPS9y": "越往后，波动率越高。",
  "Fb6kGs": "越往后，离到期的天数越多；越靠近到期，曲面越接近到期那条线。",
  "DNGYsU": "高于零面是赚，低于零面是亏。",
  "7l1MAG": "{sentence}。",
  "2nn+Sf": "在 3.0 中打开",
  "1RpBnq": "免费使用 2.0 通用，需要深入分析时再订阅 3.0 旗舰。",
  "FAhMYJ": "解锁 3.0 旗舰",
  "pChEdk": "3.0 旗舰",
  "nN/aF/": "选择 3.0 旗舰",
  "jFGl0N": "不需要。2.0 通用免费使用；需要 3.0 旗舰的深入分析工具时，再订阅即可。",
  "xquvI8": "进入 3.0",
  "Yo3/Bs": "+ 新建",
  "RyfXNL": "分享 getabg.one",
  "wDWpwe": "复制失败",
  "eE4RqV": "{date} 已到期",
  "CPEwfO": "{date} 已到期 · 在「调整」里换一个新的到期日",
  "e7Rt5M": "这里的策略都已经过了到期日，没有盈亏可以画。可以删掉，或者选中一个，在「调整」里换一个新的到期日。",
  "smpLHp": "{count}天到期",
  "OrYssY": "降低此腿的权利金",
  "9iyAfm": "提高此腿的权利金",
  "+mv46A": "每月",
  "fRd3Oz": "随时取消",
  "3MLT5m": "每年",
  "bQB+7j": "约 {price}/月 · 节省 {percent}%",
  "dC3u7Z": "最受欢迎",
  "APU9rD": "你已订阅 3.0 旗舰。",
  "ZBEnv8": "暂时无法打开订阅管理，请稍后再试。",
  "QrBDUk": "价格终身锁定，随时一键取消。",
  "dDHp0Z": "在上方选择月付或年付，然后前往安全支付。",
  "wKqcUW": "年付已享达人会员价。",
  "PUlPbH": "订阅 · {price}/年",
  "LOFGac": "订阅 · {price}/月",
  "AeaYiI": "每年按 {price} 自动续费，价格锁定、永不上涨。随时一键取消，已付费的这一年照常使用到期满。",
  "OjGfAQ": "每月按 {price} 自动续费，价格锁定、永不上涨。随时一键取消，已付费的这个月照常使用到期满。",
  "YrYFv7": "你已经订阅了，可在“设置”里管理订阅。",
  "sApwHs": "这个邮箱已经订阅了，请登录后管理订阅。",
  "gLaz5+": "怎么取消？",
  "I2NmUD": "一键取消：设置 → 会员方案 → 管理订阅。取消后不会再扣款，3.0 照常用到已付费期满。",
  "gCSohm": "以后会涨价吗？",
  "JXru6E": "不会。订阅时的价格会一直锁定，只要不取消就永不上涨。新账户注册 7 天内订阅更优惠。",
  "PiNOwW": "新会员价：{monthly}/月 或 {annual}/年",
  "7z86YI": "注册 3 天内订阅可享，价格终身锁定。已有账户？登录查看你的专属价格。",
  "10cSZz": "{days} 天 {hours} 小时",
  "0Yp4jJ": "{hours} 小时 {minutes} 分",
  "kLZhgT": "你的新会员价还剩 {remaining}",
  "xNBmzW": "现在订阅，这个价格终身锁定。之后恢复为 {monthly}/月 或 {annual}/年。",
  "tru4ls": "扫码领取新会员价",
  "K2oKdT": "注册 3 天内订阅，年付仅 $98 · 原价 $168",
  "jgwGCD": "加入 αβΓ✻1：注册 3 天内订阅 3.0 旗舰，年付仅 $98，价格终身锁定（原价 $168）：{url}",
  "0t5b/d": "新会员年付价",
  "iBvMKT": "分享新会员价",
  "CM7DlJ": "{price}/年",
  "ueYsIr": "{price}/月",
  "/NokQV": "年付 · {price}",
  "lHgR2N": "月付 · {price}",
  "CXsnkT": "上次扣款没有成功，请更新银行卡以继续使用 3.0。",
  "s9ia4W": "已取消，3.0 可用到 {date}。",
  "4JaRgt": "将于 {date} 自动续费，价格已锁定。",
  "6uS8Qe": "正在打开...",
  "PAes8S": "取消、恢复订阅、换卡或下载发票",
  "gczcC5": "订阅",
  "yfKeQP": "3.0 旗舰为月付或年付订阅，按你订阅时的价格自动续费，直到你取消为止。你可以随时在“设置 → 会员方案 → 管理订阅”中取消：取消后不会再扣款，已付费的周期照常使用到期满。已支付的款项不会自动退款；如遇问题，请联系我们，我们会个案处理。",
  "MQhNBe": "更新于：2026年10月",
  "shhS1o": "不会。订阅时的价格会一直锁定，只要不取消就永不上涨。新账户注册 3 天内订阅更优惠。",
  "r+yR2U": "价格终身锁定，随时取消。",
  "lFwAuV": "每年按 {price} 自动续费，价格锁定、永不上涨。随时取消，已付费的这一年照常使用到期满。",
  "7p3RG+": "每月按 {price} 自动续费，价格锁定、永不上涨。随时取消，已付费的这个月照常使用到期满。",
  "Jp8u8l": "自动续费，随时取消。",
  "3MPFV2": "每年 {price}，自动续费，随时取消。",
  "NScyeW": "每月 {price}，自动续费，随时取消。",
  "sP/VLr": "已取消，可用到 {date}",
  "NWED1U": "{date} 自动续费",
  "os7LaB": "注册 3 天内订阅可享。",
  "iYT0uq": "之后恢复 {monthly}/月、{annual}/年。",
  "Xyjpeu": "注册 3 天内订阅：{monthly}/月、{annual}/年",
  "KuckUy": "优惠还剩 {remaining}",
  "qBv3+/": "注册 3 天内订阅的优惠价（{monthly}/月、{annual}/年）",
  "pZdCN0": "3 天内订阅的优惠价（{monthly}/月、{annual}/年），还剩 {remaining}",
  "wByHhF": "注册 3 天后订阅：原价 {monthly}/月、{annual}/年",
  "0zeuTO": "注册 3 天后订阅：原价 {monthly}/月、{annual}/年",
  "aJOIZu": "注册 3 天后订阅恢复原价",
  "mmafso": "立即订阅",
  "e2VKTh": "{remaining}后订阅恢复原价",
  "0MoFx3": "优惠仅限注册后 3 天",
  "lVGtgN": "注册后超过 3 天订阅恢复原价",
  "WeTNQc": "立即订阅，锁定优惠",
  "lAyIo8": "注册超过 3 天后，首次订阅为 {monthly}/月、{annual}/年",
  "bRkTvW": "3 天内订阅优惠",
  "v/2PT/": "首次订阅优惠",
  "I54eeZ": "好友推荐 · 年费 {price}",
  "GhZZxV": "推荐优惠 · 年费 {price}",
  "FgfuL5": "年费已按好友推荐价计算。",
  "dnb4vu": "推荐码 {code} 已生效",
  "ZNFw12": "更换推荐码",
  "AjkQGQ": "好友通过你的链接订阅年费，只需 $98（原价 $168）。"
}
